import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MapInformationService } from 'src/app/services/map-information.service';
import { DeltaworldService } from 'src/app/services/deltaworld.service';
import { EstimateService } from 'src/app/services/estimate.service';
import { UserService } from 'src/app/services/user.service';
import { DxContextMenuComponent, DxDataGridComponent, DxTreeViewComponent, DxDiagramComponent, DxSelectBoxComponent } from 'devextreme-angular';
import CustomStore from 'devextreme/data/custom_store';
import { TranslateService } from '@ngx-translate/core';
import { DragChangeEvent, DragEndEvent, DragStartEvent } from 'devextreme/ui/sortable';
import { dxTreeViewNode } from 'devextreme/ui/tree_view';

import { Router } from '@angular/router';
import * as XLSX from 'xlsx';
import "jspdf-autotable";
import { UtilityService } from 'src/app/services/utility.service';
import { SalesProjectService } from 'src/app/services/sales-project.service';
import { ToastService } from 'ng-uikit-pro-standard';
import { LoadingService } from 'src/app/services/loading.service';
import { PayCreditComponent } from '../pay-credit/pay-credit.component';
import { SystemComponentService } from 'src/app/services/system-component.service';

type AOA = any[][];


declare var $: any;
@Component({
  selector: 'app-treeview-area-system',
  templateUrl: './treeview-area-system.component.html',
  styleUrls: ['./treeview-area-system.component.scss']
})
export class TreeviewAreaSystemComponent implements OnInit {
  @ViewChild('treeViewSystemArea', { static: false }) treeViewSystemArea: DxTreeViewComponent;
  @ViewChild('galleryLibCatTree', { static: false }) galleryLibCatTree: DxTreeViewComponent;
  @ViewChild('treeDelete', { static: false }) treeDelete: DxTreeViewComponent;
  @ViewChild(DxTreeViewComponent, { static: false }) treeView;
  @ViewChild(DxTreeViewComponent, { static: false }) treeView2;
  @ViewChild("gridLabor", { static: false }) gridLabor: DxDataGridComponent;
  @ViewChild("gridTemplate", { static: false }) gridTemplate: DxDataGridComponent;
  @ViewChild("gridfile", { static: false })
  gridfile: DxDataGridComponent;
  @ViewChild("gridfileAllProject", { static: false })
  gridfileAllProject: DxDataGridComponent;
  @ViewChild("wordFileUpload", { static: false }) wordFileUpload: any;
  @ViewChild("diagramNew", { static: false }) diagramNew: DxDiagramComponent;
  @ViewChild("diagramTreeView", { static: false }) diagramTreeView: DxTreeViewComponent;
  @ViewChild("payCreditRef", { static: false }) payCreditRef: PayCreditComponent;
  @ViewChild('systemLibraryGalleryEstimateSelect', { static: false })
  systemLibraryGalleryEstimateSelect: DxSelectBoxComponent;
  @ViewChild('systemLibraryGalleryDefaultEstimateSelect', { static: false })
  systemLibraryGalleryDefaultEstimateSelect: DxSelectBoxComponent;
  @ViewChild('addCompGallerySysTypeTree', { static: false }) addCompGallerySysTypeTree: DxTreeViewComponent;
  @ViewChild('cubeAIFileInput', { static: false }) cubeAIFileInput: ElementRef<HTMLInputElement>;



  @Input() showsearch = false;
  @Input() showcheckbox = true;
  @Input() showoption = false;
  @Input() checkboxmode = 'none';
  @Input() heightParent = '100%';
  @Input() heightChild = '90%';
  @Input() expanded = true;
  @Input() systemidParent;
  @Input() Commissioning;
  @Input() FindAndReplace;
  @Input() changeOfColor;
  @Input() graphicsCube;
  @Input() ModuleFrom;


  private _areas: any[] = [];

  showDiagram: boolean = false

  showEditParentModal: any;
  editingParentName: any;

  // ========= Métodos que faltan =========
  cancelEditParent(): any {
    // TODO: implement
  }

  saveEditParent(): any {
    // TODO: implement
  }

  openAI: boolean = false
  systemid: any;
  totalReplicate = 1;
  systemSelect: any;
  cancelButtonEditDiferenceLabor: { text: any; icon: string; elementAttr: { id: string; }; onClick: () => void; };
  areaslenght: any = 1
  addArea: { icon: string; type: string; hint: string; onClick: () => void; };
  addType: { icon: string; type: string; hint: string; onClick: () => void; };
  addAreaModalUpdate: { icon: string; type: string; hint: string; onClick: () => void; };
  addTypeModalUpdate: { icon: string; type: string; hint: string; onClick: () => void; };
  addNewPartOptions: { icon: string; type: string; hint: string; onClick: () => void; };
  /** Modal "New Part" propio del treeview (replica del flujo de edit-estimate, sin tocar el original). */
  popupNewPart: boolean = false;
  /** Placeholder del select de Part en el modal "Add Individual Parts" (se actualiza al crear un part). */
  addIndividualPartsPartPlaceholder: string = 'Search part...';
  popupNewSytemType: boolean;
  valueDocument: any[] = [];
  selectedFile: string;
  labelSystemType: string;
  systemTypeDatasource: any;
  systemTypeSelect: any;
  changeBase64: any;
  showselectArea: boolean = false;
  showselectSystemType: boolean = false;
  showselectSystemName: boolean = false;
  showselectSort: boolean = false;
  showselectQty: boolean = false;
  showselectSystemOrigin: boolean = false;
  missingColumnsTempo: any[];

  showPopupPaywithCredit: boolean = false;
  showSuggestedSystemPopup: boolean = false;
  suggestedSystemData: any = null;
  /** 'dataTest' | 'updateModal' — destino de import sugerido y selección múltiple */
  suggestedSystemTargetArray: 'dataTest' | 'updateModal' = 'dataTest';

  dataSystemsToShowAndUpdate: any[] = [];
  showModalToupdateSystems = false;

  // AI Popup properties
  showAIPopup: boolean = false;
  aiPopupContent: string = '';
  aiProcessingType: string = '';
  isAIButtonEnabled: boolean = false;
  from: string;
  openPopupDrawingsWithAI: boolean;
  showProcessingPlanePopup: boolean = false;
  @Input('areas')
  set areas(areas: any) {

    // this.agrupar();
    if (areas.length != undefined) {
      if (areas.length > 0) {

        // Restaurar nodos expandidos/colapsados guardados para este estimate
        this.loadEstimateTreeState();

        this.userService.Get_UserSettingsCE(localStorage.getItem("customerid")).subscribe(result => {
          // let obj = JSON.parse(result[0].CLIENTUSERSETTING);
          // if (obj.openTreeEstimate == true) {
          //   this.OpenOrClose = true
          //   this.treeViewSystemArea.instance.expandAll()
          setTimeout(() => {
            this.estiloCarpetas()
          }, 500);
          // } else {
          //   this.OpenOrClose = false
          //   this.treeViewSystemArea.instance.collapseAll()
          //   this.estiloCarpetas()
          // }
        })
        this.agrupar2(areas);
        // }

      } else {
        this.groupItems = this.applyEditEstimateRootWrapperIfNeeded([]);
      }
    }

  }

  get areas(): any { return this._areas; }

  downloads = ["Download Trial For Visual Studio", "Download Trial For All Platforms", "Package Managers"];

  groupItems: any;

  @Output() onitemchange = new EventEmitter<any>();
  @Output() reload = new EventEmitter<any>();
  @Output() closeStepper = new EventEmitter<any>();
  @Output() returnWithInfo = new EventEmitter<any>();
  @Output() changestep = new EventEmitter<any>();
  @Output() deletedSystemOrArea = new EventEmitter<any>();
  @Output() NewSystem = new EventEmitter<any>();
  @Output() gochangesystem = new EventEmitter<any>();
  @Output() changeview = new EventEmitter<any>();
  @Output() changeviewImages = new EventEmitter<any>();
  @Output() reloadData = new EventEmitter<any>();
  @Output() HideSystemsData = new EventEmitter<any>();
  @Output() nextStep = new EventEmitter<any>();
  @Output() fullProjectImportCubeMatchChoice = new EventEmitter<'cancel' | 'associateAll' | 'associatePartial'>();
  @Output() openImportOptionsPopupFromTree = new EventEmitter<any>();
  @Output() openConfigureSystemFromTree = new EventEmitter<any>();


  @Input() estimateid: number = 0;
  @Input() estimatenamestr = '';
  @Input() projectid = '';

  areaSelect = [];
  systemTypeSelectCE = [];
  itemsNewAreaSystem = [
    // {
    //   id: 1,
    //   name: "Add Areas",
    //   icon: "fas fa-map-marker-alt",
    //   description: "Create new areas to organize your project structure and group related systems together.",
    //   color: "#28a745"
    // },

    {
      id: 3,
      name: "Import from Master Library",
      icon: "fas fa-book",
      description: "Browse and import pre-configured systems from your project library or templates.",
      color: "#6f42c1"
    },

    {
      id: 2,
      name: " Add Areas and Systems",
      icon: "fas fa-cogs",
      description: "Add new systems to your areas with customizable components and configurations.",
      color: "#17a2b8"
    },
    // {
    //   id: 5,
    //   name: "Import from Excel",
    //   icon: "fas fa-file-excel",
    //   description: "Import areas and systems in bulk from an Excel spreadsheet with predefined structure.",
    //   color: "#28a745",
    //   onClick: () => {
    //     this.popupImportFromExcel = true
    //   },
    // },

    // {
    //   id: 4,
    //   name: "Purchased in cube resources",
    //   icon: "fas fa-shopping-cart",
    //   description: "Access and integrate systems purchased from the Cube Resources marketplace.",
    //   color: "#fd7e14"
    // },
  ];

  // Popup fullscreen state
  showAddOptionsPopup = false;

  itemsDuplicateAreaSystem = [
    {
      id: 1,
      name: "Duplicate Area",
    },
    {
      id: 2,
      name: "Duplicate System",
    },
    {
      id: 3,
      name: "Replicate System",
    },
  ];

  popupReplicateSystem = false;
  saveButtonReplicateSystem: any;
  cancelButtonReplicateSystem: any;

  popupEditArea = false;
  saveButtonEditArea: any;
  cancelButtonEditArea: any;
  rowsToEditArea = [];

  popupEditSystem = false;
  saveButtonEditSystem: any;
  cancelButtonEditSystem: any;

  popupDeleteSystem = false;
  popupDeleteArea = false;
  cancelButtonDeleteEstimate: any;
  saveButtonDeleteEstimate: any;

  modelArea = {
    name: '',
    id: 0,
    active: true,
    sort: 0
  }

  modelNewSystem = {
    id: 0,
    systemid: "",
    sort: "",
    areaname: "",
    systemname: "",
    qty: 1,
    systemtype: "",
    inactive: false,
    deleted: false,
    scopeofwork: "",
    sop: "",
    excludefromsearch: "",
    controldwgname: "",
    controldwgimg: "",
    tagtext: "",
    tagnum: "",
    description: "",
  };

  popupEditAreaSystem = false;
  rowsToEditAreaSystem = [];
  saveButtonEditAreaSystem: any;
  cancelButtonEditAreaSystem: any;
  OpenOrClose: boolean = true

  profileSettings: any[];
  manageSettings: any[];

  isDuplicating: boolean = false
  itemsSelected: any[] = []
  popupController: boolean = false
  imgSelected: any = "Not_Image"
  treeBoxValue: string[];
  // select
  taggingDatasource: any[] = []
  treeBoxValue2: string[];
  componentModel = {
    ID: [],
    data: []
  };

  showModalDiferencia: boolean = false

  itemsNewAreaSystemEdit = [
    {
      id: 1,
      name: "Area",
    },
    {
      id: 2,
      name: "System",
    },
  ];

  popupImportFromExcel: boolean = false

  isCollapsed: boolean = true;  // Estado inicial para controlar el ícono y las acciones

  toggleExpandCollapse() {
    if (this.isCollapsed) {
      this.OpenParents();
    } else {
      this.closeParents();
    }
    this.isCollapsed = !this.isCollapsed;  // Alterna el estado
  }


  items: any = [

    "undo", "redo", "separator",

    {
      name: "size",
      acceptedValues: ["8pt", "10pt", "12pt", "14pt", "18pt", "24pt", "36pt"]
    },
    {
      name: "font",
      acceptedValues: ["Arial", "Courier New", "Georgia", "Impact", "Lucida Console", "Tahoma", "Times New Roman", "Verdana"]
    },

    "separator", "bold", "italic", "strike", "underline", "separator",
    "alignLeft", "alignCenter", "alignRight", "alignJustify", "increaseIndent",
    "decreaseIndent", "separator",
    "orderedList", "bulletList", "separator",

    {
      name: "header",
      acceptedValues: [false, 1, 2, 3, 4, 5]
    },

    "color", "background", "link", "clear", "codeBlock", "blockquote", "separator", "insertTable", "deleteTable",
    "insertRowAbove", "insertRowBelow", "deleteRow", "insertColumnLeft", "insertColumnRight",
    "deleteColumn", "cellProperties", "tableProperties",
  ];


  selectMin: any[] = [
    { value: 60000, text: '1 minute' },
    { value: 300000, text: '5 minutes' },
    { value: 600000, text: '10 minutes' },
    { value: 900000, text: '15 minutes' },
    { value: 1800000, text: '30 minutes' },
    { value: 3600000, text: '1 hour' },
  ]


  constructor(
    private MapInformationService: MapInformationService,
    private salesProjectService: SalesProjectService,
    private estimateService: EstimateService,
    private deltaService: DeltaworldService,
    private loadingService: LoadingService,
    private utilityService: UtilityService,
    private translate: TranslateService,
    private userService: UserService,
    private toast: ToastService,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private systemComponentService: SystemComponentService,
  ) {


    this.profileSettings = [
      { value: 1, name: 'Add Area', icon: 'fas fa-plus icon-green' },
      {
        value: 4, name: 'Add System', icon: 'fas fa-plus icon-green'
      },
      { value: 2, name: 'Import from Library', icon: 'fas fa-file-import' },
      { value: 10, name: 'Import IO from Excel', icon: 'fas fa-file-excel' },
      { value: 3, name: 'Delete Area', icon: 'fas fa-trash-alt' },
      { value: 5, name: 'Delete System', icon: 'fas fa-trash-alt' },
      { value: 6, name: 'Clone Area', icon: 'fas fa-clone' },
      { value: 7, name: 'Clone System', icon: 'fas fa-clone' },
      { value: 7, name: 'Replicate System', icon: 'fas fa-clone' },
      { value: 8, name: 'Edit Area', icon: 'fas fa-edit' },
      { value: 9, name: 'Edit System', icon: 'fas fa-edit' },
      // { value: 10, name: 'Move to another Area', icon: 'fas fa-exchange-alt' },
    ];

    this.manageSettings = [
      // { value: 1, name: 'Network view', icon: 'fas fa-network-wired' },
      // {
      //   value: 4, name: 'Galery View', icon: 'fas fa-eye'
      // },
      { value: 2, name: 'Find and Replace', icon: 'assets/find.png' },
      { value: 3, name: 'Change system to area', icon: 'fas fa-exchange-alt' },
    ];

  }


  ngOnInit() {


    this.MapInformationService.getParameters("GetMostPairedComponents").subscribe((result) => {
      console.log("jsbdfkjbsdkjfbskbdfjks1231", result);
    });





    const slGal = this;
    this.systemLibraryGalleryAddEstimateBtnOptions = {
      icon: 'fas fa-cog',
      type: 'button',
      onClick: () => slGal.openSystemLibraryGalleryDefaultEstimateModal(),
    };
    this.systemLibraryGalleryCancelDefaultEstimateBtn = {
      text: this.translate.instant('ModalDefaultEst.btnClose'),
      elementAttr: { id: 'bton-gray' },
      onClick: () => slGal.closeSystemLibraryGalleryDefaultEstimateModal(),
    };
    this.systemLibraryGallerySaveDefaultEstimateBtn = {
      text: this.translate.instant('ModalDefaultEst.btnSave'),
      icon: 'check',
      elementAttr: { id: 'bton-green' },
      onClick: () => slGal.saveSystemLibraryGalleryDefaultEstimate(),
    };

    this.cancelButtonEditDiferenceLabor = {
      text: this.translate.instant('btnClose'),
      icon: "close",
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.closeLabor()
        // this.close();
      },
    };

    // this.agrupar();


    // this.getEstimateArea(this.estimateid);

    // this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
    //   this.systemTypeSelectCE = result;
    // });

    this.cancelButtonEditAreaSystem = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEditAreaSystem = false;
        // this.close();
      },
    };

    this.saveButtonEditAreaSystem = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        this.updateAreaSystem();
        // this.type = 1;
        // this.addNewComment();
        // this.updateNetworkConfiguration();
      },
    };


    this.cancelButtonDeleteEstimate = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupDeleteSystem = false;
        this.popupDeleteArea = false;
        this.componentModel.ID = []
        // this.close();
      },
    };

    this.saveButtonDeleteEstimate = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        if (this.popupDeleteSystem) {
          let data = this.getChecked();

          if (data.length == 0) {
            this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
            return;
          }

          let cantadadAEnviar = data.length;
          let cantidadEnviada = 0;


          // let reload = false
          // data.forEach(x=>{
          //   if (x.network == 1) {
          //     reload = true
          //   }
          // })
          // if (reload){
          //   this.toast.warning("The systme selected has child in network, you can´t delete it")
          //   this.reload.emit(this.estimateid);
          //   this.popupDeleteSystem = false;
          //   this.getEstimateArea(this.estimateid);
          //   return
          // } else {
          this.componentModel.ID.forEach(element => {
            this.estimateService.DeleteSystem(element).subscribe(result => {
              cantidadEnviada++;
              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgDelSys'));
                this.reload.emit(this.estimateid);
                this.popupDeleteSystem = false;
                this.getEstimateArea(this.estimateid);
              }
            })
          });
          // }

        }

        if (this.popupDeleteArea) {
          let data = this.getAreasChecked();

          if (data.length == 0) {
            this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
            return;
          }

          let cantadadAEnviar = data.length;
          let cantidadEnviada = 0;


          data.forEach(element => {

            this.estimateService.DeleteArea(element.originalid).subscribe(result => {
              cantidadEnviada++;

              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgAreDelSucc'));
                this.reload.emit(this.estimateid);
                // this.getEstimateArea(this.estimateid);
                this.popupDeleteArea = false;
                this.getEstimateArea(this.estimateid);
              }
            });

          });
        }
      },
    };

    this.cancelButtonReplicateSystem = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupReplicateSystem = false;
        // this.close();
      },
    };

    this.saveButtonReplicateSystem = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {

        let data = this.getChecked();

        if (data.length == 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
          return;
        }


        if (this.totalReplicate <= 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgRepNum'));
          return;
        }

        let cantadadAEnviar = data.length;
        let cantidadEnviada = 0;

        data.forEach(element => {


          this.estimateService.ReplicateeEstimateSystems(element.id, this.totalReplicate).subscribe(result => {
            // this.estimateService.duplicateImage(element.id,result[0].ID)
            // .subscribe(res1=>{
            cantidadEnviada++;
            if (cantidadEnviada == cantadadAEnviar) {
              this.toast.success(this.translate.instant('ModuleSystemToArea.msgRepSucc'));
              this.reload.emit(this.estimateid);
              this.totalReplicate = 0;
              this.popupReplicateSystem = false;
            }
          })
          // })
        });
      },
    };

    this.cancelButtonEditArea = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEditArea = false;
        // this.close();
      },
    };

    this.saveButtonEditArea = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        // this.type = 1;
        // this.addNewComment();
        //this.updateNetworkConfiguration();
        this.insertArea();
      },
    };

    this.cancelButtonEditSystem = {
      text: this.translate.instant('btnCancel'),
      elementAttr: {
        id: "bton-gray",
      },
      onClick: () => {
        // this.componentSales.ngOnInit();
        this.popupEditSystem = false;
        // this.close();
      },
    };

    this.saveButtonEditSystem = {
      text: this.translate.instant('btnSave'),
      icon: "check",
      elementAttr: {
        id: "bton-green",
      },
      onClick: () => {
        this.SaveSystem()
      },
    };


    this.addArea = {
      icon: "add",
      type: "button",
      hint: "Add Area",
      onClick: () => {
        // this.popupFormSequence = true;
        this.openNewAreas()
      }
    };



    this.addType = {
      icon: "add",
      type: "button",
      hint: "Add System Type",
      onClick: () => {
        this.popupNewSytemType = true
        this.getType()
      }
    };

    this.addAreaModalUpdate = {
      icon: "add",
      type: "button",
      hint: "Add Area",
      onClick: () => {
        this.openNewAreas();
      }
    };

    this.addTypeModalUpdate = {
      icon: "add",
      type: "button",
      hint: "Add System Type",
      onClick: () => {
        this.popupNewSytemType = true;
        this.getType();
      }
    };

    this.addNewPartOptions = {
      icon: "add",
      type: "button",
      hint: "Add New Part",
      onClick: () => {
        this.popupNewPart = true;
      }
    };

    // this.agruparItems(this.areas);


    this.MapInformationService.SaveInfoSites({ method: "GetEstimateDesignSVGs" })
      .subscribe(result => {
        console.log("resultjsdkbfkjskdfj", result)

        result.forEach(item => {
          if (item.IMAGENAME != undefined && item.IMAGENAME != '' && item.ACTIVE == true) {
            if (item.IMAGENAME.includes('.')) {
              this.nameSVGs.push(item.IMAGENAME.split('.')[0])
              this.componentsDesignTools.push({
                ID: item.IMAGENAME.split('.')[0],
                SystemType: 'Design Tools',
                NAME: item.IMAGENAME,
                Name: item.IMAGENAME,
                filesvg: 'assets/svgTakeoff/' + item.IMAGENAME,
                filename: item.IMAGENAME,
                componentwidth: 0.3,
                componentHeight: 0.3
              });
            }
          }

        });

        console.log("this.nameSVGs", this.nameSVGs)
      });
  }

  nameSVGs = []



  closeLabor() {
    this.showModalDiferencia = false
    this.reloadData.emit(this.estimateid);
  }

  SaveSystem() {

    let hasError = false;
    let erros = [];
    if (!this.modelNewSystem.areaname) {
      hasError = true;
      erros.push("Please select area.");
    }

    if (!this.modelNewSystem.systemname) {
      hasError = true;
      erros.push("Please enter system name.");
    }

    if (hasError) {
      this.toast.warning(erros.join(","));
      return;
    }

    this.estimateService
      .Insert_EstimateCreateNewSystemCE(
        this.estimateid,
        0,
        this.modelNewSystem.sort,
        this.modelNewSystem.areaname,
        this.modelNewSystem.systemname,
        this.modelNewSystem.qty,
        this.modelNewSystem.systemtype[0] != undefined ? this.modelNewSystem.systemtype[0] : this.modelNewSystem.systemtype,
        false, // inactive
        false, // deleted
        this.modelNewSystem.scopeofwork,
        this.modelNewSystem.sop,
        this.modelNewSystem.excludefromsearch,
        this.modelNewSystem.controldwgname,
        this.modelNewSystem.controldwgimg,
        this.modelNewSystem.tagtext,
        this.modelNewSystem.tagnum,
        this.modelNewSystem.description
      )
      .subscribe((r) => {
        this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysCreSucc'));
        this.popupEditSystem = false;
        this.reload.emit(this.estimateid);
        this.NewSystem.emit(r[0].resultID);
        this.modelNewSystem = {
          id: 0,
          systemid: this.systemid,
          sort: "",
          areaname: "",
          systemname: "",
          qty: 1,
          systemtype: "",
          inactive: false,
          deleted: false,
          scopeofwork: "",
          sop: "",
          excludefromsearch: "",
          controldwgname: "",
          controldwgimg: "",
          tagtext: "",
          tagnum: "",
          description: "",
        }
      });
  }

  getEstimateArea(id, reload = false, preferredAreaId?: number) {
    this.deltaService.GetEstimateAreaList(id).subscribe((result) => {
      this.areaSelect = result;
      if (result.length > 0) {
        let chosen = result[0];
        if (preferredAreaId != null && preferredAreaId !== undefined) {
          const match = result.find((r: any) => r.ID === preferredAreaId);
          if (match) {
            chosen = match;
          }
        }
        this.idAreaxDefault = chosen.ID;
        this.dataTest = [{
          id: 0,
          areaID: this.idAreaxDefault,
          systemTypeID: 1,
          name: "",
          sort: 1,
          qty: 1,
          sytemOrigin: null,
          matchedArea: true,
          matched: true,
        }]
      } else {
        if (reload) {
          window.location.reload();
        }
      }
    });
  }

  getAreas() {
    this.deltaService.GetEstimateAreaList(this.estimateid).subscribe(result => {
      this.areaSelect = result;
    })
  }

  insertArea() {
    let cantidadAEnviar = this.rowsToEditArea.length;
    let cantidadEnviada = 0;

    this.rowsToEditArea.forEach(item => {
      this.MapInformationService.SaveInfoSites({
        method: "Insert_EstimateAreaCE",
        estimateid: this.estimateid,
        name: item.name,
        id: item.id,
        sort: item.sort,
        inactive: !item.active,
        alternate: item.alternate == true ? 1 : 0,
      })
        // this.estimateService
        //   .Insert_EstimateAreaCE(this.estimateid, item.name, item.id, item.sort, item.active)
        .subscribe((result) => {
          cantidadEnviada++;
          if (cantidadEnviada == cantidadAEnviar) {
            this.resetModelArea();
            this.popupEditArea = false;
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgAreSucc'));
            this.reload.emit(this.estimateid);
            this.getEstimateArea(this.estimateid);
          }
        });
    })
  }

  getSystemArea() {
    this.refreshGroupItemsFromSystemArea(false);
  }

  private refreshGroupItemsFromSystemArea(expandTreeAfter: boolean, afterRefresh?: () => void) {
    this.deltaService.GetSystemArea(this.estimateid).subscribe(result => {
      let areas = Array.isArray(result) ? result.filter(x => x.ID != null) : [];
      this.agrupar2(areas);
      if (this._dragExpandSnapshot !== null) {
        const snapshot = this._dragExpandSnapshot;
        this._dragExpandSnapshot = null;
        setTimeout(() => {
          if (this.treeViewSystemArea && this.treeViewSystemArea.instance) {
            this.restoreTreeExpandedState(snapshot);
          }
        }, 50);
      } else if (expandTreeAfter) {
        setTimeout(() => {
          if (this.treeViewSystemArea && this.treeViewSystemArea.instance) {
            this.treeViewSystemArea.instance.expandAll();
          }
        }, 50);
      }
      if (afterRefresh) {
        afterRefresh();
      }
    });
  }

  private captureTreeExpandedState(): any[] {
    const ids: any[] = [];
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return ids;
    }
    const walk = (nodes: any[]) => {
      if (!nodes) { return; }
      for (const node of nodes) {
        if (node.expanded) {
          ids.push(node.key);
        }
        if (node.children && node.children.length) {
          walk(node.children);
        }
      }
    };
    try {
      walk(this.treeViewSystemArea.instance.getNodes());
    } catch (e) {}
    return ids;
  }

  private restoreTreeExpandedState(ids: any[]): void {
    if (!ids || ids.length === 0 || !this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    for (const id of ids) {
      try {
        this.treeViewSystemArea.instance.expandItem(id);
      } catch (e) {}
    }
  }

  private syncTreeViewItemsFromGroupItems() {
    const self = this;
    setTimeout(function () {
      if (!self.treeViewSystemArea || !self.treeViewSystemArea.instance || !self.groupItems) {
        return;
      }
      try {
        self.treeViewSystemArea.instance.option('items', self.groupItems);
        self.treeViewSystemArea.instance.repaint();
      } catch (e) {
      }
    }, 0);
  }

  getSystemType() {

    this.deltaService.GetEstimateSystemTypeCE().subscribe((result) => {
      this.systemTypeSelectCE = result;
    });
  }

  getAreaSystemToEdit(obj) {

    if (this.Commissioning == "Commissioning") {

      let nodes = this.getChecked();

      if (nodes.length == 1) {
        this.getEstimateArea(this.estimateid)
        this.getSystemType()
        this.popupController = true
        return false
      }

      if (obj.itemData.id == 1) {
        this.rowsToEditArea = [];
        let nodes = this.getAreasChecked();

        if (nodes && nodes.length > 0) {
          // this.modelArea.name = nodes.areaname;
          // this.modelArea.id = nodes.originalid;
          // this.modelArea.sort = nodes.sort;
          // this.modelArea.active = nodes.areaactive;
          nodes.forEach(node => {
            let AlternateTrueOrFalse = node.Alternate == 1 ? true : false
            this.rowsToEditArea.push({
              name: node.areaname,
              id: node.originalid,
              active: node.areaactive,
              sort: node.sort,
              alternate: AlternateTrueOrFalse,
            })
          });
          this.popupEditArea = true;

        }
      }
      else if (obj.itemData.id == 2) {
        let nodes = this.getChecked();

        this.estimateService
          .GetEstimateAreaSystemInfoCE(nodes.map((x) => x.id).join(","))
          .subscribe((result) => {

            this.rowsToEditAreaSystem = result.map((x) => {
              x.Active = !x.Active;
              x.MarkLib = !x.MarkLib;
              return x;
            });

            // this.customheight = "70%";
            setTimeout(() => {
              this.popupEditAreaSystem = true;
              // this.customheight = "auto";
            }, 20);
          });
      }
    } else {
      if (obj.itemData.id == 1) {
        this.rowsToEditArea = [];
        let nodes = this.getAreasChecked();


        if (nodes && nodes.length > 0) {
          // this.modelArea.name = nodes.areaname;
          // this.modelArea.id = nodes.originalid;
          // this.modelArea.sort = nodes.sort;
          // this.modelArea.active = nodes.areaactive;

          nodes.forEach(node => {
            let AlternateTrueOrFalse = node.Alternate == 1 ? true : false
            this.rowsToEditArea.push({
              name: node.areaname,
              id: node.originalid,
              active: node.areaactive,
              sort: node.sort,
              alternate: AlternateTrueOrFalse,
            })
          });
          this.popupEditArea = true;

        }
      }
      else if (obj.itemData.id == 2) {
        let nodes = this.getChecked();

        if (nodes.length == 1) {
          this.systemid = nodes[0].id
          this.getEstimateArea(this.estimateid)
          this.getSystemType()
          this.popupController = true
          return false
        }

        this.idsSystem = nodes.map((x) => x.id).join(",")
        setTimeout(() => {
          this.popupEditAreaSystem = true;
          // this.customheight = "auto";
        }, 20);
      }
    }


  }

  reloadSystems(d) {
    this.reload.emit(this.estimateid);
  }

  updateAreaSystem() {
    let cantidadLlamadas = this.rowsToEditAreaSystem.length;
    let cantidadTerminada = 0;

    this.rowsToEditAreaSystem.forEach((item) => {
      this.estimateService
        .Upadte_EstimateAreaSystemCE(
          item.ID,
          item.ID,
          item.SORT,
          item.AreaName,
          item.SystemName,
          item.QTY,
          item.SystemTypeid,
          !item.Active, // Ponemos el caso contrario porqu eel campo se llama inactive en bd y active en el front
          false, //deleted
          "", //scope
          item.SOP,
          item.MarkLib == true ? 0 : 1, // Ponemos el caso contrario porque el campo es diferente en bd y active en el front
          item.Control_Drawing,
          "", // img
          item.TAGTEXT,
          item.TAGNUM,
          item.DESCRIPTION
        )
        .subscribe((result) => {
          cantidadTerminada++;

          if (cantidadTerminada >= cantidadLlamadas) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgUpdSucc'));
            this.popupEditAreaSystem = false;
            this.reload.emit(this.estimateid);
          }
        });
    });
  }


  goToImportFromLibrary() {

    localStorage.removeItem("systemidTree")
    // localStorage.removeItem("fromLibrary")
    if (this.systemid != undefined) {
      localStorage.setItem("systemidTree", this.systemid.toString())
    }

    if (this.Commissioning == "Commissioning") {
      localStorage.setItem("fromEstimate", "No")
    } else {
      localStorage.setItem("fromEstimate", "Yes")
    }

    this.router.navigateByUrl(
      `/Estimates/import-from-library?estimateid=${this.estimateid}&project=${this.estimatenamestr}&systemid=${this.systemid}`
    );
  }

  changeActiveSystem(obj) {

    this.rowsToEditAreaSystem = this.rowsToEditAreaSystem.map(x => {
      x.Active = obj.value;

      return x;
    });
  }

  changeMarkLibSystem(obj) {

    this.rowsToEditAreaSystem = this.rowsToEditAreaSystem.map(x => {
      x.MarkLib = obj.value;

      return x;
    });
  }

  resetModelArea() {
    this.modelArea = {
      name: '',
      id: 0,
      sort: 0,
      active: true
    }

    this.popupEditArea = false
  }


  popupNewSystem: boolean = false
  /** Modal que muestra la tabla dataTest con los sistemas devueltos por la IA (Sequence / Scope) */
  showProcessedSystemsModal: boolean = false
  /** Al abrir desde menú contextual: oculta las tarjetas y muestra solo la rejilla manual (Quick entry). */
  addSystemsShowQuickEntryOnly = false;

  onItemClickNewAreaSystem(obj) {
    if (obj.itemData.id == 1) {
      this.openNewAreas()
    } else if (obj.itemData.id == 2) {
      this.openNewSystems()
      this.nextStep.emit()
    } else if (obj.itemData.id == 3) {
      this.closeStepper.emit()
      this.goToImportFromLibrary()
    } else if (obj.itemData.id == 4) {



      localStorage.setItem("SystemIDSelected", this.systemid.toString())
      localStorage.setItem("estimateIDSelected", this.estimateid.toString())
      localStorage.setItem("estimatenamestrSelected", this.estimatenamestr.toString())
      localStorage.setItem("projectIDSelected", this.projectid.toString())
      localStorage.removeItem("fromCommissioning")



      this.router.navigateByUrl(`/applications`)

    }
  }

  onItemClickDuplicateAreaSystem(obj) {


    if (obj.itemData.id == 1) {
      // this.popupEditArea = true;

      let data = this.getAreasChecked();

      if (data.length == 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
        return;
      }

      let cantadadAEnviar = data.length;
      let cantidadEnviada = 0;



      data.forEach(element => {

        this.estimateService.Insert_AreaDuplicate(element.originalid, this.estimateid).subscribe(result => {
          // this.estimateService.duplicateImage(element.id,result[0].ID)
          // .subscribe(res1=>{
          cantidadEnviada++;

          if (cantidadEnviada == cantadadAEnviar) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgArDupSucc'));
            this.reload.emit(this.estimateid);
          }

          // })
        });

      });
    } else if (obj.itemData.id == 2) {

      let data = this.getChecked();

      if (data.length == 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
        return;
      }

      let cantadadAEnviar = data.length;
      let cantidadEnviada = 0;



      data.forEach(element => {

        this.estimateService.DuplicateSystemSingle(element.areaid, element.id).subscribe(result => {
          this.estimateService.duplicateImage(element.id, result[0].ID)
            .subscribe(res1 => {
              cantidadEnviada++;
              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysDupSucc'));
                this.reload.emit(this.estimateid);
              }
            })
        })
      });
      // this.popupEditSystem = true;
      // this.customheight = "70%";
      // setTimeout(() => {
      //   this.customheight = "auto";
      // }, 20);
    } else if (obj.itemData.id == 3) {
      let data = this.getChecked();

      if (data.length == 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
        return;
      }


      if (this.totalReplicate <= 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgRepNum'));
        return;
      }

      this.popupReplicateSystem = true;
    }
  }

  onItemClickDeleteOrDuplicateAreaSystem(obj, duplicar: boolean = false) {

    this.isDuplicating = duplicar


    if (obj.itemData.id == 1) {
      // this.popupEditArea = true;

      const data = this.getAreasChecked();
      this.componentModel.data = this.getAreasChecked();

      if (this.componentModel.data.length > 0) {
        for (let i = 0; i < this.componentModel.data.length; i++) {
          this.componentModel.data[i].key = this.componentModel.data[i].originalid
        }
      }

      data.forEach(x => {
        this.componentModel.ID.push(x.key)
      })

      if (this.componentModel.ID.length > 0) {
        this.popupDeleteArea = true;
        setTimeout(() => {
          if (this.treeDelete != undefined) {
            this.componentModel.ID.forEach(x => {
              this.treeDelete.instance.selectItem(x)
            })
          }
        }, 2000);
      } else {
        this.toast.warning("You must select an area")

      }


    } else if (obj.itemData.id == 2) {
      this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x => x >= 1)
      this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x => x.key >= 1)

      if (this.componentModel.ID.length > 0) {
        this.popupDeleteSystem = true;
        setTimeout(() => {
          if (this.treeDelete != undefined) {
            this.componentModel.ID.forEach(x => {
              this.treeDelete.instance.selectItem(x)
            })
          }
        }, 2000);
      } else {
        this.toast.warning("You must select a system")
      }
    } else if (obj.itemData.id == 3) {

      this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x => x >= 1)
      this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x => x.key >= 1)


      if (this.componentModel.ID.length > 0) {
        this.popupReplicateSystem = true;
        setTimeout(() => {
          if (this.treeDelete != undefined) {
            this.componentModel.ID.forEach(x => {
              this.treeDelete.instance.selectItem(x)
            })
          }
        }, 1000);
      } else {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      }
    }

  }

  clearNewSystem() {
    this.modelNewSystem = {
      id: 0,
      systemid: "",
      sort: "",
      areaname: "",
      systemname: "",
      qty: 1,
      systemtype: "",
      inactive: false,
      deleted: false,
      scopeofwork: "",
      sop: "",
      excludefromsearch: "",
      controldwgname: "",
      controldwgimg: "",
      tagtext: "",
      tagnum: "",
      description: "",
    };

    this.popupEditSystem = false;
    this.addSystemsShowQuickEntryOnly = false;
  }

  goToFindAndReplace() {
    this.router.navigateByUrl(
      `/Estimates/find-replace?estimateid=${this.estimateid}&project=${this.estimatenamestr}&VieneDe=Comissioning`
    );
  }

  changeSystem() {
    this.gochangesystem.emit()
  }

  onItemClick(e) {
    switch (e.itemData.name) {
      case "Add Area":
        this.openNewAreas()
        break
      case "Add System":
        this.openNewSystems()
        break
      case "Import from Excel":
        this.popupImportFromExcel = true
        break
      case "Import IO from Excel":
        this.popupImportFromExcel = true
        break
      case "Import from Library":
        this.goToImportFromLibrary()
        break
      case "Delete Area":
        this.popupDeleteArea = true;
        const dataArea = this.getAreasChecked();
        this.componentModel.data = this.getAreasChecked();

        if (this.componentModel.data.length > 0) {
          for (let i = 0; i < this.componentModel.data.length; i++) {
            this.componentModel.data[i].key = this.componentModel.data[i].originalid
          }
        }

        dataArea.forEach(x => {
          this.componentModel.ID.push(x.key)
        })

        if (this.componentModel.ID.length > 0) {
          this.popupDeleteArea = true;
          setTimeout(() => {
            if (this.treeDelete != undefined) {
              this.componentModel.ID.forEach(x => {
                this.treeDelete.instance.selectItem(x)
              })
            }
          }, 2000);
        } else {
          this.toast.warning("You must select an area")

        }
        break
      case "Delete System":
        this.popupDeleteSystem = true;
        this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x => x >= 1)
        this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x => x.key >= 1)

        if (this.componentModel.ID.length > 0) {
          this.popupDeleteSystem = true;
          setTimeout(() => {
            if (this.treeDelete != undefined) {
              this.componentModel.ID.forEach(x => {
                this.treeDelete.instance.selectItem(x)
              })
            }
          }, 2000);
        } else {
          this.toast.warning("You must select a system")
        }
        break
      case "Clone Area":
        let data = this.getAreasChecked();

        if (data.length == 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
          return;
        }

        let cantadadAEnviar = data.length;
        let cantidadEnviada = 0;



        data.forEach(element => {

          this.estimateService.Insert_AreaDuplicate(element.originalid, this.estimateid).subscribe(result => {
            // this.estimateService.duplicateImage(element.id,result[0].ID)
            // .subscribe(res1=>{
            cantidadEnviada++;

            if (cantidadEnviada == cantadadAEnviar) {
              this.toast.success(this.translate.instant('ModuleSystemToArea.msgArDupSucc'));
              this.reload.emit(this.estimateid);
            }

            // })
          });

        });
        break
      case "Clone System":
        let data1 = this.getChecked();

        if (data1.length == 0) {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
          return;
        }

        let cantadadAEnviar1 = data1.length;
        let cantidadEnviada1 = 0;



        data1.forEach(element => {

          this.estimateService.DuplicateSystemSingle(element.areaid, element.id).subscribe(result => {
            this.estimateService.duplicateImage(element.id, result[0].ID)
              .subscribe(res1 => {
                cantidadEnviada1++;
                if (cantidadEnviada1 == cantadadAEnviar1) {
                  this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysDupSucc'));
                  this.reload.emit(this.estimateid);
                }
              })
          })
        });
        break
      case 'Replicate System':
        this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter(x => x >= 1)
        this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter(x => x.key >= 1)


        if (this.componentModel.ID.length > 0) {
          this.popupReplicateSystem = true;
          setTimeout(() => {
            if (this.treeDelete != undefined) {
              this.componentModel.ID.forEach(x => {
                this.treeDelete.instance.selectItem(x)
              })
            }
          }, 1000);
        } else {
          this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
        }
        break
      case "Edit Area":
        this.rowsToEditArea = [];
        let nodesArea = this.getAreasChecked();


        if (nodesArea && nodesArea.length > 0) {
          // this.modelArea.name = nodesArea.areaname;
          // this.modelArea.id = nodesArea.originalid;
          // this.modelArea.sort = nodesArea.sort;
          // this.modelArea.active = nodesArea.areaactive;


          nodesArea.forEach(node => {
            let AlternateTrueOrFalse = node.Alternate == 1 || node.Alternate == true ? true : false
            this.rowsToEditArea.push({
              name: node.areaname,
              id: node.originalid,
              active: node.areaactive,
              sort: node.sort,
              alternate: AlternateTrueOrFalse,
            })
          });
          this.popupEditArea = true;

        }
        break

      case "Edit System":
        let nodes = this.getChecked();

        if (nodes.length == 1) {
          this.getEstimateArea(this.estimateid)
          this.getSystemType()
          this.popupController = true
          return false
        }

        // this.idsSystem = nodes.map((x) => x.id).join(",")

        // this.popupController = true


        // let nodes1 = this.getChecked();


        this.estimateService
          .GetEstimateAreaSystemInfoCE(nodes.map((x) => x.id).join(","))
          .subscribe((result) => {
            this.rowsToEditAreaSystem = result.map((x) => {
              x.Active = !x.Active;
              x.MarkLib = !x.MarkLib;
              return x;
            });


            this.idsSystem = nodes.map((x) => x.id).join(",")
            setTimeout(() => {
              this.popupEditAreaSystem = true;
            }, 20);
          });

        break
    }
  }

  idsSystem: any

  onItemClickManage(e) {
    switch (e.itemData.name) {
      case "Network view":

        break
      case "Galery View":

        break
      case "Find and Replace":
        this.goToFindAndReplace()
        break
      case "Change system to area":
        this.changeSystem()
        break
      case "":
        break
      case "":
        break
    }
  }

  itemSelected: any
  isItemSelected: boolean = false;

  selectItem(item) {
    this.itemSelected = item
    if (this.systemid != item.itemData.id) { //if agregado en la optimizacion 
      this.onitemchange.emit(item.itemData);
      this.systemid = item.itemData.id > 0 ? item.itemData.id : this.systemid;
      $(".dx-treeview-item").removeClass("currently-active-item");
      $(item.itemElement).addClass("currently-active-item");

    } else {
      this.onitemchange.emit(item.itemData);
    }
  }


  // this.changestep.emit();

  deselectAll() {
    this.treeViewSystemArea.instance.unselectAll()
  }

  onSelectionChange(item) {
    //muestra u oculta el boton eliminar
    this.isItemSelected = item.component.getSelectedNodes().length > 0;
    if (item.node.selected) {
      this.selectItem(item);
    }
  }

  dataTestTempo: any[] = []

  onSelectBoxChanged(event: any, selectBoxName: string) {

    this.dataTestTempo = this.deepClone(this.dataTest);
    this.missingColumnsTempo = [...this.missingColumns]; // Array simple, spread es suficiente


    if (selectBoxName == 'Area Name') {
      this.dataFormatted.data.forEach(element => {
        this.dataTest.forEach(x => {
          if (x.id == element.id) {


            x.areaID = this.areaSelect.some(area => area.ID == element[event.value]) ? Number(element[event.value]) : '',
              x.matchedArea = true
            this.showselectArea = false
            this.iconBack = true
            this.showbackactionAreaName = true
            this.showbackactionSort = false
            this.showbackactionSystemType = false
            this.showbackactionSystemName = false
            this.showbackactionQty = false
            this.showbackactionDescription = false
            this.missingColumns = this.missingColumns.filter(col => col !== event.value)
          }
        });
      });
    } else if (selectBoxName == 'System Type') {
      this.dataFormatted.data.forEach(element => {
        this.dataTest.forEach(x => {
          if (x.id == element.id) {
            x.systemTypeID = element[event.value]
            x.matched = true
            this.iconBack = true
            this.showselectSystemType = false
            this.showbackactionAreaName = false
            this.showbackactionSort = false
            this.showbackactionSystemType = true
            this.showbackactionSystemName = false
            this.showbackactionQty = false
            this.showbackactionDescription = false
            this.missingColumns = this.missingColumns.filter(col => col !== event.value)
          }
        });
      });
    } else if (selectBoxName == 'System Name') {
      this.dataFormatted.data.forEach(element => {
        this.dataTest.forEach(x => {
          if (x.id == element.id) {
            x.name = element[event.value]
            this.showselectSystemName = false
            this.iconBack = true
            this.showbackactionAreaName = false
            this.showbackactionSort = false
            this.showbackactionSystemType = false
            this.showbackactionSystemName = true
            this.showbackactionQty = false
            this.showbackactionDescription = false
            this.missingColumns = this.missingColumns.filter(col => col !== event.value)
          }
        });
      });
    } else if (selectBoxName == 'Sort') {
      this.dataFormatted.data.forEach(element => {
        this.dataTest.forEach(x => {
          if (x.id == element.id) {
            x.sort = element[event.value]
            this.iconBack = true
            this.showselectSort = false
            this.showbackactionAreaName = false
            this.showbackactionSort = true
            this.showbackactionSystemType = false
            this.showbackactionSystemName = false
            this.showbackactionQty = false
            this.showbackactionDescription = false
            this.missingColumns = this.missingColumns.filter(col => col !== event.value)
          }
        });
      });
    } else if (selectBoxName == 'Qty') {
      this.dataFormatted.data.forEach(element => {
        this.dataTest.forEach(x => {
          if (x.id == element.id) {
            x.qty = element[event.value]
            this.iconBack = true
            this.showselectQty = false
            this.showbackactionAreaName = false
            this.showbackactionSort = false
            this.showbackactionSystemType = false
            this.showbackactionSystemName = false
            this.showbackactionQty = true
            this.showbackactionDescription = false
            this.missingColumns = this.missingColumns.filter(col => col !== event.value)
          }
        });
      });
    }








  }

  /** Primer nivel del tree = áreas (sin nodo synthetic estimate). */
  private getGroupItemsTopLevelAreas(): any[] {
    if (!this.groupItems || !Array.isArray(this.groupItems)) {
      return [];
    }
    if (
      this.ModuleFrom === 'Edit Estimate' &&
      this.groupItems.length === 1 &&
      this.groupItems[0] &&
      this.groupItems[0].isEstimateRoot === true &&
      this.groupItems[0].items &&
      Array.isArray(this.groupItems[0].items)
    ) {
      return this.groupItems[0].items;
    }
    return this.groupItems;
  }

  /** En Edit Estimate, un nivel raíz con el nombre del estimate; debajo, las áreas como hasta ahora. */
  private applyEditEstimateRootWrapperIfNeeded(flatAreas: any[]): any[] {
    if (this.ModuleFrom !== 'Edit Estimate' || !flatAreas || !Array.isArray(flatAreas)) {
      return flatAreas;
    }
    const namePart =
      this.estimatenamestr != null && String(this.estimatenamestr).trim() !== ''
        ? String(this.estimatenamestr).trim()
        : '';
    const label = namePart;
    return [
      {
        id: '__estimate_root_' + String(this.estimateid),
        text: label,
        icon: 'fas fa-sitemap c-blue',
        expanded: this.expanded,
        isEstimateRoot: true,
        issystem: false,
        originalid: '__estimate_root__',
        items: flatAreas,
      },
    ];
  }

  agrupar() {
    const unique = [...new Set(this.areas.map(item => item.AreaName))];
    let prueba = unique.map(x => {
      let obj = {
        id: Math.random(),
        originalid: this.areas.find(a => a.AreaName == x).ID,
        sort: this.areas.find(a => a.AreaName == x).AreaSort,

        areaname: x,
        text: this.areas.find(a => a.AreaName == x).AreaSort + '-' + x,
        expanded: this.expanded,
        items: this.areas.filter(a => a.AreaName == x).map(a => {
          return {
            id: a.SystemID,
            text: a.SystemName,
            icon: a.AreaActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
            issystem: true,
            areaid: a.ID,
            path: a.ImagePath,
            SystemActive: a.AreaActive,
            Cubeshopid: a.Cubeshopid
          }
        })
      }

      return obj;
    });

    this.groupItems = this.applyEditEstimateRootWrapperIfNeeded(prueba);
    this.restoreTreeState();

    if (this.groupItems.length > 0) {
      const top = this.getGroupItemsTopLevelAreas();
      if (top.length > 0 && top[0].items && top[0].items.length > 0) {
        this.selectItem({ itemData: top[0].items[0] });
      }
    }

    setTimeout(() => {
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
      if ($(".dx-treeview-item").length > 1) {
        $(".dx-treeview-item").removeClass("currently-active-item");
        $($(".dx-treeview-item")[1]).addClass("currently-active-item");
      }
    }, 1000);
  }

  folderStyle() {
    $(".systamactive").attr("style", "color:green !important");
    $(".systeminactive").attr("style", "color:red !important");
  }

  agrupar2(arr) {
    arr = arr.filter(x => x.ID != null);
    var x = arr.reduce(function (map, node) {
      let parentid = node.ParetID;
      let nodeid = node.ID;
      map.i[nodeid] = node;
      node.items = [];
      if (parentid === null || parentid === 0) {
        map.result.push(node);
      }
      else if (parentid in map.i) {
        map.i[parentid].items.push(node);
      }
      else {
        (parentid in map.cache) ?
          map.cache[parentid].push(node) :
          map.cache[parentid] = [node];
      }
      if (nodeid in map.cache) {
        node.items = node.items.concat(map.cache[nodeid]);
        delete map.cache[nodeid];
      }
      return map;
    }, { i: {}, cache: {}, result: [] }).result;



    let data = x.map(item => {
      let obj
      if (this.changeOfColor == true) {
        obj = {
          id: Math.random(),
          originalid: (item.ID * -1),
          sort: item.Sort,
          areaname: item.Name,
          areaactive: item.AreaActive,
          Cubeshopid: item.Cubeshopid,
          icon: item.AreaActive == 1 ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
          text: item.Sort + '-' + item.Name,
          expanded: this.expanded,
          network: item.HASNETWORK,
          hasTakeoffImage: item.HAS_TAKEOFF_IMAGE,
          Alternate: item.Alternate,
          paretid: item.ParetID == null || item.ParetID === '' ? 0 : item.ParetID,
          items: item.items.map(a => {
            return {
              id: a.ID,
              text: a.Name,
              Cubeshopid: a.Cubeshopid,
              icon: a.HASSCOMPONENTS == 1 && a.AreaActive == true ? 'fas fa-folder systWithComponent' : a.AreaActive == true ? 'fas fa-folder systWithOutComponent' : 'fas fa-folder systeminactive',
              hassComponents: a.HASSCOMPONENTS,
              issystem: true,
              areaid: (a.ParetID * -1),
              path: a.ImagePath,
              Sort: a.Sort,
              SystemActive: a.AreaActive,
              network: a.HASNETWORK,
              hasTakeoffImage: a.HAS_TAKEOFF_IMAGE,
              Alternate: a.Alternate
            }
          })
        }
      } else {
        obj = {
          id: Math.random(),
          originalid: (item.ID * -1),
          sort: item.Sort,
          Cubeshopid: item.Cubeshopid,
          areaname: item.Name,
          areaactive: item.AreaActive,
          icon: item.AreaActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
          text: item.Sort + '-' + item.Name,
          expanded: this.expanded,
          network: item.HASNETWORK,
          hasTakeoffImage: item.HAS_TAKEOFF_IMAGE,
          Alternate: item.Alternate,
          paretid: item.ParetID == null || item.ParetID === '' ? 0 : item.ParetID,
          items: item.items.map(a => {
            return {
              id: a.ID,
              text: a.Name,
              Cubeshopid: a.Cubeshopid,
              icon: a.AreaActive ? 'fas fa-folder systamactive' : 'fas fa-folder systeminactive',
              issystem: true,
              areaid: (a.ParetID * -1),
              path: a.ImagePath,
              Sort: a.Sort,
              SystemActive: a.AreaActive,
              network: a.HASNETWORK,
              hasTakeoffImage: a.HAS_TAKEOFF_IMAGE,
              Alternate: a.Alternate
            }
          })
        }

      }


      return obj;
    });

    this.groupItems = this.applyEditEstimateRootWrapperIfNeeded(data);
    this.restoreTreeState();

    let first = arr.filter(x => x.ID > 0)[0];

    let topAreas = this.getGroupItemsTopLevelAreas();
    let child = topAreas.filter(x => x.items && x.items.length > 0)[0];
    if (child && child.items.length > 0) {
      if (this.systemid != undefined) {
        child.items.forEach(element => {
          if (element.id == this.systemid) {
            this.selectItem({ itemData: element });
          }
        });
      } else {
        this.selectItem({ itemData: child.items[0] });
      }
    }

    setTimeout(() => {
      if (this.FindAndReplace == undefined) {
        if (localStorage.getItem("systemidTree") != undefined) {
          this.treeViewSystemArea.instance.unselectAll()
          this.treeViewSystemArea.instance.selectItem(Number(localStorage.getItem("systemidTree")))
          this.estiloCarpetas()
          localStorage.removeItem("systemidTree")
          setTimeout(() => {
            this.treeViewSystemArea.instance.unselectAll()
            this.SelectASystem(this.systemidParent)
          }, 2000);
        } else {
          // localStorage.removeItem("fromLibrary")
          if (this.systemidParent != 0 && this.systemidParent != undefined) {
            this.treeViewSystemArea.instance.unselectAll()
            this.treeViewSystemArea.instance.selectItem(this.systemidParent)

            setTimeout(() => {
              $(".systamactive").attr("style", "color:green !important");
              $(".systeminactive").attr("style", "color:red !important");
              if ($(".dx-treeview-item").length > 1) {
                $(".dx-treeview-item").removeClass("currently-active-item");
                $(this.itemSelected.itemElement).addClass("currently-active-item");
              }
            }, 800);
          }
        }
      }
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
    }, 2000);

    this.syncTreeViewItemsFromGroupItems();
  }

  // ── estimateTree en localStorage (solo lectura arriba; guardado en expand/collapse) ──
  private estimateTreeExpanded: any[] = [];
  private estimateTreeCollapsed: any[] = [];

  /** Solo lectura — llamar antes de agrupar2. */
  loadEstimateTreeState(): void {
    this.estimateTreeExpanded = [];
    this.estimateTreeCollapsed = [];
    if (!this.estimateid) {
      return;
    }
    try {
      const raw = localStorage.getItem('estimateTree');
      if (!raw) {
        return;
      }
      const saved = JSON.parse(raw);
      if (!saved || Number(saved.estimateid) !== Number(this.estimateid)) {
        return;
      }
      this.estimateTreeExpanded = Array.isArray(saved.expanded) ? saved.expanded.slice() : [];
      this.estimateTreeCollapsed = Array.isArray(saved.collapsed) ? saved.collapsed.slice() : [];
    } catch (e) {}
  }

  private writeEstimateTreeStorage(): void {
    if (!this.estimateid) {
      return;
    }
    localStorage.setItem(
      'estimateTree',
      JSON.stringify({
        estimateid: this.estimateid,
        expanded: this.estimateTreeExpanded,
        collapsed: this.estimateTreeCollapsed,
      })
    );
  }

  private findTreeNodeIdByOriginalid(originalid: any): any {
    const walk = (nodes: any[]): any => {
      if (!nodes || !nodes.length) {
        return null;
      }
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (!n) {
          continue;
        }
        if (n.originalid === originalid || String(n.originalid) === String(originalid)) {
          return n.id;
        }
        if (n.items && n.items.length) {
          const found = walk(n.items);
          if (found != null) {
            return found;
          }
        }
      }
      return null;
    };
    return walk(this.groupItems || []);
  }

  restoreTreeState(): void {
    if (!this.estimateTreeExpanded.length && !this.estimateTreeCollapsed.length) {
      return;
    }
    const self = this;
    const attempt = function (retriesLeft: number) {
      if (!self.treeViewSystemArea || !self.treeViewSystemArea.instance) {
        if (retriesLeft > 0) {
          setTimeout(function () { attempt(retriesLeft - 1); }, 400);
        }
        return;
      }
      const tree = self.treeViewSystemArea.instance;
      self.estimateTreeCollapsed.forEach(function (originalid) {
        const runtimeId = self.findTreeNodeIdByOriginalid(originalid);
        if (runtimeId != null) {
          tree.collapseItem(runtimeId);
        }
      });
      self.estimateTreeExpanded.forEach(function (originalid) {
        const runtimeId = self.findTreeNodeIdByOriginalid(originalid);
        if (runtimeId != null) {
          tree.expandItem(runtimeId);
        }
      });
    };
    setTimeout(function () { attempt(5); }, 600);
  }

  onItemExpanded(ev?: any) {
    setTimeout(() => {
      $(".systamactive").attr("style", "color:green !important")
      $(".systeminactive").attr("style", "color:red !important")
    }, 500);
    const originalid = ev && ev.itemData ? ev.itemData.originalid : null;
    if (originalid == null || originalid === '' || String(originalid).indexOf('__estimate_root') === 0) {
      return;
    }
    if (ev && ev.itemData) {
      this.estimateTreeCollapsed = this.estimateTreeCollapsed.filter(function (x) {
        return x !== originalid && String(x) !== String(originalid);
      });
      if (this.estimateTreeExpanded.indexOf(originalid) < 0) {
        this.estimateTreeExpanded.push(originalid);
      }
      this.writeEstimateTreeStorage();
    }
  }

  onItemCollapsed(ev?: any) {
    const originalid = ev && ev.itemData ? ev.itemData.originalid : null;
    if (originalid == null || originalid === '' || String(originalid).indexOf('__estimate_root') === 0) {
      return;
    }
    if (ev && ev.itemData) {
      this.estimateTreeExpanded = this.estimateTreeExpanded.filter(function (x) {
        return x !== originalid && String(x) !== String(originalid);
      });
      if (this.estimateTreeCollapsed.indexOf(originalid) < 0) {
        this.estimateTreeCollapsed.push(originalid);
      }
      this.writeEstimateTreeStorage();
    }
  }

  getChecked() {
    let nodes = this.treeViewSystemArea.instance.getSelectedNodes();
    let data = nodes.map(x => x.itemData).filter(f => f.issystem)
    return data;
  }

  getAreasChecked() {
    let nodes = this.treeViewSystemArea.instance.getSelectedNodes();
    const self = this;
    let data = nodes.map(x => x.itemData).filter(function (f) {
      return f && self.isTreeviewAreaItem(f);
    });
    return data
  }

  getSystemsChecked() {
    let nodes = this.treeViewSystemArea.instance.getSelectedNodes();
    let data = nodes.map(x => x.itemData).filter(f => this.isTreeviewSystemItem(f));
    return data
  }


  closeParents() {
    this.treeViewSystemArea.instance.collapseAll()
    this.OpenOrClose = false
    this.userService.Get_UserSettingsCE(localStorage.getItem("customerid")).subscribe(result => {
      let obj = JSON.parse(result[0].CLIENTUSERSETTING);

      obj.openTreeEstimate = false
      let data = {
        usersettings: JSON.stringify(obj)
      }
      this.userService.saveUserSettingCoor(data).subscribe(result => {
        this.estiloCarpetas()
      })
    })
  }

  estiloCarpetas() {
    if (this.changeOfColor) {
      $(".systWithOutComponent").attr("style", "color:green !important");
      $(".systWithComponent").attr("style", "color:#ffc107 !important");
    } else {
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
    }
    if ($(".dx-treeview-item").length > 1) {
      $(".dx-treeview-item").removeClass("currently-active-item");
      $($(".dx-treeview-item")[1]).addClass("currently-active-item");
    }
  }
  // "{"dateFormat":"MM/dd/yyyy","moneyFormat":"$","startPage":"/projects","estimateidDefault":1717,"method":"update_UserSettingsCoor","DefaultSystemType":"9","map":"Santo Domingo de los Tsachilas, Ecuador"}"

  OpenParents() {
    this.treeViewSystemArea.instance.expandAll()
    this.OpenOrClose = true

    this.userService.Get_UserSettingsCE(localStorage.getItem("customerid")).subscribe(result => {
      let obj = JSON.parse(result[0].CLIENTUSERSETTING);

      obj.openTreeEstimate = true
      let data = {
        usersettings: JSON.stringify(obj)
      }
      this.userService.saveUserSettingCoor(data).subscribe(result => {

        this.estiloCarpetas()

      })

    })

    this.onItemExpanded()
    setTimeout(() => {
      $(".systamactive").attr("style", "color:green !important");
      $(".systeminactive").attr("style", "color:red !important");
      if ($(".dx-treeview-item").length > 1) {
        $(".dx-treeview-item").removeClass("currently-active-item");
        $($(".dx-treeview-item")[1]).addClass("currently-active-item");
      }
    }, 1000);

  }

  SelectASystem(id) {
    this.treeViewSystemArea.instance.selectItem(id)

    this.estiloCarpetas()

    this.treeViewSystemArea.instance.expandItem(id)

  }

  syncTreeViewSelection(e) {

    var component =
      (e && e.component) || (this.treeView && this.treeView.instance);

    if (!component) return;

    if (!this.treeBoxValue) {
      component.unselectAll();
    }

    if (this.treeBoxValue) {
      this.treeBoxValue.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }
  }

  treeView_itemSelectionChanged(e) {
    // this.modelSystemInformation.systemtype = e.itemData.SystemType
    // this.modelSystemInformation.SystemTypeid = e.itemData.ID
    this.treeBoxValue = e.component.getSelectedNodeKeys();
  }

  showImagesEstimate() {
    localStorage.removeItem("systemidTree")
    if (this.systemid != undefined) {
      localStorage.setItem("systemidTree", this.systemid.toString())
    }
    this.changeviewImages.emit(this.groupItems)
  }

  syncTreeViewSelection2(e) {
    var component =
      (e && e.component) || (this.treeView2 && this.treeView2.instance);

    if (!component) return;

    if (!this.treeBoxValue2) {
      component.unselectAll();
    }

    if (this.treeBoxValue2) {
      this.treeBoxValue2.forEach(
        function (value) {
          component.selectItem(value);
        }.bind(this)
      );
    }

    if (this.componentModel.ID.length > 0) {
      setTimeout(() => {
        if (this.treeDelete != undefined) {
          this.componentModel.ID.forEach(x => {
            if (this.popupDeleteArea) {
              this.treeDelete.instance.selectItem(x.originalid * -1)
            } else {
              this.treeDelete.instance.selectItem(x)
            }
          })
        }
      }, 1000);
    }
  }

  treeView_itemSelectionChanged2(e) {
    //  && this.notAllowed == false
    if (e.itemElement != undefined) {
      this.componentModel.ID = e.component.getSelectedNodeKeys()
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();
    } else {
      // this.notAllowed = false
    }

    // && this.notAllowed == false && this.FirtsTime 
    if (e.itemElement != undefined) {
      // this.componentModel.tagid = e.itemData.ID
      this.componentModel.ID = e.component.getSelectedNodeKeys();
      this.treeBoxValue2 = e.component.getSelectedNodeKeys();
      // this.FirtsTime = false
    }


  }

  cancelDelete() {
    this.popupDeleteSystem = false;
    this.popupDeleteArea = false;
    this.componentModel.ID = []
    if (this.treeDelete != undefined) {
      this.treeDelete.instance.unselectAll()
    }
  }

  DeleteSystemsOrArea() {
    if (this.popupDeleteSystem) {
      let data = this.getChecked();

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      //   return;
      // }

      let cantadadAEnviar = this.componentModel.ID.length;
      let cantidadEnviada = 0;
      this.componentModel.ID.forEach(element => {
        this.estimateService.DeleteSystem(element).subscribe(result => {
          cantidadEnviada++;

          if (cantidadEnviada == cantadadAEnviar) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgDelSys'));
            this.popupDeleteSystem = false;
            this.getEstimateArea(this.estimateid);
            this.cancelDelete()


            this.MapInformationService.SaveInfoSites({ method: "Get_AreaSystemAllCE2", estimateid: this.estimateid }).subscribe(resp => {
              let contador = 0
              resp.forEach(x => {
                if (x.ID > 0) {
                  contador++
                }
              });
              if (contador == 0) {
                window.location.reload();
              } else {
                this.reload.emit(this.estimateid);
                this.deletedSystemOrArea.emit();
                resp.forEach(x => {
                  if (x.ID > 0) {
                    this.treeViewSystemArea.instance.selectItem(x.ID)
                  }
                });

              }
            });



            // if (this.groupItems != undefined) {
            //   if (this.groupItems.length > 0) {
            //     if (this.groupItems[0].items.length > 0) {
            //       if (this.groupItems[0].items.length == 1) {

            //         this.deletedSystemOrArea.emit();
            //         this.reload.emit(this.estimateid);
            //         // window.location.reload();
            //         // return false
            //       }
            //       let contador = 0
            //       this.groupItems[0].items.forEach((x) => {
            //         if (contador == 0 && x.id != element) {
            //           this.treeViewSystemArea.instance.selectItem(x.id)
            //           this.reload.emit(this.estimateid);
            //           contador++
            //           return false;
            //         }
            //       });
            //     }
            //   }
            // }
          }
        })
      });
    }

    if (this.popupDeleteArea) {
      let data = this.getAreasChecked();

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      //   return;
      // }

      let cantadadAEnviar = this.componentModel.ID.length;
      let cantidadEnviada = 0;


      this.componentModel.ID.forEach(element => {

        this.estimateService.DeleteArea(element).subscribe(result => {
          cantidadEnviada++;

          if (cantidadEnviada == cantadadAEnviar) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgAreDelSucc'));
            // this.reload.emit(this.estimateid);
            // this.getEstimateArea(this.estimateid);
            this.popupDeleteArea = false;
            this.getEstimateArea(this.estimateid, true);
            this.cancelDelete()
            if (this.groupItems != undefined) {
              const topAreas = this.getGroupItemsTopLevelAreas();
              if (topAreas.length > 0) {
                if (topAreas.length == 1) {
                  this.deletedSystemOrArea.emit();
                  return false
                }

                let contador = 0
                topAreas.forEach((x) => {
                  if (contador == 0 && x.originalid != element && x.items && x.items.length > 0) {
                    this.treeViewSystemArea.instance.selectItem(x.items[0].id)
                    this.reload.emit(this.estimateid);
                    contador++
                    return false;
                  }
                });
              }
            }
          }
        });

      });
    }
  }

  DuplicateSystemsOrArea() {


    if (this.popupDeleteArea) {
      // this.popupEditArea = true;

      let data = this.getAreasChecked();

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      //   return;
      // }

      let cantadadAEnviar = this.componentModel.ID.length;
      let cantidadEnviada = 0;


      this.componentModel.ID.forEach(element => {


        this.estimateService.Insert_AreaDuplicate(element, this.estimateid).subscribe(result => {
          // this.estimateService.duplicateImage(element.id,result[0].ID)
          // .subscribe(res1=>{
          cantidadEnviada++;

          if (cantidadEnviada == cantadadAEnviar) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgArDupSucc'));
            this.reload.emit(this.estimateid);
            this.popupDeleteSystem = false;
            this.cancelDelete()
          }

          // })
        });

      });
    } else if (this.popupDeleteSystem) {

      let data = []
      if (this.treeDelete != undefined) {
        let nodes = this.treeDelete.instance.getSelectedNodes();
        data = nodes.map(x => x.itemData).filter(f => f.ParetID != undefined)
      } else {
        data = this.getChecked();
      }
      let dataFinal = []
      this.componentModel.ID.forEach(x => {
        data.forEach(y => {
          if (x == y.id || x == y.ID) {
            dataFinal.push(y)
          }

        })
      })

      // if (data.length == 0) {
      //   this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      //   return;
      // }

      let cantadadAEnviar = dataFinal.length;
      let cantidadEnviada = 0;

      dataFinal.forEach(element => {

        this.estimateService.DuplicateSystemSingle(element.areaid != undefined ? element.areaid : element.ParetID * -1, element.id != undefined ? element.id : element.ID).subscribe(result => { //debes buscar el area id
          this.estimateService.duplicateImage(element.id, result[0].ID)
            .subscribe(res1 => {
              cantidadEnviada++;
              if (cantidadEnviada == cantadadAEnviar) {
                this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysDupSucc'));
                this.reload.emit(this.estimateid);
                this.popupDeleteArea = false;
                this.cancelDelete()
              }
            })
        })
      });
    } else if (this.popupReplicateSystem) {
      // let data = this.getChecked();

      //   if (data.length == 0) {
      //     this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      //     return;
      //   }


      if (this.totalReplicate <= 0) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgRepNum'));
        return;
      }

      let cantadadAEnviar = this.componentModel.ID.length;
      let cantidadEnviada = 0;

      this.componentModel.ID.forEach(element => {


        this.estimateService.ReplicateeEstimateSystems(element, this.totalReplicate).subscribe(result => {
          // this.estimateService.duplicateImage(element.id,result[0].ID)
          // .subscribe(res1=>{
          cantidadEnviada++;
          if (cantidadEnviada == cantadadAEnviar) {
            this.toast.success(this.translate.instant('ModuleSystemToArea.msgRepSucc'));
            this.reload.emit(this.estimateid);
            this.totalReplicate = 0;
            this.popupReplicateSystem = false;
          }
        })
        // })
      });
    }

  }

  closeReplicar() {
    this.totalReplicate = 1
    this.popupReplicateSystem = false;
    this.cancelDelete()
  }

  dataDifferenceLabor: any[] = []

  OpenDiference() {
    let keys = this.treeViewSystemArea.instance.getSelectedNodeKeys()
    let idsFinal = []
    keys.forEach(x => {
      if (1 < x) {
        idsFinal.push(x)
      }
    })
    this.MapInformationService.SaveInfoSites({ method: "GetEstimateAreaSystemSugestedLaborMultSystems", systemid: idsFinal.join(",") }) //29779
      .subscribe(resp => {
        this.dataDifferenceLabor = resp
      })
  }

  openModalDiference() {
    this.showModalDiferencia = true
  }

  prepareRowPartLabor(info) {
    if (info.rowType === "data") {
      if (info.data.Est_Dif == 0) {
        info.rowElement.className = info.rowElement.className + ' checkbox-none'
      }
    }
  }

  NewLabor(data) {
    this.MapInformationService.SaveInfoSites({ method: "CreateSystemDetailFromDetailID", detailid: data.DetailID, laborid: data.LaborID, qty: data.TotalNewQty, systemid: data.SystemID })
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
        // this.showModalDiferencia = false
        this.OpenDiference()
        // this.reload.emit(this.estimateid);
      })
  }

  UpdateLabor(data) {
    this.MapInformationService.SaveInfoSites({ method: "CreateSystemDetailFromDetailID", detailid: data.DetailID, laborid: data.LaborID, qty: data.TotalNewQty, systemid: data.SystemID })
      .subscribe(resp => {
        this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
        // this.showModalDiferencia = false
        this.OpenDiference()
        // this.reload.emit(this.estimateid);
      })
  }

  UpdateSelected() {
    const data = this.gridLabor.instance.getSelectedRowsData()
    if (data.length > 0) {
      let contador = 0
      data.forEach(info => {
        if (info.Est_Dif != 0) {
          this.MapInformationService.SaveInfoSites({ method: "CreateSystemDetailFromDetailID", detailid: info.DetailID, laborid: info.LaborID, qty: info.TotalNewQty, systemid: info.SystemID })
            .subscribe(resp => {
              contador++
              if (contador == data.length) {
                this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
                this.OpenDiference()
                // this.reload.emit(this.estimateid);
                this.gridLabor.instance.deselectAll()
              }
            })
        } else {
          contador++
          if (contador == data.length) {
            this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
            this.OpenDiference()
            // this.reload.emit(this.estimateid);
            this.gridLabor.instance.deselectAll()
          }
        }
      })
    } else {
      this.toast.warning(this.translate.instant('ModuleEditEstimate.msgLeasReg'));
    }
  }

  UpdateAll() {
    if (this.dataDifferenceLabor.length > 0) {
      let contador = 0
      this.dataDifferenceLabor.forEach(info => {
        if (info.Est_Dif != 0) {
          this.MapInformationService.SaveInfoSites({ method: "CreateSystemDetailFromDetailID", detailid: info.DetailID, laborid: info.LaborID, qty: info.TotalNewQty, systemid: info.SystemID })
            .subscribe(resp => {
              contador++
              if (contador == this.dataDifferenceLabor.length) {
                this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
                this.OpenDiference()
                // this.reload.emit(this.estimateid);
                this.gridLabor.instance.deselectAll()
              }
            })
        } else {
          contador++
          if (contador == this.dataDifferenceLabor.length) {
            this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
            this.OpenDiference()
            // this.reload.emit(this.estimateid);
            this.gridLabor.instance.deselectAll()
          }
        }
      })
    } else {
      this.toast.warning(this.translate.instant('ModuleEditEstimate.msgRegUpdate'));
    }
  }

  goToTutorial(id) {
    // let id = "ibtVDO1"
    // this.router.navigateByUrl()

    let url = window.location.href.split("#");
    let finalUrl = url[0] + `#/videoTutorial?numVideo=${id}`;
    window.open(finalUrl, "_blank");

  }

  dataTest: any[] = [
    {
      id: 0,
      areaID: 1,
      systemTypeID: 1,
      name: "",
      sort: 1,
      qty: 1,
      sytemOrigin: null,
      description: null
    }
  ]

  systemTypeMultipleData: any[] = []
  idAreaxDefault: any
  openNewSystems(preferredAreaId?: number, quickEntryOnly = false) {
    this.addSystemsShowQuickEntryOnly = quickEntryOnly;
    this.popupNewSystem = true;
    this.getEstimateArea(this.estimateid, false, preferredAreaId);
    this.getSystemTypeMultiple();
  }

  closeAddMultipleSystem() {

    this.dataTest = [
      {
        id: 0,
        areaID: this.idAreaxDefault,
        systemTypeID: 1,
        name: "",
        sort: 1,
        qty: 1
      }
    ]
    // this.onFileRemove()
    this.dataFormatted = {
      headers: [],
      data: []
    }
    this.hasUploadedFile = false;
    this.dataTest = []

    this.showselectArea = false
    this.showselectSystemType = false
    this.showselectSystemName = false
    this.showselectSort = false
    this.showselectQty = false
    this.showselectSystemOrigin = false
    this.showbackactionAreaName = false
    this.showbackactionSystemType = false
    this.showbackactionSystemName = false
    this.showbackactionSort = false
    this.showbackactionQty = false
    this.showbackactionDescription = false
    this.missingColumns = []
    this.iconBack = false
    this.dataTest = []
    this.hasUploadedFile = false;
    this.showselectArea = false
    this.popupNewSystem = false
    this.showExcelInputElement = false;
    this.showAIInputElement = false;
    this.hasUploadedFile = false;
    this.addSystemsShowQuickEntryOnly = false;

  }

  async SaveSystemMultiples() {
    if (this.dataTest.length <= 0) {
      return;
    }

    let stop = false;
    for (const x of this.dataTest) {
      if (x.areaID == undefined || x.areaID == '' || x.name == undefined || x.name == '') {
        stop = true;
        this.toast.warning("All records must have an assigned area and name");
      }
    }

    if (stop) {
      this.toast.warning("All records must have an assigned area");
      return;
    }

    let lastModel: any;
    try {
      for (const x of this.dataTest) {
        if (x.sytemOrigin != undefined) {
          const masterResp: any[] = await this.MapInformationService.SaveInfoSites({
            method: "Get_ControllerMasterData",
            systemid: x.sytemOrigin
          }).toPromise();
          if (masterResp.length > 0) {
            x.CONTROLDWGNAME = masterResp[0].CONTROLDWGNAME;
          }
        }

        const model = {
          method: "Insert_EstimateCreateNewSystemCE",
          id: this.estimateid,
          systemid: 0,
          sort: x.sort,
          areaname: x.areaID,
          systemname: x.name,
          qty: x.qty,
          systemtype: x.systemTypeID,
          inactive: 0,
          deleted: 0,
          scopeofwork: 0,
          sop: "",
          excludefromsearch: "",
          controldwgname: x.CONTROLDWGNAME != undefined ? x.CONTROLDWGNAME : "",
          controldwgimg: "",
          tagtext: "",
          tagnum: "",
          description: "",
          idNewSystem: 0,
        };

        const insertResp: any[] = await this.MapInformationService.SaveInfoSites(model).toPromise();
        const resultId = insertResp[0].resultID;

        if (x.base64 != undefined && x.base64 != "") {
          await this.estimateService.SaveImageSystem(x.base64, resultId).toPromise();
        }

        if (x.sytemOrigin != undefined) {
          await this.MapInformationService.SaveInfoSites({
            method: "ImportintoSystemSingle",
            systemid: x.sytemOrigin,
            newsystemid: resultId
          }).toPromise();
          await this.estimateService.duplicateImage(x.sytemOrigin, resultId).toPromise();
        }

        model.idNewSystem = resultId;
        lastModel = model;
      }

      this.toast.success("Created Successfully");
      this.popupNewSystem = false;
      this.showProcessedSystemsModal = false;
      this.dataTest = [
        {
          id: 0,
          areaID: this.idAreaxDefault,
          systemTypeID: 1,
          name: "",
          sort: 1,
          qty: 1
        }
      ];
      this.returnWithInfo.emit(lastModel);
      this.closeStepper.emit();
      this.reload.emit();
      this.showExcelInputElement = false;
      this.hasUploadedFile = false;
    } catch {
      this.toast.error("Error creating systems");
    }
  }

  newSystemMultiple() {
    let dataTempo = [...this.dataTest]
    const newSort = this.dataTest[this.dataTest.length - 1].sort + 1
    dataTempo.push({
      id: this.dataTest.length++,
      areaID: this.idAreaxDefault,
      systemTypeID: 1,
      name: "",
      sort: newSort,
      qty: 1,
      matchedArea: true,
      matched: true,
    })
    this.dataTest = dataTempo
  }

  getSystemTypeMultiple(done?: () => void) {
    this.MapInformationService.SaveInfoSites({ method: "Get_EstimateSytemTypeCreateSystem" })
      .subscribe(resp => {
        this.systemTypeMultipleData = resp
        if (done) { done(); }
      })

  }

  deletesystemMultipleDrawing(data) {
    // if (this.dataDrawingTempo.length > 1) {
    const dataTempo = this.dataDrawingTempo.filter(x => x.id != data.id)
    this.dataDrawingTempo = dataTempo
    // }
  }


  deletesystemMultiple(data) {
    // if (this.dataTest.length > 1) {
    const dataTempo = this.dataTest.filter(x => x.id != data.id)
    this.dataTest = dataTempo
    // }
  }

  // javascript create JSON object from two dimensional Array
  arrayToJSONObject(arr) {
    // header
    const keys = arr[0];

    // vacate keys from main array
    const newArr = arr.slice(1, arr.length);

    const formatted = [];
    const data = newArr;
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      const o = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  dataFormatted = { headers: [], data: [] };
  onFileRemove() {
    this.dataFormatted = {
      headers: [],
      data: []
    }
    this.hasUploadedFile = false;
    this.dataTest = []

    this.showselectArea = false
    this.showselectSystemType = false
    this.showselectSystemName = false
    this.showselectSort = false
    this.showselectQty = false
    this.showselectSystemOrigin = false
    this.showbackactionAreaName = false
    this.showbackactionSystemType = false
    this.showbackactionSystemName = false
    this.showbackactionSort = false
    this.showbackactionQty = false
    this.showbackactionDescription = false
    this.missingColumns = []
    this.iconBack = false
    this.dataTest = []
    this.dataFormatted = {
      headers: [],
      data: []
    }
    this.hasUploadedFile = false;
    this.showselectArea = false

  }

  fileData: any[][] = [];
  hasUploadedFile: boolean = false;
  showProgressPopup: boolean = false;
  progressInfo: any = {
    total: 0,
    completed: 0,
    percentage: 0,
    currentStatus: ''
  };

  showButtonProcessExcel: boolean = false;


  onFileAdd(obj: File) {
    // Validate if the file is an Excel file
    const validExcelTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'application/vnd.ms-excel.template.macroEnabled.12'
    ];

    const validExtensions = ['.xls', '.xlsx', '.xlsm', '.xltx'];
    const fileExtension = obj.name.toLowerCase().substring(obj.name.lastIndexOf('.'));

    if (!validExcelTypes.includes(obj.type) && !validExtensions.includes(fileExtension)) {
      this.showButtonProcessExcel = false;
      // this.toast.error('Please upload a valid Excel file (.xls, .xlsx, .xlsm, .xltx)');
      // No es un excel 
      this.hasUploadedFile = true;
      if (obj.type === 'application/pdf') {
        this.uploadedPdfFile = obj;
        this.aiSessionInfo.status = 'PDF Uploaded';
        this.toast.success('PDF file uploaded successfully');

        // Convert file to base64
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.uploadedPdfBase64 = e.target.result;
        };
        reader.readAsDataURL(obj);
      }
    } else {

      this.showButtonProcessExcel = true;

      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
        try {
          /* read workbook */
          const bstr: string = e.target.result;
          const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

          /* grab first sheet */
          const wsname: string = wb.SheetNames[0];
          const ws: XLSX.WorkSheet = wb.Sheets[wsname];

          /* save data */
          let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
          data = data.filter(x => x.length > 0);
          this.fileData = data;
          this.dataFormatted.headers = data[0];

          this.dataFormatted.data = this.arrayToJSONObject(data);
          if (this.dataFormatted.data.length > 0) {
            this.dataFormatted.data.forEach((element, index) => {
              element.id = index + 1
            });
          }
          this.hasUploadedFile = true;
        } catch (error) {
          this.toast.error('Error reading Excel file. Please make sure it is a valid Excel file.');
          console.error('Error reading Excel file:', error);
          this.hasUploadedFile = false;
        }
      };
      reader.readAsBinaryString(obj);

    }

  }

  columnExcel = [
    'id',
    'Area ID',
    'System Type',
    'System Name',
    'Sort',
    'Qty',
    'System Origin',
    "Description"
  ]

  missingColumns: any[] = []


  processDataexcel() {
    if (this.dataFormatted.data.length > 0) {
      let dataTempo = [...this.dataTest]
      // let newid = this.dataTest[this.dataTest.length - 1].id + 1

      // Mostrar todas las keys únicas
      const allKeys = new Set();
      this.dataFormatted.data.forEach(x => {
        Object.keys(x).forEach(key => allKeys.add(key))
      })



      // Crear variable con las palabras que están en allKeys pero no en this.columnExcel
      this.missingColumns = Array.from(allKeys).filter((column: string) => !this.columnExcel.includes(column));


      // Crear variable con las palabras que están en this.columnExcel pero no en allKeys
      const columnMatched = this.columnExcel.filter(column => !allKeys.has(column));


      //   [
      //     "area",
      //     "system name",
      //     "origin"
      // ]


      this.showselectArea = columnMatched.includes('Area ID'),
        this.showselectSystemType = columnMatched.includes('System Type'),
        this.showselectSystemName = columnMatched.includes('System Name'),
        this.showselectSort = columnMatched.includes('Sort'),
        this.showselectQty = columnMatched.includes('Qty'),
        this.showselectSystemOrigin = columnMatched.includes('System Origin'),



        this.dataFormatted.data.forEach((x) => {
          dataTempo.push({
            id: x.id,
            areaID: this.areaSelect.some(area => area.ID == x['Area ID']) ? Number(x['Area ID']) : '',
            matchedArea: this.areaSelect.some(area => area.ID == x['Area ID']) ? true : false,
            systemTypeID: this.systemTypeMultipleData.some(type => type.ID == x['System Type']) ? Number(x['System Type']) : '',
            matched: this.systemTypeMultipleData.some(type => type.ID == x['System Type']) ? true : false,
            name: x['System Name'],
            sort: x['Sort'],
            qty: x['Qty'],
            sytemOrigin: x['System Origin'],
            Description: x['Description'],




          })
        })
      this.dataTest = dataTempo
    }
  }

  selectAreaByDefault() {
    this.dataTest.forEach(element => {
      element.areaID = this.areaSelect[0].ID
      element.matchedArea = true
    })
  }

  selectTypeByDefault() {
    this.dataTest.forEach(element => {
      element.systemTypeID = this.systemTypeMultipleData[0].ID
      element.matched = true
    })
  }

  showExcelInputElement: boolean = false;
  showExcelInput() {
    this.showExcelInputElement = true;
    this.showAIInputElement = false;
  }

  showAIInputElement: boolean = false;
  /** Controla el modal "Start with CUBE AI" (opciones de AI Processing) del estimate root. */
  startWithCubeAIVisible: boolean = false;
  showAIInput() {
    this.showAIInputElement = true;
    this.showExcelInputElement = false;
  }

  closeExcelUpload() {
    this.showExcelInputElement = false;
    this.showAIInputElement = false;
  }

  private deepClone(obj: any): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (obj instanceof Date) {
      return new Date(obj.getTime());
    }

    if (Array.isArray(obj)) {
      return obj.map(item => this.deepClone(item));
    }

    const clonedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = this.deepClone(obj[key]);
      }
    }

    return clonedObj;
  }

  processExcel() {
    this.processDataexcel();
    this.toast.success('Excel file processed successfully!');
  }

  processPlanWithAI() {
    // Close the current popup and open the AI processing popup
    this.popupNewSystem = false;
    this.popupAIProcessing = true;
  }

  updateProgress(completed: number, total: number, status: string = '') {
    this.progressInfo.completed = completed;
    this.progressInfo.total = total;
    this.progressInfo.percentage = total > 0 ? Math.round((completed / total) * 100) : 0;
    this.progressInfo.currentStatus = status;
  }

  showProgressBar() {
    this.showProgressPopup = true;
  }
  window: any = window;

  hideProgressBar() {
    this.showProgressPopup = false;
    this.progressInfo = {
      total: 0,
      completed: 0,
      percentage: 0,
      currentStatus: ''
    };
  }

  // Area

  AreaTypeMultipleData: any[] = []
  dataArea: any[] = [
    {
      id: 0,
      name: "",
      sort: 1,
      alternate: false,
    }
  ]

  popupNewArea: boolean = false

  /** Modal galería: componentes sugeridos (GetMostPairedComponents) */
  popupAddComponentsGallery = false;
  addComponentsGalleryLoading = false;
  addComponentsGalleryItems: any[] = [];
  addComponentsGallerySystemId: any = null;
  /** Selección múltiple para el modal estilo galería. */
  addComponentsGallerySelectedRows: any[] = [];
  /** ComponentIds ya asignados al sistema (GetEstimateAreaSystemComponentsList) → se preseleccionan con CSS distinto. */
  addComponentsGalleryPreselectedIds: string[] = [];
  /** Confirmación al hacer click en un componente ya presente en el sistema. */
  showAlreadyInSystemConfirm: boolean = false;
  alreadyInSystemPendingComponent: any = null;
  addComponentsGallerySystemLabel = '';
  addComponentsGalleryAreaLabel = '';
  addComponentsGalleryInserting = false;
  addComponentsGalleryBudgetUsed = 0;
  addComponentsGalleryBudgetTotal = 0;
  addComponentsGalleryFilter = '';
  addComponentsGalleryFilteredItems: any[] = [];
  private _galleryFilterTimer: any = null;

  /** Tab activo del modal Add Components: 'suggested' | 'library' */
  activeGalleryTab: 'suggested' | 'library' = 'suggested';

  /** Librería completa de componentes (Get_EstimateLibComponentsTreeCE) */
  galleryLibLoading = false;
  galleryLibLoaded = false;
  galleryLibCategories: Array<{ id: any; name: string; count: number }> = [];
  galleryLibSelectedCategoryId: any = null;
  galleryLibFilter = '';
  galleryLibFilteredItems: any[] = [];
  private _galleryLibAllComponents: any[] = [];
  private _galleryLibReadyCallbacks: Array<{ ok: () => void; err: () => void }> = [];

  /** Tipos del sidebar */
  galleryLibTypeTree: any[] = [];
  galleryLibItems: any[] = [];
  galleryLibCatSearch = '';
  galleryLibTreeExpanded = false;
  private _galleryLibTypeMap: { [id: string]: any } = {};

  // ── Library tab navigation state ──────────────────────────────────────────
  galleryLibNavL1Id: any = null;
  /** Stack of nodes navigated into from L2 downward (supports unlimited depth). */
  galleryLibNavStack: any[] = [];

  get galleryLibNavL1(): any[] { return this.galleryLibTypeTree; }

  get galleryLibNavL2(): any[] {
    if (this.galleryLibNavL1Id == null) return [];
    const n = this.galleryLibTypeTree.find((x: any) => x.id === this.galleryLibNavL1Id);
    return n ? n.children : [];
  }

  /** The deepest node currently selected in the nav stack. */
  get galleryLibNavCurrentNode(): any {
    if (this.galleryLibNavStack.length === 0) return null;
    return this.galleryLibNavStack[this.galleryLibNavStack.length - 1];
  }

  selectGalleryLibNavL1(node: any): void {
    if (node.id === '__selected__') {
      // Enter selected mode: reset nav to root so cards show top-level categories
      this.galleryLibInSelectedMode = true;
      this.galleryLibNavStack = [];
      this.setGalleryLibCategory(this.galleryLibNavL1Id);
      return;
    }
    this.galleryLibInSelectedMode = false;
    this.galleryLibNavL1Id = node.id;
    this.galleryLibNavStack = [];
    this.setGalleryLibCategory(node.id);
  }

  /** "All" card clicked — filter to current node, no stack change. */
  selectGalleryLibNavLeaf(node: any): void {
    this.galleryLibInSelectedMode = false;
    if (node) { this.setGalleryLibCategory(node.id); }
  }

  /** Card clicked — always push node onto stack and filter. */
  galleryLibNavSelectCard(node: any): void {
    this.galleryLibInSelectedMode = false;
    this.galleryLibNavStack = [...this.galleryLibNavStack, node];
    this.setGalleryLibCategory(node.id);
  }

  /** Back button — pop one level from the stack. */
  galleryLibNavGoBack(): void {
    this.galleryLibInSelectedMode = false;
    if (this.galleryLibNavStack.length > 1) {
      this.galleryLibNavStack = this.galleryLibNavStack.slice(0, -1);
      this.setGalleryLibCategory(this.galleryLibNavStack[this.galleryLibNavStack.length - 1].id);
    } else {
      this.galleryLibNavStack = [];
      this.setGalleryLibCategory(this.galleryLibNavL1Id);
    }
  }

  /** Breadcrumb click — jump to a specific depth in the stack. */
  galleryLibNavGoTo(index: number): void {
    this.galleryLibInSelectedMode = false;
    this.galleryLibNavStack = this.galleryLibNavStack.slice(0, index + 1);
    this.setGalleryLibCategory(this.galleryLibNavStack[index].id);
  }

  /** Items shown in the current card grid level. */
  get galleryLibNavCurrentItems(): any[] {
    if (this.galleryLibNavStack.length === 0) return this.galleryLibNavL2;
    const node = this.galleryLibNavCurrentNode;
    return (node && node.children) ? node.children : [];
  }

  galleryLibInSelectedMode: boolean = false;
  showClearSelectionConfirm: boolean = false;
  clearGalleryLibSelection(): void { this.addComponentsGallerySelectedRows = []; }
  confirmClearGalleryLibSelection(): void {
    this.addComponentsGallerySelectedRows = [];
    this.showClearSelectionConfirm = false;
    this.galleryLibInSelectedMode = false;
  }

  showCubeAIPopup: boolean = false;
  /** Centrado en viewport (evita que quede pegado arriba con galería fullscreen detrás). */
  cubeAIPopupCenterPosition: any = { my: 'center', at: 'center', of: window };

  /** Re-centra el overlay tras abrir (DevExtreme a veces calcula top con maxHeight). */
  onCubeAIPopupLayerShown(event: any): void {
    const component = event != null ? event.component : null;
    if (component != null && typeof component.repaint === 'function') {
      component.repaint();
    }
    const self = this;
    setTimeout(function () {
      self.applyCubeAIPopupViewportCenter(component);
    }, 0);
    setTimeout(function () {
      self.applyCubeAIPopupViewportCenter(component);
    }, 80);
  }

  private getCubeAIImagePopupElement(): HTMLElement | null {
    if (this.cubeAIImagePopupRef != null && typeof this.cubeAIImagePopupRef.element === 'function') {
      const fromRef = this.cubeAIImagePopupRef.element();
      if (fromRef != null) {
        return fromRef;
      }
    }
    const nodes = document.querySelectorAll('.dx-overlay-content.cube-ai-popup-el--image');
    for (let i = 0; i < nodes.length; i++) {
      const candidate = nodes[i] as HTMLElement;
      if (candidate.offsetParent != null || candidate.getClientRects().length > 0) {
        return candidate;
      }
    }
    return null;
  }

  private setPopupViewportCenterStyles(el: HTMLElement): void {
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('top', '50%', 'important');
    el.style.setProperty('left', '50%', 'important');
    el.style.setProperty('right', 'auto', 'important');
    el.style.setProperty('bottom', 'auto', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('transform', 'translate(-50%, -50%)', 'important');
  }

  private applyCubeAIPopupViewportCenter(component: any): void {
    let el: HTMLElement = null;
    if (component != null && typeof component.element === 'function') {
      el = component.element();
    }
    if (el == null) {
      return;
    }
    this.setPopupViewportCenterStyles(el);
  }

  private applyCubeAIImagePopupViewportCenter(): void {
    const el = this.getCubeAIImagePopupElement();
    if (el == null) {
      return;
    }
    this.setPopupViewportCenterStyles(el);
  }

  private cubeAIImagePopupRecenterGen = 0;

  /** Mantiene el modal de imagen centrado cuando cambia el alto (preview cargada, etc.). */
  private scheduleCubeAIImagePopupRecenter(): void {
    if (!this.showCubeAIImagePopup) {
      return;
    }
    const self = this;
    const gen = ++self.cubeAIImagePopupRecenterGen;
    const delays = [0, 20, 60, 120, 220, 400, 650];
    let i = 0;
    const tick = function () {
      if (!self.showCubeAIImagePopup || gen !== self.cubeAIImagePopupRecenterGen) {
        return;
      }
      const comp = self.cubeAIImagePopupRef;
      if (comp != null && typeof comp.repaint === 'function') {
        comp.repaint();
      }
      self.applyCubeAIImagePopupViewportCenter();
      i++;
      if (i < delays.length) {
        self.cubeAIImagePopupRecenterTimer = setTimeout(tick, delays[i] - (i > 0 ? delays[i - 1] : 0));
      }
    };
    self.cubeAIImagePopupRecenterTimer = setTimeout(tick, 0);
  }

  onCubeAIImagePopupShown(event: any): void {
    this.cubeAIImagePopupRef = event != null ? event.component : null;
    this.onCubeAIPopupLayerShown(event);
    this.bindCubeAIImagePopupCenterGuard();
    this.scheduleCubeAIImagePopupRecenter();
  }

  private bindCubeAIImagePopupCenterGuard(): void {
    this.unbindCubeAIImagePopupCenterGuard();
    const el = this.getCubeAIImagePopupElement();
    if (el == null || typeof MutationObserver === 'undefined') {
      return;
    }
    const self = this;
    let guardLock = false;
    this.cubeAIImagePopupCenterObserver = new MutationObserver(function () {
      if (!self.showCubeAIImagePopup || guardLock) {
        return;
      }
      const top = el.style.top;
      if (top != null && top !== '' && top.indexOf('50%') === -1) {
        guardLock = true;
        self.applyCubeAIImagePopupViewportCenter();
        guardLock = false;
      }
    });
    this.cubeAIImagePopupCenterObserver.observe(el, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  private unbindCubeAIImagePopupCenterGuard(): void {
    this.cubeAIImagePopupRecenterGen++;
    if (this.cubeAIImagePopupCenterObserver != null) {
      this.cubeAIImagePopupCenterObserver.disconnect();
      this.cubeAIImagePopupCenterObserver = null;
    }
    if (this.cubeAIImagePopupRecenterTimer != null) {
      clearTimeout(this.cubeAIImagePopupRecenterTimer);
      this.cubeAIImagePopupRecenterTimer = null;
    }
  }

  onCubeAIImagePreviewLoaded(): void {
    this.scheduleCubeAIImagePopupRecenter();
  }

  /** Opciones del modal Cube AI (mismo patrón que edit-estimate importMethodOptions). */
  cubeAIMethodOptions = [
    {
      id: 'image',
      nameKey: 'ModuleSystemToArea.cubeAIImportFromImage',
      descKey: 'ModuleSystemToArea.cubeAIDescImage',
      icon: 'fas fa-camera',
      color: '#0d6efd',
      featured: true,
      badgeKey: 'ModuleSystemToArea.cubeAIBadgeRecommended',
    },
    {
      id: 'text',
      nameKey: 'ModuleSystemToArea.cubeAIImportFromText',
      descKey: 'ModuleSystemToArea.cubeAIDescText',
      icon: 'fas fa-align-left',
      color: '#6f42c1',
    },
  ];

  openCubeAI(): void {
    this.showCubeAIPopup = true;
  }

  closeCubeAIPopup(): void {
    this.showCubeAIPopup = false;
    this.showCubeAIImagePopup = false;
    this.showCubeAIImageSuccessPopup = false;
    this.showCubeAITextPopup = false;
    this.cubeAISuccessFromText = false;
    this.cubeAIImageProcessing = false;
    this.cubeAITextProcessing = false;
    this.clearCubeAIImage();
    this.cubeAITextContent = '';
  }

  closeCubeAIImagePopup(): void {
    this.showCubeAIImagePopup = false;
    this.clearCubeAIImage();
  }

  backToCubeAIChooserFromImage(): void {
    this.showCubeAIImagePopup = false;
    this.clearCubeAIImage();
    this.showCubeAIPopup = true;
  }

  onCubeAIImagePopupHidden(): void {
    this.showCubeAIImagePopup = false;
    this.unbindCubeAIImagePopupCenterGuard();
    this.cubeAIImagePopupRef = null;
    this.clearCubeAIImage();
  }

  closeCubeAIImageSuccessPopup(): void {
    this.showCubeAIImageSuccessPopup = false;
    this.cubeAIImageSuccessPreselectedCount = 0;
    this.cubeAISuccessFromText = false;
    // After AI processing (image or text): switch to All Components tab in Selected mode
    if (this.addComponentsGallerySelectedRows && this.addComponentsGallerySelectedRows.length > 0) {
      this.activeGalleryTab = 'library';
      this.galleryLibInSelectedMode = true;
      this.galleryLibNavStack = [];
      this.setGalleryLibCategory(this.galleryLibNavL1Id);
      this.cdr.detectChanges();
    }
  }

  handleCubeAIOptionSelect(option: { id: string }): void {
    if (option == null || option.id == null) {
      return;
    }
    this.showCubeAIPopup = false;
    if (option.id === 'image') {
      this.clearCubeAIImage();
      this.showCubeAIImagePopup = true;
    } else if (option.id === 'text') {
      this.cubeAITextContent = '';
      this.showCubeAITextPopup = true;
    }
  }

  // ── Cube AI: Image Import ──────────────────────────────────────────────────
  showCubeAIImagePopup: boolean = false;
  showCubeAIImageSuccessPopup: boolean = false;
  cubeAIImageSuccessPreselectedCount = 0;
  /** Modal de éxito: mensaje para importación por texto vs imagen. */
  cubeAISuccessFromText = false;
  /** Cube AI: punto rojo en pestaña si hay coincidencias (exclusivo: Most Used primero). */
  cubeAIGalleryTabDotSuggested = false;
  cubeAIGalleryTabDotLibrary = false;
  cubeAIImageFile: any = null;
  cubeAIImagePreviewUrl: string = '';
  cubeAIImageDragOver = false;
  private cubeAIImageDragCounter = 0;
  cubeAIImageIsImagePreview = false;
  private cubeAIImagePopupRef: any = null;
  private cubeAIImagePopupCenterObserver: MutationObserver = null;
  private cubeAIImagePopupRecenterTimer: any = null;
  cubeAIImageProcessing = false;
  /** Components returned by Cube AI (GetComponentsByTag) for review in the left panel. */
  cubeAIImageAnalysisRows: any[] = [];
  cubeAIImageSelectedKeys: any[] = [];

  onCubeAIFileChange(event: any): void {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      return;
    }
    this.applyCubeAIImageFile(file);
    if (event.target) {
      event.target.value = '';
    }
  }

  onCubeAIImageDragEnter(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.cubeAIImageDragCounter++;
    this.cubeAIImageDragOver = true;
  }

  onCubeAIImageDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'copy';
    }
    this.cubeAIImageDragOver = true;
  }

  onCubeAIImageDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.cubeAIImageDragCounter--;
    if (this.cubeAIImageDragCounter <= 0) {
      this.cubeAIImageDragCounter = 0;
      this.cubeAIImageDragOver = false;
    }
  }

  onCubeAIImageDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.cubeAIImageDragCounter = 0;
    this.cubeAIImageDragOver = false;
    const files = event.dataTransfer && event.dataTransfer.files;
    if (files && files.length > 0) {
      this.applyCubeAIImageFile(files[0]);
    }
  }

  onCubeAIDropZoneClick(event: MouseEvent): void {
    if (this.cubeAIImageProcessing) {
      return;
    }
    const target = event.target as HTMLElement;
    if (target && target.closest('.cube-ai-img-modal__select-btn, .cube-ai-img-modal__change-file, .cube-ai-img-modal__file-meta-change, .cube-ai-image-ws__select-btn, .cube-ai-image-ws__change-file')) {
      return;
    }
    if (!this.cubeAIImageFile && this.cubeAIFileInput && this.cubeAIFileInput.nativeElement) {
      this.cubeAIFileInput.nativeElement.click();
    }
  }

  private isCubeAIAllowedFile(file: File): boolean {
    if (!file) {
      return false;
    }
    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    if (type.indexOf('image/') === 0) {
      return true;
    }
    if (type === 'application/pdf' || name.endsWith('.pdf')) {
      return true;
    }
    return false;
  }

  private applyCubeAIImageFile(file: File): void {
    if (!file) {
      return;
    }
    if (!this.isCubeAIAllowedFile(file)) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.cubeAIInvalidFileType'));
      return;
    }
    this.cubeAIImageFile = file;
    this.cubeAIImageAnalysisRows = [];
    this.cubeAIImageSelectedKeys = [];
    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    this.cubeAIImageIsImagePreview = type.indexOf('image/') === 0 && !name.endsWith('.pdf');
    const reader = new FileReader();
    const self = this;
    reader.onload = (e: any) => {
      self.cubeAIImagePreviewUrl = e.target.result;
      self.cdr.detectChanges();
      self.scheduleCubeAIImagePopupRecenter();
    };
    reader.readAsDataURL(file);
    self.scheduleCubeAIImagePopupRecenter();
  }

  clearCubeAIImage(): void {
    this.cubeAIImageFile = null;
    this.cubeAIImagePreviewUrl = '';
    this.cubeAIImageIsImagePreview = false;
    this.cubeAIImageAnalysisRows = [];
    this.cubeAIImageSelectedKeys = [];
    this.cubeAIImageDragOver = false;
    this.cubeAIImageDragCounter = 0;
    this.cubeAIImageProcessing = false;
  }

  /** Sistema activo en la galería de componentes (clic en Use Cube AI). */
  private findGallerySystemTreeItem(): any | null {
    const sid = this.addComponentsGallerySystemId;
    if (sid == null || sid === '') {
      return null;
    }
    const walk = (nodes: any[]): any | null => {
      if (!nodes || !nodes.length) {
        return null;
      }
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (!n) {
          continue;
        }
        if (this.isTreeviewSystemItem(n) && n.id === sid) {
          return n;
        }
        if (n.items && n.items.length) {
          const found = walk(n.items);
          if (found != null) {
            return found;
          }
        }
      }
      return null;
    };
    return walk(this.getGroupItemsTopLevelAreas());
  }

  private getCubeAIImageSystemTypeId(): number {
    const sid = this.addComponentsGallerySystemId;
    if (sid != null && this.dataTest && this.dataTest.length) {
      for (let i = 0; i < this.dataTest.length; i++) {
        const row = this.dataTest[i];
        if (row != null && row.id === sid && row.systemTypeID != null && !isNaN(Number(row.systemTypeID))) {
          return Number(row.systemTypeID);
        }
      }
    }
    return 1;
  }

  private normalizeCubeAIComponentRow(row: any): any | null {
    if (row == null || typeof row !== 'object') {
      return null;
    }
    const displayName =
      row.DISPLAY_NAME != null && String(row.DISPLAY_NAME).trim() !== ''
        ? String(row.DISPLAY_NAME).trim()
        : row.NAME != null
          ? String(row.NAME).trim()
          : row.Component_Name != null
            ? String(row.Component_Name).trim()
            : '';
    if (displayName === '') {
      return null;
    }
    const componentId = row.ID != null ? row.ID : row.ComponentId != null ? row.ComponentId : row.componentId;
    return {
      DISPLAY_NAME: displayName,
      NAME: row.NAME,
      CUBE_TAG: row.CUBE_TAG,
      ID: componentId,
      ComponentId: componentId,
      Component_Name: displayName,
      Tag_Id: row.Tag_Id != null ? row.Tag_Id : row.TAG_ID,
      Description: row.Description != null ? String(row.Description) : '',
    };
  }

  get cubeAIImageSelectedCount(): number {
    return this.getCubeAIImageSelectedRows().length;
  }

  getCubeAIImageSelectedRows(): any[] {
    const keys = this.cubeAIImageSelectedKeys;
    if (!keys || !keys.length || !this.cubeAIImageAnalysisRows.length) {
      return [];
    }
    const keySet: any = {};
    for (let i = 0; i < keys.length; i++) {
      keySet[keys[i]] = true;
    }
    const out: any[] = [];
    for (let j = 0; j < this.cubeAIImageAnalysisRows.length; j++) {
      const row = this.cubeAIImageAnalysisRows[j];
      if (row != null && keySet[row.DISPLAY_NAME]) {
        out.push(row);
      }
    }
    return out;
  }

  onCubeAIImageListSelectionChanged(e: any): void {
    if (e && e.component) {
      this.cubeAIImageSelectedKeys = e.component.option('selectedItemKeys') || [];
    }
  }

  private galleryComponentIdKey(c: any): string {
    if (c == null || c.ComponentId == null || c.ComponentId === '') {
      return '';
    }
    return String(c.ComponentId);
  }

  clearCubeAIGalleryTabBadges(): void {
    this.cubeAIGalleryTabDotSuggested = false;
    this.cubeAIGalleryTabDotLibrary = false;
  }

  /** Indicador por pestaña: Most Used primero; All Components solo si no está en Most Used. */
  private updateCubeAIGalleryTabBadges(ids: string[]): void {
    if (!ids || !ids.length) {
      this.clearCubeAIGalleryTabBadges();
      return;
    }
    const suggested = this.addComponentsGalleryItems || [];
    const library = this._galleryLibAllComponents || [];
    let hasSuggested = false;
    let hasLibraryOnly = false;
    for (let j = 0; j < ids.length; j++) {
      const id = ids[j];
      let inSuggested = false;
      for (let s = 0; s < suggested.length; s++) {
        const c = suggested[s];
        if (c != null && String(c.ComponentId) === id) {
          inSuggested = true;
          break;
        }
      }
      if (inSuggested) {
        hasSuggested = true;
        continue;
      }
      for (let l = 0; l < library.length; l++) {
        const c = library[l];
        if (c != null && String(c.ComponentId) === id) {
          hasLibraryOnly = true;
          break;
        }
      }
    }
    this.cubeAIGalleryTabDotSuggested = hasSuggested;
    this.cubeAIGalleryTabDotLibrary = hasLibraryOnly;
  }

  /** Preselecciona en Most Used y All Components por ComponentId. */
  preselectCubeAIFoundComponentsInGallery(): number {
    const rows = this.cubeAIImageAnalysisRows;
    if (!rows || !rows.length) {
      this.addComponentsGallerySelectedRows = [];
      this.clearCubeAIGalleryTabBadges();
      return 0;
    }
    const idSet: any = {};
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      if (r != null && r.ComponentId != null && r.ComponentId !== '') {
        idSet[String(r.ComponentId)] = true;
      }
    }
    const ids = Object.keys(idSet);
    if (!ids.length) {
      this.addComponentsGallerySelectedRows = [];
      this.clearCubeAIGalleryTabBadges();
      return 0;
    }
    this.updateCubeAIGalleryTabBadges(ids);
    const suggested = this.addComponentsGalleryItems || [];
    const library = this._galleryLibAllComponents || [];
    const selected: any[] = [];
    const seen: any = {};
    for (let j = 0; j < ids.length; j++) {
      const id = ids[j];
      let match: any = null;
      for (let s = 0; s < suggested.length; s++) {
        const c = suggested[s];
        if (c != null && String(c.ComponentId) === id) {
          match = c;
          break;
        }
      }
      if (match == null) {
        for (let l = 0; l < library.length; l++) {
          const c = library[l];
          if (c != null && String(c.ComponentId) === id) {
            match = c;
            break;
          }
        }
      }
      if (match != null && !seen[id]) {
        seen[id] = true;
        selected.push(match);
      }
    }
    this.addComponentsGallerySelectedRows = selected;
    this._applyGalleryFilter();
    this._applyGalleryLibFilter();
    return selected.length;
  }

  private flushGalleryLibReadyCallbacks(success: boolean): void {
    const pending = this._galleryLibReadyCallbacks.slice();
    this._galleryLibReadyCallbacks = [];
    for (let i = 0; i < pending.length; i++) {
      if (success) {
        pending[i].ok();
      } else {
        pending[i].err();
      }
    }
  }

  /** Asegura que All Components esté cargado antes de Cube AI. */
  ensureGalleryLibLoadedForCubeAI(ok: () => void, err: () => void): void {
    if (this.galleryLibLoaded) {
      ok();
      return;
    }
    this._galleryLibReadyCallbacks.push({ ok: ok, err: err });
    if (!this.galleryLibLoading) {
      this.loadGalleryLibComponents();
    }
  }

  private waitForGalleryMostUsedLoaded(ok: () => void): void {
    const self = this;
    if (!self.addComponentsGalleryLoading) {
      ok();
      return;
    }
    const started = Date.now();
    const tick = function () {
      if (!self.addComponentsGalleryLoading) {
        ok();
        return;
      }
      if (Date.now() - started > 60000) {
        ok();
        return;
      }
      setTimeout(tick, 120);
    };
    setTimeout(tick, 120);
  }

  /** All Components + Most Used listos (carga lib si hace falta). */
  ensureGalleryDataBeforeCubeAI(ok: () => void, err: () => void): void {
    const self = this;
    self.ensureGalleryLibLoadedForCubeAI(function () {
      self.waitForGalleryMostUsedLoaded(ok);
    }, err);
  }

  onAddCubeAIImageComponentsClick(): void {
    const rows = this.getCubeAIImageSelectedRows();
    if (!rows.length) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelectComponentFirst'));
      return;
    }
    const withId = rows.filter((r) => r != null && r.ComponentId != null && r.ComponentId !== '');
    if (!withId.length) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelectComponentFirst'));
      return;
    }
    this.insertGalleryComponentsToSystem(withId);
    this.showCubeAIImagePopup = false;
    this.clearCubeAIImage();
  }

  analyzeCubeAIImage(): void {
    if (!this.cubeAIImageFile || !this.cubeAIImagePreviewUrl) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.cubeAINoImageAvailable'));
      return;
    }
    const self = this;
    const base64Payload = self.getCubeAIImageBase64ForApi();
    if (!base64Payload) {
      self.toast.warning(self.translate.instant('ModuleSystemToArea.cubeAINoImageAvailable'));
      return;
    }
    self.cubeAIImageProcessing = true;
    self.cubeAIImageAnalysisRows = [];
    self.cubeAIImageSelectedKeys = [];
    self.cdr.detectChanges();
    self.scheduleCubeAIImagePopupRecenter();

    // 1) Cargar All Components antes de comp_tags_base64_alt
    self.ensureGalleryDataBeforeCubeAI(function () {
      self.runCubeAIImageTagsPipeline(base64Payload);
    }, function () {
      self.cubeAIImageProcessing = false;
      self.toast.error(self.translate.instant('ModuleSystemToArea.msgLoadGalleryLibFail'));
      self.cdr.detectChanges();
      self.scheduleCubeAIImagePopupRecenter();
    });
  }

  private runCubeAIImageTagsPipeline(base64Payload: string): void {
    const self = this;
    self.MapInformationService.compTagsBase64Alt({
      Base64: base64Payload,
      dpi: 350,
    }).subscribe(
      function (response: any) {
        const tags =
          response != null && response.tags != null
            ? String(response.tags)
            : response != null && response.Tags != null
              ? String(response.Tags)
              : '';
        if (!tags || tags.trim() === '') {
          self.cubeAIImageProcessing = false;
          self.toast.warning(self.translate.instant('ModuleSystemToArea.cubeAINoTagsFound'));
          self.cdr.detectChanges();
          self.scheduleCubeAIImagePopupRecenter();
          return;
        }
        self.fetchCubeAIComponentsByTags(tags, function () {
          self.cubeAIImageProcessing = false;
        }, function () {
          self.cubeAISuccessFromText = false;
          self.showCubeAIImagePopup = false;
          self.clearCubeAIImage();
        }, function () {
          self.scheduleCubeAIImagePopupRecenter();
        });
      },
      function () {
        self.cubeAIImageProcessing = false;
        self.toast.error(self.translate.instant('ModuleSystemToArea.cubeAINoTagsFound'));
        self.cdr.detectChanges();
        self.scheduleCubeAIImagePopupRecenter();
      }
    );
  }

  /** Tags desde analyze_sequence_tags_only (mismo contrato que ai-estimate). */
  private extractCubeAISequenceTags(response: any): string {
    if (response == null) {
      return '';
    }
    if (response.success === false) {
      return '';
    }
    let raw = response.tags != null ? response.tags : response.Tags;
    if (raw == null) {
      return '';
    }
    if (Array.isArray(raw)) {
      const parts: string[] = [];
      for (let i = 0; i < raw.length; i++) {
        const t = raw[i];
        if (t != null && String(t).trim() !== '') {
          parts.push(String(t).trim());
        }
      }
      return parts.length ? parts.join(',') : '';
    }
    const s = String(raw).trim();
    return s;
  }

  /** GetComponentsByTag + preselección en galería (imagen y texto). */
  private fetchCubeAIComponentsByTags(
    tags: string,
    onProcessingEnd: () => void,
    onBeforeSuccessPopup: () => void,
    onAfterError?: () => void
  ): void {
    const self = this;
    const systemTypeID = self.getCubeAIImageSystemTypeId();
    self.MapInformationService.SaveInfoSites({
      method: 'GetComponentsByTag',
      tagids: tags,
      systemtypeID: systemTypeID,
    }).subscribe(
      function (componets: any[]) {
        onProcessingEnd();
        const normalized: any[] = [];
        const autoKeys: any[] = [];
        if (componets && componets.length) {
          for (let i = 0; i < componets.length; i++) {
            const row = self.normalizeCubeAIComponentRow(componets[i]);
            if (row != null) {
              normalized.push(row);
              if (row.ComponentId != null && row.ComponentId !== '') {
                autoKeys.push(row.DISPLAY_NAME);
              }
            }
          }
        }
        self.cubeAIImageAnalysisRows = normalized;
        self.cubeAIImageSelectedKeys = autoKeys.slice();
        if (!normalized.length) {
          self.toast.warning(self.translate.instant('ModuleSystemToArea.cubeAINoComponentsFound'));
        } else {
          const preselected = self.preselectCubeAIFoundComponentsInGallery();
          onBeforeSuccessPopup();
          self.activeGalleryTab = 'suggested';
          self.cubeAIImageSuccessPreselectedCount = preselected;
          self.showCubeAIImageSuccessPopup = true;
        }
        self.cdr.detectChanges();
      },
      function () {
        onProcessingEnd();
        self.toast.error(self.translate.instant('ModuleSystemToArea.cubeAINoComponentsFound'));
        self.cdr.detectChanges();
        if (onAfterError) {
          onAfterError();
        }
      }
    );
  }

  /** Base64 listo para comp_tags_base64_alt (data URL completo, igual que ai-estimate). */
  private getCubeAIImageBase64ForApi(): string {
    const raw = this.cubeAIImagePreviewUrl != null ? String(this.cubeAIImagePreviewUrl).trim() : '';
    return raw;
  }

  // ── Cube AI: Text Import ───────────────────────────────────────────────────
  showCubeAITextPopup: boolean = false;
  cubeAITextContent: string = '';
  cubeAITextProcessing = false;
  /** Altura del dx-html-editor en import from text. */
  cubeAITextEditorHeight = 520;

  get cubeAITextPlainLength(): number {
    const raw = this.cubeAITextContent != null ? String(this.cubeAITextContent) : '';
    if (!raw.trim()) {
      return 0;
    }
    const text = raw.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
    return text.length;
  }

  closeCubeAITextPopup(): void {
    this.showCubeAITextPopup = false;
    this.cubeAITextContent = '';
    this.cubeAITextProcessing = false;
  }

  onCubeAITextPopupHidden(): void {
    this.showCubeAITextPopup = false;
    this.cubeAITextContent = '';
    this.cubeAITextProcessing = false;
  }

  backToCubeAIChooserFromText(): void {
    this.showCubeAITextPopup = false;
    this.cubeAITextContent = '';
    this.cubeAITextProcessing = false;
    this.showCubeAIPopup = true;
  }

  onCubeAITextEditorChanged(event: any): void {
    if (event != null && event.value != null) {
      this.cubeAITextContent = event.value;
    }
  }

  analyzeCubeAIText(): void {
    if (this.cubeAITextPlainLength === 0) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.cubeAITextRequired'));
      return;
    }
    const self = this;
    const sequenceText = self.cubeAITextContent != null ? String(self.cubeAITextContent) : '';
    if (!sequenceText.trim()) {
      self.toast.warning(self.translate.instant('ModuleSystemToArea.cubeAITextRequired'));
      return;
    }
    self.cubeAITextProcessing = true;
    self.cubeAIImageAnalysisRows = [];
    self.cubeAIImageSelectedKeys = [];
    self.cdr.detectChanges();

    self.ensureGalleryDataBeforeCubeAI(function () {
      self.runCubeAITextTagsPipeline(sequenceText);
    }, function () {
      self.cubeAITextProcessing = false;
      self.toast.error(self.translate.instant('ModuleSystemToArea.msgLoadGalleryLibFail'));
      self.cdr.detectChanges();
    });
  }

  private runCubeAITextTagsPipeline(sequenceText: string): void {
    const self = this;
    self.MapInformationService.SuggetsComponents({
      sequence_text: sequenceText,
    }).subscribe(
      function (response: any) {
        const tags = self.extractCubeAISequenceTags(response);
        if (!tags) {
          self.cubeAITextProcessing = false;
          self.toast.warning(self.translate.instant('ModuleSystemToArea.cubeAINoTagsFoundText'));
          self.cdr.detectChanges();
          return;
        }
        self.fetchCubeAIComponentsByTags(tags, function () {
          self.cubeAITextProcessing = false;
        }, function () {
          self.cubeAISuccessFromText = true;
          self.showCubeAITextPopup = false;
          self.cubeAITextContent = '';
        });
      },
      function () {
        self.cubeAITextProcessing = false;
        self.toast.error(self.translate.instant('ModuleSystemToArea.cubeAINoTagsFoundText'));
        self.cdr.detectChanges();
      }
    );
  }

  /** Flat tree: all levels expanded, click any node to filter */
  get galleryLibFlatNodes(): Array<{node: any, level: number}> {
    const result: Array<{node: any, level: number}> = [];
    const walk = (nodes: any[], level: number) => {
      for (const n of nodes) {
        result.push({node: n, level});
        if (n.children && n.children.length) { walk(n.children, level + 1); }
      }
    };
    walk(this.galleryLibTypeTree, 0);
    return result;
  }

  selectGalleryLibNode(node: any): void {
    this.galleryLibNavL1Id = node.id;
    this.setGalleryLibCategory(node.id);
  }
  // ── end Library tab navigation ─────────────────────────────────────────────

  get galleryLibCategoriesFiltered(): Array<{ id: any; name: string; count: number }> {
    const q = (this.galleryLibCatSearch || '').trim().toLowerCase();
    return q
      ? this.galleryLibCategories.filter(c => (c.name || '').toLowerCase().includes(q))
      : this.galleryLibCategories;
  }

  onGalleryLibCatSearch(value: string): void {
    this.galleryLibCatSearch = value;
  }

  /** Galería: añadir sistema desde librería (Get_AreaSystemAllCE2) */
  popupSystemLibraryGallery = false;
  systemLibraryGalleryLoading = false;
  systemLibraryGalleryCategories: Array<{ id: number; name: string; systems: any[]; loaded?: boolean }> = [];
  systemLibraryGalleryAreaItem: any = null;
  systemLibraryGallerySelectedRows: any[] = [];
  systemLibraryGalleryInserting = false;
  systemLibraryGallerySearch = '';
  /** id del padre seleccionado; tras cargar el SP queda el primero por defecto */
  systemLibraryGalleryCategoryKey: any = null;
  /** Filas hijo (ID > 0) del SP; los sistemas por categoría se hidratan al pulsar el chip */
  private systemLibraryGalleryChildRowsPool: any[] = [];
  /**
   * Fallback si no hay estimate elegido en el select ni estimateid del árbol.
   */
  private readonly SYSTEM_LIBRARY_SP_ESTIMATE_ID_STATIC = 581;
  private readonly SYSTEM_LIBRARY_SP_VIEWTYPE_ID_STATIC = 1;
  /** Importar contenido de biblioteca dentro del sistema del clic derecho (→ ImportintoSystemSingle). */
  systemLibraryGalleryImportIntoSystemId: number | null = null;

  /** Area select shown only when the gallery is opened from outside (e.g. "Take me there" banner). */
  systemLibraryGalleryShowAreaSelect = false;
  systemLibraryGalleryExternalAreas: any[] = [];
  systemLibraryGallerySelectedExternalArea: any = null;

  /** Estimate del catálogo Get_AreaSystemAllCE2 (select del modal); si es null se usa @Input estimateid o estático */
  systemLibraryGalleryCatalogEstimateId: number | null = null;
  systemLibraryGalleryEstimateDataSource: any = null;
  systemLibraryGalleryAddEstimateBtnOptions: any;
  popupSystemLibraryDefaultEstimate = false;
  systemLibraryGalleryDefaultEstimatePickId: number | null = null;
  systemLibraryGalleryCancelDefaultEstimateBtn: any;
  systemLibraryGallerySaveDefaultEstimateBtn: any;
  private systemLibraryGallerySyncingEstimateSelect = false;
  /** Orden alfabético por nombre con números naturales (ej. 1, 2, 10). */
  private readonly _systemLibraryNameCollator = new Intl.Collator(undefined, {
    numeric: true,
    sensitivity: 'base',
  });

  get systemLibraryGallerySelectionCount(): number {
    const rows = this.systemLibraryGallerySelectedRows;
    return rows && rows.length ? rows.length : 0;
  }

  onGalleryFilterChange(value: string): void {
    this.addComponentsGalleryFilter = value;
    this._applyGalleryFilter();
  }

  private _applyGalleryFilter(): void {
    const q = (this.addComponentsGalleryFilter || '').trim().toLowerCase();
    this.addComponentsGalleryFilteredItems = q
      ? this.addComponentsGalleryItems.filter((c: any) =>
          (c.Component_Name || '').toLowerCase().includes(q) ||
          (c.Description || '').toLowerCase().includes(q) ||
          (c.CategoryLabel || '').toLowerCase().includes(q))
      : this.addComponentsGalleryItems.slice();
  }

  /** Unifica el input de búsqueda para ambos tabs del modal */
  onGallerySearchInput(value: string): void {
    if (this.activeGalleryTab === 'library') {
      this.galleryLibFilter = value;
      this._applyGalleryLibFilter();
    } else {
      this.addComponentsGalleryFilter = value;
      this._applyGalleryFilter();
    }
  }

  clearGallerySearch(): void {
    this.onGallerySearchInput('');
  }

  get gallerySearchValue(): string {
    return this.activeGalleryTab === 'library' ? this.galleryLibFilter : this.addComponentsGalleryFilter;
  }

  get gallerySearchHasValue(): boolean {
    return this.gallerySearchValue.length > 0;
  }

  get galleryLibTotalCount(): number {
    return this._galleryLibAllComponents ? this._galleryLibAllComponents.length : 0;
  }

  get showGalleryFooter(): boolean {
    if (this.activeGalleryTab === 'library') {
      return !this.galleryLibLoading && this.galleryLibLoaded;
    }
    return !this.addComponentsGalleryLoading &&
      this.addComponentsGalleryItems != null &&
      this.addComponentsGalleryItems.length > 0;
  }

  onGalleryTabChange(tab: 'suggested' | 'library'): void {
    if (this.activeGalleryTab === tab) { return; }
    this.activeGalleryTab = tab;
    // Limpiar búsqueda al cambiar de tab para evitar confusión
    this.addComponentsGalleryFilter = '';
    this.galleryLibFilter = '';
    this._applyGalleryFilter();
    this._applyGalleryLibFilter();
    if (tab === 'library' && !this.galleryLibLoaded && !this.galleryLibLoading) {
      this.loadGalleryLibComponents();
    }
  }

  loadGalleryLibComponents(): void {
    if (this.galleryLibLoading) { return; }
    this.galleryLibLoading = true;
    this.MapInformationService.SaveInfoSites({
      method: 'Get_EstimateLibComponentsTreeCE',
    }).subscribe(
      (resp: any) => {
        this.galleryLibLoading = false;
        this.galleryLibLoaded = true;
        const rows: any[] = Array.isArray(resp) ? resp : [];
        const typeMap: { [id: string]: any } = {};
        const allTypes: any[] = [];
        const comps: any[] = [];

        // Separar tipos y componentes
        for (let i = 0; i < rows.length; i++) {
          const r = rows[i];
          if (!r) { continue; }
          const isParent = r.TreeFlag === 'P' || (r.ID != null && Number(r.ID) < 0);
          if (isParent) {
            const node = {
              id: r.ID,
              name: String(r.SystemType || '').trim(),
              parentId: r.PARENTID,
              count: 0,
              totalCount: 0,
              children: [],
              expanded: false,
            };
            typeMap[String(r.ID)] = node;
            allTypes.push(node);
          } else {
            comps.push({
              ComponentId: r.ID,
              Component_Name: String(r.SystemType || '').trim(),
              ACHR: r.ACHR || '',
              Description: r.visioname || '',
              Tag_Id: null,
              _parentId: r.PARENTID,
            });
          }
        }

        // Contar componentes directos por tipo
        for (let i = 0; i < comps.length; i++) {
          const pid = String(comps[i]._parentId);
          if (typeMap[pid]) { typeMap[pid].count++; }
        }

        // Construir árbol padre-hijo
        // Parent nodes have negative IDs; their PARENTID in raw data is the positive equivalent
        // of their parent's negative ID — same negation used in the groupItems reduce
        const rootTypes: any[] = [];
        for (let i = 0; i < allTypes.length; i++) {
          const node = allTypes[i];
          const resolvedParentId = node.id < 0 && node.parentId ? String(node.parentId * -1) : String(node.parentId);
          const parentNode = typeMap[resolvedParentId];
          if (parentNode && parentNode.id !== node.id) {
            parentNode.children.push(node);
          } else {
            rootTypes.push(node);
          }
        }

        // totalCount recursivo
        const computeTotal = (node: any): number => {
          let t = node.count;
          for (let i = 0; i < node.children.length; i++) { t += computeTotal(node.children[i]); }
          node.totalCount = t;
          return t;
        };
        for (let i = 0; i < rootTypes.length; i++) { computeTotal(rootTypes[i]); }

        // Ordenar y filtrar vacíos
        const sortNodes = (nodes: any[]) => {
          nodes.sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''));
          for (let i = 0; i < nodes.length; i++) { sortNodes(nodes[i].children); }
        };
        sortNodes(rootTypes);
        const filterEmpty = (nodes: any[]): any[] =>
          nodes.filter(n => n.totalCount > 0).map(n => ({ ...n, children: filterEmpty(n.children) }));

        comps.sort((a: any, b: any) => (a.Component_Name || '').localeCompare(b.Component_Name || ''));

        this._galleryLibTypeMap = typeMap;
        this.galleryLibTypeTree = filterEmpty(rootTypes);
        // Auto-select the single root node so categories show immediately (skip "Master" step)
        if (this.galleryLibTypeTree.length > 0 && this.galleryLibNavL1Id == null) {
          this.galleryLibNavL1Id = this.galleryLibTypeTree[0].id;
        }

        // Same logic as itemsTree() / groupItems in control-drawing-newVersion
        const catRows = rows.filter((r: any) => r != null && Number(r.ID) < 0);
        const arr = catRows.map((r: any) => ({
          id: r.ID,
          id2: r.ID,
          text: String(r.SystemType || '').trim(),
          expanded: false,
          parentId: r.PARENTID,
          items: [],
          totalCount: typeMap[String(r.ID)] ? typeMap[String(r.ID)].totalCount : 0
        }));
        this.galleryLibItems = arr.reduce(function(map: any, node: any) {
          const parentid = node.parentId && node.id < 0 ? node.parentId * -1 : node.parentId;
          const nodeid = node.id;
          map.i[nodeid] = node;
          if (parentid === null || parentid === undefined) {
            node.expanded = true;
            map.result.push(node);
          } else if (parentid in map.i) {
            map.i[parentid].items.push(node);
          } else {
            (parentid in map.cache) ?
              map.cache[parentid].push(node) :
              map.cache[parentid] = [node];
          }
          if (nodeid in map.cache) {
            node.items = node.items.concat(map.cache[nodeid]);
            delete map.cache[nodeid];
          }
          return map;
        }, { i: {}, cache: {}, result: [] }).result;
        this._galleryLibAllComponents = comps;
        // Lista plana de todos los tipos con componentes, ordenada alfabéticamente
        this.galleryLibCategories = allTypes
          .filter((n: any) => n.totalCount > 0)
          .sort((a: any, b: any) => (a.name || '').localeCompare(b.name || ''))
          .map((n: any) => ({ id: n.id, name: n.name, count: n.totalCount }));
        this._applyGalleryLibFilter();
        this.flushGalleryLibReadyCallbacks(true);
      },
      () => {
        this.galleryLibLoading = false;
        this.flushGalleryLibReadyCallbacks(false);
        this.toast.error(this.translate.instant('ModuleSystemToArea.msgLoadGalleryLibFail'));
      }
    );
  }

  setGalleryLibCategory(id: any): void {
    this.galleryLibSelectedCategoryId = id;
    this._applyGalleryLibFilter();
  }

  toggleGalleryLibTree(): void {
    this.galleryLibTreeExpanded = !this.galleryLibTreeExpanded;
    if (this.galleryLibCatTree && this.galleryLibCatTree.instance) {
      if (this.galleryLibTreeExpanded) {
        this.galleryLibCatTree.instance.expandAll();
      } else {
        this.galleryLibCatTree.instance.collapseAll();
      }
    }
  }

  trackByGalleryLibCat(index: number, cat: any): any {
    return cat && cat.id != null ? cat.id : index;
  }

  private _getDescendantTypeIds(id: any): Set<string> {
    const ids = new Set<string>();
    const node = this._galleryLibTypeMap[String(id)];
    if (!node) { ids.add(String(id)); return ids; }
    const walk = (n: any) => {
      ids.add(String(n.id));
      for (let i = 0; i < n.children.length; i++) { walk(n.children[i]); }
    };
    walk(node);
    return ids;
  }

  private _applyGalleryLibFilter(): void {
    const q = (this.galleryLibFilter || '').trim().toLowerCase();
    if (q) {
      // Búsqueda activa: ignorar tipo y buscar en todos los componentes
      this.galleryLibFilteredItems = this._galleryLibAllComponents.filter((c: any) =>
        (c.Component_Name || '').toLowerCase().includes(q) ||
        (c.Description || '').toLowerCase().includes(q)
      );
    } else if (this.galleryLibSelectedCategoryId != null) {
      // Filtrar por tipo seleccionado e incluir sub-tipos
      const ids = this._getDescendantTypeIds(this.galleryLibSelectedCategoryId);
      this.galleryLibFilteredItems = this._galleryLibAllComponents.filter(
        (c: any) => ids.has(String(c._parentId))
      );
    } else {
      this.galleryLibFilteredItems = this._galleryLibAllComponents.slice();
    }
  }

  galleryLibImgSrc(row: any): string {
    if (row == null || !row.ACHR || String(row.ACHR).trim() === '') { return ''; }
    return 'assets/imgcomponent/' + String(row.ACHR).trim();
  }

  trackByGalleryLib(index: number, row: any): string {
    return row && row.ComponentId != null ? 'lib-' + String(row.ComponentId) : 'lib-' + index;
  }

  openNewAreas() {
    this.popupNewArea = true;
  }

  closeAddMultipleArea() {
    this.dataArea = [
      {
        id: 0,
        name: "",
        sort: 1,
        alternate: false,
      }
    ]
    // this.onFileRemove()
    this.popupNewArea = false

  }



  SaveAreaMultiples() {

    if (this.dataArea.length > 0) {
      let contador = 0
      this.dataArea.forEach(x => {

        let model = {
          method: "Insert_EstimateAreaCE",
          estimateid: this.estimateid,
          name: x.name,
          id: 0,
          sort: x.sort,
          inactive: 0,
          alternate: x.alternate == true || x.alternate == 1 || x.alternate == "1" ? 1 : 0,
        };
        this.MapInformationService.SaveInfoSites(model)
          .subscribe(resp => {
            contador++
            if (contador == this.dataArea.length) {
              this.toast.success("Created Successfully")
              this.popupNewArea = false
              this.reload.emit()
              this.closeAddMultipleArea()
              this.deltaService.GetEstimateAreaList(this.estimateid).subscribe((result) => {
                this.areaSelect = result;
              })
            }
          })
      })
    }


  }

  newAreaMultiple() {
    let dataTempo = [...this.dataArea]
    const newSort = this.dataArea[this.dataArea.length - 1].sort + 1
    dataTempo.push({
      id: this.dataArea.length++,
      name: "",
      sort: newSort,
      alternate: false
    })
    this.dataArea = dataTempo
  }


  deleteAreaMultiple(data) {
    if (this.dataArea.length > 1) {
      const dataTempo = this.dataArea.filter(x => x.id != data.id)
      this.dataArea = dataTempo
    }
  }

  onFileAddAreas(obj: File) {
    // this.loadingService.isLoading.next(true);

    // Validate if the file is an Excel file
    const validExcelTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'application/vnd.ms-excel.template.macroEnabled.12'
    ];

    const validExtensions = ['.xls', '.xlsx', '.xlsm', '.xltx'];
    const fileExtension = obj.name.toLowerCase().substring(obj.name.lastIndexOf('.'));

    if (!validExcelTypes.includes(obj.type) && !validExtensions.includes(fileExtension)) {
      this.toast.error('Please upload a valid Excel file (.xls, .xlsx, .xlsm, .xltx)');
      return;
    }

    /* wire up file reader */
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      try {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
        data = data.filter(x => x.length > 0);
        this.fileData = data;
        this.dataFormatted.headers = data[0];

        this.dataFormatted.data = this.arrayToJSONObject(data);

        if (this.dataFormatted.data.length > 0) {
          let dataTempo = [...this.dataArea]
          let newid = this.dataArea[this.dataArea.length - 1].id + 1

          this.dataFormatted.data.forEach(x => {
            dataTempo.push({
              id: x.id,
              name: x.Name,
              sort: x.Sort,
              alternate: x.isAlternate
            })
          })
          this.dataArea = dataTempo
        }
      } catch (error) {
        this.toast.error('Error reading Excel file. Please make sure it is a valid Excel file.');
        console.error('Error reading Excel file:', error);
      }
    };
    reader.readAsBinaryString(obj);
  }


  refreshTree() {
    // this.showAddOptionsPopup = true;
    this.reload.emit()

  }

  // Función para manejar la selección de opciones
  handleOptionSelect(option: any) {


    // if (obj.itemData.id == 1) {
    //   this.openNewAreas()
    // } else if (obj.itemData.id == 2) {
    //   this.openNewSystems()
    // } else if (obj.itemData.id == 3) {
    //   this.goToImportFromLibrary()
    // } else if (obj.itemData.id == 4) {



    //   localStorage.setItem("SystemIDSelected", this.systemid.toString())
    //   localStorage.setItem("estimateIDSelected", this.estimateid.toString())
    //   localStorage.setItem("estimatenamestrSelected", this.estimatenamestr.toString())
    //   localStorage.setItem("projectIDSelected", this.projectid.toString())
    //   localStorage.removeItem("fromCommissioning")



    //   this.router.navigateByUrl(`/applications`)

    // }

    switch (option.id) {
      case 1: // Add Areas
        // Lógica para agregar áreas
        break;
      case 2: // Add Systems
        // Lógica para agregar sistemas
        this.openNewSystems()
        break;
      case 3: // Import from Library
        // Lógica para importar de biblioteca
        this.goToImportFromLibrary()
        break;
      case 4: // Purchased in cube resources
        // Lógica para recursos comprados
        break;
      case 5: // Import from Excel
        this.popupImportFromExcel = true

        // localStorage.setItem("SystemIDSelected", this.systemid.toString())
        // localStorage.setItem("estimateIDSelected", this.estimateid.toString())
        // localStorage.setItem("estimatenamestrSelected", this.estimatenamestr.toString())
        // localStorage.setItem("projectIDSelected", this.projectid.toString())
        // localStorage.removeItem("fromCommissioning")

        // this.router.navigateByUrl(`/applications`)

        break;
      default:
        break;
    }


    this.showAddOptionsPopup = false;


  }

  // Función para cerrar el popup
  closeAddOptionsPopup() {
    this.showAddOptionsPopup = false;
  }

  selectfirtsArea() {
  }

  dataSystemSelected: any

  OpenNewAI(dataSystem) {
    this.openAI = true
    this.dataSystemSelected = dataSystem
  }

  hidden() {
    this.openAI = false
  }


  returnImage(datasystem) {

    this.dataTest.map(x => {
      x = datasystem
      return x
    })
    this.toast.success("Image loaded successfully")
  }

  eliminarFoto(datasystem) {

    this.dataTest.map(x => {
      x = datasystem
      return x
    })
    this.toast.success("Image deleted successfully")
  }

  AsignarSystem(datasystem) {
    this.dataTest.map(x => {
      x = datasystem
      return x
    })
    this.toast.success("Components loaded successfully")
  }



  modal: boolean = false;
  title: any = "";


  componetsIDS: any[] = []

  importComponentFromLibrary(dataSystem) {
    this.modal = true
    console.log("dataSystem", dataSystem)
    this.dataSystemSelected = dataSystem
    this.closeStepper.emit('ENG-ENGPROJ-MODIMPORTLIBRARY')

  }





  validateFile() {
    this.dataFormatted.data.forEach(x => {
      this.estimateService.Get_EstimateAreaSystemDetailsImportCE(x.PARTNUMBER, x.APPNOTES, x.POINTTYPE).subscribe(result => {
        let obj = result[0];
        if (obj) {
          x.FlagApp_Note = obj.App_Note;
          x.FlagPart_Number = obj.Part_Number;
          x.FlagPoint_Type = obj.Point_Type;
        }

      });
    });
  }
  // javascript create JSON object from two dimensional Array
  arrayToJSONObject2(arr) {
    // header
    const keys = arr[0];

    // vacate keys from main array
    const newArr = arr.slice(1, arr.length);

    const formatted = [];
    const data = newArr;
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < data.length; i++) {
      const d = data[i];
      const o = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  onFileRemove2() {
    this.dataFormatted = {
      headers: [],
      data: []
    }
  }

  onFileAdd2(obj: File) {
    // Validate if the file is an Excel file
    const validExcelTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'application/vnd.ms-excel.template.macroEnabled.12'
    ];

    const validExtensions = ['.xls', '.xlsx', '.xlsm', '.xltx'];
    const fileExtension = obj.name.toLowerCase().substring(obj.name.lastIndexOf('.'));

    if (!validExcelTypes.includes(obj.type) && !validExtensions.includes(fileExtension)) {
      this.toast.error('Please upload a valid Excel file (.xls, .xlsx, .xlsm, .xltx)');
      return;
    }

    /* wire up file reader */
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      try {
        /* read workbook */
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

        /* grab first sheet */
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];

        /* save data */
        let data = <AOA>(XLSX.utils.sheet_to_json(ws, { header: 1 }));
        data = data.filter(x => x.length > 0);
        this.fileData = data;
        this.dataFormatted.headers = data[0];

        this.dataFormatted.data = this.arrayToJSONObject2(data);
        if (this.dataFormatted.data.length > 0) {
          this.dataFormatted.data.forEach(element => {
            element.id = this.dataFormatted.data.length + 1
          });
        }
        this.validateFile();
      } catch (error) {
        this.toast.error('Error reading Excel file. Please make sure it is a valid Excel file.');
        console.error('Error reading Excel file:', error);
      }
    };
    reader.readAsBinaryString(obj);
  }

  uploadFile() {
    let data = this.gridfile.instance.getVisibleRows().map(x => x.data);

    let invalid = data.some(x => !x.TAG || !x.QTY || !x.POINTTYPE || !x.PARTNUMBER || !x.APPNOTES);

    if (invalid) {
      this.toast.warning(this.translate.instant('ModuleEditEstimate.msgValues'));
      return;
    }

    let cantidadAEnviar = data.length;
    let cantidadEnviada = 0;

    data.forEach(element => {
      this.estimateService.Insert_EstimateAreaSystemDetails(
        element.QTY,
        element.PARTNUMBER,
        element.APPNOTES,
        element.TAG,
        element.POINTTYPE,
        element.POINTNUMBER,
        element.SYSTEMID,
        0
      ).subscribe(x => {
        cantidadEnviada++;

        if (cantidadEnviada == cantidadAEnviar) {
          this.toast.success(this.translate.instant('ModuleEditEstimate.msgUpdSucc'));
          this.popupImportFromExcel = false;
          this.onFileRemove()
          // this.updateEstimate({
          //   selectedItem: {
          //     PROJECT_NAME: this.estimatenamestr,
          //     ID: this.estimateid
          //   }
          // });
          this.reload.emit()
        }
      });
    });
  }


  reloadDataMaster() {
    this.reload.emit()
  }

  showpopupSystems: boolean = false
  dataTemplate: any[] = []
  showSystems() {
    this.MapInformationService.SaveInfoSites({ method: "GetSystemTemplate" })
      .subscribe(resp => {
        this.dataTemplate = resp
        this.showpopupSystems = true
      })
  }


  getTemplate() {
    this.MapInformationService.SaveInfoSites({ method: "GetSystemTemplate" })
      .subscribe(resp => {
        let idArea = 0
        const topAreas = this.getGroupItemsTopLevelAreas();
        if (topAreas.length > 0) {
          idArea = topAreas[0].originalid
        }

        if (resp.length > 0) {
          let dataTempo = []
          resp.forEach(x => {
            dataTempo.push({
              id: x.ID,
              areaID: idArea,
              systemTypeID: x.SYSTEMTYPE,
              name: x.SYSTEMNAME,
              sort: 0,
              qty: 1,
              sytemOrigin: x.COPYFROMSYSTEM == 0 || x.COPYFROMSYSTEM == undefined ? null : x.COPYFROMSYSTEM
            })
          })
          this.dataTest = dataTempo
        } else {
          this.toast.warning("You don´t have systems template")
        }
      })
  }



  closeModalTempla() {
    this.showpopupSystems = false
    this.gridTemplate.instance.deselectAll()
  }

  insertData() {
    const resp = this.gridTemplate.instance.getSelectedRowsData()

    if (resp.length > 0) {
      let dataTempo = []
      let idArea = 0
      const topAreas = this.getGroupItemsTopLevelAreas();
      if (topAreas.length > 0) {
        idArea = topAreas[0].originalid
      }
      resp.forEach((x, index) => {
        dataTempo.push({
          id: x.ID,
          areaID: idArea,
          systemTypeID: x.SYSTEMTYPE,
          name: x.SYSTEMNAME,
          sort: x.SORT == undefined ? index : x.SORT,
          qty: 1,
          sytemOrigin: x.COPYFROMSYSTEM == 0 || x.COPYFROMSYSTEM == undefined ? null : x.COPYFROMSYSTEM,
          matchedArea: true,
          matched: true,
        })
      })
      this.dataTest = dataTempo
      this.closeModalTempla()
    } else {
      this.toast.warning("You don´t have systems template")
    }
  }

  onCleanClick(item) {
    this.dataTest.forEach(x => {
      if (x.id == item.id) {
        x.sytemOrigin = null
      }
    })
  }

  updateMultiplesystemsGrid() {
    let nodes = this.getChecked();

    if (nodes.length == 1) {
      this.systemid = nodes[0].id
      this.getEstimateArea(this.estimateid)
      this.getSystemType()
      this.popupController = true
      return false
    }

    this.idsSystem = nodes.map((x) => x.id).join(",")
    setTimeout(() => {
      this.popupEditAreaSystem = true;
      // this.customheight = "auto";
    }, 20);
  }


  openSaveTemplate: boolean = false

  // Función para verificar si Save as Template debe estar deshabilitado
  isSaveAsTemplateDisabled(): boolean {
    return this.dataTest.length === 1 && (!this.dataTest[0].name || this.dataTest[0].name.trim() === '');
  }

  saveAsTemplate() {
    if (this.isSaveAsTemplateDisabled()) {
      return; // No ejecutar si está deshabilitado
    }
    this.openSaveTemplate = true
  }

  SaveTemplate() {


    this.MapInformationService.SaveInfoSites({ method: "DeleteSystemTemplate" })
      .subscribe(resp => {
        let contador = 0
        this.dataTest.forEach((x, index) => {
          const dataFinal = {
            isfirst: index == 0 ? 1 : 0,
            copyfrom: x.sytemOrigin,
            systemname: x.name,
            systemtypeid: x.systemTypeID,
            sort: x.sort,
            method: "SaveSystemTemplate"
          }

          this.MapInformationService.SaveInfoSites(dataFinal)
            .subscribe(resp => {
              contador++
              if (contador == this.dataTest.length) {
                this.toast.success("Template Saved Successfully")
                this.openSaveTemplate = false
                // this.getTemplate()
              }
            })

        })
      })
  }


  areaSelectedNew: any = {
    areaID: 0,
    AreaName: ''
  }

  onAreaSelectedNew(e) {

    console.log('esndfm,snd,fmsnd,fmns,dfms,', e)

    if (e.event != undefined) {
      this.areaSelectedNew.AreaName = this.areaSelect.find(x => x.ID == e.value).AreaName
      this.areaSelectedNew.areaID = e.value
      this.dataDrawingTempo.forEach(item => {
        item.matchedArea = true
        item.areaname = e.selectedItem.AreaName
        item.areaID = e.value
      })


      this.MapInformationService.SaveInfoSites({
        method: "GetAreaAnalyzedImage",
        areaid: e.value
      }).subscribe(resp => {
        console.log("resp", resp)
        if (resp && resp.length > 0) {
          // Guardar la respuesta para poder importarla después
          this.existingWorkData = resp;
          // Mostrar popup preguntando al usuario
          this.showExistingWorkPopup = true;
        }
      })


    }
  }

  hideSystem() {
    this.HideSystemsData.emit()
  }

  // AI Plane Processing Popup
  popupAIProcessing: boolean = false;
  aiSessionInfo: any = {
    sessionId: '',
    status: 'Ready',
    timestamp: new Date().toISOString()
  };
  uploadedPdfFile: File | null = null;
  uploadedPdfBase64: string | null = null;
  uploadedWordFile: File | null = null;
  uploadedWordBase64: string | null = null;
  wordDocumentFile: File | null = null;
  wordDocumentBase64: string | null = null;
  uploadedImageFile: File | null = null;
  uploadedImageBase64: string | null = null;
  isProcessing: boolean = false;

  ProcessPlaneWithCubeAI() {
    this.popupAIProcessing = true;
    this.generateAISession();
  }

  generateAISession() {
    // Generate a unique session ID
    this.aiSessionInfo.sessionId = 'AI_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    this.aiSessionInfo.timestamp = new Date().toISOString();
    this.aiSessionInfo.status = 'Session Created';
  }

  onPdfFileAdded(file: File) {
    if (file.type === 'application/pdf') {
      this.uploadedPdfFile = file;
      this.aiSessionInfo.status = 'PDF Uploaded';
      this.toast.success('PDF file uploaded successfully');

      // Convert file to base64
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.uploadedPdfBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    } else {
      this.toast.error('Please upload a valid PDF file');
    }
  }

  onPdfFileRemoved() {
    this.uploadedPdfFile = null;
    this.uploadedPdfBase64 = null;
    this.aiSessionInfo.status = 'Ready';
  }

  onImageFileAdded(file: File) {
    if (file.type === 'image/jpeg' || file.type === 'image/png') {
      this.uploadedImageFile = file;
      this.aiSessionInfo.status = 'Image Uploaded';
      this.toast.success('Image file uploaded successfully');

      // Convert file to base64
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.uploadedImageBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    } else {
      this.toast.error('Please upload a valid JPEG or PNG image file');
    }
  }

  onImageFileRemoved() {
    this.uploadedImageFile = null;
    this.uploadedImageBase64 = null;
    this.aiSessionInfo.status = 'Ready';
    this.dataDrawingTempo = []
  }

  onWordFileAdded(file: File) {
    // Validar que sea un archivo Word
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document', // .docx
      'application/msword' // .doc
    ];

    if (file && allowedTypes.includes(file.type)) {
      this.uploadedWordFile = file;
      this.aiSessionInfo.status = 'Word Document Uploaded';
      // this.toast.success('Word document uploaded successfully');

      // Convert file to base64
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.uploadedWordBase64 = e.target.result;
      };
      reader.readAsDataURL(file);
    } else if (file) {
      this.toast.error('Please upload only Word documents (.doc or .docx files)');
    }
  }

  onWordFileRemoved() {
    this.uploadedWordFile = null;
    this.uploadedWordBase64 = null;
    this.aiSessionInfo.status = 'Ready';
  }

  onWordDocumentAdded(file: File) {
    const allowedTypes = [
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/msword'
    ];

    const allowedExtensions = ['.doc', '.docx'];
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));

    if (file && allowedTypes.includes(file.type) && allowedExtensions.includes(fileExtension)) {
      this.wordDocumentFile = file;
      this.aiSessionInfo.status = 'Word Document Uploaded';
      // this.toast.success('Word document uploaded successfully');

      this.convertWordFileToBase64(file);
    } else if (file) {
      this.toast.error('Only Word documents (.doc and .docx files) are allowed. Invalid file removed.');
      this.wordDocumentFile = null;
      this.wordDocumentBase64 = null;

      this.clearWordFileUpload();
    }
  }

  clearWordFileUpload() {
    setTimeout(() => {
      if (this.wordFileUpload && this.wordFileUpload.nativeElement) {
        const fileInput = this.wordFileUpload.nativeElement.querySelector('input[type="file"]') as HTMLInputElement;
        if (fileInput) {
          fileInput.value = '';
        }

        const previewElements = this.wordFileUpload.nativeElement.querySelectorAll('.file-preview, .file-info, .file-name, .file-item');
        previewElements.forEach(element => {
          element.remove();
        });

        const dropZone = this.wordFileUpload.nativeElement.querySelector('.file-drop-zone, .mdb-file-upload');
        if (dropZone) {
          dropZone.classList.remove('file-dragover', 'file-uploaded', 'has-file');
        }
      } else {
        const fileUploadElement = document.getElementById('hintInputWord');
        if (fileUploadElement) {
          const fileInput = fileUploadElement.querySelector('input[type="file"]') as HTMLInputElement;
          if (fileInput) {
            fileInput.value = '';
          }

          const previewElements = fileUploadElement.querySelectorAll('.file-preview, .file-info, .file-name, .file-item');
          previewElements.forEach(element => {
            element.remove();
          });

          const dropZone = fileUploadElement.querySelector('.file-drop-zone, .mdb-file-upload');
          if (dropZone) {
            dropZone.classList.remove('file-dragover', 'file-uploaded', 'has-file');
          }
        }
      }
    }, 100);
  }

  onWordDocumentRemoved() {
    this.wordDocumentFile = null;
    this.wordDocumentBase64 = null;
    this.aiSessionInfo.status = 'Ready';
    this.dataWordDocumentBase64 = {
      fileName: '',
      fileSize: 0,
      fileType: '',
      base64Length: 0,
      base64: '',
    }
  }

  dataWordDocumentBase64: any = {
    fileName: '',
    fileSize: 0,
    fileType: '',
    base64Length: 0,
    base64: '',
  }

  convertWordFileToBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        try {
          const base64String = event.target.result;

          if (base64String && base64String.length > 0) {
            const base64Data = base64String.includes(',')
              ? base64String.split(',')[1]
              : base64String;

            const isIntegrityValid = this.verifyBase64Integrity(file, base64Data);

            if (isIntegrityValid) {
              this.wordDocumentBase64 = base64Data;

              this.dataWordDocumentBase64.fileName = file.name;
              this.dataWordDocumentBase64.fileSize = file.size;
              this.dataWordDocumentBase64.fileType = file.type;
              this.dataWordDocumentBase64.base64Length = base64Data.length;
              this.dataWordDocumentBase64.base64 = base64Data;
              this.dataWordDocumentBase64.mimeType = file.type;
              this.dataWordDocumentBase64.integrityCheck = 'PASSED';

              resolve(base64Data);
            } else {
              throw new Error('Base64 integrity check failed - file may be corrupted');
            }
          } else {
            throw new Error('Base64 conversion resulted in empty string');
          }
        } catch (error) {
          console.error('Error processing base64 conversion:', error);
          this.toast.error('Error converting Word document to base64');
          reject(error);
        }
      };

      reader.onerror = (error) => {
        console.error('FileReader error:', error);
        this.toast.error('Error reading Word document file');
        reject(error);
      };

      reader.onabort = () => {
        console.warn('FileReader operation was aborted');
        this.toast.warning('File reading was cancelled');
        reject(new Error('File reading aborted'));
      };

      reader.readAsDataURL(file);
    });
  }

  verifyBase64Integrity(originalFile: File, base64String: string): boolean {
    try {
      const expectedBase64Size = Math.ceil(originalFile.size / 3) * 4;
      const actualBase64Size = base64String.length;

      const sizeDifference = Math.abs(expectedBase64Size - actualBase64Size);
      const tolerance = expectedBase64Size * 0.1;

      if (sizeDifference > tolerance) {
        console.warn('Base64 size mismatch:', {
          expected: expectedBase64Size,
          actual: actualBase64Size,
          difference: sizeDifference,
          tolerance: tolerance
        });
        return false;
      }

      const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
      if (!base64Regex.test(base64String)) {
        console.error('Invalid base64 characters detected');
        return false;
      }

      return true;
    } catch (error) {
      console.error('Error verifying base64 integrity:', error);
      return false;
    }
  }

  getBase64FileInfo(): any {
    if (!this.wordDocumentFile || !this.wordDocumentBase64) {
      return null;
    }

    return {
      fileName: this.wordDocumentFile.name,
      fileSize: this.wordDocumentFile.size,
      fileType: this.wordDocumentFile.type,
      base64Length: this.wordDocumentBase64.length,
      base64Size: Math.ceil(this.wordDocumentBase64.length * 0.75),
      integrityCheck: this.verifyBase64Integrity(this.wordDocumentFile, this.wordDocumentBase64),
      lastModified: this.wordDocumentFile.lastModified
    };
  }








  closeAIPopup() {

    this.popupAIProcessing = false;
    this.uploadedPdfFile = null;
    this.uploadedPdfBase64 = null;
    this.uploadedWordFile = null;
    this.uploadedWordBase64 = null;
    this.wordDocumentFile = null;
    this.wordDocumentBase64 = null;
    this.isProcessing = false;
    this.aiSessionInfo.status = 'Ready';
    // New AI popup properties
    this.showAIPopup = false;
    this.aiPopupContent = '';
    this.aiProcessingType = '';
    this.isAIButtonEnabled = false;
    this.dataWordDocumentBase64 = {
      fileName: '',
      fileSize: 0,
      fileType: '',
      base64Length: 0,
      base64: '',
    }

    this.dataDrawingTempo = []
  }

  parseAllResponses(responses: string[]): any[] {
    let allSystems: any[] = [];

    responses.forEach(response => {
      // Verificar que response no sea null, undefined o vacío
      if (!response || typeof response !== 'string' || response.trim() === '') {
        console.warn('Skipping invalid response:', response);
        return;
      }

      try {
        // Limpiar la respuesta de texto adicional
        let cleanResponse = response.trim();

        // Remover marcadores de código como ```json o ```
        cleanResponse = cleanResponse.replace(/```json\s*/g, '').replace(/```\s*/g, '');

        // Manejar caracteres de escape comunes
        cleanResponse = cleanResponse
          .replace(/\\n/g, '\n')
          .replace(/\\t/g, '\t')
          .replace(/\\"/g, '"')
          .replace(/\\\\/g, '\\');

        // Intentar parsear como JSON
        const parsed = JSON.parse(cleanResponse);

        if (Array.isArray(parsed)) {
          // Si es un array, agregar todos los elementos
          parsed.forEach(system => {
            if (system && system.name) { // Verificar que system existe y tiene name
              allSystems.push({
                id: allSystems.length + 1,
                areaID: this.isValidNumber(system.areaname) ? Number(system.areaname) : '', // buscar esto ahora 
                areaname: system.areaname || '',

                systemTypeID: this.isValidNumber(system.systemType) ? Number(system.systemType) : '',
                systemTypeName: system.systemType,
                name: system.name,
                sort: allSystems.length + 1,
                qty: system.qty || 1,
                sytemOrigin: null,
                description: system.description || '',
                matched: this.isValidNumber(system.systemType) ? true : false,
                matchedArea: this.isValidNumber(system.areaname) ? true : false,
              });
            }
          });
        } else if (parsed && parsed.name) { // Verificar que parsed existe y tiene name
          // Si es un objeto individual
          allSystems.push({
            id: allSystems.length + 1,
            areaID: this.isValidNumber(parsed.areaname) ? Number(parsed.areaname) : '', // buscar esto ahora
            areaname: parsed.areaname || '',

            systemTypeID: this.isValidNumber(parsed.systemType) ? Number(parsed.systemType) : '',
            systemTypeName: parsed.systemType,
            name: parsed.name,
            sort: allSystems.length + 1,
            qty: parsed.qty || 1,
            sytemOrigin: null,
            description: parsed.description || '',
            matched: this.isValidNumber(parsed.systemType) ? true : false,
            matchedArea: this.isValidNumber(parsed.areaname) ? true : false,
          });
        }
      } catch (parseError) {
        console.warn('Failed to parse response:', response, parseError);

        // Intentar parsing alternativo si falla el JSON estándar
        try {
          // Verificar que response sea una cadena válida antes de usar match
          if (typeof response === 'string' && response.length > 0) {
            // Buscar patrones JSON en el texto, incluyendo bloques de código markdown
            let jsonMatch = response.match(/```json\s*(\[[\s\S]*?\]|\{[\s\S]*?\})\s*```/);
            if (jsonMatch && jsonMatch[1]) {
              // Si encuentra un bloque ```json, usar el contenido capturado
              const alternativeParsed = JSON.parse(jsonMatch[1]);
              if (Array.isArray(alternativeParsed)) {
                alternativeParsed.forEach(system => {
                  if (system && system.name) {
                    allSystems.push({
                      id: allSystems.length + 1,
                      areaID: null,
                      systemTypeID: null,
                      name: system.name,
                      sort: allSystems.length + 1,
                      qty: system.qty || 1,
                      sytemOrigin: null,
                      description: system.description || '',
                      areaname: system.areaname || ''
                    });
                  }
                });
              } else if (alternativeParsed && alternativeParsed.name) {
                allSystems.push({
                  id: allSystems.length + 1,
                  areaID: null,
                  systemTypeID: null,
                  name: alternativeParsed.name,
                  sort: allSystems.length + 1,
                  qty: alternativeParsed.qty || 1,
                  sytemOrigin: null,
                  description: alternativeParsed.description || '',
                  areaname: alternativeParsed.areaname || ''
                });
              }
            } else {
              // Si no encuentra bloque de código, buscar JSON directo
              jsonMatch = response.match(/\[[\s\S]*?\]|\{[\s\S]*?\}/);
              if (jsonMatch && jsonMatch[0]) {
                const alternativeParsed = JSON.parse(jsonMatch[0]);
                if (Array.isArray(alternativeParsed)) {
                  alternativeParsed.forEach(system => {
                    if (system && system.name) {
                      allSystems.push({
                        id: allSystems.length + 1,
                        areaID: null,
                        systemTypeID: null,
                        name: system.name,
                        sort: allSystems.length + 1,
                        qty: system.qty || 1,
                        sytemOrigin: null,
                        description: system.description || '',
                        areaname: system.areaname || ''
                      });
                    }
                  });
                } else if (alternativeParsed && alternativeParsed.name) {
                  allSystems.push({
                    id: allSystems.length + 1,
                    areaID: null,
                    systemTypeID: null,
                    name: alternativeParsed.name,
                    sort: allSystems.length + 1,
                    qty: alternativeParsed.qty || 1,
                    sytemOrigin: null,
                    description: alternativeParsed.description || '',
                    areaname: alternativeParsed.areaname || ''
                  });
                }
              }
            }
          }
        } catch (alternativeError) {
          console.error('Alternative parsing also failed for response:', response, alternativeError);
        }
      }
    });


    return allSystems;
  }


  modelSystemType = {
    typename: '',
    availabe: true,
    vav: false,
    shop: false,
    parentId: 0,
    image: '',
    id: 0,
    attachment: ""
  };

  availableSelect = [{ value: true, label: 'Yes' }, { value: false, label: 'No' }];

  BorrarDocument() {
    this.valueDocument = [];
    this.selectedFile = '';
    this.modelSystemType.attachment = ""
  }


  addSystemType() {

    if (!this.modelSystemType.typename) {
      this.toast.warning(this.translate.instant('ModuleUtilyEng.msgvalidTypeName'));
      return;
    }


    this.utilityService.InsertUpdateSystemTypesEngUtility(
      this.modelSystemType.id,
      this.modelSystemType.typename,
      this.modelSystemType.availabe,
      this.modelSystemType.vav,
      this.modelSystemType.shop,
      this.modelSystemType.parentId,
      this.modelSystemType.attachment
    ).subscribe(result => {
      this.salesProjectService.SaveDocumentDinamico(this.modelSystemType.attachment, this.selectedFile, result[0].returnID, "systemtypesutility")
        .subscribe((resp) => {


          if (this.modelSystemType.id > 0) {
            this.toast.success(this.translate.instant('ModuleUtilyEng.msgUpdSucc'));
          } else {
            this.toast.success(this.translate.instant('ModuleUtilyEng.msgAdddSucc'));
          }
          this.labelSystemType = "New System Type"
          this.getSystemTypeMultiple()
          this.clearModelSystemType();
          this.getSystemTypeDatasource(true);
          this.BorrarDocument()

        }, error => {
        });
    });
  }

  clearModelSystemType() {
    this.modelSystemType = {
      typename: '',
      availabe: true,
      vav: false,
      shop: false,
      parentId: 0,
      image: '',
      id: 0,
      attachment: ""
    };
    this.popupNewSytemType = false;
    this.labelSystemType = "New System Type"
  }

  getSystemTypeDatasource(reload = false) {
    if (this.systemTypeDatasource.length == 0 || reload)
      this.utilityService.GetSystemEngUtility().subscribe(result => {
        let info = result.filter(x => x.ID != 0)
        this.systemTypeDatasource = info.map(x => {
          x.Available == true ? x.AvailableYesOrNo = "Yes" : x.AvailableYesOrNo = "No"
          x.SHOP == true ? x.SHOPYesOrNo = "Yes" : x.SHOPYesOrNo = "No"
          x.Available3 == true ? x.Available3YesOrNo = "Yes" : x.Available3YesOrNo = "No"
          x.PARENTID == undefined ? x.PARENTID = 0 : x.PARENTID = Number(x.PARENTID)
          return x
        });
      });
  }

  getType() {
    this.deltaService.GetEstimateSystemType().subscribe(result => {
      this.systemTypeSelect = result;
    });
  }

  attachment: any = "";


  changeFile(ev) {
    if (this.changeBase64 && ev.value[0] && ev.value[0].size < 40000000) {
      // this._documentForm.get('attachment').setValue(ev.value[0].name);
      this.modelSystemType.attachment = ev.value[0].name
      this.getBase64(ev.value[0]);
    } else {
      this.changeBase64 = true;
    }
  }


  getBase64(file: File) {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      let data = e.target.result.toString().split(",")

      // this.dataFinalBase64 = e.target.result.toString()
      this.attachment = data[1]
      this.selectedFile = data[1];

    };
    reader.readAsDataURL(file);
  }
  changeAreaName(newValue: string, item: any) {

    let model = {
      method: "Insert_EstimateAreaCE",
      estimateid: this.estimateid,
      name: newValue,
      id: 0,
      sort: null,
      inactive: 0,
      alternate: 0,
    };

    this.MapInformationService.SaveInfoSites(model).subscribe(result => {
      for (let index = 0; index < this.dataTest.length; index++) {
        if (this.dataTest[index].areaname == item.areaname) {
          this.dataTest[index].areaID = result[0].ID
          this.dataTest[index].matchedArea = true
        }
      }

      this.getAreas()
    })

  }

  changeSystemType(newValue: string, item: any) {

    let model = {
      "method": "InsertUpdate_SystemTypesEngUtility",
      "typrname": newValue,
      "available": true,
      "vav": false,
      "shop": false,
      "parentid": 0,
      "image": "",
      "id": 0
    }

    this.MapInformationService.SaveInfoSites(model).subscribe(result => {
      for (let index = 0; index < this.dataTest.length; index++) {
        if (this.dataTest[index].systemTypeName == item.systemTypeName) {
          this.dataTest[index].systemTypeID = result[0].returnID
          this.dataTest[index].matched = true
        }
      }

      this.getSystemTypeMultiple()
    })



  }

  isValidNumber(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return false;
    }
    const num = Number(value);
    return !isNaN(num) && isFinite(num);
  }

  changeToSelect(item: any) {




    this.dataTest.forEach(element => {
      if (element.id == item.id) {
        element.matched = !element.matched

        const dataSPAI = {
          method: "GetCubeOpenAIQuestionByType",
          topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
        }

        // obtener todas las preguntas del AI
        this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultPReguntasAI => {

          const itemEachPregunta = resultPReguntasAI[0]

          const key = itemEachPregunta.TYPEPROMPT.split(':')[2]; // Extract the key after the second colon
          const spDinamic = itemEachPregunta.TYPEPROMPT.split(':')[1]; // Extract the key after the second colon
          const newVariable = {
            method: spDinamic,
          };

          this.MapInformationService.SaveInfoSites(newVariable).subscribe(result1 => {

            const resultString = JSON.stringify(result1);

            let prompt = {
              systemPrompt: `${itemEachPregunta.SYSTEMPROMPT} `, // ${resultString}
              userprompt: `${itemEachPregunta.USERPROMPT} ${element.name} ${resultString}`, // ${resultString}
            };

            // Actualizar progreso antes de procesar
            // this.updateProgress(allResponses.length, eachBase64.length, `Processing image ${index + 1} of ${eachBase64.length}...`);
            this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultDatafromAI => {
              if (resultDatafromAI.content != undefined) {
                const resultData = JSON.parse(resultDatafromAI.content)
                element.systemTypeID = resultData.id
              }
            })
          })
        })

      }
    });
  }

  changeToSelectArea(item: any) {


    this.dataTest.forEach(element => {
      if (element.id == item.id) {
        element.matchedArea = !element.matchedArea
      }
    });
  }

  selectFisrtItem() {
    this.treeViewSystemArea.instance.selectItem(this.groupItems[0])
  }

  ExpandAll() {
    this.treeViewSystemArea.instance.expandAll()
  }

  iconBack: boolean = false
  showbackactionSort: boolean = false
  showbackactionAreaName: boolean = false
  showbackactionSystemType: boolean = false
  showbackactionSystemName: boolean = false
  showbackactionQty: boolean = false
  showbackactionDescription: boolean = false

  SendBackData(type: string) {

    if (type == 'Sort') {
      this.showselectSort = true
      this.showbackactionSort = false
    } else if (type == 'Area Name') {
      this.showselectArea = true
      this.showbackactionAreaName = false
    } else if (type == 'System Type') {
      this.showselectSystemType = true
      this.showbackactionSystemType = false
    } else if (type == 'System Name') {
      this.showselectSystemName = true
      this.showbackactionSystemName = false
    } else if (type == 'Qty') {
      this.showselectQty = true
      this.showbackactionQty = false
    } else if (type == 'Description') {
      this.showselectSystemOrigin = true
      this.showbackactionDescription = false
    }

    this.dataTest = this.dataTestTempo
    this.missingColumns = this.missingColumnsTempo
    this.iconBack = false

  }


  // ****************************************************** logica para el guide Tour ******************************************************


  openNewSystem() {
    this.addSystemsShowQuickEntryOnly = false;
    this.popupNewSystem = true;
    this.getEstimateArea(this.estimateid);
    this.getSystemTypeMultiple();
  }

  changeVariableExcel() {
    this.showExcelInput()
  }

  writeNewSystem() {
    const text = "New System";
    let currentIndex = 0;

    // Clear the current text
    this.dataTest[0].name = "";

    // Typewriter effect with 100ms delay between letters
    const typeInterval = setInterval(() => {
      if (currentIndex < text.length) {
        this.dataTest[0].name += text[currentIndex];
        currentIndex++;
      } else {
        clearInterval(typeInterval);
      }
    }, 100); // 100ms delay - adjust this value to make it faster (lower) or slower (higher)
  }


  changeViewCard() {
    // this.showExcelInputElement = true
  }

  gotToLibraryMaster() {
    this.router.navigate(['/LibraryMaster'])
  }

  goToImportFromLibraryGuideTour() {

    localStorage.removeItem("systemidTree")
    // localStorage.removeItem("fromLibrary")
    if (this.systemid != undefined) {
      localStorage.setItem("systemidTree", this.systemid.toString())
    }

    if (this.Commissioning == "Commissioning") {
      localStorage.setItem("fromEstimate", "No")
    } else {
      localStorage.setItem("fromEstimate", "Yes")
    }

    localStorage.setItem("guideTour", "Yes")

    this.router.navigateByUrl(
      `/Estimates/import-from-library?estimateid=${this.estimateid}&project=${this.estimatenamestr}&systemid=${this.systemid}`
    );
  }


  goToImportFromLibraryWithoutGuideTour() {

    localStorage.removeItem("systemidTree")
    // localStorage.removeItem("fromLibrary")
    if (this.systemid != undefined) {
      localStorage.setItem("systemidTree", this.systemid.toString())
    }

    if (this.Commissioning == "Commissioning") {
      localStorage.setItem("fromEstimate", "No")
    } else {
      localStorage.setItem("fromEstimate", "Yes")
    }


    this.router.navigateByUrl(
      `/Estimates/import-from-library?estimateid=${this.estimateid}&project=${this.estimatenamestr}&systemid=${this.systemid}`
    );
  }

  getItemsSelected() {
    this.treeViewSystemArea.instance.getSelectedNodes()
    return this.treeViewSystemArea.instance.getSelectedNodes()
  }


  getElement(ref: any) {
    return ref && ref.instance ? ref.instance.element() : null;
  }

  /**
   * Process the sequence of operations for the project
   */
  processSequenceOfOperation() {
    this.aiProcessingType = 'sequence';

    this.showAIPopup = true;
  }

  /**
   * Process the scope of work for the project
   */
  processScopeOfWork() {
    this.aiProcessingType = 'scope';

    this.showAIPopup = true;
  }

  /**
   * Process the project plan
   */

  textSaveAccount: any = ""

  processPlan() {
    this.aiProcessingType = 'drawing';

    // this.showAIPopup = true;

    this.code = "Process Drawing"

    this.popupAIProcessing = true;
  }




  /**
   * Process with Cube AI
   */
  processWithCubeAI() {

    if (this.aiProcessingType == 'sequence') {
      this.showModalWithCredit(this.aiProcessingType);
      this.code = "Process Word"
    } else if (this.aiProcessingType == 'scope') {
      this.code = "Process Scope"
      this.showModalWithCredit(this.aiProcessingType);
    } else if (this.aiProcessingType == 'drawing') {
      this.code = "Process Drawing"
      this.showModalWithCredit(this.aiProcessingType);
    }



  }


  processDataScope() {

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "GET_SCOPE_OF_WORK_ALL_PROJECT"
    }


    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {

      const item = result[0];


      const resultString = JSON.stringify(this.aiPopupContent);

      let prompt = {
        systemPrompt: item.SYSTEMPROMPT,
        userprompt: item.USERPROMPT + ' ' + resultString,
      }

      this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {

        const infoTempo = JSON.parse(result.content);
        infoTempo.forEach((item, index) => {
          item.id = Date.now().toString(16) + Math.random().toString(16).substring(2)
          this.dataTest.push(item)
        })
        this.closeAIPopup();
        this.showProcessedSystemsModal = true;

        this.toast.success('Scope of Work processed successfully with Cube AI');
      });
    })


  }


  getDataSequenceOfOperation() {


    if (!this.dataWordDocumentBase64.base64) {
      this.toast.warning('Please upload a Word document first');
      return;
    }

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "GET_SEQUENCE_OPERATION_ALL_PROJECT"
    }


    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {

      const wordPrompt = {
        Base64Docx: this.dataWordDocumentBase64.base64
      };

      this.MapInformationService.getInfoDocumentWord(wordPrompt).subscribe(dataWord => {

        const item = result[0];

        const resultString = JSON.stringify(this.aiPopupContent);

        let prompt = {
          systemPrompt: item.SYSTEMPROMPT,
          userprompt: item.USERPROMPT + ' ' + dataWord.docText,
        }

        this.MapInformationService.GetCodeFromAI(prompt).subscribe(result => {

          this.dataTest = JSON.parse(result.content);
          this.closeAIPopup();
          this.showProcessedSystemsModal = true;

          this.toast.success('Scope of Work processed successfully with Cube AI');
        });
      })
    });
  }




  openModalDiagramNew: boolean = false

  // Template JSON para inicializar el diagrama
  templateJSONNew: any = {
    "page": {
      "width": 24491,
      "height": 15817,
      "pageColor": -1,
      "pageWidth": 15817,
      "pageHeight": 24491,
      "pageLandscape": true,
      "viewUnits": "in",
      "units": "in"
    },
    "connectors": [],
    "shapes": []
  };

  zoomDiagramNew: number = 0.75;

  // Variables de prueba para el diagrama nuevo
  // componentsDesignTools: any[] = [
  //   {
  //     ID: 'co2icon',
  //     SystemType: 'Design Tools',
  //     NAME: 'co2icon',
  //     Name: 'co2icon',
  //     filesvg: 'assets/svgTakeoff/co2icon.svg',
  //     filename: 'co2icon.svg',
  //     componentwidth: 0.3,
  //     componentHeight: 0.3
  //   },
  //   {
  //     ID: 'Hicon',
  //     SystemType: 'Design Tools',
  //     NAME: 'Hicon',
  //     Name: 'Hicon',
  //     filesvg: 'assets/svgTakeoff/Hicon.svg',
  //     filename: 'Hicon.svg',
  //     componentwidth: 0.3,
  //     componentHeight: 0.3
  //   },
  //   {
  //     ID: 'THicon',
  //     SystemType: 'Design Tools',
  //     NAME: 'THicon',
  //     Name: 'THicon',
  //     filesvg: 'assets/svgTakeoff/THicon.svg',
  //     filename: 'THicon.svg',
  //     componentwidth: 0.3,
  //     componentHeight: 0.3
  //   },
  //   {
  //     ID: 'Ticon',
  //     SystemType: 'Design Tools',
  //     NAME: 'Ticon',
  //     Name: 'Ticon',
  //     filesvg: 'assets/svgTakeoff/Ticon.svg',
  //     filename: 'Ticon.svg',
  //     componentwidth: 0.3,
  //     componentHeight: 0.3
  //   }
  // ];

  componentsDesignTools: any[] = [];

  componentsNew: any[] = [];

  // componentsGroupsNew: string[] = ['HVAC', 'Electrical', 'Plumbing'];

  componentsGroupsNew: string[] = [];

  // Datos estáticos de prueba para el treeview del diagrama
  // groupItemsDiagram: any[] = [
  //   {
  //     id: 1,
  //     text: 'HVAC',
  //     expanded: true,
  //     parentId: null,
  //     items: [
  //       {
  //         id: 11,
  //         text: 'Ventilador',
  //         expanded: false,
  //         parentId: 1,
  //         items: []
  //       },
  //       {
  //         id: 12,
  //         text: 'Compresor',
  //         expanded: false,
  //         parentId: 1,
  //         items: []
  //       },
  //       {
  //         id: 13,
  //         text: 'Termostato',
  //         expanded: false,
  //         parentId: 1,
  //         items: []
  //       }
  //     ]
  //   },
  //   {
  //     id: 2,
  //     text: 'Electrical',
  //     expanded: true,
  //     parentId: null,
  //     items: [
  //       {
  //         id: 21,
  //         text: 'Interruptor',
  //         expanded: false,
  //         parentId: 2,
  //         items: []
  //       },
  //       {
  //         id: 22,
  //         text: 'Panel Eléctrico',
  //         expanded: false,
  //         parentId: 2,
  //         items: []
  //       },
  //       {
  //         id: 23,
  //         text: 'Transformador',
  //         expanded: false,
  //         parentId: 2,
  //         items: []
  //       }
  //     ]
  //   },
  //   {
  //     id: 3,
  //     text: 'Plumbing',
  //     expanded: true,
  //     parentId: null,
  //     items: [
  //       {
  //         id: 31,
  //         text: 'Válvula',
  //         expanded: false,
  //         parentId: 3,
  //         items: []
  //       },
  //       {
  //         id: 32,
  //         text: 'Bomba',
  //         expanded: false,
  //         parentId: 3,
  //         items: []
  //       },
  //       {
  //         id: 33,
  //         text: 'Filtro',
  //         expanded: false,
  //         parentId: 3,
  //         items: []
  //       }
  //     ]
  //   },
  //   {
  //     id: 4,
  //     text: 'Mechanical',
  //     expanded: false,
  //     parentId: null,
  //     items: [
  //       {
  //         id: 41,
  //         text: 'Motor',
  //         expanded: false,
  //         parentId: 4,
  //         items: []
  //       },
  //       {
  //         id: 42,
  //         text: 'Engranaje',
  //         expanded: false,
  //         parentId: 4,
  //         items: []
  //       }
  //     ]
  //   }
  // ];

  groupItemsDiagram: any[] = [];

  image_name: string = '';
  base64Returned: string = '';
  showConfirmDeleteTreeItem: boolean = false;
  showDeleteSelectionModal: boolean = false;
  itemToDeleteTree: any = null;
  deleteSelection: string = 'parent'; // 'parent' o 'children'
  deleteOptions: any[] = [
    { value: 'parent', text: 'Delete parent and all children' },
    { value: 'children', text: 'Delete only children' }
  ];
  showAddTextModal: boolean = false;
  newTextItemName: string = '';
  selectedParentForNewItem: any = null;
  itemEditingId: number | null = null;
  itemEditingText: string = '';

  @ViewChild('treeContextMenu', { static: false }) treeContextMenu: DxContextMenuComponent;
  contextMenuCurrentItem: any = null;
  contextMenuItems: any[] = [];
  /** Identificador del `dx-sortable` que envuelve el tree (un solo árbol). */
  readonly treeSortableDataId = 'treeviewAreaSystemSortable';
  /** Clase aplicada al panel real del menú (overlay); debe coincidir con estilos en styles.scss */
  treeContextMenuCssClass = 'treeview-area-ctx-menu';
  /** Inline rename (area): solo nombre en el tree */
  inlineRenameAreaOriginalId: any = null;
  inlineRenameAreaDraft = '';
  inlineRenameAreaSort: any = null;
  inlineRenameAreaActive: any = null;
  inlineRenameAreaAlternate = false;

  /** Inline rename (system): solo nombre en el tree */
  inlineRenameSystemId: any = null;
  inlineRenameSystemDraft = '';

  onTreeItemContextMenu(e: any) {
    if (!e || !e.event) {
      return;
    }
    e.event.preventDefault();
    if (this.ModuleFrom !== 'Edit Estimate') {
      return;
    }

    if (!e.itemData) {
      if (this.treeContextMenu && this.treeContextMenu.instance) {
        this.treeContextMenu.instance.hide();
      }
      return;
    }

    this.contextMenuCurrentItem = e.itemData;
    const items = this.buildContextMenuItems(e.itemData);
    if (!items || !items.length) {
      if (this.treeContextMenu && this.treeContextMenu.instance) {
        this.treeContextMenu.instance.hide();
      }
      return;
    }

    this.contextMenuItems = items;
    const ev = e.event;
    const pageX = typeof ev.pageX === 'number' ? ev.pageX : ev.clientX + (window.scrollX || 0);
    const pageY = typeof ev.pageY === 'number' ? ev.pageY : ev.clientY + (window.scrollY || 0);

    let positionCfg: any;
    let el: any = ev.target;
    if (el && el.nodeType === 3 && el.parentElement) {
      el = el.parentElement;
    }
    const row = el && typeof el.closest === 'function' ? el.closest('.dx-treeview-item') : null;
    if (row instanceof Element) {
      positionCfg = {
        my: 'left top',
        at: 'left bottom',
        of: row,
        collision: 'flip fit',
      };
    } else {
      positionCfg = {
        my: 'left top',
        at: 'left top',
        of: document.body,
        offset: String(pageX) + ' ' + String(pageY),
        collision: 'flip fit',
      };
    }

    // Hide immediately (no-op if already hidden), then wait one frame so
    // DevExtreme finishes tearing down the overlay before we set fresh data
    // and show again. Data is pushed via option() — no Angular CD needed.
    if (this.treeContextMenu && this.treeContextMenu.instance) {
      this.treeContextMenu.instance.hide();
    }

    setTimeout(() => {
      if (this.treeContextMenu && this.treeContextMenu.instance) {
        this.treeContextMenu.instance.option('cssClass', this.treeContextMenuCssClass);
        this.treeContextMenu.instance.option('dataSource', items);
        this.treeContextMenu.instance.option('position', positionCfg);
        this.treeContextMenu.instance.show();
      }
    }, 50);
  }

  /** Quita borde/fondo cuadrado del .dx-overlay-content del tema Genérico */
  onTreeContextMenuShown() {
    const menuEl = document.querySelector('.treeview-area-ctx-menu.dx-context-menu');
    if (!menuEl) {
      return;
    }
    let el: HTMLElement | null = menuEl as HTMLElement;
    while (el) {
      if (el.classList && el.classList.contains('dx-overlay-content')) {
        el.classList.add('treeview-area-ctx-overlay-shell');
        break;
      }
      el = el.parentElement;
    }
  }

  onTreeContextMenuHidden() {
    const shells = document.querySelectorAll('.treeview-area-ctx-overlay-shell');
    for (let i = 0; i < shells.length; i++) {
      shells[i].classList.remove('treeview-area-ctx-overlay-shell');
    }
  }

  treeItemDragEnabled(item: any): boolean {
    if (this.Commissioning === 'Commissioning') {
      return false;
    }
    if (item == null) {
      return false;
    }
    if (item.isEstimateRoot === true) {
      return false;
    }
    if (this.inlineRenameAreaOriginalId != null && this.isTreeviewAreaItem(item) && item.originalid == this.inlineRenameAreaOriginalId) {
      return false;
    }
    if (this.inlineRenameSystemId != null && this.isTreeviewSystemItem(item) && item.id == this.inlineRenameSystemId) {
      return false;
    }
    return true;
  }

  onTreeSortableDragStart(e: DragStartEvent): void {
    if (this.ModuleFrom !== 'Edit Estimate') {
      e.cancel = true;
      return;
    }
    if (e.fromIndex == null || e.fromIndex < 0 || !this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    const fromNode = this.treeSortableFindNodeByFlatIndex(e.fromIndex);
    if (!fromNode || !fromNode.itemData || !this.treeItemDragEnabled(fromNode.itemData)) {
      e.cancel = true;
    }
  }

  onTreeSortableDragChange(e: DragChangeEvent): void {
    if (this.ModuleFrom !== 'Edit Estimate') {
      e.cancel = true;
      return;
    }
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    const fromIdx = e.fromIndex;
    const toIdx = e.toIndex;
    if (fromIdx == null || toIdx == null || fromIdx < 0 || toIdx < 0) {
      return;
    }
    const fromNode = this.treeSortableFindNodeByFlatIndex(fromIdx);
    const toNode = this.treeSortableFindNodeByFlatIndex(this.treeSortableCalculateToIndex(e));
    if (!fromNode || !fromNode.itemData) {
      e.cancel = true;
      return;
    }
    if (!this.treeItemDragEnabled(fromNode.itemData)) {
      e.cancel = true;
      return;
    }
    if (!toNode || !toNode.itemData || fromNode.itemData === toNode.itemData) {
      e.cancel = true;
      return;
    }
    if (fromNode && toNode && this.treeSortableIsDescendantOf(fromNode, toNode)) {
      e.cancel = true;
      return;
    }
    if (toNode.itemData.isEstimateRoot === true && e.dropInsideItem === true) {
      e.cancel = true;
      return;
    }
    const src = fromNode.itemData;
    const tgt = toNode.itemData;
    const srcSys = src.issystem === true;
    const tgtSys = tgt.issystem === true;
    if (srcSys && !tgtSys && tgt.isEstimateRoot === true) {
      e.cancel = true;
      return;
    }
    if (srcSys && tgtSys) {
      if (src.areaid == null || tgt.areaid == null || src.areaid != tgt.areaid) {
        e.cancel = true;
      }
      return;
    }
    if (!srcSys && tgtSys) {
      e.cancel = true;
      return;
    }
    if (srcSys && !tgtSys) {
      return;
    }
    if (!srcSys && !tgtSys) {
      const dropInside = e.dropInsideItem === true;
      const sameParent = this.normalizeParetid(src.paretid) === this.normalizeParetid(tgt.paretid);
      if (dropInside) {
        if (src.originalid == tgt.originalid) {
          e.cancel = true;
        }
        return;
      }
      if (!sameParent) {
        e.cancel = true;
      }
    }
  }

  onTreeSortableDragEnd(e: DragEndEvent): void {
    e.cancel = true;
    if (this.ModuleFrom !== 'Edit Estimate') {
      return;
    }
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    if (e.fromIndex === e.toIndex && !e.dropInsideItem) {
      return;
    }
    const fromNode = this.treeSortableFindNodeByFlatIndex(e.fromIndex);
    const toNode = this.treeSortableFindNodeByFlatIndex(this.treeSortableCalculateToIndex(e));
    const source = fromNode && fromNode.itemData;
    const target = toNode && toNode.itemData;
    if (!source || !target) {
      return;
    }
    this._dragExpandSnapshot = this.captureTreeExpandedState();
    if (source.isEstimateRoot === true || target.isEstimateRoot === true) {
      return;
    }
    if (source.issystem === true && target.issystem === true) {
      if (source.areaid != null && target.areaid != null && source.areaid == target.areaid) {
        this.applyReorderSiblingSystems(source, target);
      }
      return;
    }
    if (source.issystem === true && target.issystem !== true) {
      this.applyMoveSystemToArea(source, target);
      return;
    }
    if (source.issystem !== true && target.issystem !== true) {
      if (e.dropInsideItem) {
        this.applyNestAreaUnderArea(source, target);
        return;
      }
      const sameParent = this.normalizeParetid(source.paretid) === this.normalizeParetid(target.paretid);
      if (sameParent) {
        this.applyReorderSiblingAreas(source, target);
        return;
      }
      this.toast.warning(
        'Para reordenar, suelta entre nodos del mismo nivel. Para anidar dentro de un área, suelta sobre el nodo (dentro).'
      );
    }
  }

  private treeSortableCalculateToIndex(e: {
    fromComponent?: unknown;
    toComponent?: unknown;
    fromIndex?: number;
    toIndex?: number;
    dropInsideItem?: boolean;
  }): number {
    const fromIdx = e.fromIndex != null ? e.fromIndex : 0;
    const toIdx = e.toIndex != null ? e.toIndex : 0;
    if (e.fromComponent !== e.toComponent || e.dropInsideItem) {
      return toIdx;
    }
    return fromIdx >= toIdx ? toIdx : toIdx + 1;
  }

  private treeSortableReadItemIdFromNodeEl(nodeEl: Element): string | null {
    const row = nodeEl.querySelector('.treeview-item-row[data-dnd-tree-id]');
    const raw = row ? row.getAttribute('data-dnd-tree-id') : null;
    return raw != null && raw !== '' ? raw : null;
  }

  private treeSortableFindNodeByItemId(nodes: dxTreeViewNode[] | undefined, id: string): dxTreeViewNode | null {
    if (!nodes || !nodes.length) {
      return null;
    }
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i];
      if (n && n.itemData != null && String(n.itemData.id) === id) {
        return n;
      }
      if (n && n.children && n.children.length) {
        const found = this.treeSortableFindNodeByItemId(n.children, id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  private treeSortableFindNodeByFlatIndex(index: number): dxTreeViewNode | null {
    const tv = this.treeViewSystemArea && this.treeViewSystemArea.instance;
    if (tv == null || index == null || index < 0) {
      return null;
    }
    const host = tv.element();
    if (!host) {
      return null;
    }
    const list = host.querySelectorAll('.dx-treeview-node');
    const nodeEl = list[index] as Element;
    if (!nodeEl) {
      return null;
    }
    const id = this.treeSortableReadItemIdFromNodeEl(nodeEl);
    if (id == null) {
      return null;
    }
    return this.treeSortableFindNodeByItemId(tv.getNodes(), id);
  }

  private treeSortableIsDescendantOf(ancestor: dxTreeViewNode | null, candidate: dxTreeViewNode | null): boolean {
    if (!ancestor || !ancestor.itemData || !candidate || !candidate.itemData) {
      return false;
    }
    const parentKey = ancestor.itemData.id;
    let p: dxTreeViewNode | null = candidate.parent != null ? candidate.parent : null;
    while (p != null) {
      if (p.itemData != null && String(p.itemData.id) === String(parentKey)) {
        return true;
      }
      p = p.parent != null ? p.parent : null;
    }
    return false;
  }

  private normalizeParetid(v: any): number {
    if (v === null || v === undefined || v === '' || v === 0) {
      return 0;
    }
    const n = Number(v);
    return isNaN(n) ? 0 : n;
  }

  private areaDbIdFromOriginal(originalid: any): number {
    const n = Number(originalid);
    if (isNaN(n)) {
      return 0;
    }
    if (n < 0) {
      return -n;
    }
    return n;
  }

  private findAreaBranchByOriginalId(nodes: any[], originalId: any): any {
    if (!nodes || !Array.isArray(nodes)) {
      return null;
    }
    for (let i = 0; i < nodes.length; i++) {
      const n = nodes[i];
      if (!n) {
        continue;
      }
      if (n.issystem !== true && n.originalid == originalId) {
        return n;
      }
      if (n.items && n.items.length) {
        const found = this.findAreaBranchByOriginalId(n.items, originalId);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  private areaBranchContainsAreaAncestor(branch: any, descendantOriginalId: any): boolean {
    if (!branch || !branch.items || descendantOriginalId == null) {
      return false;
    }
    for (let i = 0; i < branch.items.length; i++) {
      const c = branch.items[i];
      if (!c || c.issystem === true) {
        continue;
      }
      if (c.originalid == descendantOriginalId) {
        return true;
      }
      if (this.areaBranchContainsAreaAncestor(c, descendantOriginalId)) {
        return true;
      }
    }
    return false;
  }

  private computeNextSystemSortInArea(areaNode: any): number {
    let maxSort = 0;
    if (!areaNode || !areaNode.items || !Array.isArray(areaNode.items)) {
      return 1;
    }
    for (let i = 0; i < areaNode.items.length; i++) {
      const it = areaNode.items[i];
      if (!it || it.issystem !== true) {
        continue;
      }
      const s = Number(it.Sort);
      if (!isNaN(s) && s > maxSort) {
        maxSort = s;
      }
    }
    return maxSort + 1;
  }

  private collectSystemsInArea(areaOriginalId: any): any[] {
    const areaNode = this.findAreaBranchByOriginalId(this.groupItems, areaOriginalId);
    if (!areaNode || !areaNode.items || !Array.isArray(areaNode.items)) {
      return [];
    }
    const out: any[] = [];
    for (let j = 0; j < areaNode.items.length; j++) {
      const ch = areaNode.items[j];
      if (ch && ch.issystem === true) {
        out.push(ch);
      }
    }
    return out;
  }

  private applyReorderSiblingSystems(sourceSys: any, targetSys: any) {
    const self = this;
    if (!sourceSys || !targetSys || sourceSys.issystem !== true || targetSys.issystem !== true) {
      return;
    }
    const areaOrig = sourceSys.areaid;
    if (areaOrig == null || targetSys.areaid == null || areaOrig != targetSys.areaid) {
      return;
    }
    const siblings = this.collectSystemsInArea(areaOrig);
    if (siblings.length < 2) {
      return;
    }
    const order = siblings.slice();
    let from = -1;
    let to = -1;
    for (let i = 0; i < order.length; i++) {
      if (order[i].id == sourceSys.id) {
        from = i;
      }
      if (order[i].id == targetSys.id) {
        to = i;
      }
    }
    if (from < 0 || to < 0 || from === to) {
      return;
    }
    const moving = order.splice(from, 1)[0];
    let insertTo = to;
    if (from < to) {
      insertTo = to - 1;
    }
    order.splice(insertTo, 0, moving);
    let pending = order.length;
    let hadError = false;
    for (let j = 0; j < order.length; j++) {
      const it = order[j];
      this.estimateService.UpadteSort_EstimateAreaSystemCESingle(it.id, j + 1).subscribe(
        function () {
          pending -= 1;
          if (pending === 0 && !hadError) {
            self.toast.success(self.translate.instant('ModuleSystemToArea.msgUpdSucc'));
            self.refreshGroupItemsFromSystemArea(true, function () {
              self.reload.emit(self.estimateid);
            });
          }
        },
        function () {
          hadError = true;
          pending -= 1;
          if (pending === 0) {
            self.toast.error('Could not reorder systems.');
            self.refreshGroupItemsFromSystemArea(false);
          }
        }
      );
    }
  }

  private applyMoveSystemToArea(systemItem: any, targetArea: any) {
    const self = this;
    if (systemItem == null || systemItem.id == null || targetArea == null || targetArea.originalid == null) {
      return;
    }
    const areaNode = this.findAreaBranchByOriginalId(this.groupItems, targetArea.originalid) || targetArea;
    const nextSort = this.computeNextSystemSortInArea(areaNode);
    this.estimateService.Upadte_EstimateSystemAreaCE(systemItem.id, targetArea.originalid, nextSort).subscribe(
      function () {
        self.toast.success(self.translate.instant('ModuleSystemToArea.msgUpdSucc'));
        self.refreshGroupItemsFromSystemArea(true, function () {
          self.reload.emit(self.estimateid);
        });
      },
      function () {
        self.toast.error('Could not move system.');
      }
    );
  }

  private applyNestAreaUnderArea(sourceArea: any, targetArea: any) {
    const self = this;
    if (sourceArea == null || targetArea == null || sourceArea.originalid == null || targetArea.originalid == null) {
      return;
    }
    const parentDbId = this.areaDbIdFromOriginal(targetArea.originalid);
    const activeBool = sourceArea.areaactive === true || sourceArea.areaactive == 1;
    const model = {
      method: 'Insert_EstimateAreaCE',
      estimateid: this.estimateid,
      name: sourceArea.areaname,
      id: sourceArea.originalid,
      sort: sourceArea.sort,
      inactive: !activeBool,
      alternate: sourceArea.Alternate == 1 || sourceArea.Alternate === true ? 1 : 0,
      paretid: parentDbId,
    };
    this.MapInformationService.SaveInfoSites(model).subscribe(
      function () {
        self.toast.success(self.translate.instant('ModuleSystemToArea.msgAreSucc'));
        self.refreshGroupItemsFromSystemArea(true, function () {
          self.reload.emit(self.estimateid);
        });
      },
      function () {
        self.toast.error('Could not move area (nested). Check that the server accepts paretid.');
      }
    );
  }

  private findAreaBranchByDbId(nodes: any, dbId: number): any {
    if (dbId === 0 || nodes == null) {
      return null;
    }
    const list = Array.isArray(nodes) ? nodes : [nodes];
    for (let i = 0; i < list.length; i++) {
      const n = list[i];
      if (!n) {
        continue;
      }
      if (n.issystem !== true && this.areaDbIdFromOriginal(n.originalid) === dbId) {
        return n;
      }
      if (n.items && n.items.length) {
        const f = this.findAreaBranchByDbId(n.items, dbId);
        if (f) {
          return f;
        }
      }
    }
    return null;
  }

  private collectAreaSiblingsForParent(parentParetidNorm: number): any[] {
    if (!this.groupItems || !Array.isArray(this.groupItems)) {
      return [];
    }
    if (parentParetidNorm === 0) {
      const roots = this.getGroupItemsTopLevelAreas();
      return roots.filter(function (g) {
        return g && g.issystem !== true;
      });
    }
    const parent = this.findAreaBranchByDbId(this.groupItems, parentParetidNorm);
    if (!parent || !parent.items || !Array.isArray(parent.items)) {
      return [];
    }
    const out: any[] = [];
    for (let j = 0; j < parent.items.length; j++) {
      const ch = parent.items[j];
      if (ch && ch.issystem !== true) {
        out.push(ch);
      }
    }
    return out;
  }

  private applyReorderSiblingAreas(sourceArea: any, targetArea: any) {
    const self = this;
    const parentP = this.normalizeParetid(targetArea.paretid);
    const siblings = this.collectAreaSiblingsForParent(parentP);
    if (siblings.length < 2) {
      return;
    }
    const order = siblings.slice();
    let from = -1;
    let to = -1;
    for (let i = 0; i < order.length; i++) {
      if (order[i].originalid == sourceArea.originalid) {
        from = i;
      }
      if (order[i].originalid == targetArea.originalid) {
        to = i;
      }
    }
    if (from < 0 || to < 0 || from === to) {
      return;
    }
    const moving = order.splice(from, 1)[0];
    let insertTo = to;
    if (from < to) {
      insertTo = to - 1;
    }
    order.splice(insertTo, 0, moving);
    let pending = order.length;
    let hadError = false;
    for (let j = 0; j < order.length; j++) {
      const it = order[j];
      this.estimateService.Update_EstimateAreaCE(it.originalid, j + 1).subscribe(
        function () {
          pending -= 1;
          if (pending === 0 && !hadError) {
            self.toast.success(self.translate.instant('ModuleSystemToArea.msgAreSucc'));
            self.refreshGroupItemsFromSystemArea(true, function () {
              self.reload.emit(self.estimateid);
            });
          }
        },
        function () {
          hadError = true;
          pending -= 1;
          if (pending === 0) {
            self.toast.error('Could not reorder areas.');
            self.refreshGroupItemsFromSystemArea(false);
          }
        }
      );
    }
  }

  /** Nodo sistema en el árbol: issystem puede venir como true, 1 o '1' desde API. */
  private isTreeviewSystemItem(item: any): boolean {
    if (item == null) {
      return false;
    }
    return item.issystem === true || item.issystem === 1 || item.issystem === '1';
  }

  /** Nodo área (carpeta); excluye raíz estimate y sistemas. */
  private isTreeviewAreaItem(item: any): boolean {
    if (item == null || item.isEstimateRoot === true) {
      return false;
    }
    return !this.isTreeviewSystemItem(item);
  }

  private buildContextMenuItems(item: any): any[] {
    if (!item) {
      return [];
    }
    if (item.isEstimateRoot === true) {
      if (this.ModuleFrom !== 'Edit Estimate') {
        return [];
      }
      return [
        {
          text: this.translate.instant('ModuleSystemToArea.ctxEstimateRootInstantArea'),
          action: 'ctxQuickEntryAreaEstimateRoot',
          iconClass: 'tree-ctx-icon fas fa-bolt tree-ctx-ic--quick',
        },
        {
          dividerTop: true,
          text: 'Start with CUBE AI',
          action: 'ctxEstimateRootUseCubeAI',
          iconSrc: 'assets/ai6.png',
          badge: 'New',
        },
      ];
    }
    if (this.isTreeviewAreaItem(item)) {
      return [
        // ── ADD ──
        { text: 'ADD', isHeader: true, disabled: true },
        { text: 'Quick Entry', action: 'ctxQuickEntryArea', iconClass: 'tree-ctx-icon fas fa-bolt tree-ctx-ic--quick' },
        {
          text: this.translate.instant('ModuleSystemToArea.ctxAreaAddMultipleSystems'),
          action: 'ctxNewSystemArea',
          iconClass: 'tree-ctx-icon fas fa-plus-circle tree-ctx-ic--new',
        },
        {
          text: this.translate.instant('ModuleSystemToArea.ctxAreaAddFromSystemLibrary'),
          action: 'ctxAddFromSystemLibrary',
          iconClass: 'tree-ctx-icon fas fa-book-open tree-ctx-ic--lib',
        },
        {
          text: this.translate.instant('ModuleSystemToArea.ctxAreaUseCubeAI'),
          action: 'ctxAreaUseCubeAI',
          iconSrc: 'assets/ai6.png',
        },
        // ── EDIT ──
        { text: 'EDIT', isHeader: true, disabled: true },
        { text: 'Rename', action: 'ctxRenameArea', iconClass: 'tree-ctx-icon fas fa-pen tree-ctx-ic--rename' },
        { text: 'Modify Area', action: 'ctxEditArea', iconClass: 'tree-ctx-icon fas fa-sliders-h tree-ctx-ic--edit' },
        { text: 'Duplicate', action: 'ctxDuplicateArea', iconClass: 'tree-ctx-icon far fa-clone tree-ctx-ic--dup' },
        // ── separator → Delete ──
        {
          dividerTop: true,
          text: 'Delete',
          action: 'ctxDeleteArea',
          iconClass: 'tree-ctx-icon far fa-trash-alt tree-ctx-ic--del',
          isDestructive: true,
        },
      ];
    }
    const items: any[] = [
      // ── ADD ──
      { text: 'ADD', isHeader: true, disabled: true },
      {
        text: this.translate.instant('ModuleSystemToArea.ctxSystemAddComponents'),
        action: 'ctxAddComponentsSystem',
        iconClass: 'tree-ctx-icon fas fa-cubes tree-ctx-ic--new',
      },
      { text: 'Add Parts', action: 'ctxAddIndividualParts', iconClass: 'tree-ctx-icon fas fa-puzzle-piece tree-ctx-ic--new' },
      {
        text: 'Import from Library',
        action: 'ctxImportLibraryIntoSystem',
        iconClass: 'tree-ctx-icon fas fa-book-open tree-ctx-ic--lib',
      },
    ];
    if (this.ModuleFrom === 'Edit Estimate') {
      items.push({
        text: this.translate.instant('ModuleSystemToArea.ctxAreaUseCubeAI'),
        action: 'ctxSystemUseCubeAI',
        iconSrc: 'assets/ai6.png',
      });
    }
    // ── EDIT ──
    items.push(
      { text: 'EDIT', isHeader: true, disabled: true },
      { text: 'Edit System', action: 'ctxEditSystem', iconClass: 'tree-ctx-icon far fa-edit tree-ctx-ic--sys' },
      { text: 'Rename', action: 'ctxRenameSystem', iconClass: 'tree-ctx-icon fas fa-pen tree-ctx-ic--rename' },
      { text: 'Duplicate', action: 'ctxDuplicateSystem', iconClass: 'tree-ctx-icon far fa-clone tree-ctx-ic--dup' },
      { text: 'Configure System', action: 'ctxConfigureSystem', iconClass: 'tree-ctx-icon fas fa-cog tree-ctx-ic--sys' },
    );
    // ── separator → Clear Data + Delete ──
    items.push(
      { dividerTop: true, text: 'Clear Data', action: 'ctxClearSystem', iconClass: 'tree-ctx-icon fas fa-eraser tree-ctx-ic--del' },
      { text: 'Delete', action: 'ctxDeleteSystem', iconClass: 'tree-ctx-icon far fa-trash-alt tree-ctx-ic--del', isDestructive: true },
    );
    return items;
  }

  onContextMenuItemClick(e: any) {
    const item = this.contextMenuCurrentItem;
    if (!item || !e || !e.itemData) {
      return;
    }
    const action = e.itemData.action;
    if (action === undefined || action === null) {
      return;
    }
    if (item.isEstimateRoot === true) {
      if (this.ModuleFrom !== 'Edit Estimate') {
        return;
      }
      switch (action) {
        case 'ctxQuickEntryAreaEstimateRoot':
          this.insertEstimateRootQuickEntryArea();
          break;
        case 'ctxEstimateRootUseCubeAI':
          this.openContextUseCubeAIFromEstimateRoot();
          break;
      }
      return;
    }
    if (this.isTreeviewAreaItem(item)) {
      switch (action) {
        case 'ctxNewSystemArea':
          if (item.originalid == null || item.originalid === '') {
            this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
            break;
          }
          this.openNewSystems(item.originalid, false);
          break;
        case 'ctxQuickEntryArea':
          if (item.originalid == null || item.originalid === '') {
            this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
            break;
          }
          this.quickEntryInsertSystemFromArea(item);
          break;
        case 'ctxRenameArea':
          this.startInlineRenameAreaFromTree(item);
          break;
        case 'ctxEditArea':
          this.openContextEditAreaFromTree(item);
          break;
        case 'ctxDuplicateArea':
          this.openContextDuplicateAreaFromTree(item);
          break;
        case 'ctxAddFromSystemLibrary':
          this.openSystemLibraryGalleryFromArea(item);
          break;
        case 'ctxAreaUseCubeAI':
          this.openContextUseCubeAIFromTree(item);
          break;
        case 'ctxDeleteArea':
          this.openContextDeleteAreaFromTree(item);
          break;
      }
      return;
    }
    switch (action) {
      case 'ctxAddComponentsSystem':
        this.openContextAddComponentsFromTree(item);
        break;
      case 'ctxAddIndividualParts':
        this.openAddIndividualPartsFromTree(item);
        break;
      case 'ctxEditSystem':
        this.openContextEditSystemFromTree(item);
        break;
      case 'ctxConfigureSystem':
        this.openContextConfigureSystemFromTree(item);
        break;
      case 'ctxRenameSystem':
        this.startInlineRenameSystemFromTree(item);
        break;
      case 'ctxDuplicateSystem':
        this.openContextDuplicateSystemFromTree(item);
        break;
      case 'ctxImportLibraryIntoSystem':
        this.openContextImportLibraryIntoSystemFromTree(item);
        break;
      case 'ctxSystemUseCubeAI':
        this.openContextUseCubeAIParentImportFromTree(item);
        break;
      case 'ctxDeleteSystem':
        this.openContextDeleteSystemFromTree(item);
        break;
      case 'ctxClearSystem':
        this.openContextClearSystemFromTree(item);
        break;
    }
  }

  private findAreaNodeByOriginalIdInGroupItems(originalId: any): any {
    if (!this.groupItems || !Array.isArray(this.groupItems)) {
      return null;
    }
    const roots = this.getGroupItemsTopLevelAreas();
    for (let i = 0; i < roots.length; i++) {
      const n = roots[i];
      if (n && this.isTreeviewAreaItem(n) && n.originalid == originalId) {
        return n;
      }
    }
    return null;
  }

  private collectQuickEntryStatsFromAreaItems(nodes: any[]): { maxSuffix: number; maxSort: number; systemCount: number } {
    let maxSuffix = 0;
    let maxSort = 0;
    let systemCount = 0;
    const reNum = /^New System\s+(\d+)$/i;
    const reExact = /^New System$/i;
    const walk = (arr: any[]) => {
      if (!arr || !Array.isArray(arr)) {
        return;
      }
      for (let i = 0; i < arr.length; i++) {
        const n = arr[i];
        if (!n) {
          continue;
        }
        if (n.issystem === true) {
          systemCount++;
          const name = n.text != null ? n.text : n.name;
          if (name != null && name !== '') {
            const sName = String(name).trim();
            if (reExact.test(sName)) {
              maxSuffix = Math.max(maxSuffix, 1);
            } else {
              const m = sName.match(reNum);
              if (m) {
                const num = parseInt(m[1], 10);
                if (!isNaN(num) && num > maxSuffix) {
                  maxSuffix = num;
                }
              }
            }
          }
          const s = n.Sort;
          if (s != null && !isNaN(Number(s)) && Number(s) > maxSort) {
            maxSort = Number(s);
          }
        }
        if (n.items && n.items.length > 0) {
          walk(n.items);
        }
      }
    };
    walk(nodes || []);
    return { maxSuffix: maxSuffix, maxSort: maxSort, systemCount: systemCount };
  }

  /** Quick Entry: SP insert + next "New System {n}" from live tree; after insert refreshes and expandAll. */
  private quickEntryInsertSystemFromArea(areaItem: any) {
    const areaId = areaItem.originalid;
    if (areaId == null || areaId === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }

    this.refreshGroupItemsFromSystemArea(false, () => {
      const areaNode = this.findAreaNodeByOriginalIdInGroupItems(areaId) || areaItem;
      const itemsForStats = areaNode && areaNode.items && Array.isArray(areaNode.items) ? areaNode.items : [];
      const stats = this.collectQuickEntryStatsFromAreaItems(itemsForStats);
      const counter = stats.maxSuffix + 1;
      const nextSort = stats.systemCount > 0 ? stats.maxSort + 1 : 1;

      const model = {
        method: 'Insert_EstimateCreateNewSystemCE',
        id: this.estimateid,
        systemid: 0,
        sort: nextSort,
        areaname: areaId,
        systemname: 'New System ',
        qty: 1,
        systemtype: 1,
        inactive: 0,
        deleted: 0,
        scopeofwork: 0,
        sop: '',
        excludefromsearch: '',
        controldwgname: '',
        controldwgimg: '',
        tagtext: '',
        tagnum: '',
        description: '',
        idNewSystem: 0,
      };

      this.MapInformationService.SaveInfoSites(model).subscribe(
        (insertResp: any[]) => {
          if (!insertResp || !insertResp.length) {
            this.toast.error('Error creating system');
            return;
          }
          this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysCreSucc'));
          this.reload.emit(this.estimateid);
          this.refreshGroupItemsFromSystemArea(true);
          if (insertResp[0] && insertResp[0].resultID != null) {
            this.NewSystem.emit(insertResp[0].resultID);
          }
        },
        () => {
          this.toast.error('Error creating system');
        }
      );
    });
  }

  private getTopLevelAreaNameForNaming(n: any): string {
    if (n == null) {
      return '';
    }
    const a = n.areaname;
    if (a != null && String(a).trim() !== '') {
      return String(a).trim();
    }
    const t = n.text != null ? String(n.text).trim() : '';
    if (t === '') {
      return '';
    }
    const m = t.match(/^\s*\d+\s*-\s*(.+)$/);
    if (m) {
      return m[1].trim();
    }
    return t;
  }

  private collectQuickEntryStatsForEstimateRootAreas(): {
    maxSuffix: number;
    maxSort: number;
    areaCount: number;
  } {
    const roots = this.getGroupItemsTopLevelAreas();
    let maxSuffix = 0;
    let maxSort = 0;
    let areaCount = 0;
    const reNum = /^New Area\s+(\d+)$/i;
    const reExact = /^New Area$/i;
    for (let i = 0; i < roots.length; i++) {
      const n = roots[i];
      if (!n || n.issystem === true || n.isEstimateRoot === true) {
        continue;
      }
      areaCount++;
      const raw = this.getTopLevelAreaNameForNaming(n);
      if (raw !== '') {
        if (reExact.test(raw)) {
          maxSuffix = Math.max(maxSuffix, 1);
        } else {
          const m = raw.match(reNum);
          if (m) {
            const num = parseInt(m[1], 10);
            if (!isNaN(num) && num > maxSuffix) {
              maxSuffix = num;
            }
          }
        }
      }
      const s = n.sort;
      if (s != null && !isNaN(Number(s)) && Number(s) > maxSort) {
        maxSort = Number(s);
      }
    }
    return { maxSuffix: maxSuffix, maxSort: maxSort, areaCount: areaCount };
  }

  private pickQuickSerialNewAreaName(stats: { maxSuffix: number }): string {
    const counter = stats.maxSuffix + 1;
    if (counter <= 1) {
      return 'New Area';
    }
    return 'New Area ' + counter;
  }

  /** Raíz del estimate (Edit Estimate): Quick Entry — inserta un área top-level con nombre por defecto en secuencia. */
  private insertEstimateRootQuickEntryArea(): void {
    const self = this;
    if (!self.estimateid) {
      return;
    }
    self.refreshGroupItemsFromSystemArea(false, () => {
      const stats = self.collectQuickEntryStatsForEstimateRootAreas();
      const nextSort = stats.areaCount > 0 ? stats.maxSort + 1 : 1;
      const areaName = self.pickQuickSerialNewAreaName(stats);
      const model = {
        method: 'Insert_EstimateAreaCE',
        estimateid: self.estimateid,
        name: areaName,
        id: 0,
        sort: nextSort,
        inactive: 0,
        alternate: 0,
      };
      self.MapInformationService.SaveInfoSites(model).subscribe(
        () => {
          self.toast.success(self.translate.instant('ModuleSystemToArea.msgAreSucc'));
          self.reload.emit(self.estimateid);
          self.refreshGroupItemsFromSystemArea(true);
        },
        () => {
          self.toast.error('Could not create area.');
        }
      );
    });
  }

  onInlineRenameTextBoxInit(e: any) {
    if (e && e.component && typeof e.component.option === 'function') {
      try {
        e.component.option('enterKeyAction', 'submit');
      } catch (err) {
      }
    }
  }

  onInlineRenameEnterKey(e: any) {
    if (e && e.event) {
      e.event.preventDefault();
      e.event.stopPropagation();
    }
    if (this.inlineRenameSystemId != null) {
      this.saveInlineRenameSystem();
    } else {
      this.saveInlineRenameArea();
    }
  }

  /** Tras abrir rename inline: foco en el TextBox (el menú contextual suelta el foco al cerrar). */
  private scheduleFocusInlineRenameInput(): void {
    const self = this;
    setTimeout(function () {
      self.focusInlineRenameTextBoxInTree();
    }, 0);
    setTimeout(function () {
      self.focusInlineRenameTextBoxInTree();
    }, 80);
    setTimeout(function () {
      self.focusInlineRenameTextBoxInTree();
    }, 200);
  }

  private focusInlineRenameTextBoxInTree(): void {
    const root = document.getElementById('simple-treeview');
    if (root == null) {
      return;
    }
    const input = root.querySelector('.tree-inline-rename__input .dx-texteditor-input') as HTMLInputElement;
    if (input == null || typeof input.focus !== 'function') {
      return;
    }
    input.focus();
    const v = input.value;
    if (v != null && v !== '' && typeof input.setSelectionRange === 'function') {
      const len = String(v).length;
      try {
        input.setSelectionRange(0, len);
      } catch (err) {
      }
    }
  }

  private startInlineRenameAreaFromTree(treeItem: any) {
    if (treeItem == null || treeItem.originalid == null || treeItem.originalid === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    this.clearInlineRenameSystemState();
    let draft = '';
    if (treeItem.areaname != null && String(treeItem.areaname).trim() !== '') {
      draft = String(treeItem.areaname).trim();
    } else if (treeItem.text != null) {
      const t = String(treeItem.text);
      const idx = t.indexOf('-');
      draft = idx >= 0 ? t.slice(idx + 1).trim() : t.trim();
    }
    this.inlineRenameAreaOriginalId = treeItem.originalid;
    this.inlineRenameAreaDraft = draft;
    this.inlineRenameAreaSort = treeItem.sort;
    this.inlineRenameAreaActive = treeItem.areaactive;
    this.inlineRenameAreaAlternate = treeItem.Alternate == 1 || treeItem.Alternate === true;
    if (this.treeViewSystemArea && this.treeViewSystemArea.instance) {
      this.treeViewSystemArea.instance.repaint();
    }
    this.scheduleFocusInlineRenameInput();
  }

  saveInlineRenameArea() {
    const trimmed = (this.inlineRenameAreaDraft || '').trim();
    if (trimmed === '') {
      this.toast.warning('Please enter an area name.');
      return;
    }
    if (this.inlineRenameAreaOriginalId == null || this.inlineRenameAreaOriginalId === '') {
      return;
    }
    const activeBool = this.inlineRenameAreaActive === true || this.inlineRenameAreaActive === 1;
    this.MapInformationService.SaveInfoSites({
      method: 'Insert_EstimateAreaCE',
      estimateid: this.estimateid,
      name: trimmed,
      id: this.inlineRenameAreaOriginalId,
      sort: this.inlineRenameAreaSort,
      inactive: !activeBool,
      alternate: this.inlineRenameAreaAlternate ? 1 : 0,
    }).subscribe(
      () => {
        this.clearInlineRenameAreaState();
        this.toast.success(this.translate.instant('ModuleSystemToArea.msgAreSucc'));
        const self = this;
        setTimeout(function () {
          self.refreshGroupItemsFromSystemArea(false, function () {
            self.reload.emit(self.estimateid);
          });
        }, 200);
      },
      () => {
        this.toast.error('Could not save area name.');
      }
    );
  }

  cancelInlineRenameArea() {
    this.clearInlineRenameAreaState();
    if (this.treeViewSystemArea && this.treeViewSystemArea.instance) {
      this.treeViewSystemArea.instance.repaint();
    }
  }

  private clearInlineRenameAreaState() {
    this.inlineRenameAreaOriginalId = null;
    this.inlineRenameAreaDraft = '';
    this.inlineRenameAreaSort = null;
    this.inlineRenameAreaActive = null;
    this.inlineRenameAreaAlternate = false;
  }

  clearInlineRenameSystemState() {
    this.inlineRenameSystemId = null;
    this.inlineRenameSystemDraft = '';
  }

  private startInlineRenameSystemFromTree(treeItem: any) {
    if (treeItem == null || treeItem.id == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.inlineRenameSystemId = treeItem.id;
    // Usa el texto del nodo: split por "-" y toma la posición [1].
    const raw = treeItem.text != null ? String(treeItem.text) : '';
    const parts = raw.split('-');
    this.inlineRenameSystemDraft = (parts.length > 1 ? parts[1] : raw).trim();
    if (this.treeViewSystemArea && this.treeViewSystemArea.instance) {
      this.treeViewSystemArea.instance.repaint();
    }
    this.scheduleFocusInlineRenameInput();
  }

  saveInlineRenameSystem() {
    const trimmed = (this.inlineRenameSystemDraft || '').trim();
    if (trimmed === '') {
      this.toast.warning('Please enter a system name.');
      return;
    }
    if (this.inlineRenameSystemId == null || this.inlineRenameSystemId === '') {
      return;
    }
    const self = this;
    this.estimateService.GetEstimateAreaSystemInfoCE(String(this.inlineRenameSystemId)).subscribe(
      function (result) {
        if (!result || !result.length) {
          self.toast.error('Could not load system.');
          return;
        }
        const row = result[0];
        const item: any = {};
        for (const k in row) {
          if (Object.prototype.hasOwnProperty.call(row, k)) {
            item[k] = row[k];
          }
        }
        item.Active = !item.Active;
        item.MarkLib = !item.MarkLib;
        item.SystemName = trimmed;
        const stid = item.SystemTypeid != null ? item.SystemTypeid : item.SystemTypeID;
        self.estimateService
          .Upadte_EstimateAreaSystemCE(
            item.ID,
            item.ID,
            item.SORT,
            item.AreaName,
            item.SystemName,
            item.QTY,
            stid,
            !item.Active,
            false,
            '',
            item.SOP,
            item.MarkLib == true ? 0 : 1,
            item.Control_Drawing,
            '',
            item.TAGTEXT,
            item.TAGNUM,
            item.DESCRIPTION
          )
          .subscribe(
            function () {
              self.clearInlineRenameSystemState();
              self.toast.success(self.translate.instant('ModuleSystemToArea.msgUpdSucc'));
              setTimeout(function () {
                self.refreshGroupItemsFromSystemArea(false, function () {
                  self.reload.emit(self.estimateid);
                });
              }, 200);
            },
            function () {
              self.toast.error('Could not save system name.');
            }
          );
      },
      function () {
        self.toast.error('Could not load system.');
      }
    );
  }

  cancelInlineRenameSystem() {
    this.clearInlineRenameSystemState();
    if (this.treeViewSystemArea && this.treeViewSystemArea.instance) {
      this.treeViewSystemArea.instance.repaint();
    }
  }

  private openContextEditAreaFromTree(item: any) {
    if (item == null || item.originalid == null || item.originalid === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    const alternateTrueOrFalse = item.Alternate == 1 || item.Alternate === true;
    this.rowsToEditArea = [{
      name: item.areaname,
      id: item.originalid,
      active: item.areaactive,
      sort: item.sort,
      alternate: alternateTrueOrFalse,
    }];
    this.popupEditArea = true;
    if (this.treeViewSystemArea && this.treeViewSystemArea.instance) {
      this.treeViewSystemArea.instance.repaint();
    }
  }

  private openContextDuplicateAreaFromTree(item: any) {
    if (item == null || item.originalid == null || item.originalid === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    this.estimateService.Insert_AreaDuplicate(item.originalid, this.estimateid).subscribe(() => {
      this.toast.success(this.translate.instant('ModuleSystemToArea.msgArDupSucc'));
      this.reload.emit(this.estimateid);
    });
  }

  private applyAIPopupAreaDefaultFromTreeItem(item: any): void {
    if (item == null) {
      return;
    }
    const oid = item.originalid;
    let resolvedId: any = oid;
    if (oid != null && oid !== '') {
      const n = Number(oid);
      if (!isNaN(n)) {
        resolvedId = Math.abs(n);
      }
    }
    let areaNameForSelect = item.areaname != null ? String(item.areaname) : '';
    let chosenId: any = resolvedId;
    if (this.areaSelect && this.areaSelect.length) {
      for (let i = 0; i < this.areaSelect.length; i++) {
        const a = this.areaSelect[i];
        if (!a || a.ID == null) {
          continue;
        }
        if (Number(a.ID) === Number(resolvedId)) {
          chosenId = a.ID;
          if (a.AreaName != null) {
            areaNameForSelect = String(a.AreaName);
          }
          break;
        }
      }
    }
    this.areaSelectedNew.areaID = chosenId;
    this.areaSelectedNew.AreaName = areaNameForSelect;
  }

  private openContextUseCubeAIFromTree(item: any): void {
    if (item == null || item.originalid == null || item.originalid === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    if (this.treeViewSystemArea && this.treeViewSystemArea.instance && item.id != null) {
      this.treeViewSystemArea.instance.unselectAll();
      this.treeViewSystemArea.instance.selectItem(item.id);
    }
    this.systemid = item.id;
    this.onitemchange.emit(item);

    this.aiProcessingType = 'drawing';
    this.code = 'Process Drawing';

    const self = this;
    const finishOpen = function () {
      self.applyAIPopupAreaDefaultFromTreeItem(item);
      self.generateAISession();
      self.popupAIProcessing = true;
    };

    if (self.estimateid != null && self.estimateid !== 0) {
      self.deltaService.GetEstimateAreaList(self.estimateid).subscribe(
        function (result: any) {
          self.areaSelect = result || [];
          finishOpen();
        },
        function () {
          finishOpen();
        }
      );
    } else {
      finishOpen();
    }
  }

  /** Estimate root → "Start with CUBE AI": abre el modal de opciones de AI Processing
   *  (Plan / Sequence / Scope / Import Excel). Cada opción dispara su flujo existente. */
  private openContextUseCubeAIFromEstimateRoot(): void {
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();

    const self = this;
    const open = function () { self.startWithCubeAIVisible = true; };

    // Pre-carga los tipos de sistema (SP Get_EstimateSytemTypeCreateSystem) para que
    // el select de System Type en la tabla dataTest tenga opciones.
    this.getSystemTypeMultiple();

    // Pre-carga la lista de áreas para que los flujos descendentes tengan datos.
    if (this.estimateid != null && this.estimateid !== 0) {
      this.deltaService.GetEstimateAreaList(this.estimateid).subscribe(
        function (result: any) { self.areaSelect = result || []; open(); },
        function () { open(); }
      );
    } else {
      open();
    }
  }

  private openContextDeleteAreaFromTree(item: any) {
    if (item == null || item.originalid == null || item.originalid === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    this.componentModel.data = [{ ...item, key: item.originalid }];
    this.componentModel.ID = [item.originalid];
    if (this.componentModel.ID.length > 0) {
      this.popupDeleteArea = true;
      setTimeout(() => {
        if (this.treeDelete !== undefined) {
          this.componentModel.ID.forEach((x: any) => {
            this.treeDelete.instance.selectItem(x);
          });
        }
      }, 2000);
    } else {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
    }
  }

  private positiveAreaIdFromTreeAreaItem(item: any): number | null {
    if (item == null || item.originalid == null || item.originalid === '') {
      return null;
    }
    const n = Number(item.originalid);
    if (isNaN(n)) {
      return null;
    }
    return Math.abs(n);
  }

  /** Área padre del sistema seleccionado en el árbol (Edit Estimate). */
  private findAreaTreeItemContainingSystem(systemItem: any): any | null {
    if (systemItem == null || systemItem.id == null) {
      return null;
    }
    const targetId = systemItem.id;
    const walk = (nodes: any[]): any | null => {
      if (!nodes || !nodes.length) {
        return null;
      }
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (!n || !this.isTreeviewAreaItem(n)) {
          continue;
        }
        if (n.items && n.items.length) {
          for (let j = 0; j < n.items.length; j++) {
            const ch = n.items[j];
            if (ch && this.isTreeviewSystemItem(ch) && ch.id === targetId) {
              return n;
            }
          }
          const deeper = walk(n.items);
          if (deeper != null) {
            return deeper;
          }
        }
      }
      return null;
    };
    return walk(this.getGroupItemsTopLevelAreas());
  }

  openSystemLibraryGalleryFromArea(item: any): void {
    if (!this.isTreeviewAreaItem(item)) {
      return;
    }
    if (item == null || item.originalid == null || item.originalid === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    this.systemLibraryGalleryImportIntoSystemId = null;
    this.openSystemLibraryGalleryCore(item, item.id);
  }

  /** Opens the System Library Gallery with an area selector loaded from the given estimateId. */
  openSystemLibraryGallery(estimateId: any): void {
    this.systemLibraryGalleryImportIntoSystemId = null;
    this.systemLibraryGalleryExternalAreas = [];
    this.systemLibraryGalleryShowAreaSelect = true;
    this.systemLibraryGallerySelectedExternalArea = null;
    this.systemLibraryGalleryAreaItem = null;

    this.MapInformationService.SaveInfoSites({ method: 'GetEstimateAreaList', estimateid: estimateId })
      .subscribe((result: any[]) => {
        this.systemLibraryGalleryExternalAreas = result || [];
        if (this.systemLibraryGalleryExternalAreas.length > 0) {
          const first = this.systemLibraryGalleryExternalAreas[0];
          this.systemLibraryGallerySelectedExternalArea = first;
          this.systemLibraryGalleryAreaItem = { originalid: first.ID, areaname: first.AreaName };
        }
      });

    this.openSystemLibraryGalleryCore(null, null);
  }

  private openSystemLibraryGalleryCore(areaTreeItem: any, treeSelectNodeId: any): void {
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    if (this.treeViewSystemArea && this.treeViewSystemArea.instance && treeSelectNodeId != null) {
      this.treeViewSystemArea.instance.unselectAll();
      this.treeViewSystemArea.instance.selectItem(treeSelectNodeId);
    }
    this.systemLibraryGalleryAreaItem = areaTreeItem;
    this.systemLibraryGallerySelectedRows = [];
    this.systemLibraryGallerySearch = '';
    this.systemLibraryGalleryCategoryKey = null;
    this.systemLibraryGalleryCategories = [];
    this.ensureSystemLibraryGalleryEstimateDataSource(false);
    this.popupSystemLibraryGallery = true;

    const self = this;
    const finishOpen = function (): void {
      self.refreshSystemLibraryGalleryEstimateSelectWidget();
      self.loadSystemLibraryGalleryData();
    };

    const fromSettings = self.readEstimateIdDefaultFromLocalSettings();
    if (fromSettings != null) {
      self.systemLibraryGalleryCatalogEstimateId = fromSettings;
      finishOpen();
      return;
    }

    self.systemLibraryGalleryLoading = true;
    self.MapInformationService.SaveInfoSites({ method: 'Get_EstimateLibraryDefault' }).subscribe(
      function (res: any) {
        if (res && res.length > 0) {
          const r0 = res[0];
          const rid = r0.id != null ? r0.id : r0.ID;
          if (rid != null && !isNaN(Number(rid)) && Number(rid) > 0) {
            self.systemLibraryGalleryCatalogEstimateId = Number(rid);
            finishOpen();
            return;
          }
        }
        self.systemLibraryGalleryCatalogEstimateId =
          self.estimateid != null && Number(self.estimateid) > 0 ? Number(self.estimateid) : null;
        finishOpen();
      },
      function () {
        self.systemLibraryGalleryCatalogEstimateId =
          self.estimateid != null && Number(self.estimateid) > 0 ? Number(self.estimateid) : null;
        finishOpen();
      }
    );
  }

  onSystemLibraryGalleryModalHidden(): void {
    this.popupSystemLibraryGallery = false;
    this.systemLibraryGalleryLoading = false;
    this.systemLibraryGalleryInserting = false;
    this.systemLibraryGalleryCategories = [];
    this.systemLibraryGalleryAreaItem = null;
    this.systemLibraryGallerySelectedRows = [];
    this.systemLibraryGallerySearch = '';
    this.systemLibraryGalleryCategoryKey = null;
    this.systemLibraryGalleryChildRowsPool = [];
    this.popupSystemLibraryDefaultEstimate = false;
    this.systemLibraryGalleryDefaultEstimatePickId = null;
    this.systemLibraryGalleryImportIntoSystemId = null;
    this.systemLibraryGalleryShowAreaSelect = false;
    this.systemLibraryGalleryExternalAreas = [];
    this.systemLibraryGallerySelectedExternalArea = null;
  }

  onSystemLibraryGalleryExternalAreaChange(area: any): void {
    this.systemLibraryGallerySelectedExternalArea = area;
    if (!area) {
      this.systemLibraryGalleryAreaItem = null;
      return;
    }
    this.systemLibraryGalleryAreaItem = { originalid: area.ID, areaname: area.AreaName };
  }

  closeSystemLibraryGalleryClick(): void {
    this.popupSystemLibraryGallery = false;
  }

  systemLibraryGalleryAreaLabel(): string {
    const item = this.systemLibraryGalleryAreaItem;
    if (item == null) {
      return '';
    }
    if (item.areaname != null && String(item.areaname).trim() !== '') {
      return String(item.areaname).trim();
    }
    return item.text != null ? String(item.text) : '';
  }

  /** Nombre del sistema destino cuando la galería importa dentro de un sistema (clic derecho). */
  systemLibraryGalleryImportIntoTargetLabel(): string {
    const id = this.systemLibraryGalleryImportIntoSystemId;
    if (id == null || isNaN(Number(id))) {
      return '';
    }
    const walk = (nodes: any[]): string => {
      if (!nodes || !nodes.length) {
        return '';
      }
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (!n) {
          continue;
        }
        if (this.isTreeviewSystemItem(n) && Number(n.id) === Number(id)) {
          return n.text != null ? String(n.text) : '';
        }
        if (n.items && n.items.length) {
          const s = walk(n.items);
          if (s !== '') {
            return s;
          }
        }
      }
      return '';
    };
    return walk(this.getGroupItemsTopLevelAreas());
  }

  private ensureSystemLibraryGalleryEstimateDataSource(force: boolean): void {
    if (this.systemLibraryGalleryEstimateDataSource != null && !force) {
      return;
    }
    const mythis = this;
    this.systemLibraryGalleryEstimateDataSource = new CustomStore({
      key: 'ID',
      load: function (loadOptions: any) {
        return mythis.estimateService
          .Get_EstimateListNavAll(loadOptions.searchValue)
          .toPromise()
          .then(function (data: any) {
            return data;
          })
          .catch(function () {
            throw 'Data Loading Error';
          });
      },
    });
  }

  private resolveSystemLibraryCatalogEstimateId(): number {
    if (
      this.systemLibraryGalleryCatalogEstimateId != null &&
      !isNaN(Number(this.systemLibraryGalleryCatalogEstimateId)) &&
      Number(this.systemLibraryGalleryCatalogEstimateId) > 0
    ) {
      return Number(this.systemLibraryGalleryCatalogEstimateId);
    }
    if (this.estimateid != null && !isNaN(Number(this.estimateid)) && Number(this.estimateid) > 0) {
      return Number(this.estimateid);
    }
    return this.SYSTEM_LIBRARY_SP_ESTIMATE_ID_STATIC;
  }

  private readEstimateIdDefaultFromLocalSettings(): number | null {
    const raw = localStorage.getItem('settings');
    if (raw == null || raw === 'null') {
      return null;
    }
    try {
      const settings = JSON.parse(raw);
      const def = settings != null ? settings.estimateidDefault : null;
      if (def != null && def !== '' && !isNaN(Number(def)) && Number(def) > 0) {
        return Number(def);
      }
    } catch (e) {
      return null;
    }
    return null;
  }

  private refreshSystemLibraryGalleryEstimateSelectWidget(): void {
    const self = this;
    const eid = self.systemLibraryGalleryCatalogEstimateId;
    setTimeout(function () {
      const sel = self.systemLibraryGalleryEstimateSelect;
      if (!sel || !sel.instance) {
        return;
      }
      if (eid == null || isNaN(Number(eid)) || Number(eid) <= 0) {
        sel.instance.reset();
        sel.instance.option('placeholder', self.translate.instant('ModalDefaultEst.placSearEst'));
        return;
      }
      self.systemLibraryGallerySyncingEstimateSelect = true;
      self.estimateService.Get_EstimateListNavAll('', eid).subscribe(
        function (res: any) {
          self.systemLibraryGallerySyncingEstimateSelect = false;
          if (!res || !res.length || !sel.instance) {
            return;
          }
          const row = res[0];
          const idRaw = row.ID != null ? row.ID : row.id;
          const idNum = Number(idRaw);
          const name = row.PROJECT_NAME != null ? String(row.PROJECT_NAME) : '';
          if (!isNaN(idNum) && idNum > 0) {
            sel.instance.option('placeholder', idNum + '-' + name);
            sel.instance.option('value', idNum);
          }
        },
        function () {
          self.systemLibraryGallerySyncingEstimateSelect = false;
        }
      );
    }, 480);
  }

  onSystemLibraryGalleryEstimateSelectionChanged(ev: any): void {
    if (this.systemLibraryGallerySyncingEstimateSelect) {
      return;
    }
    if (ev == null || ev.selectedItem == null) {
      return;
    }
    const rawId = ev.selectedItem.ID != null ? ev.selectedItem.ID : ev.selectedItem.id;
    const id = Number(rawId);
    if (isNaN(id) || id <= 0) {
      return;
    }
    this.systemLibraryGalleryCatalogEstimateId = id;
    this.systemLibraryGallerySelectedRows = [];
    this.systemLibraryGalleryCategoryKey = null;
    this.systemLibraryGallerySearch = '';
    this.loadSystemLibraryGalleryData();
  }

  openSystemLibraryGalleryDefaultEstimateModal(): void {
    this.popupSystemLibraryDefaultEstimate = true;
    const self = this;
    const catalogId =
      self.systemLibraryGalleryCatalogEstimateId != null &&
      !isNaN(Number(self.systemLibraryGalleryCatalogEstimateId)) &&
      Number(self.systemLibraryGalleryCatalogEstimateId) > 0
        ? Number(self.systemLibraryGalleryCatalogEstimateId)
        : null;
    const settingsId = self.readEstimateIdDefaultFromLocalSettings();
    const syncId = catalogId != null ? catalogId : settingsId;
    self.systemLibraryGalleryDefaultEstimatePickId = syncId;

    setTimeout(function () {
      const sel = self.systemLibraryGalleryDefaultEstimateSelect;
      if (!sel || !sel.instance) {
        return;
      }
      if (syncId == null || syncId <= 0) {
        sel.instance.reset();
        sel.instance.option('placeholder', self.translate.instant('ModalDefaultEst.placeSeDefEst'));
        self.systemLibraryGalleryDefaultEstimatePickId = null;
        return;
      }
      self.estimateService.Get_EstimateListNavAll('', syncId).subscribe(
        function (res: any) {
          if (!res || !res.length || !sel.instance) {
            return;
          }
          const row = res[0];
          const idRaw = row.ID != null ? row.ID : row.id;
          const idNum = Number(idRaw);
          const name = row.PROJECT_NAME != null ? String(row.PROJECT_NAME) : '';
          if (!isNaN(idNum) && idNum > 0) {
            sel.instance.option('placeholder', idNum + '-' + name);
            sel.instance.option('value', idNum);
          }
        },
        function () {
          /* leave pick id as syncId */
        }
      );
    }, 520);
  }

  closeSystemLibraryGalleryDefaultEstimateModal(): void {
    this.popupSystemLibraryDefaultEstimate = false;
    this.systemLibraryGalleryDefaultEstimatePickId = null;
  }

  onSystemLibraryGalleryDefaultEstimatePick(ev: any): void {
    if (ev != null && ev.selectedItem != null) {
      const raw = ev.selectedItem.ID != null ? ev.selectedItem.ID : ev.selectedItem.id;
      const n = Number(raw);
      this.systemLibraryGalleryDefaultEstimatePickId = !isNaN(n) && n > 0 ? n : null;
    }
  }

  saveSystemLibraryGalleryDefaultEstimate(): void {
    const self = this;
    const pick =
      self.systemLibraryGalleryDefaultEstimatePickId != null &&
      !isNaN(Number(self.systemLibraryGalleryDefaultEstimatePickId))
        ? Number(self.systemLibraryGalleryDefaultEstimatePickId)
        : null;
    if (pick == null || pick <= 0) {
      self.toast.warning(self.translate.instant('ModuleImportLibrary.msgDefEst'));
      return;
    }
    let raw = localStorage.getItem('settings');
    let settings: any = {};
    if (raw && raw !== 'null') {
      try {
        settings = JSON.parse(raw);
      } catch (e) {
        settings = {};
      }
    }
    settings.estimateidDefault = pick;
    const userSetting: any = {};
    self.userService.settings.next(settings);
    userSetting.usersettings = JSON.stringify(self.userService.settings.value);
    self.userService.saveUserSettingCoor(userSetting).subscribe(
      function () {
        self.toast.success(self.translate.instant('ModuleImportLibrary.msgSavSucc'));
        self.popupSystemLibraryDefaultEstimate = false;
        self.systemLibraryGalleryDefaultEstimatePickId = null;
        localStorage.setItem('settings', JSON.stringify(settings));
        self.systemLibraryGalleryEstimateDataSource = null;
        self.ensureSystemLibraryGalleryEstimateDataSource(true);
        self.cdr.detectChanges();
      },
      function () {
        self.toast.error(self.translate.instant('ModuleSystemToArea.msgDefaultEstimateSaveError'));
      }
    );
  }

  private loadSystemLibraryGalleryData(): void {
    const self = this;
    self.systemLibraryGalleryLoading = true;
    self.systemLibraryGalleryCategories = [];
    self.MapInformationService.SaveInfoSites({
      method: 'Get_AreaSystemAllCE2',
      estimateid: self.resolveSystemLibraryCatalogEstimateId(),
      viewtypeid: self.SYSTEM_LIBRARY_SP_VIEWTYPE_ID_STATIC,
    }).subscribe(
      function (resp: any) {
        let list: any[] = [];
        if (Array.isArray(resp)) {
          list = resp;
        } else if (resp != null && typeof resp === 'object') {
          list = [resp];
        }
        self.systemLibraryGalleryCategories = self.buildSystemLibraryGalleryCategories(list);
        if (self.systemLibraryGalleryCategories.length > 0) {
          self.setSystemLibraryCategory(self.systemLibraryGalleryCategories[0].id);
        }
        self.systemLibraryGalleryLoading = false;
      },
      function () {
        self.systemLibraryGalleryLoading = false;
        self.toast.error(self.translate.instant('ModuleSystemToArea.msgSystemLibraryLoadFail'));
      }
    );
  }

  private rowLibraryParenId(row: any): number | null {
    if (row == null) {
      return null;
    }
    const raw =
      row.ParetID != null && row.ParetID !== ''
        ? row.ParetID
        : row.PARENTID != null && row.PARENTID !== ''
          ? row.PARENTID
          : row.ParentID != null && row.ParentID !== ''
            ? row.ParentID
            : null;
    if (raw == null || raw === '') {
      return null;
    }
    const n = Number(raw);
    return isNaN(n) ? null : n;
  }

  /** Hijo de librería: ID numérico positivo (sistema con imagen / duplicable). */
  private rowLibrarySystemId(row: any): number | null {
    if (row == null || row.ID == null || row.ID === '') {
      return null;
    }
    const n = Number(row.ID);
    return !isNaN(n) && n > 0 ? n : null;
  }

  /** Nodo carpeta / categoría: ID negativo según contrato del SP. */
  private rowLibraryParentId(row: any): number | null {
    if (row == null || row.ID == null || row.ID === '') {
      return null;
    }
    const n = Number(row.ID);
    return !isNaN(n) && n < 0 ? n : null;
  }

  /**
   * Get_AreaSystemAllCE2: carpetas con ID negativo; hijos (sistemas ID positivo) con ParetID === ID del padre (ej. padre -1263, hijo ParetID -1263).
   */
  private childBelongsToLibraryParent(child: any, parentNumericId: number): boolean {
    const pv = this.rowLibraryParenId(child);
    if (pv == null) {
      return false;
    }
    return pv === parentNumericId;
  }

  private sortLibrarySystems(arr: any[]): any[] {
    const collator = this._systemLibraryNameCollator;
    return arr.slice().sort(function (a: any, b: any) {
      const na = (a.Name || '').toString();
      const nb = (b.Name || '').toString();
      let cmp = collator.compare(na, nb);
      if (cmp !== 0) {
        return cmp;
      }
      const sa = a.Sort != null ? Number(a.Sort) : 0;
      const sb = b.Sort != null ? Number(b.Sort) : 0;
      if (sa !== sb) {
        return sa - sb;
      }
      const ida = a.ID != null ? Number(a.ID) : 0;
      const idb = b.ID != null ? Number(b.ID) : 0;
      return ida - idb;
    });
  }

  private libraryChildBelongsToAnyKnownParent(child: any, parentNumericIds: number[]): boolean {
    for (let i = 0; i < parentNumericIds.length; i++) {
      if (this.childBelongsToLibraryParent(child, parentNumericIds[i])) {
        return true;
      }
    }
    return false;
  }

  /** Rellena systems[] y dispara carga de miniaturas solo la primera vez que se elige la categoría */
  private hydrateSystemLibraryCategory(cat: { id: number; name: string; systems: any[]; loaded?: boolean }): void {
    if (cat.loaded) {
      return;
    }
    const pool = this.systemLibraryGalleryChildRowsPool;
    const pid = cat.id;
    let children: any[];
    if (pid === 0) {
      const parentIds = this.systemLibraryGalleryCategories
        .filter(function (c) {
          return c.id !== 0;
        })
        .map(function (c) {
          return Number(c.id);
        });
      children = pool.filter(
        function (s) {
          return !this.libraryChildBelongsToAnyKnownParent(s, parentIds);
        }.bind(this)
      );
    } else {
      children = pool.filter(
        function (s) {
          return this.childBelongsToLibraryParent(s, pid);
        }.bind(this)
      );
    }
    cat.systems = this.sortLibrarySystems(children);
    cat.loaded = true;
    this.prefetchSystemLibraryThumbs(cat.systems);
  }

  private buildSystemLibraryGalleryCategories(rows: any[]): Array<{ id: number; name: string; systems: any[]; loaded?: boolean }> {
    if (!rows || !rows.length) {
      this.systemLibraryGalleryChildRowsPool = [];
      return [];
    }
    const parents: any[] = rows.filter(
      function (r: any) {
        return this.rowLibraryParentId(r) != null;
      }.bind(this)
    );
    const systems: any[] = rows.filter(
      function (r: any) {
        return this.rowLibrarySystemId(r) != null;
      }.bind(this)
    );
    this.systemLibraryGalleryChildRowsPool = systems.slice();

    parents.sort(function (a: any, b: any) {
      const sa = a.Sort != null ? Number(a.Sort) : 0;
      const sb = b.Sort != null ? Number(b.Sort) : 0;
      if (sa !== sb) {
        return sa - sb;
      }
      return Number(a.ID) - Number(b.ID);
    });

    const categories: Array<{ id: number; name: string; systems: any[]; loaded?: boolean }> = [];
    const parentNumericIds: number[] = [];
    for (let i = 0; i < parents.length; i++) {
      const p = parents[i];
      const pid = Number(p.ID);
      parentNumericIds.push(pid);
      const nm = p.Name != null ? String(p.Name) : String(pid);
      categories.push({ id: pid, name: nm, systems: [], loaded: false });
    }

    const orphansExist =
      systems.filter(
        function (s) {
          return !this.libraryChildBelongsToAnyKnownParent(s, parentNumericIds);
        }.bind(this)
      ).length > 0;
    if (orphansExist) {
      categories.push({
        id: 0,
        name: this.translate.instant('ModuleSystemToArea.labelSystemLibraryOther'),
        systems: [],
        loaded: false,
      });
    }
    return categories;
  }

  getSystemLibraryFilteredSystems(): any[] {
    let list: any[] = [];
    const key = this.systemLibraryGalleryCategoryKey;
    if (key == null || key === '') {
      return [];
    }
    for (let i = 0; i < this.systemLibraryGalleryCategories.length; i++) {
      const c = this.systemLibraryGalleryCategories[i];
      if (Number(c.id) === Number(key)) {
        list = c.systems.slice();
        break;
      }
    }
    const q = (this.systemLibraryGallerySearch || '').trim().toLowerCase();
    if (q) {
      list = list.filter(function (s) {
        const n = (s.Name || '').toLowerCase();
        const t = (s.SystemTypeName || '').toLowerCase();
        return n.indexOf(q) >= 0 || t.indexOf(q) >= 0;
      });
    }
    return list;
  }

  onSystemLibrarySearchInput(value: string): void {
    this.systemLibraryGallerySearch = value != null ? String(value) : '';
  }

  onSystemLibrarySearchEvent(ev: Event): void {
    const el = ev.target as HTMLInputElement;
    this.onSystemLibrarySearchInput(el && el.value != null ? el.value : '');
  }

  setSystemLibraryCategory(key: any): void {
    this.systemLibraryGalleryCategoryKey = key;
    if (key == null || key === '') {
      return;
    }
    for (let i = 0; i < this.systemLibraryGalleryCategories.length; i++) {
      const c = this.systemLibraryGalleryCategories[i];
      if (Number(c.id) === Number(key)) {
        this.hydrateSystemLibraryCategory(c);
        break;
      }
    }
    this.cdr.detectChanges();
  }

  systemLibraryRowSelected(row: any): boolean {
    if (row == null || row.ID == null) {
      return false;
    }
    const id = Number(row.ID);
    const rows = this.systemLibraryGallerySelectedRows;
    if (!rows || !rows.length) {
      return false;
    }
    for (let i = 0; i < rows.length; i++) {
      if (rows[i] != null && Number(rows[i].ID) === id) {
        return true;
      }
    }
    return false;
  }

  // ── No-components warning popup ─────────────────────────────────────────
  popupSystemLibraryNoComp = false;
  private _systemLibraryNoCompPendingRow: any = null;

  confirmSystemLibraryNoComp(): void {
    this.popupSystemLibraryNoComp = false;
    const row = this._systemLibraryNoCompPendingRow;
    this._systemLibraryNoCompPendingRow = null;
    if (row == null) { return; }
    this._doToggleSystemLibraryRow(row);
  }

  cancelSystemLibraryNoComp(): void {
    this.popupSystemLibraryNoComp = false;
    this._systemLibraryNoCompPendingRow = null;
  }
  // ─────────────────────────────────────────────────────────────────────────

  toggleSystemLibraryRow(row: any, ev?: Event): void {
    if (ev) {
      ev.stopPropagation();
    }
    if (row == null || Number(row.ID) <= 0) {
      return;
    }
    // If the system has no components, show a friendly warning first
    if (Number(row.HASSCOMPONENTS) !== 1) {
      const id = Number(row.ID);
      const rows = this.systemLibraryGallerySelectedRows;
      const alreadySelected = rows.some(r => r != null && Number(r.ID) === id);
      if (!alreadySelected) {
        this._systemLibraryNoCompPendingRow = row;
        this.popupSystemLibraryNoComp = true;
        return;
      }
    }
    this._doToggleSystemLibraryRow(row);
  }

  private _doToggleSystemLibraryRow(row: any): void {
    const id = Number(row.ID);
    const rows = this.systemLibraryGallerySelectedRows;
    let idx = -1;
    for (let i = 0; i < rows.length; i++) {
      if (rows[i] != null && Number(rows[i].ID) === id) {
        idx = i;
        break;
      }
    }
    if (this.systemLibraryGalleryImportIntoSystemId != null) {
      if (idx >= 0) {
        rows.splice(idx, 1);
      } else {
        rows.length = 0;
        rows.push(row);
      }
      return;
    }
    if (idx >= 0) {
      rows.splice(idx, 1);
    } else {
      rows.push(row);
    }
  }

  trackBySystemLibraryRow(index: number, row: any): any {
    return row != null && row.ID != null ? row.ID : index;
  }

  private normalizeLibraryImagePath(path: any): string {
    if (path == null) {
      return '';
    }
    return String(path).trim();
  }

  ensureSystemLibraryThumb(row: any): void {
    if (row == null || row._libThumbSrc || row._libThumbLoading) {
      return;
    }
    const path = row.ImagePath;
    if (!path || String(path).trim() === '') {
      row._libThumbErr = true;
      return;
    }
    const self = this;
    row._libThumbLoading = true;
    this.MapInformationService.GetDocumentThumImg(this.normalizeLibraryImagePath(path)).subscribe(
      function (resultImages: any) {
        row._libThumbLoading = false;
        if (!resultImages || !resultImages.filestring) {
          row._libThumbErr = true;
          self.cdr.detectChanges();
          return;
        }
        const data = resultImages.filestring.substring(0, 5);
        const tipo = data.toUpperCase() === '/9J/4' ? 'jpeg' : 'png';
        row._libThumbTipo = tipo;
        row._libThumbSrc =
          (tipo === 'jpeg' ? 'data:image/jpeg;base64,' : 'data:image/png;base64,') + resultImages.filestring;
        self.cdr.detectChanges();
      },
      function () {
        row._libThumbLoading = false;
        row._libThumbErr = true;
        self.cdr.detectChanges();
      }
    );
  }

  /** Lanza todas las peticiones de miniatura en paralelo al mostrar la categoría */
  private prefetchSystemLibraryThumbs(rows: any[]): void {
    if (!rows || !rows.length) {
      return;
    }
    for (let i = 0; i < rows.length; i++) {
      this.ensureSystemLibraryThumb(rows[i]);
    }
  }

  onSystemLibraryThumbError(row: any): void {
    if (row) {
      row._libThumbErr = true;
    }
  }

  confirmAddSystemFromLibrary(): void {
    const areaItem = this.systemLibraryGalleryAreaItem;
    const rows =
      this.systemLibraryGallerySelectedRows != null && this.systemLibraryGallerySelectedRows.length
        ? this.systemLibraryGallerySelectedRows.slice()
        : [];
    const self = this;
    if (areaItem == null) {
      self.toast.warning(self.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    if (!rows.length) {
      self.toast.warning(self.translate.instant('ModuleSystemToArea.msgSelectSystemLibraryFirst'));
      return;
    }

    const importIntoId = self.systemLibraryGalleryImportIntoSystemId;
    if (importIntoId != null && importIntoId > 0) {
      const lib = rows[0];
      const sourceSystemId =
        lib != null && lib.ID != null && lib.ID !== '' ? Number(lib.ID) : NaN;
      if (lib == null || isNaN(sourceSystemId) || sourceSystemId <= 0) {
        self.toast.warning(self.translate.instant('ModuleSystemToArea.msgSystemLibraryAddFail'));
        return;
      }
      self.systemLibraryGalleryInserting = true;
      self.MapInformationService.SaveInfoSites({
        method: 'ImportintoSystemSingle',
        systemid: sourceSystemId,
        newsystemid: importIntoId,
      }).subscribe(
        function () {
          // After ImportintoSystemSingle, call DuplicateSystem to copy assets
          self.estimateService.duplicateImage(sourceSystemId, importIntoId).subscribe(
            function () {
              self.systemLibraryGalleryInserting = false;
              self.toast.success(self.translate.instant('ModuleImportLibrary.msgSucc'));
              self.onSystemLibraryGalleryModalHidden();
              if (self.estimateid != null && self.estimateid !== 0) {
                self.reload.emit(self.estimateid);
              }
              self.refreshGroupItemsFromSystemArea(true);
            },
            function () {
              // DuplicateSystem failed — still finish the import, just warn
              self.systemLibraryGalleryInserting = false;
              self.toast.success(self.translate.instant('ModuleImportLibrary.msgSucc'));
              self.onSystemLibraryGalleryModalHidden();
              if (self.estimateid != null && self.estimateid !== 0) {
                self.reload.emit(self.estimateid);
              }
              self.refreshGroupItemsFromSystemArea(true);
            }
          );
        },
        function () {
          self.systemLibraryGalleryInserting = false;
          self.toast.error(self.translate.instant('ModuleSystemToArea.msgSystemLibraryAddFail'));
        }
      );
      return;
    }

    const areaId = self.positiveAreaIdFromTreeAreaItem(areaItem);
    if (areaId == null) {
      self.toast.warning(self.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    self.systemLibraryGalleryInserting = true;
    self.duplicateSystemLibraryRowsSequential(Number(areaId), rows, 0);
  }

  private extractDuplicateSystemSingleNewId(result: any): number | null {
    if (result == null) {
      return null;
    }
    const row = Array.isArray(result) ? result[0] : result;
    if (row == null || row.ID == null || row.ID === '') {
      return null;
    }
    const id = Number(row.ID);
    return isNaN(id) ? null : id;
  }

  private duplicateSystemLibraryRowsSequential(areaId: number, rows: any[], index: number): void {
    const self = this;
    const total = rows.length;
    if (index >= total) {
      self.systemLibraryGalleryInserting = false;
      if (total === 1) {
        self.toast.success(self.translate.instant('ModuleSystemToArea.msgSystemLibraryAdded'));
      } else {
        self.toast.success(self.translate.instant('ModuleSystemToArea.msgSystemsLibraryAdded', { n: total }));
      }
      self.onSystemLibraryGalleryModalHidden();
      self.reload.emit(self.estimateid);
      self.refreshGroupItemsFromSystemArea(true);
      return;
    }
    const lib = rows[index];
    const sourceSystemId =
      lib != null && lib.ID != null && lib.ID !== '' ? Number(lib.ID) : NaN;
    if (lib == null || isNaN(sourceSystemId) || sourceSystemId <= 0) {
      self.systemLibraryGalleryInserting = false;
      self.toast.warning(self.translate.instant('ModuleSystemToArea.msgSystemLibraryAddFail'));
      return;
    }
    self.estimateService.DuplicateSystemSingle(areaId, sourceSystemId).subscribe(
      function (result: any) {
        const newId = self.extractDuplicateSystemSingleNewId(result);
        if (newId == null) {
          self.systemLibraryGalleryInserting = false;
          self.toast.warning(self.translate.instant('ModuleSystemToArea.msgSystemLibraryAddFail'));
          return;
        }
        self.estimateService.duplicateImage(sourceSystemId, newId).subscribe(
          function () {
            self.duplicateSystemLibraryRowsSequential(areaId, rows, index + 1);
          },
          function () {
            self.systemLibraryGalleryInserting = false;
            self.toast.error(self.translate.instant('ModuleSystemToArea.msgSystemLibraryAddFail'));
          }
        );
      },
      function () {
        self.systemLibraryGalleryInserting = false;
        self.toast.error(self.translate.instant('ModuleSystemToArea.msgSystemLibraryAddFail'));
      }
    );
  }

  /** Menú contextual sistema: modal galería GetMostPairedComponents. */
  private openContextAddComponentsFromTree(item: any): void {
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    if (item == null || item.id == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    this.treeViewSystemArea.instance.unselectAll();
    this.treeViewSystemArea.instance.selectItem(item.id);
    this.systemid = item.id;
    this.onitemchange.emit(item);
    this.addComponentsGallerySystemId = item.id;
    this.addComponentsGallerySelectedRows = [];
    // Componentes ya asignados al sistema → se preseleccionan (match c.ComponentId === ID) con CSS distinto.
    this.addComponentsGalleryPreselectedIds = [];
    this.MapInformationService.SaveInfoSites({ method: 'GetEstimateAreaSystemComponentsList', systemid: item.id })
      .subscribe((res: any) => {
        this.addComponentsGalleryPreselectedIds = (res || [])
          .filter((x: any) => x && x.ID != null)
          .map((x: any) => String(x.ID));
      });
    this.addComponentsGallerySystemLabel = item.text != null ? String(item.text) : '';
    this.addComponentsGalleryAreaLabel = this.getAreaLabelForGallerySystemItem(item);
    this.addComponentsGalleryItems = [];
    this.activeGalleryTab = 'suggested';
    this.addComponentsGalleryFilter = '';
    this.galleryLibFilter = '';
    this.galleryLibSelectedCategoryId = null;
    this.galleryLibCatSearch = '';
    if (this.galleryLibLoaded) {
      this._applyGalleryLibFilter();
    } else if (!this.galleryLibLoading) {
      this.loadGalleryLibComponents();
    }
    this.addCompGalleryCurrentSysTypeId = null;
    this.addCompGallerySystemMasterData = null;
    this.addCompGalleryEditSysTypeValue = null;
    this.addCompGalleryEditSysTypeVisible = false;
    this.popupAddComponentsGallery = true;
    this.ensureAddCompGallerySysTypes();
    this.loadGetMostPairedComponents(item.id);          // initial load (no similarity_type yet)
    this.loadAddCompGallerySystemMasterData(item.id);   // async: resolves type and reloads
  }

  private getAreaLabelForGallerySystemItem(systemItem: any): string {
    if (systemItem == null) { return ''; }
    const areas = this.getGroupItemsTopLevelAreas();
    if (!areas || !areas.length) { return ''; }
    const sid = systemItem.id;
    for (let i = 0; i < areas.length; i++) {
      const area = areas[i];
      if (!area || !area.items) { continue; }
      if (area.items.some((s: any) => s && s.id === sid)) {
        return this._areaNodeLabel(area);
      }
    }
    return '';
  }

  private _areaNodeLabel(area: any): string {
    if (area.areaname != null && String(area.areaname).trim() !== '') {
      return String(area.areaname).trim();
    }
    const t = area.text != null ? String(area.text) : '';
    return t.replace(/^\s*\d+\s*-\s*/, '').trim() || t;
  }

  get addComponentsGallerySelectionCount(): number {
    const rows = this.addComponentsGallerySelectedRows;
    return rows && rows.length ? rows.length : 0;
  }

  closeAddComponentsGalleryClick(): void {
    this.popupAddComponentsGallery = false;
    this.clearCubeAIGalleryTabBadges();
  }

  get addComponentsGallerySelectionProgress(): number {
    const items = this.addComponentsGalleryItems;
    const rows = this.addComponentsGallerySelectedRows;
    const total = items && items.length ? items.length : 0;
    if (total === 0) {
      return 0;
    }
    const n = rows && rows.length ? rows.length : 0;
    return Math.round((n * 100) / total);
  }

  addComponentsGallerySelectionNamesPreview(maxNames: number): string {
    const rows = this.addComponentsGallerySelectedRows;
    if (!rows || !rows.length) {
      return '';
    }
    const names: string[] = [];
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      if (r != null && r.Component_Name != null && String(r.Component_Name).trim() !== '') {
        names.push(String(r.Component_Name).trim());
      }
    }
    const cap = maxNames != null && maxNames > 0 ? maxNames : 3;
    const shown = names.slice(0, cap);
    let s = shown.join(', ');
    if (names.length > cap) {
      s += ' +' + String(names.length - cap);
    }
    return s;
  }

  // ── System Type display + edit for gallery header ────────────────────────
  addCompGallerySysTypeDataSource: any[] = [];
  addCompGalleryCurrentSysTypeId: any = null;
  addCompGallerySystemMasterData: any = null;     // full row from Get_ControllerMasterData
  addCompGalleryEditSysTypeVisible: boolean = false;
  addCompGalleryEditSysTypeValue: any = null;
  addCompGalleryEditSysTypeSaving: boolean = false;

  get addCompGalleryCurrentSysTypeName(): string {
    if (this.addCompGalleryCurrentSysTypeId == null || !this.addCompGallerySysTypeDataSource.length) { return ''; }
    const node = this.addCompGallerySysTypeDataSource.find(
      (n: any) => String(n.ID) === String(this.addCompGalleryCurrentSysTypeId)
    );
    return node ? (node.SystemType || '') : '';
  }

  private ensureAddCompGallerySysTypes(): void {
    if (this.addCompGallerySysTypeDataSource.length > 0) { return; }
    this.MapInformationService.SaveInfoSites({ method: 'Get_EstimateSytemTypeCE' }).subscribe(
      (res: any) => { this.addCompGallerySysTypeDataSource = Array.isArray(res) ? res : []; },
      () => {}
    );
  }

  loadAddCompGallerySystemMasterData(systemid: any): void {
    this.MapInformationService.SaveInfoSites({
      method: 'Get_ControllerMasterData',
      systemid: systemid,
    }).subscribe(
      (res: any) => {
        const row = Array.isArray(res) ? res[0] : (res != null ? res : null);
        this.addCompGallerySystemMasterData = row || null;
        if (row) {
          this.addCompGalleryCurrentSysTypeId = row.SystemType != null ? row.SystemType : null;
          // Reload Most Used with the resolved system type
          this.loadGetMostPairedComponents(systemid);
        }
      },
      () => { this.addCompGallerySystemMasterData = null; }
    );
  }

  openEditSysType(): void {
    this.addCompGalleryEditSysTypeValue = this.addCompGalleryCurrentSysTypeId;
    this.addCompGalleryEditSysTypeVisible = true;
  }

  syncAddCompGallerySysTypeTree(e: any): void {
    const tv = e.component || (this.addCompGallerySysTypeTree && this.addCompGallerySysTypeTree.instance);
    if (!tv) { return; }
    if (this.addCompGalleryEditSysTypeValue == null) {
      tv.unselectAll();
    } else {
      tv.selectItem(this.addCompGalleryEditSysTypeValue);
    }
  }

  onAddCompGallerySysTypeChanged(e: any): void {
    if (e.node && e.node.selected === false) { return; }
    const nodes = e.component.getSelectedNodes();
    this.addCompGalleryEditSysTypeValue = nodes.length > 0 ? nodes[0].key : null;
  }

  saveEditSysType(): void {
    if (this.addComponentsGallerySystemId == null) { return; }
    const d = this.addCompGallerySystemMasterData || {};
    const newType = this.addCompGalleryEditSysTypeValue != null ? this.addCompGalleryEditSysTypeValue : '';
    const areaid = d.AreaName != null ? d.AreaName : '';
    const areaname = areaid ? (String(areaid) + (this.addComponentsGalleryAreaLabel ? '-' + this.addComponentsGalleryAreaLabel : '')) : (this.addComponentsGalleryAreaLabel || '');
    this.addCompGalleryEditSysTypeSaving = true;
    this.MapInformationService.SaveInfoSites({
      method: 'Upadte_EstimateAreaSystemCESingle',
      id: d.ID != null ? d.ID : this.addComponentsGallerySystemId,
      systemid: d.ID != null ? d.ID : this.addComponentsGallerySystemId,
      sort: d.SORT != null ? d.SORT : 0,
      areaname: areaname,
      areaid: areaid,
      systemname: d.SystemName || '',
      qty: d.QTY != null ? d.QTY : 1,
      systemtype: newType,
      inactive: d.INACTIVE != null ? d.INACTIVE : false,
      deleted: d.DELETED != null ? d.DELETED : false,
      scopeofwork: d.SCOPEOFWORK != null ? d.SCOPEOFWORK : '',
      sop: d.SOP != null ? d.SOP : '',
      excludefromsearch: d.EXCLUDEFROMSEARCH != null ? d.EXCLUDEFROMSEARCH : false,
      controldwgname: d.CONTROLDWGNAME != null ? d.CONTROLDWGNAME : '',
      controldwgimg: d.CONTROLDWGIMG != null ? d.CONTROLDWGIMG : '',
      tagtext: d.TAGTEXT != null ? d.TAGTEXT : '',
      tagnum: d.TAGNUM != null ? d.TAGNUM : '',
      description: d.DESCRIPTION != null ? d.DESCRIPTION : '',
    }).subscribe(
      () => {
        this.addCompGalleryCurrentSysTypeId = this.addCompGalleryEditSysTypeValue;
        if (this.addCompGallerySystemMasterData) {
          this.addCompGallerySystemMasterData.SystemType = newType;
        }
        this.addCompGalleryEditSysTypeVisible = false;
        this.addCompGalleryEditSysTypeSaving = false;
        this.loadGetMostPairedComponents(this.addComponentsGallerySystemId);
      },
      () => {
        this.addCompGalleryEditSysTypeSaving = false;
        this.toast.error('Failed to update system type.');
      }
    );
  }
  // ── end System Type display + edit ────────────────────────────────────────

  loadGetMostPairedComponents(systemid: any): void {
    this.addComponentsGalleryLoading = true;
    this.addComponentsGalleryItems = [];
    this.MapInformationService.SaveInfoSites({
      method: 'GetMostPairedComponents',
      compids: '',
      systemid: systemid,
      similarity_type: this.addCompGalleryCurrentSysTypeId != null ? this.addCompGalleryCurrentSysTypeId : '',
    }).subscribe(
      (resp: any) => {
        this.addComponentsGalleryLoading = false;
        let list: any[] = [];
        if (Array.isArray(resp)) {
          list = resp;
        } else if (resp != null && typeof resp === 'object') {
          list = [resp];
        }
        this.addComponentsGalleryItems = list.map((row: any) => this.normalizePairedComponentRow(row)).filter((r: any) => r != null)
          .sort((a: any, b: any) => (a.Component_Name || '').localeCompare(b.Component_Name || ''));
        this._applyGalleryFilter();
      },
      () => {
        this.addComponentsGalleryLoading = false;
        this.addComponentsGalleryItems = [];
        this.toast.error(this.translate.instant('ModuleSystemToArea.msgLoadPairedComponentsFail'));
      }
    );
  }

  onAddComponentsGalleryModalHidden(): void {
    this.popupAddComponentsGallery = false;
    this.addComponentsGalleryLoading = false;
    this.addComponentsGalleryInserting = false;
    this.addComponentsGalleryItems = [];
    this.addComponentsGallerySystemId = null;
    this.addComponentsGallerySelectedRows = [];
    this.addComponentsGalleryPreselectedIds = [];
    this.addComponentsGallerySystemLabel = '';
    this.addComponentsGalleryAreaLabel = '';
    this.addCompGalleryCurrentSysTypeId = null;
    this.addCompGallerySystemMasterData = null;
    this.addCompGalleryEditSysTypeValue = null;
    this.addCompGalleryEditSysTypeVisible = false;
    this.addComponentsGalleryBudgetUsed = 0;
    this.addComponentsGalleryBudgetTotal = 0;
    this.addComponentsGalleryFilter = '';
    this.addComponentsGalleryFilteredItems = [];
    this.activeGalleryTab = 'suggested';
    this.galleryLibFilter = '';
    this.galleryLibSelectedCategoryId = null;
    this.galleryLibCatSearch = '';
    // Auto-select the first root node if tree is already cached (skip "Master" step)
    this.galleryLibNavL1Id = (this.galleryLibLoaded && this.galleryLibTypeTree.length > 0)
      ? this.galleryLibTypeTree[0].id
      : null;
    this.galleryLibNavStack = [];
    this.galleryLibInSelectedMode = false;
    // No resetear galleryLibLoaded/_galleryLibAllComponents/galleryLibTypeTree: se cachea entre aperturas
    if (this._galleryFilterTimer) { clearTimeout(this._galleryFilterTimer); }
  }

  trackByComponentGallery(index: number, c: any): string {
    if (c == null) {
      return 'gallery-null-' + index;
    }
    const idPart = c.ComponentId != null ? String(c.ComponentId) : 'noid';
    const tagPart = c.Tag_Id != null ? String(c.Tag_Id) : 'notag';
    return 'gallery-' + index + '-' + idPart + '-' + tagPart;
  }

  componentGalleryImgSrc(c: any): string {
    if (c == null || c.ACHR == null || String(c.ACHR).trim() === '') {
      return '';
    }
    return 'assets/imgcomponent/' + String(c.ACHR).trim();
  }

  onComponentGalleryImgError(ev: Event): void {
    const el = ev.target as HTMLImageElement;
    if (el && el.style) {
      el.style.visibility = 'hidden';
    }
  }

  /** ¿La card corresponde a un componente ya asignado al sistema? (match c.ComponentId === SP.ID) */
  galleryRowPreselected(c: any): boolean {
    if (!c || c.ComponentId == null || c.ComponentId === '') {
      return false;
    }
    return this.addComponentsGalleryPreselectedIds.indexOf(String(c.ComponentId)) >= 0;
  }

  galleryRowSelected(c: any): boolean {
    const key = this.galleryComponentIdKey(c);
    if (!key) {
      return this.addComponentsGallerySelectedRows.indexOf(c) >= 0;
    }
    const rows = this.addComponentsGallerySelectedRows;
    for (let i = 0; i < rows.length; i++) {
      if (this.galleryComponentIdKey(rows[i]) === key) {
        return true;
      }
    }
    return false;
  }

  toggleAddComponentsGalleryItem(c: any, ev?: Event): void {
    if (c == null) {
      return;
    }
    if (ev) {
      ev.stopPropagation();
    }
    // Si el componente ya está en el sistema y aún no fue seleccionado por el usuario,
    // pedimos confirmación antes de importarlo de nuevo.
    if (this.galleryRowPreselected(c) && !this.galleryRowSelected(c)) {
      this.alreadyInSystemPendingComponent = c;
      this.showAlreadyInSystemConfirm = true;
      return;
    }
    this._toggleGalleryItemSelection(c);
  }

  /** Alterna la selección de una card en addComponentsGallerySelectedRows. */
  private _toggleGalleryItemSelection(c: any): void {
    const key = this.galleryComponentIdKey(c);
    const list = this.addComponentsGallerySelectedRows.slice();
    let i = -1;
    if (key) {
      for (let j = 0; j < list.length; j++) {
        if (this.galleryComponentIdKey(list[j]) === key) {
          i = j;
          break;
        }
      }
    } else {
      i = list.indexOf(c);
    }
    if (i >= 0) {
      list.splice(i, 1);
    } else {
      list.push(c);
    }
    this.addComponentsGallerySelectedRows = list;
  }

  /** Confirma importar un componente que ya está en el sistema → lo selecciona. */
  confirmImportAlreadyInSystem(): void {
    const c = this.alreadyInSystemPendingComponent;
    this.showAlreadyInSystemConfirm = false;
    this.alreadyInSystemPendingComponent = null;
    if (c) {
      this._toggleGalleryItemSelection(c);
    }
  }

  cancelImportAlreadyInSystem(): void {
    this.showAlreadyInSystemConfirm = false;
    this.alreadyInSystemPendingComponent = null;
  }

  componentGalleryDescription(c: any): string {
    if (c == null) {
      return '';
    }
    const d = c.Description;
    if (d != null && String(d).trim() !== '') {
      return String(d).trim();
    }
    const n = c.CompCnt;
    if (n != null && n !== '') {
      return this.translate.instant('ModuleSystemToArea.labelPairCount', { n: n });
    }
    return '';
  }

  componentGalleryCategoryLabel(c: any): string {
    if (c == null) {
      return '';
    }
    const raw = c.CategoryLabel != null ? String(c.CategoryLabel).trim() : '';
    if (raw !== '') {
      const up = raw.toUpperCase();
      return up.length > 14 ? up.substr(0, 14) : up;
    }
    return this.translate.instant('ModuleSystemToArea.badgeGalleryPart');
  }

  addComponentsGalleryCardIdLabel(c: any): string {
    if (c == null) {
      return '';
    }
    if (c.ComponentId != null && c.ComponentId !== '') {
      return String(c.ComponentId);
    }
    if (c.Tag_Id != null && c.Tag_Id !== '') {
      return String(c.Tag_Id);
    }
    return '';
  }

  /** Formato SP: "153/-2,282/-3" (contador temporal negativo desde -2). */
  private buildInsertComponentIdsString(rows: any[]): string {
    if (!rows || !rows.length) {
      return '';
    }
    const seen = new Set<string>();
    let counter = 2;
    const parts: string[] = [];
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      if (row == null) {
        continue;
      }
      const cid = row.ComponentId != null ? row.ComponentId : row.componentId;
      if (cid == null || cid === '') {
        continue;
      }
      const key = String(cid);
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      parts.push(key + '/' + String(counter * -1));
      counter++;
    }
    return parts.join(',');
  }

  onAddSelectedGalleryComponentsClick(): void {
    if (!this.addComponentsGallerySelectedRows || !this.addComponentsGallerySelectedRows.length) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelectComponentFirst'));
      return;
    }
    this.insertGalleryComponentsToSystem(this.addComponentsGallerySelectedRows.slice());
  }

  onAddAllGalleryComponentsClick(): void {
    if (this.activeGalleryTab === 'library') {
      if (!this.galleryLibFilteredItems || !this.galleryLibFilteredItems.length) { return; }
      this.insertGalleryComponentsToSystem(this.galleryLibFilteredItems.slice());
    } else {
      if (!this.addComponentsGalleryItems || !this.addComponentsGalleryItems.length) { return; }
      this.insertGalleryComponentsToSystem(this.addComponentsGalleryItems.slice());
    }
  }

  private insertGalleryComponentsToSystem(rows: any[]): void {
    const self = this;
    if (self.addComponentsGalleryInserting) {
      return;
    }
    if (self.addComponentsGallerySystemId == null || self.addComponentsGallerySystemId === '') {
      self.toast.warning(self.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    const componentids = self.buildInsertComponentIdsString(rows);
    if (!componentids) {
      self.toast.warning(self.translate.instant('ModuleSystemToArea.msgSelectComponentFirst'));
      return;
    }
    const systemidStr = String(self.addComponentsGallerySystemId) + '-1';
    self.addComponentsGalleryInserting = true;
    self.MapInformationService.SaveInfoSites({
      method: 'insert_EstimateRevisionAreaSystemDetail2',
      systemid: systemidStr,
      componentids: componentids,
    }).subscribe(
      () => {
        self.addComponentsGalleryInserting = false;
        self.toast.success(self.translate.instant('ModuleSystemToArea.msgGalleryComponentsInserted'));
        self.onAddComponentsGalleryModalHidden();
        self.reload.emit(self.estimateid);
        self.refreshGroupItemsFromSystemArea(true);
      },
      () => {
        self.addComponentsGalleryInserting = false;
        self.toast.error(self.translate.instant('ModuleSystemToArea.msgGalleryComponentsInsertFail'));
      }
    );
  }

  private normalizePairedComponentRow(row: any): any {
    if (row == null || typeof row !== 'object') {
      return null;
    }
    return {
      CompCnt: row.CompCnt != null ? row.CompCnt : row.compCnt,
      ComponentId: row.ComponentId != null ? row.ComponentId : row.componentId,
      Component_Name:
        row.Component_Name != null
          ? row.Component_Name
          : row.component_name != null
            ? row.component_name
            : row.ComponentName != null
              ? row.ComponentName
              : row.componentName != null
                ? row.componentName
                : '',
      Tag_Id: row.Tag_Id != null ? row.Tag_Id : row.tag_Id != null ? row.tag_Id : row.tag_id,
      ACHR: row.ACHR != null ? row.ACHR : row.achr != null ? row.achr : '',
      Description:
        row.Description != null
          ? String(row.Description)
          : row.Component_Description != null
            ? String(row.Component_Description)
            : row.description != null
              ? String(row.description)
              : '',
      CategoryLabel:
        row.Category != null
          ? String(row.Category)
          : row.ComponentCategory != null
            ? String(row.ComponentCategory)
            : row.Component_Type != null
              ? String(row.Component_Type)
              : row.component_type != null
                ? String(row.component_type)
                : '',
    };
  }

  private openContextEditSystemFromTree(item: any) {
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    if (item == null || item.id == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    this.treeViewSystemArea.instance.unselectAll();
    this.treeViewSystemArea.instance.selectItem(item.id);
    this.getEstimateArea(this.estimateid);
    this.getSystemType();
    this.popupController = true;
  }

  private openContextUseCubeAIParentImportFromTree(item: any): void {
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    if (item == null || item.id == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    this.treeViewSystemArea.instance.unselectAll();
    this.treeViewSystemArea.instance.selectItem(item.id);
    this.systemid = item.id;
    this.onitemchange.emit(item);
    if (this.ModuleFrom === 'Edit Estimate') {
      this.openImportOptionsPopupFromTree.emit(item);
    }
  }

  /** Estimate root/system → "Configure System": selecciona el sistema y avisa al padre para abrir el modal de componentes. */
  private openContextConfigureSystemFromTree(item: any): void {
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    if (item == null || item.id == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    this.treeViewSystemArea.instance.unselectAll();
    this.treeViewSystemArea.instance.selectItem(item.id);
    this.systemid = item.id;
    this.onitemchange.emit(item);
    this.openConfigureSystemFromTree.emit(item);
  }

  private openContextDuplicateSystemFromTree(item: any) {
    if (item == null || item.id == null || item.areaid == null || item.areaid === '') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    this.estimateService.DuplicateSystemSingle(item.areaid, item.id).subscribe(result => {
      if (!result || !result.length || !result[0] || result[0].ID == null) {
        this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
        return;
      }
      this.estimateService.duplicateImage(item.id, result[0].ID).subscribe(() => {
        this.toast.success(this.translate.instant('ModuleSystemToArea.msgSysDupSucc'));
        this.reload.emit(this.estimateid);
      });
    });
  }

  private openContextDeleteSystemFromTree(item: any) {
    if (!this.treeViewSystemArea || !this.treeViewSystemArea.instance) {
      return;
    }
    if (item == null || item.id == null) {
      this.toast.warning('You must select a system');
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    this.treeViewSystemArea.instance.unselectAll();
    this.treeViewSystemArea.instance.selectItem(item.id);
    this.componentModel.ID = this.treeViewSystemArea.instance.getSelectedNodeKeys().filter((x: any) => x >= 1);
    this.componentModel.data = this.treeViewSystemArea.instance.getSelectedNodes().filter((x: any) => x.key >= 1);
    if (this.componentModel.ID.length > 0) {
      this.popupDeleteSystem = true;
      setTimeout(() => {
        if (this.treeDelete !== undefined) {
          this.componentModel.ID.forEach((x: any) => {
            this.treeDelete.instance.selectItem(x);
          });
        }
      }, 2000);
    } else {
      this.toast.warning('You must select a system');
    }
  }

  // ===== Clear System: vaciar todos los componentes y parts de un sistema =====
  showClearSystemConfirm: boolean = false;
  clearSystemTargetId: any = null;
  clearSystemTargetName: string = '';

  /** Abre el modal de confirmación "Remove all components and parts from [name]?" */
  private openContextClearSystemFromTree(item: any) {
    if (item == null || item.id == null) {
      this.toast.warning('You must select a system');
      return;
    }
    this.clearInlineRenameAreaState();
    this.clearInlineRenameSystemState();
    this.clearSystemTargetId = item.id;
    this.clearSystemTargetName = item.text || '';
    this.showClearSystemConfirm = true;
  }

  /**
   * Confirma el Clear System: llama al SP Update_EstimateRevisionAreaSystemDetailFromWebDiagram_SCV2
   * con componentids vacío (el service arma systemid como `${id}-1`), lo que elimina
   * todos los componentes/parts del sistema.
   */
  confirmClearSystem() {
    const systemId = this.clearSystemTargetId;
    if (systemId == null) {
      this.showClearSystemConfirm = false;
      return;
    }

    const done = () => {
      this.toast.success('System cleared successfully');
      this.showClearSystemConfirm = false;
      this.clearSystemTargetId = null;
      this.clearSystemTargetName = '';
      this.reload.emit(this.estimateid);
    };

    // Limpia los componentes del sistema (SCV2 con componentids vacío → systemid "<id>-1").
    const clearComponents = () => {
      this.estimateService.Insert_EstimateRevisionAreaSystemDetailCE2_SCV2(systemId, "").subscribe(
        () => done(),
        () => {
          this.toast.error('Error clearing system');
          this.showClearSystemConfirm = false;
        }
      );
    };

    // 1) Junta los IDs de los detalles del "Add Parts & labor" grid del sistema y los borra
    //    con Delete_EstimateRevisionAreaSystemDetailCE; luego limpia los componentes.
    this.estimateService.GetEstimateAreaSystemDetailwithOutPrice(systemId).subscribe(
      (details: any[]) => {
        const ids = (details || [])
          .map((d: any) => d.ID)
          .filter((x: any) => x != null && x !== '');
        if (ids.length > 0) {
          this.estimateService.Delete_EstimateRevisionAreaSystemDetailCE(systemId, ids.join(',')).subscribe(
            () => clearComponents(),
            () => clearComponents() // si falla el borrado de detalles, igual limpiamos componentes
          );
        } else {
          clearComponents();
        }
      },
      () => clearComponents() // si no se pudieron leer los detalles, igual limpiamos componentes
    );
  }

  showImportTypeModal: boolean = false;
  showExistingWorkPopup: boolean = false;
  existingWorkData: any = null;
  showCloseDiagramConfirmation: boolean = false;
  showSelectSystemsPopup: boolean = false;
  filteredSystemsForSelection: any[] = [];
  selectedSystemsForChange: number[] = [];
  showErrorCreditReturnedPopup: boolean = false;
  useStoredConfiguration: boolean = false;
  showAssociateSystemOriginPopup: boolean = false;
  showSelectSystemWarningPopup: boolean = false;
  showDisableStoredConfigConfirmation: boolean = false;
  filteredChildrenForSystemOrigin: any[] = [];
  saveConfigurationOptions: any[] = [];
  selectedSaveConfiguration: any = 60000;
  enableAutoSave: boolean = false;
  propertyChangeCheckInterval: any = null;
  autosaveInterval: any = null;
  selectedChildrenForSystemOrigin: string[] = [];
  currentSystemOriginData: any = null;
  showChangeParentPopup: boolean = false;
  childToMove: any = null;
  availableParents: any[] = [];
  selectedNewParentId: any = null;
  showColorPickerPopup: boolean = false;
  parentForColor: any = null;
  selectedColor: string = '#007bff';

  transformResultsToGroupItems(results: any[]): any[] {
    if (!results || results.length === 0) {
      return [];
    }

    let groupId = 1;
    let itemId = 100;
    const transformedGroups: any[] = [];




    results.forEach((resultItem) => {
      // Crear el grupo principal (el item con systemType, name, etc.)
      const uniqueHexId = Date.now().toString(16) + Math.random().toString(16).substring(2);

      const group = {
        id: uniqueHexId,
        text: resultItem.name,
        expanded: true,
        parentId: null,
        items: [] as any[]
      };

      // Agregar los children como items dentro del grupo
      if (resultItem.children && resultItem.children.length > 0) {
        resultItem.children.forEach((child: any) => {
          const uniqueHexId2 = Date.now().toString(16) + Math.random().toString(16).substring(2);
          group.items.push({
            id: uniqueHexId2,
            text: child.name || 'Sin nombre',
            expanded: false,
            parentId: group.id,
            items: [],
            // Mantener información adicional del child si es necesario
            bbox: child.bbox,
            source: child.source
          });
        });
      }

      transformedGroups.push(group);
    });

    return transformedGroups;
  }

  expandDiagramTree() {
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      this.diagramTreeView.instance.expandAll();
    }
  }

  collapseDiagramTree() {
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      this.diagramTreeView.instance.collapseAll();
    }
  }

  deleteSelectedTreeItem() {
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const selectedItem = this.diagramTreeView.instance.getSelectedNodes();

      if (selectedItem && selectedItem.length > 0) {
        const itemToDelete = selectedItem[0];
        const itemId = itemToDelete.itemData.id;
        const itemData = itemToDelete.itemData;

        if (itemId) {
          // Verificar si es un parent (tiene hijos)
          const hasChildren = itemData.items && itemData.items.length > 0;

          // Guardar el item a eliminar
          this.itemToDeleteTree = {
            id: itemId,
            text: itemData.text || 'the selected item',
            itemData: itemData,
            isParent: hasChildren,
            children: hasChildren ? this.getAllChildrenIds(itemData) : []
          };

          // Si tiene hijos, mostrar modal de selección, sino mostrar confirmación normal
          if (hasChildren) {
            this.deleteSelection = 'parent'; // Por defecto seleccionar parent
            this.showDeleteSelectionModal = true;
          } else {
            this.showConfirmDeleteTreeItem = true;
          }
        } else {
          this.toast.warning('Could not get the ID of the selected item');
        }
      } else {
        this.toast.warning('Please select an item from the tree to delete');
      }
    }
  }

  // Función recursiva para obtener todos los IDs de los hijos
  getAllChildrenIds(item: any): number[] {
    let ids: number[] = [];
    if (item.items && item.items.length > 0) {
      item.items.forEach((child: any) => {
        if (child.id) {
          ids.push(child.id);
        }
        // Recursivamente obtener los hijos de este hijo
        ids = ids.concat(this.getAllChildrenIds(child));
      });
    }
    return ids;
  }

  // Manejar el cambio en la selección del radio button
  onDeleteSelectionChanged(e: any) {
    if (e && e.value !== undefined) {
      this.deleteSelection = e.value;
    }
  }

  // Confirmar la selección y proceder con el borrado
  confirmDeleteSelection() {
    this.showDeleteSelectionModal = false;

    // Asegurarse de que deleteSelection sea un string
    const selection = typeof this.deleteSelection === 'string'
      ? this.deleteSelection
      : (this.deleteSelection && (this.deleteSelection as any).value) || 'parent';

    if (selection === 'parent') {
      // Borrar parent y todos sus hijos
      this.deleteParentWithChildren();
    } else if (selection === 'children') {
      // Borrar solo los children
      this.deleteOnlyChildren();
    }
  }

  // Cancelar la selección
  cancelDeleteSelection() {
    this.showDeleteSelectionModal = false;
    this.itemToDeleteTree = null;
    this.deleteSelection = 'parent';
  }

  // Borrar parent y todos sus hijos
  deleteParentWithChildren() {
    if (!this.itemToDeleteTree || !this.itemToDeleteTree.id) return;

    const idsToDelete: number[] = [this.itemToDeleteTree.id];
    const parentText = this.itemToDeleteTree.text;

    // Agregar todos los hijos
    if (this.itemToDeleteTree.children && this.itemToDeleteTree.children.length > 0) {
      idsToDelete.push(...this.itemToDeleteTree.children);
    }

    // Eliminar del tree
    idsToDelete.forEach(id => {
      this.removeItem(this.groupItemsDiagram, id);
    });

    // Eliminar de componentsNew (parent y todos sus hijos)
    this.componentsNew = this.componentsNew.filter(component => {
      return !idsToDelete.includes(component.ID);
    });

    // Eliminar de newDataGroupNames si es un parent (grupo raíz)
    if (parentText) {
      this.newDataGroupNames = this.newDataGroupNames.filter(name => name !== parentText);

      // Asegurar que "Design Tools" esté presente si no está
      if (!this.newDataGroupNames.includes("Design Tools")) {
        this.newDataGroupNames.push("Design Tools");
      }
    }

    // Eliminar del diagrama
    if (this.diagramNew && this.diagramNew.instance) {
      let json = this.diagramNew.instance.export();
      let diagram = JSON.parse(json);

      // Convertir todos los types a string
      diagram.shapes.forEach((item: any) => {
        if (item.type !== undefined) {
          item.type = `${item.type}`;
        }
      });

      // Eliminar todos los shapes que coincidan con los IDs
      diagram.shapes = diagram.shapes.filter((shape: any) => {
        return !idsToDelete.includes(shape.key);
      });

      this.diagramNew.instance.import(JSON.stringify(diagram));
    }

    // Actualizar el treeview
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
      this.diagramTreeView.instance.option('items', sortedItems);
    }

    this.toast.success(`"${this.itemToDeleteTree.text}" and all its children deleted successfully`);
    this.itemToDeleteTree = null;
  }

  // Borrar solo los children
  deleteOnlyChildren() {
    if (!this.itemToDeleteTree || !this.itemToDeleteTree.children || this.itemToDeleteTree.children.length === 0) {
      this.toast.warning('No children to delete');
      return;
    }

    const childrenIds = this.itemToDeleteTree.children;

    // Eliminar solo los hijos del tree (no el parent)
    childrenIds.forEach(id => {
      this.removeItem(this.groupItemsDiagram, id);
    });

    // Eliminar solo los hijos de componentsNew (no el parent)
    this.componentsNew = this.componentsNew.filter(component => {
      return !childrenIds.includes(component.ID);
    });

    // Nota: No eliminamos de newDataGroupNames porque solo se eliminan los children, el parent permanece

    // Eliminar solo los hijos del diagrama
    if (this.diagramNew && this.diagramNew.instance) {
      let json = this.diagramNew.instance.export();
      let diagram = JSON.parse(json);

      // Convertir todos los types a string
      diagram.shapes.forEach((item: any) => {
        if (item.type !== undefined) {
          item.type = `${item.type}`;
        }
      });

      // Eliminar solo los shapes de los hijos (no el parent)
      diagram.shapes = diagram.shapes.filter((shape: any) => {
        return !childrenIds.includes(shape.key);
      });

      this.diagramNew.instance.import(JSON.stringify(diagram));
    }

    // Actualizar el treeview
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
      this.diagramTreeView.instance.option('items', sortedItems);
    }

    this.toast.success(`${childrenIds.length} child item(s) deleted successfully`);
    this.itemToDeleteTree = null;
  }

  editTreeItem(item: any) {
    if (item && item.id) {
      this.itemEditingId = item.id;
      this.itemEditingText = item.text || '';
      // Enfocar el text-box después de que Angular renderice el cambio
      setTimeout(() => {
        const textBoxElement = document.querySelector(`#edit-textbox-${item.id}`) as HTMLElement;
        if (textBoxElement) {
          const inputElement = textBoxElement.querySelector('input');
          if (inputElement) {
            inputElement.focus();
            inputElement.select();
          }
        }
      }, 100);
    }
  }

  saveTreeItem(item: any) {
    if (!this.itemEditingId || !this.itemEditingText || this.itemEditingText.trim() === '') {
      this.toast.warning('El nombre no puede estar vacío');
      return;
    }

    // Buscar y actualizar el item en el array groupItemsDiagram
    const updated = this.updateItemInArray(this.groupItemsDiagram, this.itemEditingId, this.itemEditingText.trim());

    if (updated) {
      // Actualizar el diagrama si el shape existe
      if (this.diagramNew && this.diagramNew.instance) {
        let json = this.diagramNew.instance.export();
        let diagram = JSON.parse(json);

        if (diagram.shapes) {
          const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === this.itemEditingId);

          if (shapeIndex !== -1) {
            // Actualizar el texto del shape
            if (diagram.shapes[shapeIndex].text) {
              diagram.shapes[shapeIndex].text = this.itemEditingText.trim();
            }

            // Convertir todos los types a string
            diagram.shapes.forEach((shape: any) => {
              if (shape.type !== undefined) {
                shape.type = `${shape.type}`;
              }
            });

            const viewData = this.getCurrentDiagramView();

            // Importar el diagrama
            this.diagramNew.instance.import(JSON.stringify(diagram));

            // Restaurar el zoom y scroll después del import
            if (viewData) {
              setTimeout(() => {
                if (this.diagramNew && this.diagramNew.instance) {
                  // Restaurar zoom
                  if (viewData.zoom > 0) {
                    try {
                      this.diagramNew.instance.option('zoomLevel', viewData.zoom);
                      this.zoomDiagramNew = viewData.zoom;
                    } catch (e) {
                      console.warn('Error al restaurar zoom:', e);
                    }
                  }

                  // Restaurar scroll
                  const diagramElement = document.getElementById('diagramNew');
                  if (diagramElement && (viewData.scrollLeft > 0 || viewData.scrollTop > 0)) {
                    try {
                      const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
                      if (scrollableContainer) {
                        scrollableContainer.scrollLeft = viewData.scrollLeft;
                        scrollableContainer.scrollTop = viewData.scrollTop;
                        // scrollableContainer.scrollLeft = newShape.x;
                        // scrollableContainer.scrollTop = newShape.y;
                      } else {
                        const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
                        if (scrollableWrapper) {
                          scrollableWrapper.scrollLeft = viewData.scrollLeft;
                          scrollableWrapper.scrollTop = viewData.scrollTop;
                          // scrollableWrapper.scrollLeft = newShape.x;
                          // scrollableWrapper.scrollTop = newShape.y;
                        }
                      }
                    } catch (e) {
                      console.warn('Error al restaurar scroll:', e);
                    }
                  }
                }
              }, 100);
            }
          }
        }
      }

      // Actualizar el treeview
      if (this.diagramTreeView && this.diagramTreeView.instance) {



        this.newDataGroupNames = []

        this.componentsNew.forEach(component => {
          if (component.ID == item.id) {
            component.SystemType = this.itemEditingText;
          }
        });
        const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
        this.diagramTreeView.instance.option('items', sortedItems);




        this.newDataGroupNames = this.componentsNew.slice(1).map(component => component.SystemType);

        console.log("this.componentsNew", this.componentsNew)

        if (!this.newDataGroupNames.includes("Design Tools")) {
          this.newDataGroupNames.push("Design Tools")
        }


        setTimeout(() => {
          this.diagramNew.instance.option('zoomLevel', 1);
        }, 100);
      }

      this.toast.success('Item actualizado correctamente');
    } else {
      this.toast.warning('No se pudo actualizar el item');
    }

    // Limpiar el estado de edición
    this.itemEditingId = null;
    this.itemEditingText = '';
  }










  cancelEditTreeItem() {
    this.itemEditingId = null;
    this.itemEditingText = '';
  }

  updateItemInArray = (items: any[], id: number, newText: string): boolean => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === id) {
        items[i].text = newText;
        return true;
      }
      if (items[i].items && items[i].items.length > 0) {
        if (this.updateItemInArray(items[i].items, id, newText)) {
          return true;
        }
      }
    }
    return false;
  };

  deleteTreeItem(item: any) {
    console.log('Delete item:', item);
    if (item && item.id) {
      // Guardar el item a eliminar y mostrar el modal de confirmación
      this.itemToDeleteTree = {
        id: item.id,
        text: item.text || 'the selected item',
        itemData: item
      };
      this.showConfirmDeleteTreeItem = true;
    } else {
      this.toast.warning('Could not get the ID of the item to delete');
    }
  }


  removeItem = (items: any[], id: number): boolean => {
    for (let i = 0; i < items.length; i++) {
      if (items[i].id === id) {
        items.splice(i, 1);
        return true;
      }
      if (items[i].items && items[i].items.length > 0) {
        if (this.removeItem(items[i].items, id)) {
          return true;
        }
      }
    }
    return false;
  };

  confirmDeleteTreeItem() {
    if (this.itemToDeleteTree && this.itemToDeleteTree.id) {
      // Función recursiva para eliminar el item del array

      // Eliminar el item del array
      const removed = this.removeItem(this.groupItemsDiagram, this.itemToDeleteTree.id);




      if (removed) {
        let json = this.diagramNew.instance.export();
        let diagram = JSON.parse(json);

        const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === this.itemToDeleteTree.id);

        if (shapeIndex !== -1) {

          // Convertir todos los types a string
          diagram.shapes.forEach((item: any) => {
            if (item.type !== undefined) {
              item.type = `${item.type}`;
            }
          });
          diagram.shapes.splice(shapeIndex, 1);
          this.diagramNew.instance.import(JSON.stringify(diagram));
        }



        // Actualizar el treeview
        if (this.diagramTreeView && this.diagramTreeView.instance) {
          const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
          this.diagramTreeView.instance.option('items', sortedItems);
        }
        this.toast.success(`"${this.itemToDeleteTree.text}" deleted successfully`);
      } else {
        this.toast.warning('Could not delete the selected item');
      }

      // Cerrar el modal y limpiar
      this.showConfirmDeleteTreeItem = false;
      this.itemToDeleteTree = null;
    }
  }

  cancelDeleteTreeItem() {
    this.showConfirmDeleteTreeItem = false;
    this.itemToDeleteTree = null;
  }

  addTextElementToDiagram() {
    // Obtener el item seleccionado en el treeview si existe
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const selectedNodes = this.diagramTreeView.instance.getSelectedNodes();
      if (selectedNodes && selectedNodes.length > 0) {

        console.log("selectedNodes", selectedNodes)
        this.selectedParentForNewItem = selectedNodes[0].itemData;
      } else {
        this.selectedParentForNewItem = null;
      }
    }

    // Limpiar el input y abrir el modal
    this.newTextItemName = '';
    this.showAddTextModal = true;
  }

  saveNewTextItem() {
    if (!this.newTextItemName || this.newTextItemName.trim() === '') {
      this.toast.warning('Please enter a name for the new item');
      return;
    }

    // Generar un ID único
    const uniqueHexId = Date.now().toString(16) + Math.random().toString(16).substring(2);

    // Crear el nuevo item con la misma estructura que los demás
    const newItem = {
      id: uniqueHexId,
      text: this.newTextItemName.trim(),
      expanded: false,
      parentId: null,
      items: [],
      bbox: '[0,0,0,0]',
      source: ''
    };

    // if (this.selectedParentForNewItem) {
    //   // Si hay un padre seleccionado, agregar como hijo
    //   // Buscar recursivamente en todos los niveles
    //   const findAndAddToParent = (items: any[]): boolean => {
    //     for (const item of items) {
    //       if (item.id === this.selectedParentForNewItem.id) {
    //         item.items.push(newItem);
    //         return true;
    //       }
    //       if (item.items && item.items.length > 0) {
    //         if (findAndAddToParent(item.items)) {
    //           return true;
    //         }
    //       }
    //     }
    //     return false;
    //   };

    //   if (!findAndAddToParent(this.groupItemsDiagram)) {
    //     // Si no se encuentra el padre, agregar como grupo raíz
    //     this.groupItemsDiagram.push(newItem);
    //   }
    // } else {
    // Si no hay padre seleccionado, agregar como grupo raíz
    this.groupItemsDiagram.push(newItem);
    // }

    // Si es un grupo raíz (sin parentId), agregarlo a newDataGroupNames y componentsNew
    // if (!newItem.parentId) {
    // Actualizar newDataGroupNames con todos los grupos raíz
    this.newDataGroupNames = this.groupItemsDiagram.map(item => item.text);

    if (!this.newDataGroupNames.includes("Design Tools")) {
      this.newDataGroupNames.push("Design Tools")
    }

    // Agregar a componentsNew
    const componentData = {
      "ID": uniqueHexId,
      "SystemType": newItem.text,
      "TypeId": uniqueHexId,
      "NAME": '',
      "COMPSCOPE": '',
      "Imagepath": "assets/imgcomponent/rectangulo.svg",
      "filesvg": "assets/imgcomponent/rectangulo.svg",
      "filename": "imageTest.jpg",
      "ACHR": "",
      "TAGID": 0,
      "TAGNAME": "NULL",
      "componentwidth": 0.5,
      "componentHeight": 0.5,
      "Name": '',
      "locked": false
    };

    this.componentsNew.push(componentData);

    console.log("this.componentsNew", this.componentsNew)
    // }

    // Actualizar el treeview
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
      this.diagramTreeView.instance.option('items', sortedItems);
    }

    // Cerrar el modal y limpiar
    this.showAddTextModal = false;
    this.newTextItemName = '';
    this.selectedParentForNewItem = null;
    this.toast.success('Item added successfully');
  }

  cancelAddTextItem() {
    this.showAddTextModal = false;
    this.newTextItemName = '';
    this.selectedParentForNewItem = null;
  }


  newDataGroupNames: any[] = [];
  dimensionsImage: any = {
    width: 0,
    height: 0
  };

  processPlaneWithAI() {

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      // topic: "GET_SYSTEM_TYPE_AI_NEW_ESTIMATE_IMAGE",
      topic: "GET_SYSTEM_TYPE_AI_NEW_ESTIMATE",

    }


    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(result => {

      const item = result[0];

      const resultString = JSON.stringify(this.aiPopupContent);

      const cubeclientid = localStorage.getItem('cubeclientid');

      let prompt = {
        SystemPrompt: item.SYSTEMPROMPT,
        UserPrompt: item.USERPROMPT,
        Base64: this.uploadedPdfBase64,
        // Base64: 'jskdgjsdgnkjdgkdfjkgdfjgkjdnf',
        // estimateid:  this.estimateid,
        areaid: cubeclientid + '_' + this.areaSelectedNew.areaID,
      }




      setTimeout(() => {
        this.showPaymentSuccess = false
        this.loadingService.isLoading.next(false);

        // Mostrar popup de procesamiento del plano
        this.showProcessingPlanePopup = true;

      }, 2000)


      this.MapInformationService.cubeAIReconizePDF(prompt).subscribe(result => {

        this.payCreditRef.SaveEstimatePay()

        this.modalWithCredit = false


        // Transformar result.results al formato de groupItemsDiagram
        this.groupItemsDiagram = this.transformResultsToGroupItems(result.results);
        console.log('groupItemsDiagram', this.groupItemsDiagram)

        this.newDataGroupNames = this.groupItemsDiagram.map(item => item.text);

        if (!this.newDataGroupNames.includes("Design Tools")) {
          this.newDataGroupNames.push("Design Tools")
        }

        this.groupItemsDiagram.forEach(item => {
          // Generar un ID hexadecimal único que nunca se repita
          // item.text + '-' + item.items.length

          const data = {
            "ID": item.id,
            "SystemType": item.text,
            "TypeId": item.id,
            "NAME": '',
            "COMPSCOPE": '',
            "Imagepath": "assets/imgcomponent/rectangulo.svg",
            "filesvg": "assets/imgcomponent/rectangulo.svg",
            "filename": "imageTest.jpg",
            "ACHR": "",
            "TAGID": 0,
            "TAGNAME": "NULL",
            "componentwidth": 0.5,
            "componentHeight": 0.5,
            "Name": '',
            "locked": false
          }

          this.componentsNew.push(data)
        });

        console.log("this.componentsNew", this.componentsNew)

        // nueva logica con imagen, se deeb abrir un nuevo popup
        this.MapInformationService.cubePreviewImage({ image_name: result.results[0].preview }).subscribe(resultImage => {

          // Cerrar popup de procesamiento
          this.showProcessingPlanePopup = false;

          this.image_name = resultImage.image_name
          this.base64Returned = resultImage.base64

          // Obtener las dimensiones de la imagen
          this.getImageDimensions(this.base64Returned).then(dimensions => {
            this.dimensionsImage.width = dimensions.width;
            this.dimensionsImage.height = dimensions.height;
          }).catch(error => {
            console.error('Error al obtener dimensiones de la imagen:', error);
          });

          this.openModalDiagramNew = true

          //           // Inicializar el diagrama después de que el modal esté visible
          setTimeout(() => {
            this.initDiagramNew();
            // Agregar la imagen de fondo después de inicializar el diagrama
            setTimeout(() => {
              this.addBackgroundImage(true);
            }, 300);
          }, 500);


        }, error => {
          setTimeout(() => {
            this.showProcessingPlanePopup = false;
            this.showPaymentSuccess = false;
            this.modalWithCredit = false
          }, 2100)
          this.showPaymentSuccess = false;
          this.showErrorCreditReturnedPopup = true;
          this.modalWithCredit = false
        })

      }, error => {
        setTimeout(() => {
          this.showProcessingPlanePopup = false;
          this.showPaymentSuccess = false;
          this.modalWithCredit = false

        }, 2100)
        this.showPaymentSuccess = false;
        this.showErrorCreditReturnedPopup = true;
        this.modalWithCredit = false
      })
    })
  }

  matchSystemType(item: any) {

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
    }
    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {

      const itemMatch = resultMatch[0]

      const key = itemMatch.TYPEPROMPT.split(':')[2];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };

      this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {

        const resultString = JSON.stringify(resultSp);
        let prompt = {
          systemPrompt: `${itemMatch.SYSTEMPROMPT}`, // 
          userprompt: `${itemMatch.USERPROMPT} ${item.name} ${resultString}`, // 
        };

        this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
          const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID

          this.dataDrawingTempo.forEach(itemOrigin => {
            if (itemOrigin.id == item.id) {
              item.systemTypeID = systemTypeIDFromAI
            }
          })
        })
      })
    })
  }

  matchAllSystemType() {

    let contador = 0;

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
    }
    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {

      const itemMatch = resultMatch[0]

      const key = itemMatch.TYPEPROMPT.split(':')[2];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };


      this.dataDrawingTempo.forEach(itemEachAI => {

        this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {

          const resultString = JSON.stringify(resultSp);
          let prompt = {
            systemPrompt: `${itemMatch.SYSTEMPROMPT}`, // 
            userprompt: `${itemMatch.USERPROMPT} ${itemEachAI.name} ${resultString}`, // 
          };

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
            const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID

            this.dataDrawingTempo.forEach(itemOrigin => {
              if (itemOrigin.id == itemEachAI.id) {
                itemEachAI.systemTypeID = systemTypeIDFromAI
              }
            })
          })
        })
      })

    })


  }

  matchAllSystemTypeOrigin() {

    let contador = 0;

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
    }

    console.log('jfdbgkjdbfjgkbdkfbgjdbfk')
    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {

      const itemMatch = resultMatch[0]

      const key = itemMatch.TYPEPROMPT.split(':')[2];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };


      this.dataTest.forEach(itemEachAI => {

        this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {

          const resultString = JSON.stringify(resultSp);
          let prompt = {
            systemPrompt: `${itemMatch.SYSTEMPROMPT}`, // 
            userprompt: `${itemMatch.USERPROMPT} ${itemEachAI.name} ${resultString}`, // 
          };

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
            const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID

            // this.dataTest.forEach(itemOrigin => {
            //   if (itemOrigin.id == itemEachAI.id) {
            itemEachAI.systemTypeID = systemTypeIDFromAI
            //   }
            // })
          })
        })
      })

    })


  }



  matchSystemTypeOrigin(item: any) {
    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
    }

    console.log('nbnbnb')
    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {

      const itemMatch = resultMatch[0]

      const key = itemMatch.TYPEPROMPT.split(':')[2];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };

      this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {

        const resultString = JSON.stringify(resultSp);
        let prompt = {
          systemPrompt: `${itemMatch.SYSTEMPROMPT}`, // 
          userprompt: `${itemMatch.USERPROMPT} ${item.name} ${resultString}`, // 
        };

        this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
          const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID

          this.dataTest.forEach(itemOrigin => {
            if (itemOrigin.id == item.id) {
              item.systemTypeID = systemTypeIDFromAI
            }
          })
        })
      })
    })
  }

  dataDrawingTempo: any[] = [];


  // Logica de pago con credito
  modalWithCredit: boolean = false;
  currentBalance: number = 0;
  remainingBalance: number = 0;
  serviceCost: number = 50;

  titleCredit: string = "Processing Drawing with Cube AI";
  code: string = "";


  showNoCreditModal: boolean = false;

  showModalWithCredit(from) {
    this.MapInformationService.SaveInfoSites({
      method: "GetClientCubeShopCredit",
    }).subscribe(resp => {

      // Sin crédito ([{credit: null}], vacío, 0, etc.) → mostrar modal de "sin crédito" y salir.
      if (!resp || !resp[0] || !resp[0].credit) {
        this.showNoCreditModal = true;
        return;
      }

      this.MapInformationService.SaveInfoSites({
        // method: "GetClientCubeShopCredit", // Cambiar
        method: "Get_AcctPartsDetailByNumber", // Cambiar
        partnum: this.code
        // partnum: 111111
      }).subscribe(cost => {

        this.serviceCost = cost[0].STDCOST

        if (resp[0].credit) {
          this.currentBalance = resp[0].credit
          this.remainingBalance = this.currentBalance - this.serviceCost


          if (this.aiProcessingType == 'drawing') {
            this.textSaveAccount = "The drawing was processed in estimate " + this.estimatenamestr + " under project " + this.projectid
          } else if (this.aiProcessingType == 'sequence') {
            this.textSaveAccount = "The Sequence was processed in estimate " + this.estimatenamestr + " under project " + this.projectid
          } else if (this.aiProcessingType == 'scope') {
            this.textSaveAccount = "The Scope was processed in estimate " + this.estimatenamestr + " under project " + this.projectid
          }


          this.modalWithCredit = true




        }
      })


    })
  }
  showPaymentSuccess: boolean = false

  returnInfo(event: any) {

    if (!event.dontapplylogic) {
      if (this.aiProcessingType == 'drawing') {
        this.processPlaneWithAI()
      } else if (this.aiProcessingType == 'sequence') {
        this.modalWithCredit = false
        this.getDataSequenceOfOperation()
      } else if (this.aiProcessingType == 'scope') {
        this.modalWithCredit = false
        this.processDataScope()
      }
      if (event.showModalSuccess) {
        this.showPaymentSuccess = true
      }
    }






  }

  returnClosePopupPay(event: any) {
    // this.modalWithCredit = false
  }


  showCancelConfirmation: boolean = false

  ValidateClose() {
    if (this.dataDrawingTempo.length > 0) {
      this.showCancelConfirmation = true
    } else {
      this.closeAIPopup()
      this.areaSelectedNew = {
        areaID: 0,
        AreaName: ''
      }
      this.dataTemporal = undefined;
    }
  }


  confirmDataDrawing(action: number) {
    if (action == 1) {
      this.dataDrawingTempo.forEach(item => {
        this.dataTest.push(item)
      })
      this.closeAIPopup()
    } else if (action == 2) {
      this.dataDrawingTempo.forEach(item => {
        this.dataTest.push(item)
      })



      this.dataDrawingTempo = []
      this.uploadedPdfFile = null;
      this.uploadedPdfBase64 = null;
      this.uploadedWordFile = null;
      this.uploadedWordBase64 = null;
      this.wordDocumentFile = null;
      this.wordDocumentBase64 = null;
      this.isProcessing = false;
      this.aiSessionInfo.status = 'Ready';
      // New AI popup properties
      this.showAIPopup = false;
      this.aiPopupContent = '';
      // this.aiProcessingType = '';
      this.isAIButtonEnabled = false;
      this.dataWordDocumentBase64 = {
        fileName: '',
        fileSize: 0,
        fileType: '',
        base64Length: 0,
        base64: '',
      }
    }
  }

  imgSystemSelected: string = '';
  dataSystemInfo: any = {};
  usedTimes: number = 0;

  showSuggestedSystem(item: any) {
    this.suggestedSystemTargetArray = 'dataTest';

    this.MapInformationService.SaveInfoSites({ method: "GetMostUsedSystemBySystemType", systemtypeid: item.systemTypeID }).subscribe(respSystem => {


      if (respSystem.length > 0) {
        this.MapInformationService.SaveInfoSites({ method: "GetEstimateAreaSystemInfoCE", systemid: respSystem[0].systemid }).subscribe(respSystemInfo => {

          // obtener el numero de veces que se ha usado el sistema
          this.usedTimes = respSystem[0].cnt;

          // obtener informacion del sistema

          this.dataSystemInfo = respSystemInfo[0];

          this.MapInformationService.SaveInfoSites({ method: "Get_SystemImagePath", systemid: respSystem[0].systemid }).subscribe(respPath => { //
            this.MapInformationService.GetDocument(respPath[0].ImagePath).subscribe(result => {
              if (result.filestring && result.filestring !== 'Not_Image') {
                // Detectar el tipo de imagen basándose en los primeros caracteres del base64
                let imageType = 'jpeg'; // Por defecto
                const base64Start = result.filestring.substring(0, 5).toUpperCase();

                if (base64Start === 'IVBOR') {
                  imageType = 'png';
                } else if (base64Start === '/9J/4') {
                  imageType = 'jpeg';
                }

                // Agregar el prefijo data:image si no lo tiene
                if (!result.filestring.startsWith('data:image')) {
                  this.imgSystemSelected = `data:image/${imageType};base64,${result.filestring}`;
                } else {
                  this.imgSystemSelected = result.filestring;
                }
              } else {
                this.imgSystemSelected = 'Not_Image';
              }
              this.suggestedSystemData = item;
              this.showSuggestedSystemPopup = true;
            })
          })
        })
      } else {
        this.toast.warning('No suggested system found for the selected system type');
      }
    })
  }

  onImportSuggestedSystem() {
    // Cerrar el popup de sistema sugerido
    this.showSuggestedSystemPopup = false;

    const targetList =
      this.suggestedSystemTargetArray === 'updateModal'
        ? this.dataSystemsToShowAndUpdate
        : this.dataTest;

    // Lógica original: actualizar el registro seleccionado
    targetList.forEach(item => {
      if (item.id == this.suggestedSystemData.id) {
        item.sytemOrigin = this.dataSystemInfo.ID;
      }
    });

    // Después de actualizar, mostrar modal para seleccionar otros registros
    // Obtener el systemTypeID del sistema seleccionado
    const selectedSystemTypeID = this.suggestedSystemData.systemTypeID || this.dataSystemInfo.systemTypeID;

    if (selectedSystemTypeID) {
      // Filtrar por systemTypeID (excluyendo el que ya se actualizó)
      this.filteredSystemsForSelection = targetList.filter(item =>
        item.systemTypeID === selectedSystemTypeID && item.id !== this.suggestedSystemData.id
      );

      console.log("this.filteredSystemsForSelection", this.filteredSystemsForSelection)

      if (this.filteredSystemsForSelection.length > 0) {
        // Inicializar vacío ya que el registro seleccionado ya se actualizó
        this.selectedSystemsForChange = [];

        // Mostrar popup de selección
        this.showSelectSystemsPopup = true;
      }
    }
  }

  confirmSystemSelection() {
    const targetList =
      this.suggestedSystemTargetArray === 'updateModal'
        ? this.dataSystemsToShowAndUpdate
        : this.dataTest;

    // Aplicar el cambio a los sistemas adicionales seleccionados
    targetList.forEach(item => {
      if (this.selectedSystemsForChange.includes(item.id)) {
        item.sytemOrigin = this.dataSystemInfo.ID;
      }
    });

    this.showSelectSystemsPopup = false;
    this.selectedSystemsForChange = [];
    this.filteredSystemsForSelection = [];
  }

  cancelSystemSelection() {
    // Solo cerrar el modal, el registro original ya se actualizó
    this.showSelectSystemsPopup = false;
    this.selectedSystemsForChange = [];
    this.filteredSystemsForSelection = [];
  }

  // Diagram functions
  initDiagramNew() {
    // Inicializar el diagrama con el template JSON
    if (this.diagramNew && this.diagramNew.instance) {
      console.log("initDiagramNew")
      console.log("this.templateJSONNew", this.templateJSONNew)
      const obj = JSON.stringify(this.templateJSONNew);
      this.diagramNew.instance.import(obj);

      // Desactivar la cuadrícula y el ajuste a la cuadrícula
      this.diagramNew.instance.option('showGrid', false);
      this.diagramNew.instance.option('snapToGrid', false);

      // Configurar para que los shapes bloqueados no se puedan editar ni borrar
      this.diagramNew.instance.option('editing', {
        allowChangeConnection: false,
        allowChangeConnectorPoints: false,
        allowChangeConnectorText: false,
        allowChangeShapeText: (e) => {
          // Permitir editar texto solo si el shape no está bloqueado
          return !e.item.locked;
        },
        allowDeleteShape: (e) => {
          // No permitir borrar shapes bloqueados
          return !e.item.locked;
        },
        allowResizeShape: (e) => {
          // No permitir redimensionar shapes bloqueados
          return !e.item.locked;
        },
        allowMoveShape: (e) => {
          // No permitir mover shapes bloqueados
          return !e.item.locked;
        },
        onInserting: (e) => {
        }
      });

      // Configurar zoom y autoZoomMode para centrar el contenido
      this.zoomDiagramNew = 0.75;
      setTimeout(() => {
        this.zoomDiagramNew = 0.70;
        if (this.diagramNew) {
          this.diagramNew.autoZoomMode = "fitContent";
          setTimeout(() => {
            if (this.diagramNew) {
              this.diagramNew.autoZoomMode = "disabled";
            }
          }, 1000);
        }
      }, 500);
    }
  }


  importDiagramPreservingView(diagramJson: string) {
    if (!this.diagramNew || !this.diagramNew.instance) {
      console.error('Diagrama no inicializado');
      return;
    }

    // Capturar el zoom y la posición actual antes del import
    const currentZoom = this.diagramNew.instance.option('zoomLevel') || this.zoomDiagramNew;

    // Obtener la posición del scroll del contenedor del diagrama
    const diagramElement = document.getElementById('diagramNew');
    let scrollLeft = 0;
    let scrollTop = 0;

    if (diagramElement) {
      // Buscar el contenedor con scroll dentro del diagrama
      const scrollContainer = diagramElement.querySelector('.dx-diagram-content') ||
        diagramElement.querySelector('.dx-scrollable-container') ||
        diagramElement;
      scrollLeft = scrollContainer.scrollLeft || 0;
      scrollTop = scrollContainer.scrollTop || 0;
    }

    // Importar el diagrama
    this.diagramNew.instance.import(diagramJson);

    // Restaurar el zoom y la posición después del import
    setTimeout(() => {
      if (this.diagramNew && this.diagramNew.instance) {
        this.diagramNew.instance.option('zoomLevel', currentZoom);
        this.zoomDiagramNew = currentZoom;

        // Restaurar la posición del scroll
        if (diagramElement) {
          const scrollContainer = diagramElement.querySelector('.dx-diagram-content') ||
            diagramElement.querySelector('.dx-scrollable-container') ||
            diagramElement;
          if (scrollContainer) {
            scrollContainer.scrollLeft = scrollLeft;
            scrollContainer.scrollTop = scrollTop;
          }
        }
      }
    }, 100);
  }

  importDiagramPreservingViewOnAdd(diagramJson: string, savedZoom?: number | null, savedScrollLeft?: number, savedScrollTop?: number) {
    if (!this.diagramNew || !this.diagramNew.instance) {
      console.error('Diagrama no inicializado');
      return;
    }

    // Usar los valores guardados si se proporcionaron, sino intentar capturarlos
    let currentZoom: number | null = savedZoom !== undefined ? savedZoom : null;
    let scrollLeft = savedScrollLeft !== undefined ? savedScrollLeft : 0;
    let scrollTop = savedScrollTop !== undefined ? savedScrollTop : 0;

    // Si no se proporcionaron valores guardados, intentar capturarlos
    if (currentZoom === null) {
      try {
        const zoomFromOption = this.diagramNew.instance.option('zoomLevel');
        const zoomFromVariable = this.zoomDiagramNew;

        if (typeof zoomFromOption === 'number' && !isNaN(zoomFromOption) && isFinite(zoomFromOption) && zoomFromOption > 0) {
          currentZoom = zoomFromOption;
        } else if (typeof zoomFromVariable === 'number' && !isNaN(zoomFromVariable) && isFinite(zoomFromVariable) && zoomFromVariable > 0) {
          currentZoom = zoomFromVariable;
        }
      } catch (error) {
        console.warn('Error al obtener el zoom:', error);
      }
    }

    // Si no se proporcionaron valores de scroll, intentar capturarlos
    if (savedScrollLeft === undefined || savedScrollTop === undefined) {
      const diagramElement = document.getElementById('diagramNew');
      if (diagramElement) {
        const scrollContainer = diagramElement.querySelector('.dx-diagram-content') ||
          diagramElement.querySelector('.dx-scrollable-container') ||
          diagramElement;
        if (scrollContainer) {
          scrollLeft = scrollContainer.scrollLeft || 0;
          scrollTop = scrollContainer.scrollTop || 0;
        }
      }
    }

    // Importar el diagrama
    this.diagramNew.instance.import(diagramJson);

    // Restaurar el zoom y la posición después del import con timeout más largo
    // para permitir que el nuevo elemento se renderice completamente
    setTimeout(() => {
      if (this.diagramNew && this.diagramNew.instance) {
        // Aplicar el zoom solo si es válido
        if (currentZoom !== null && typeof currentZoom === 'number' && !isNaN(currentZoom) && isFinite(currentZoom) && currentZoom > 0) {
          try {
            this.diagramNew.instance.option('zoomLevel', currentZoom);
            this.zoomDiagramNew = currentZoom;
          } catch (error) {
            console.warn('Error al establecer el zoom:', error);
          }
        }

        // Esperar un poco más antes de restaurar la posición del scroll
        setTimeout(() => {
          if (this.diagramNew && this.diagramNew.instance) {
            const diagramElement = document.getElementById('diagramNew');
            if (diagramElement) {
              const scrollContainer = diagramElement.querySelector('.dx-diagram-content') ||
                diagramElement.querySelector('.dx-scrollable-container') ||
                diagramElement;
              if (scrollContainer) {
                scrollContainer.scrollLeft = scrollLeft;
                scrollContainer.scrollTop = scrollTop;
              }
            }
          }
        }, 150);
      }
    }, 200);
  }




  onContentReady(event: any) {
    // Inicializar el diagrama con el template JSON
    this.zoomDiagramNew = 0.75
    setTimeout(() => {
      this.zoomDiagramNew = 0.70
      this.diagramNew.autoZoomMode = "fitContent"
    }, 500);
  }

  exportChange(event: any) {
    // To be implemented
  }




  diagramOldVersion: any


  validateSystems() {

    let json = this.diagramNew.instance.export();
    let diagram = JSON.parse(json);

    this.diagramOldVersion.shapes.forEach(element => {
      let contador = 0;
      diagram.shapes.forEach(x => {
        if (x.key == element.key) {
          contador++;
        }
      })
      if (contador == 0) {
        // Eliminar el elemento de groupItemsDiagram usando su key como id
        // const removed = this.removeItem(this.groupItemsDiagram, element.key);
        this.diagramTreeView.instance.unselectItem(element.key);
        // if (removed) {
        //   if (this.diagramTreeView && this.diagramTreeView.instance) {
        //     this.diagramTreeView.instance.option('items', [...this.groupItemsDiagram]);
        //   }
        // }
      }
    })



  }






  onSelectionChanged(e: any) {
    // Se dispara cuando un item cambia, incluyendo cuando se edita el texto
    if (e.items.length > 0) {

      let json = this.diagramNew.instance.export();

      let diagram = JSON.parse(json);


      // if (e.items[0].type == "text") {
      // } else {
      // }
    }
  }

  AsignarImage(event: any) {
    // To be implemented
  }




  assingParent(event: any) {
  }

  onItemInserted(event: any) {
    // Este evento se dispara cuando se inserta un item en el diagrama desde el toolbox
    if (event.item && event.item.category) {
      // Buscar el grupo correspondiente usando la categoría (que es el item.id)
      const groupId = event.item.category;
      const group = this.groupItemsDiagram.find(item => item.id == groupId);

      if (group) {
        // Aquí puedes hacer lo que necesites con el nombre del grupo
        // Por ejemplo, asignarlo al item insertado
        if (event.item) {
          // Opcional: puedes asignar el nombre del grupo como una propiedad del item
          // event.item.groupName = group.text;
        }
      }
    }
  }


  saveDataDiagram() {
    // Abrir modal para preguntar el tipo de importación
    this.showImportTypeModal = true;
  }

  confirmImportGrouped() {
    this.dataDrawingTempo = [];
    const sortCounter = { value: 0 };

    // Agrupar children por systemOrigin (los children están dentro de items)
    const groupedBySystemOrigin: { [key: string]: any[] } = {};
    const childrenWithoutSystemOrigin: any[] = [];

    console.log("this.groupItemsDiagram", this.groupItemsDiagram)

    // Iterar sobre cada parent y agrupar sus children por systemOrigin
    this.groupItemsDiagram.forEach(parent => {
      if (parent.items && Array.isArray(parent.items)) {
        parent.items.forEach(child => {
          if (child.systemOrigin) {
            const systemOriginKey = String(child.systemOrigin);
            if (!groupedBySystemOrigin[systemOriginKey]) {
              groupedBySystemOrigin[systemOriginKey] = [];
            }
            groupedBySystemOrigin[systemOriginKey].push(child);
          } else {
            childrenWithoutSystemOrigin.push(child);
          }
        });
      }
    });

    console.log("groupedBySystemOrigin", groupedBySystemOrigin)
    console.log("childrenWithoutSystemOrigin", childrenWithoutSystemOrigin)

    // Agregar grupos por systemOrigin
    Object.keys(groupedBySystemOrigin).forEach(systemOrigin => {
      const childrenInGroup = groupedBySystemOrigin[systemOrigin];

      // Buscar el parent del primer child para obtener su nombre
      let parentName = '';
      if (childrenInGroup.length > 0) {
        const firstChild = childrenInGroup[0];
        if (firstChild.parentId) {
          const parent = this.groupItemsDiagram.find(p => p.id === firstChild.parentId);
          if (parent && parent.text) {
            parentName = parent.text.replace(/\s*\(\s*qty:\s*\d+\s*\)/gi, '').trim();
          }
        }
      }

      // Si no se encontró el parent, usar un nombre por defecto
      if (!parentName) {
        if (childrenInGroup.length === 1) {
          const text = childrenInGroup[0].text || '';
          parentName = text.replace(/\s*\(\s*qty:\s*\d+\s*\)/gi, '').trim();
        } else {
          parentName = `Group (${childrenInGroup.length} items)`;
        }
      }

      this.dataTest.push({
        id: childrenInGroup[0].id,
        areaID: this.areaSelectedNew.areaID,
        areaname: this.areaSelectedNew.AreaName,
        systemTypeID: childrenInGroup[0].systemtypeid || '',
        systemTypeName: '',
        name: parentName,
        sort: ++sortCounter.value,
        qty: childrenInGroup.length,
        sytemOrigin: systemOrigin,
        description: '',
        matched: true,
        matchedArea: true
      });
    });

    // Agrupar children sin systemOrigin por parentId
    const groupedByParentId: { [key: string]: any[] } = {};

    childrenWithoutSystemOrigin.forEach(child => {
      if (child.parentId) {
        const parentIdKey = String(child.parentId);
        if (!groupedByParentId[parentIdKey]) {
          groupedByParentId[parentIdKey] = [];
        }
        groupedByParentId[parentIdKey].push(child);
      } else {
        // Si no tiene parentId, agregarlo a un grupo especial
        if (!groupedByParentId['noParent']) {
          groupedByParentId['noParent'] = [];
        }
        groupedByParentId['noParent'].push(child);
      }
    });

    // Agregar grupos por parentId para children sin systemOrigin
    Object.keys(groupedByParentId).forEach(parentId => {
      const childrenInGroup = groupedByParentId[parentId];

      // Buscar el parent por su id
      let parentName = '';
      if (parentId !== 'noParent' && childrenInGroup.length > 0) {
        const firstChild = childrenInGroup[0];
        const parent = this.groupItemsDiagram.find(p => p.id === firstChild.parentId);
        if (parent && parent.text) {
          parentName = parent.text.replace(/\s*\(\s*qty:\s*\d+\s*\)/gi, '').trim();
        }
      }

      // Si no se encontró el parent o no tiene nombre, usar un nombre por defecto
      if (!parentName) {
        if (childrenInGroup.length === 1) {
          const text = childrenInGroup[0].text || '';
          parentName = text.replace(/\s*\(\s*qty:\s*\d+\s*\)/gi, '').trim();
        } else {
          parentName = `Unassigned Group (${childrenInGroup.length} items)`;
        }
      }

      this.dataTest.push({
        id: childrenInGroup[0].id,
        areaID: this.areaSelectedNew.areaID,
        areaname: this.areaSelectedNew.AreaName,
        systemTypeID: '',
        systemTypeName: '',
        name: parentName,
        sort: ++sortCounter.value,
        qty: childrenInGroup.length,
        sytemOrigin: null,
        description: '',
        matched: true,
        matchedArea: true
      });
    });

    this.SaveAndStay()

    setTimeout(() => {
      this.popupAIProcessing = false;

      setTimeout(() => {
        this.getSystemTypeMultiple();
        this.getEstimateAreaFromTreeview(this.estimateid);
        this.popupNewSystem = true;
      }, 200);

      this.finishImport();
    }, 1000);
  }

  getEstimateAreaFromTreeview(id, reload = false) {
    this.deltaService.GetEstimateAreaList(id).subscribe((result) => {
      this.areaSelect = result;
    });
  }

  confirmImportIndividual() {
    this.dataDrawingTempo = [];
    const sortCounter = { value: 0 };

    // Solo tomar los children (items dentro de items)
    this.groupItemsDiagram.forEach(parent => {
      if (parent.items && Array.isArray(parent.items) && parent.items.length > 0) {
        console.log("parent", parent)
        this.mapItemsToDataDrawing(parent.items, sortCounter);
      }
    });

    this.SaveAndStay()
    // setTimeout(() => {
    //   this.popupAIProcessing = false;
    //   this.finishImport();
    // }, 1000);

    setTimeout(() => {
      this.popupAIProcessing = false;

      setTimeout(() => {
        this.getSystemTypeMultiple();
        this.getEstimateAreaFromTreeview(this.estimateid);
        this.popupNewSystem = true;
      }, 200);

      this.finishImport();
    }, 1000);
  }

  finishImport() {
    // Reiniciar el diagrama importando un diagrama vacío
    if (this.diagramNew && this.diagramNew.instance) {
      const emptyDiagram = {
        "pageWidth": 15817,
        "pageHeight": 24491,
        "pageLandscape": true,
        "viewUnits": "in",
        "units": "in",
        "connectors": [],
        "shapes": []
      };
      this.diagramNew.instance.import(JSON.stringify(emptyDiagram));

      this.zoomDiagramNew = 0.75;
      setTimeout(() => {
        this.zoomDiagramNew = 0.70;
        if (this.diagramNew) {
          this.diagramNew.autoZoomMode = "fitContent";
          setTimeout(() => {
            if (this.diagramNew) {
              this.diagramNew.autoZoomMode = "disabled";
            }
          }, 1000);
        }
        this.dataDrawingTempo.sort((a, b) => a.sort - b.sort);
        this.showImportTypeModal = false;
        this.openModalDiagramNew = false;
        this.diagramOldVersion = undefined;
        this.componentsNew = [];
        this.groupItemsDiagram = [];
        this.showExistingWorkPopup = false;
        this.existingWorkData = null;
        this.showCloseDiagramConfirmation = false;
        this.fromTreeview = false;
        this.diagramTreeView.instance.option('items', []);
        this.diagramNew.instance.option('items', []);
        this.diagramNew.instance.option('items', []);
        this.dataTempoPrevConfiguration = [];
        this.useStoredConfiguration = false;

      }, 500);
    }

    this.enableAutoSave = false;
    clearInterval(this.autosaveInterval);



  }

  cancelImportType() {
    this.showImportTypeModal = false;
  }

  // Función auxiliar para ordenar alfabéticamente y numéricamente los items y sus hijos
  sortItemsAlphabetically(items: any[]): any[] {
    return items
      .map(item => {
        // Ordenar recursivamente los hijos si existen
        const sortedItem = { ...item };
        if (sortedItem.items && Array.isArray(sortedItem.items) && sortedItem.items.length > 0) {
          sortedItem.items = this.sortItemsAlphabetically(sortedItem.items);
        }
        return sortedItem;
      })
      .sort((a, b) => {
        // Ordenar por el campo 'text' alfabéticamente y numéricamente
        const textA = (a.text || '').toLowerCase();
        const textB = (b.text || '').toLowerCase();
        // Usar localeCompare con opciones numéricas para ordenar correctamente números
        return textA.localeCompare(textB, undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      });
  }

  // Función auxiliar para buscar y agregar un item a su padre en el array
  findAndAddItemToParent(items: any[], itemToAdd: any, parentId: any): boolean {
    for (const item of items) {
      if (item.id === parentId) {
        item.items.push(itemToAdd);
        return true;
      }
      if (item.items && item.items.length > 0) {
        if (this.findAndAddItemToParent(item.items, itemToAdd, parentId)) {
          return true;
        }
      }
    }
    return false;
  }

  // Función auxiliar para ordenar alfabéticamente y por número
  sortItemsAlphabeticallyAndNumeric(items: any[]): any[] {
    return items
      .map(item => {
        // Crear una copia del item y ordenar recursivamente los hijos
        const sortedItem = { ...item };
        if (sortedItem.items && Array.isArray(sortedItem.items) && sortedItem.items.length > 0) {
          sortedItem.items = this.sortItemsAlphabeticallyAndNumeric(sortedItem.items);
        }
        return sortedItem;
      })
      .sort((a, b) => {
        // Ordenar por el campo 'text' considerando texto y números
        const textA = (a.text || '').toLowerCase();
        const textB = (b.text || '').toLowerCase();

        // Usar localeCompare con opciones numéricas para ordenar correctamente números
        return textA.localeCompare(textB, undefined, {
          numeric: true,
          sensitivity: 'base'
        });
      });
  }

  // Función auxiliar para procesar y agregar items al groupItemsDiagram
  processAndAddItemsToDiagram(itemsToAdd: any[]) {
    itemsToAdd.forEach((item: any) => {
      if (item.parentId) {
        // Si tiene parentId, buscar el padre y agregarlo como hijo
        if (!this.findAndAddItemToParent(this.groupItemsDiagram, item, item.parentId)) {
          // Si no se encuentra el padre, agregar como grupo raíz
          this.groupItemsDiagram.push(item);
        }
      } else {
        // Si no tiene parentId, agregar como grupo raíz
        this.groupItemsDiagram.push(item);
      }
    });

    // Ordenar alfabéticamente y por número después de agregar todos los items
    this.groupItemsDiagram = this.sortItemsAlphabeticallyAndNumeric(this.groupItemsDiagram);
    console.log('groupItemsDiagram', this.groupItemsDiagram)
  }








  loadNewPlane() {
    // Cerrar el popup
    this.showExistingWorkPopup = false;

    // Limpiar los datos existentes
    this.existingWorkData = null;

    // Continuar con el flujo normal de cargar un nuevo plano
    // El usuario puede proceder normalmente
  }

  // Función recursiva para mapear items del treeview a dataDrawingTempo
  mapItemsToDataDrawing = (items: any[], sortCounter: { value: number } = { value: 0 }) => {
    items.forEach(item => {
      // Limpiar el texto removiendo el patrón "( qty: X)" donde X puede ser cualquier número
      const cleanText = (item.text || '').replace(/\s*\(\s*qty:\s*\d+\s*\)/gi, '').trim();

      // Agregar el item actual
      this.dataTest.push({
        id: item.id,
        areaID: this.areaSelectedNew.areaID,
        areaname: this.areaSelectedNew.AreaName,
        systemTypeID: item.systemtypeid,
        systemTypeName: '',
        name: cleanText,
        sort: ++sortCounter.value,
        qty: 1,
        sytemOrigin: item.systemOrigin,
        description: '',
        matched: true,
        matchedArea: true
      });

      // Si tiene hijos, procesarlos recursivamente
      if (item.items && Array.isArray(item.items) && item.items.length > 0) {
        this.mapItemsToDataDrawing(item.items, sortCounter);
      }
    });
  };

  onItemSelectedTreeView(event: any) {

    if (event.event != undefined) {

      console.log("event", event)

      const dataSelected = this.diagramTreeView.instance.getSelectedNodes().filter(x => x.parent != undefined)
        .map(x => x.itemData)


      if (event.itemData.parentId != undefined) {


        let json = this.diagramNew.instance.export();
        let diagram = JSON.parse(json);

        console.log('diagram.shapes', diagram.shapes)

        console.log('this.diagragramOldVersion', this.diagramOldVersion)


        if (!diagram.shapes) {
          diagram.shapes = [];
        }

        const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === event.itemData.id);

        // Si el itemData.selected es false, debe eliminarse del diagrama
        if (event.itemData.selected === false) {
          if (shapeIndex !== -1) {
            diagram.shapes.splice(shapeIndex, 1);

            diagram.shapes.forEach((item: any) => {
              if (item.type !== undefined) {
                item.type = `${item.type}`;
              }
            });

            this.diagramNew.instance.import(JSON.stringify(diagram));
          }
        }
        // Si el itemData.selected es true, debe colocarse en el diagrama
        else if (event.itemData.selected === true) {
          // Solo agregar si no existe ya en el diagrama
          if (shapeIndex === -1) {
            let bboxArray = event.itemData.bbox;
            if (typeof event.itemData.bbox === 'string') {
              try {
                bboxArray = JSON.parse(event.itemData.bbox);
              } catch (e) {
                bboxArray = [0, 0, 0, 0];
              }
            }

            let centerX = 0;
            let centerY = 0;
            if (bboxArray && Array.isArray(bboxArray) && bboxArray.length >= 4) {
              centerX = bboxArray[0]
              centerY = bboxArray[1]
            }

            const x0 = bboxArray[0];
            const y0 = bboxArray[1];
            const x1 = bboxArray[2];
            const y1 = bboxArray[3];

            const scale_x = this.pageWidth / this.dimensionsImage.width;
            const scale_y = this.pageHeight / this.dimensionsImage.height;

            let canvas_x0 = x0 * scale_x
            let canvas_y0 = y0 * scale_y
            const canvas_width = (x1 - x0) * scale_x
            const canvas_height = (y1 - y0) * scale_y


            console.log('this.dataTemporal', this.dataTemporal)

            if (this.dataTemporal != undefined) {
              if (this.dataTemporal.shapes.length > 0) {
                this.dataTemporal.shapes.forEach((item: any) => {
                  if (item.key == event.itemData.id) {
                    canvas_x0 = item.x
                    canvas_y0 = item.y
                  }
                });
              }
            }

            console.log("event.itemData.color", event.itemData)
            console.log("this.groupItemsDiagram", this.groupItemsDiagram)

            let colorParent;
            this.groupItemsDiagram.forEach(y => {
              if (y.id == event.itemData.parentId) {
                colorParent = y.color;
              }
            });


            let newShape

            // if (this.useStoredConfiguration) {

            this.groupItemsDiagram.forEach(x => {
              if (x.id == event.itemData.parentId) {
                newShape = {
                  "key": event.itemData.id,
                  "locked": false,
                  "zIndex": 0,
                  "type": 'rectangle',
                  "text": event.itemData.text || '',
                  "x": canvas_x0,
                  "y": canvas_y0,
                  "width": x.width != undefined ? x.width : 800,
                  "height": x.height != undefined ? x.height : 300,
                  "styleText": x.styleText != undefined ? x.styleText : {
                    "font-size": "8pt",
                  },
                  style: x.style != undefined ? x.style : {
                    fill: x.color != undefined ? x.color : 'white',
                    stroke: '#000000',
                  },
                  color: x.color != undefined ? x.color : 'white',
                };
              }
            });








            diagram.shapes.push(newShape);

            diagram.shapes.forEach((item: any) => {
              if (item.type !== undefined) {
                item.type = `${item.type}`;
              }
            });


            // Importar el diagrama
            this.diagramNew.instance.import(JSON.stringify(diagram));
          }
        }



        // Capturar el zoom y scroll actuales antes del import
        const viewData = this.getCurrentDiagramView();

        //  1 Restaurar el zoom y scroll después del import
        if (viewData) {
          setTimeout(() => {
            if (this.diagramNew && this.diagramNew.instance) {
              // Restaurar zoom
              if (viewData.zoom > 0) {
                try {
                  this.diagramNew.instance.option('zoomLevel', viewData.zoom);
                  this.zoomDiagramNew = viewData.zoom;
                } catch (e) {
                  console.warn('Error al restaurar zoom:', e);
                }
              }

              // Restaurar scroll
              const diagramElement = document.getElementById('diagramNew');
              if (diagramElement && (viewData.scrollLeft > 0 || viewData.scrollTop > 0)) {
                try {
                  const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
                  if (scrollableContainer) {
                    scrollableContainer.scrollLeft = viewData.scrollLeft;
                    scrollableContainer.scrollTop = viewData.scrollTop;
                    // scrollableContainer.scrollLeft = newShape.x;
                    // scrollableContainer.scrollTop = newShape.y;
                  } else {
                    const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
                    if (scrollableWrapper) {
                      scrollableWrapper.scrollLeft = viewData.scrollLeft;
                      scrollableWrapper.scrollTop = viewData.scrollTop;
                      // scrollableWrapper.scrollLeft = newShape.x;
                      // scrollableWrapper.scrollTop = newShape.y;
                    }
                  }
                } catch (e) {
                  console.warn('Error al restaurar scroll:', e);
                }
              }
            }
          }, 100);
        }




      } else {
        // Si es un item padre, procesar todos sus hijos
        if (event.itemData.items && Array.isArray(event.itemData.items)) {
          event.itemData.items.forEach((childItem: any) => {
            let json = this.diagramNew.instance.export();
            let diagram = JSON.parse(json);

            if (!diagram.shapes) {
              diagram.shapes = [];
            }

            const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === childItem.id);

            // Si el childItem.selected es false, debe eliminarse del diagrama
            if (childItem.selected === false) {
              if (shapeIndex !== -1) {
                diagram.shapes.splice(shapeIndex, 1);

                diagram.shapes.forEach((item: any) => {
                  if (item.type !== undefined) {
                    item.type = `${item.type}`;
                  }
                });

                this.diagramNew.instance.import(JSON.stringify(diagram));
              }
            }
            // Si el childItem.selected es true, debe colocarse en el diagrama
            else if (childItem.selected === true) {
              // Solo agregar si no existe ya en el diagrama
              if (shapeIndex === -1) {
                let bboxArray = childItem.bbox;
                if (typeof childItem.bbox === 'string') {
                  try {
                    bboxArray = JSON.parse(childItem.bbox);
                  } catch (e) {
                    bboxArray = [0, 0, 0, 0];
                  }
                }

                let centerX = 0;
                let centerY = 0;
                if (bboxArray && Array.isArray(bboxArray) && bboxArray.length >= 4) {
                  centerX = bboxArray[0]
                  centerY = bboxArray[1]
                }

                // Calcular escalado basado en las dimensiones de la imagen
                const x0 = bboxArray[0];
                const y0 = bboxArray[1];
                const x1 = bboxArray[2];
                const y1 = bboxArray[3];

                const scale_x = this.pageWidth / this.dimensionsImage.width;
                const scale_y = this.pageHeight / this.dimensionsImage.height;

                let canvas_x0 = x0 * scale_x
                let canvas_y0 = y0 * scale_y
                const canvas_width = (x1 - x0) * scale_x
                const canvas_height = (y1 - y0) * scale_y

                if (this.dataTemporal != undefined) {
                  if (this.dataTemporal.shapes.length > 0) {
                    this.dataTemporal.shapes.forEach((item: any) => {
                      if (item.key == childItem.id) {
                        canvas_x0 = item.x
                        canvas_y0 = item.y
                      }
                    });
                  }
                }

                let newShape

                // if (this.useStoredConfiguration) {

                console.log("childItem", childItem)


                this.groupItemsDiagram.forEach(x => {
                  if (x.id == childItem.parentId) {
                    newShape = {
                      "key": childItem.id,
                      "locked": false,
                      "zIndex": 0,
                      "type": 'rectangle',
                      "text": childItem.text || '',
                      "x": canvas_x0,
                      "y": canvas_y0,
                      "width": x.width != undefined ? x.width : 800,
                      "height": x.height != undefined ? x.height : 300,
                      "styleText": x.styleText != undefined ? x.styleText : {
                        "font-size": "8pt",
                      },
                      style: x.style != undefined ? x.style : {
                        fill: x.color != undefined ? x.color : 'white',
                        stroke: '#000000',
                      },
                      color: x.color != undefined ? x.color : 'white',
                    };
                  }
                });



                diagram.shapes.push(newShape);


                diagram.shapes.forEach((item: any) => {
                  if (item.type !== undefined) {
                    item.type = `${item.type}`;
                  }
                });

                console.log('diagram', diagram)

                this.diagramNew.instance.import(JSON.stringify(diagram));
              }
            }
          });
        }
      }


    }
  }

  getCurrentDiagramView() {
    if (!this.diagramNew || !this.diagramNew.instance) {
      return null;
    }

    // Obtener zoom - intentar múltiples métodos

    let zoom = this.zoomDiagramNew;

    try {
      // Método 1: Intentar obtener el zoom desde la opción del diagrama
      const zoomOption = this.diagramNew.instance.option('zoomLevel');
      if (zoomOption !== null && zoomOption !== undefined && typeof zoomOption === 'number' && zoomOption > 0) {
        zoom = zoomOption;
      }
    } catch (e) {
      // Continuar con otros métodos
    }

    // Método 2: Intentar obtener desde el widget de zoom level directamente
    if (zoom === this.zoomDiagramNew || zoom <= 0) {
      try {
        const diagramElement = document.getElementById('diagramNew');
        if (diagramElement) {
          // Buscar el widget de zoom (puede ser un SelectBox o NumberBox)
          const zoomWidgets = diagramElement.querySelectorAll('.dx-selectbox, .dx-numberbox, .dx-dropdownbox');

          for (let i = 0; i < zoomWidgets.length; i++) {
            const widget = zoomWidgets[i] as any;

            // Intentar obtener el valor desde el widget de DevExtreme
            if (widget.dxInstance) {
              const widgetValue = widget.dxInstance.option('value');
              if (widgetValue !== null && widgetValue !== undefined && typeof widgetValue === 'number' && widgetValue > 0) {
                zoom = widgetValue;
                break;
              }
            }

            // Intentar obtener desde el input interno
            const input = widget.querySelector('input');
            if (input && input.value) {
              const parsedValue = parseFloat(input.value);
              if (!isNaN(parsedValue) && parsedValue > 0) {
                // Si el valor es mayor a 1, puede ser porcentaje, convertir a decimal
                if (parsedValue > 1 && parsedValue <= 200) {
                  zoom = parsedValue / 100;
                } else if (parsedValue > 0 && parsedValue <= 2) {
                  zoom = parsedValue;
                }
                if (zoom > 0 && zoom !== this.zoomDiagramNew) break;
              }
            }
          }

          // Método 3: Buscar el texto visible del zoom en el toolbar
          if (zoom === this.zoomDiagramNew || zoom <= 0) {
            const zoomTextElements = diagramElement.querySelectorAll('.dx-selectbox-text, .dx-numberbox-text, .dx-toolbar-item-text');
            for (let i = 0; i < zoomTextElements.length; i++) {
              const text = (zoomTextElements[i].textContent || '').trim();
              // Buscar patrones como "75%", "0.75", "75"
              const match = text.match(/(\d+\.?\d*)\s*%?/);
              if (match) {
                const parsedValue = parseFloat(match[1]);
                if (parsedValue > 1 && parsedValue <= 200) {
                  // Es porcentaje, convertir a decimal
                  zoom = parsedValue / 100;
                } else if (parsedValue > 0 && parsedValue <= 2) {
                  // Ya es decimal
                  zoom = parsedValue;
                }
                if (zoom > 0 && zoom !== this.zoomDiagramNew) break;
              }
            }
          }
        }
      } catch (e) {
        console.warn('Error al obtener zoom desde DOM:', e);
      }
    }

    // Obtener posición del viewport del diagrama
    // DevExtreme Diagram puede usar scroll o transform para el viewport
    const diagramElement = document.getElementById('diagramNew');
    let scrollLeft = 0;
    let scrollTop = 0;

    if (diagramElement) {
      try {
        // Método 1: Buscar el contenedor scrollable principal de DevExtreme
        const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
        if (scrollableContainer) {
          scrollLeft = scrollableContainer.scrollLeft || 0;
          scrollTop = scrollableContainer.scrollTop || 0;
        }

        // Método 2: Si no encontramos, buscar el wrapper
        if (scrollLeft === 0 && scrollTop === 0) {
          const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
          if (scrollableWrapper) {
            scrollLeft = scrollableWrapper.scrollLeft || 0;
            scrollTop = scrollableWrapper.scrollTop || 0;
          }
        }

        // Método 3: Buscar el canvas o SVG y su contenedor padre
        if (scrollLeft === 0 && scrollTop === 0) {
          const canvas = diagramElement.querySelector('canvas') || diagramElement.querySelector('svg');
          if (canvas && canvas.parentElement) {
            let parent: HTMLElement | null = canvas.parentElement;
            // Buscar hacia arriba hasta encontrar un elemento con scroll
            while (parent && parent !== diagramElement) {
              if (parent.scrollLeft > 0 || parent.scrollTop > 0 ||
                (parent.scrollWidth > parent.clientWidth) ||
                (parent.scrollHeight > parent.clientHeight)) {
                scrollLeft = parent.scrollLeft || 0;
                scrollTop = parent.scrollTop || 0;
                break;
              }
              parent = parent.parentElement;
            }
          }
        }

        // Método 4: Buscar todos los elementos con scroll en el diagrama
        if (scrollLeft === 0 && scrollTop === 0) {
          const allScrollable = diagramElement.querySelectorAll('*');
          for (let i = 0; i < allScrollable.length; i++) {
            const el = allScrollable[i] as HTMLElement;
            const sl = Math.abs(el.scrollLeft) || 0;
            const st = Math.abs(el.scrollTop) || 0;

            // Tomar el elemento con mayor scroll
            if (sl > scrollLeft || st > scrollTop) {
              scrollLeft = sl;
              scrollTop = st;
            }
          }
        }

        // Método 5: Verificar el elemento raíz
        if (diagramElement.scrollLeft !== undefined && diagramElement.scrollTop !== undefined) {
          const rootSL = Math.abs(diagramElement.scrollLeft) || 0;
          const rootST = Math.abs(diagramElement.scrollTop) || 0;
          if (rootSL > scrollLeft) scrollLeft = rootSL;
          if (rootST > scrollTop) scrollTop = rootST;
        }

      } catch (e) {
        console.warn('Error al obtener scroll:', e);
      }
    }

    return {
      zoom: zoom,
      scrollLeft: scrollLeft,
      scrollTop: scrollTop
    };
  }

  dataTemporal: any

  allowChangeShapeText: boolean = false;

  onSelectionChangedTree(e: any) {

    console.log("Se detecta el evento?", e)



    if (e.items.length > 0) {
      // e.items[0].type == "rectangle" ||
      if (e.items[0].type == "text" || e.items[0].type == "ellipse" || e.items[0].type == "rectangle" ||
        e.items[0].type == "cross" || e.items[0].type == "triangle" || e.items[0].type == "diamond" ||
        e.items[0].type == "heart" || e.items[0].type == "pentagon" || e.items[0].type == "hexagon" ||
        e.items[0].type == "octagon" || e.items[0].type == "star" || e.items[0].type == "arrowTop" ||
        e.items[0].type == "arrowBottom" || e.items[0].type == "arrowLeft" || e.items[0].type == "arrowRight" ||
        e.items[0].type == "arrowNorthSouth" || e.items[0].type == "arrowEastWest"
      ) {

        if (Number(e.items[0].id) > 0) {

          // Esto que vas haecer aqui hay que probarlo bien, para que el copy and paste funcione bien se tiene que quitar el rectangle de arriba 

          console.log("es un desing flow", e.items[0].text)
          console.log("this.groupItemsDiagram", this.groupItemsDiagram)
          let contador = 0;
          this.groupItemsDiagram.forEach(x => {
            x.items.forEach(y => {
              if (y.text == e.items[0].text) {
                contador++;
              }
            })
          })

          console.log("contador", contador)

          if (contador > 0) {
            // this.AddDuplicated(e);
            console.log("Va aqui knasldknskldfnks")
            this.SystemConfiguration(e);
          } else {
            this.allowChangeShapeText = true;
          }


          // aqui solo se llamaba a this.SystemConfiguration(e);
          // this.allowChangeShapeText = true;


        } else {
          console.log("e.items[0]", e.items[0])
          console.log("primer else ")
          let contador = 0;
          this.groupItemsDiagram.forEach(x => {
            x.items.forEach(y => {
              if (y.id == e.items[0].id) {
                contador++;
              }
            })
          })

          if (contador == 0) {
            console.log("no se encontro el item en el groupItemsDiagram")
            this.allowChangeShapeText = true;
          } else {
            // console.log("Si existe el item en el groupItemsDiagram")
          }
        }

      } else if (this.nameSVGs.includes(e.items[0].type)) {
        // Cuando se arrastra un design tool, cambiar width y height a 150

        console.log("e.items[0]", e.items[0])
        console.log("Esta aquiiiiiii1212232323")

        if (Number(e.items[0].id) > 0) {
          console.log("Va aqui 12334l,ldmg;ldfmg;")
          let json = this.diagramNew.instance.export();
          let diagram = JSON.parse(json);

          const shapeIndex = diagram.shapes.findIndex((s: any) => s.key == e.items[0].id);

          if (shapeIndex !== -1) {
            console.log("Va aqui 12334l,ldmg;ldfmg;2")
            // Generar un uniqueHexId
            const uniqueHexId = Date.now().toString(16) + Math.random().toString(16).substring(2);

            // Cambiar width, height, key e id
            diagram.shapes[shapeIndex].width = 150;
            diagram.shapes[shapeIndex].height = 150;
            diagram.shapes[shapeIndex].key = uniqueHexId;

            // Actualizar el id en e.items[0] si es necesario
            e.items[0].id = uniqueHexId;

            // Convertir todos los types a string
            diagram.shapes.forEach((item: any) => {
              if (item.type != undefined) {
                item.type = `${item.type}`;
              }
            });

            // Capturar el zoom y scroll actuales antes del import
            const viewData = this.getCurrentDiagramView();

            // Importar el diagrama
            this.diagramNew.instance.import(JSON.stringify(diagram));

            // Restaurar el zoom y scroll después del import
            if (viewData) {
              setTimeout(() => {
                if (this.diagramNew && this.diagramNew.instance) {
                  if (viewData.zoom > 0) {
                    try {
                      this.diagramNew.instance.option('zoomLevel', viewData.zoom);
                      this.zoomDiagramNew = viewData.zoom;
                    } catch (e) {
                      console.warn('Error al restaurar zoom:', e);
                    }
                  }

                  const diagramElement = document.getElementById('diagramNew');
                  if (diagramElement && (viewData.scrollLeft > 0 || viewData.scrollTop > 0)) {
                    try {
                      const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
                      if (scrollableContainer) {
                        scrollableContainer.scrollLeft = viewData.scrollLeft;
                        scrollableContainer.scrollTop = viewData.scrollTop;
                      } else {
                        const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
                        if (scrollableWrapper) {
                          scrollableWrapper.scrollLeft = viewData.scrollLeft;
                          scrollableWrapper.scrollTop = viewData.scrollTop;
                        }
                      }
                    } catch (e) {
                      console.warn('Error al restaurar scroll:', e);
                    }
                  }
                }
              }, 100);
            }
          }
        }



      } else {

        console.log("Esta aquiiiiiii123456")
        this.SystemConfiguration(e);

      }

    } else {

      console.log("Va aqui sdsdf.asdasd")

      if (this.diagramNew) {

        console.log("Va aqui 12123234234")

        this.diagramNew.instance.option('editing', {
          allowChangeShapeText: false
        });
      }
      this.allowChangeShapeText = false;

      if (this.diagramOldVersion != undefined) {
        this.validateSystems();
      }
      setTimeout(() => {
        let jsonTemporal = this.diagramNew.instance.export();
        let diagramTemporal = JSON.parse(jsonTemporal);
        this.dataTemporal = diagramTemporal
      }, 500);

    }



  }

  SystemConfiguration(e: any) {
    this.diagramNew.instance.option('editing', {
      allowChangeShapeText: false
    });
    this.allowChangeShapeText = false;

    console.log("this.diagramOldVersion", this.diagramOldVersion)

    if (this.diagramOldVersion != undefined) {
      this.validateSystems();
    }
    setTimeout(() => {
      let jsonTemporal = this.diagramNew.instance.export();
      let diagramTemporal = JSON.parse(jsonTemporal);
      this.dataTemporal = diagramTemporal
    }, 500);



    if (e.items.length > 0) {
      if (e.items[0].id != "background-image-999") {
        if (e.items[0].text == "" || e.items[0].text == null || e.items[0].text == undefined) {


          let json = this.diagramNew.instance.export();
          let diagram = JSON.parse(json);

          const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === e.items[0].id);

          const uniqueHexId = Date.now().toString(16) + Math.random().toString(16).substring(2);


          console.log("e.items[0]", e.items[0])

          console.log("jsdghfjsdgfjhsdfhgsdjfgjhsdgfjhsgdfjhsgdjfhs")


          if (shapeIndex !== -1) {
            diagram.shapes[shapeIndex].styleText = {
              "font-size": "8pt",
            }

            // if (this.useStoredConfiguration) {
            console.log("jsdghfjsdgfjhsdfhgsdjfgjhsdgfjhsgdfjhsgdjfhs")
            this.groupItemsDiagram.forEach(y => {
              if (y.id == e.items[0].type) {
                diagram.shapes[shapeIndex].style = y.style != undefined ? y.style : {
                  fill: y.color != undefined ? y.color : 'white',
                  stroke: '#000000',
                }
                diagram.shapes[shapeIndex].width = y.width != undefined ? y.width : 800
                diagram.shapes[shapeIndex].height = y.height != undefined ? y.height : 300
                diagram.shapes[shapeIndex].type = 'rectangle';
                diagram.shapes[shapeIndex].text = 'Name...';
                diagram.shapes[shapeIndex].key = uniqueHexId;
                diagram.shapes[shapeIndex].styleText = y.styleText != undefined ? y.styleText : {
                  "font-size": "8pt",
                }
              }
            });

            // Convertir todos los types a string
            diagram.shapes.forEach((item: any) => {
              if (item.type !== undefined) {
                item.type = `${item.type}`;
              }
            });

            // Se creael nuevo registro en el array groupItemsDiagram
            this.groupItemsDiagram.forEach(y => {
              if (y.id == e.items[0].type) {
                y.items.push(
                  {
                    "id": uniqueHexId,
                    "text": 'Name...',
                    "expanded": false,
                    "parentId": y.id,
                    "items": [],
                    "bbox": '[0,0,0,0]',
                    "source": ''
                  }
                )
              }
            })
            const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
            this.groupItemsDiagram = sortedItems;
            console.log('groupItemsDiagram', this.groupItemsDiagram)
            this.diagramTreeView.instance.option('items', sortedItems);
            this.diagramTreeView.instance.selectItem(uniqueHexId);

            this.diagramOldVersion = diagram

            // Capturar el zoom y scroll actuales antes del import
            const viewData = this.getCurrentDiagramView();

            // Importar el diagrama
            this.diagramNew.instance.import(JSON.stringify(diagram));

            // Restaurar el zoom y scroll después del import
            if (viewData) {
              setTimeout(() => {
                if (this.diagramNew && this.diagramNew.instance) {
                  // Restaurar zoom
                  if (viewData.zoom > 0) {
                    try {
                      this.diagramNew.instance.option('zoomLevel', viewData.zoom);
                      this.zoomDiagramNew = viewData.zoom;
                    } catch (e) {
                      console.warn('Error al restaurar zoom:', e);
                    }
                  }

                  // Restaurar scroll
                  const diagramElement = document.getElementById('diagramNew');
                  if (diagramElement && (viewData.scrollLeft > 0 || viewData.scrollTop > 0)) {
                    try {
                      const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
                      if (scrollableContainer) {
                        scrollableContainer.scrollLeft = viewData.scrollLeft;
                        scrollableContainer.scrollTop = viewData.scrollTop;
                        // scrollableContainer.scrollLeft = newShape.x;
                        // scrollableContainer.scrollTop = newShape.y;
                      } else {
                        const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
                        if (scrollableWrapper) {
                          scrollableWrapper.scrollLeft = viewData.scrollLeft;
                          scrollableWrapper.scrollTop = viewData.scrollTop;
                          // scrollableWrapper.scrollLeft = newShape.x;
                          // scrollableWrapper.scrollTop = newShape.y;
                        }
                      }
                    } catch (e) {
                      console.warn('Error al restaurar scroll:', e);
                    }
                  }
                }
              }, 100);
            }




          }
        } else { // si tiene texto actualizo la variable para poder modificar ese sistema
          let json = this.diagramNew.instance.export();
          let diagram = JSON.parse(json);
          // this.diagramOldVersion = diagram; // esto estaba comentado

          let idExistDuplicated;


          console.log("diagram", diagram)
          console.log("this.diagramOldVersion", this.diagramOldVersion)


          if (this.diagramOldVersion != undefined) {
            diagram.shapes.forEach(x => {
              if (x.text == e.items[0].text && x.key != e.items[0].id) {
                if (diagram.shapes.length != this.diagramOldVersion.shapes.length) {
                  idExistDuplicated = x.key;
                }
              }
            });

            if (idExistDuplicated) {

              console.log("idExistDuplicated", idExistDuplicated)

              let parentId;
              let color;

              this.groupItemsDiagram.forEach(y => {
                y.items.forEach(z => {
                  if (z.id == idExistDuplicated) {
                    parentId = z.parentId;
                    color = z.color;
                  }
                })
              });


              if (parentId) {

                const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === e.items[0].id);

                const uniqueHexId = Date.now().toString(16) + Math.random().toString(16).substring(2);

                console.log("shapeIndex", shapeIndex)

                console.log("e.items[0]", e.items[0])

                console.log("diagram", diagram)

                console.log("this.groupItemsDiagram", this.groupItemsDiagram)


                if (shapeIndex !== -1) {


                  // if (this.useStoredConfiguration) {

                  console.log("jsdghfjsdgfjhsdfhgsdjfgjhsdgfjhsgdfjhsgdjfhs")
                  this.groupItemsDiagram.forEach(y => {
                    if (y.id == parentId) {
                      diagram.shapes[shapeIndex].style = y.style != undefined ? y.style : {
                        fill: y.color != undefined ? y.color : 'white',
                        stroke: '#000000',
                      }
                      diagram.shapes[shapeIndex].width = y.width != undefined ? y.width : 800
                      diagram.shapes[shapeIndex].height = y.height != undefined ? y.height : 300
                      diagram.shapes[shapeIndex].styleText = y.styleText != undefined ? y.styleText : {
                        "font-size": "8pt",
                      }
                    }

                  });
                  diagram.shapes[shapeIndex].text = e.items[0].text;
                  diagram.shapes[shapeIndex].key = uniqueHexId


                  // Convertir todos los types a string
                  diagram.shapes.forEach((item: any) => {
                    if (item.type !== undefined) {
                      item.type = `${item.type}`;
                    }
                  });

                  // Se creael nuevo registro en el array groupItemsDiagram
                  this.groupItemsDiagram.forEach(y => {
                    if (y.id == parentId) {
                      y.items.forEach(z => {
                        if (z.id == idExistDuplicated) {
                          z.selected = false;
                        }
                      });
                      y.items.push(
                        {
                          "id": uniqueHexId,
                          "text": e.items[0].text,
                          "expanded": false,
                          "parentId": parentId,
                          "items": [],
                          "bbox": '[0,0,0,0]',
                          "source": '',
                          "color": color,
                          "selected": true

                        }
                      )
                    }
                  })
                  const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
                  this.diagramTreeView.instance.option('items', sortedItems);
                  this.diagramTreeView.instance.selectItem(uniqueHexId);

                  this.diagramOldVersion = diagram

                  // Capturar el zoom y scroll actuales antes del import
                  const viewData = this.getCurrentDiagramView();

                  // Importar el diagrama
                  this.diagramNew.instance.import(JSON.stringify(diagram));

                  // Restaurar el zoom y scroll después del import
                  if (viewData) {
                    setTimeout(() => {
                      if (this.diagramNew && this.diagramNew.instance) {
                        // Restaurar zoom
                        if (viewData.zoom > 0) {
                          try {
                            this.diagramNew.instance.option('zoomLevel', viewData.zoom);
                            this.zoomDiagramNew = viewData.zoom;
                          } catch (e) {
                            console.warn('Error al restaurar zoom:', e);
                          }
                        }

                        // Restaurar scroll
                        const diagramElement = document.getElementById('diagramNew');
                        if (diagramElement && (viewData.scrollLeft > 0 || viewData.scrollTop > 0)) {
                          try {
                            const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
                            if (scrollableContainer) {
                              scrollableContainer.scrollLeft = viewData.scrollLeft;
                              scrollableContainer.scrollTop = viewData.scrollTop;
                              // scrollableContainer.scrollLeft = newShape.x;
                              // scrollableContainer.scrollTop = newShape.y;
                            } else {
                              const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
                              if (scrollableWrapper) {
                                scrollableWrapper.scrollLeft = viewData.scrollLeft;
                                scrollableWrapper.scrollTop = viewData.scrollTop;
                                // scrollableWrapper.scrollLeft = newShape.x;
                                // scrollableWrapper.scrollTop = newShape.y;
                              }
                            }
                          } catch (e) {
                            console.warn('Error al restaurar scroll:', e);
                          }
                        }
                      }
                    }, 100);
                  }
                }
              }
            } else {
              this.diagramOldVersion = diagram;
              console.log("e.items[0].id", e.items[0].id)
              this.selectItemInTreeView(e.items[0].id);
            }
          } else {
            this.diagramOldVersion = diagram;
            console.log("e.items[0].id", e.items[0].id)
            this.selectItemInTreeView(e.items[0].id);
          }
        }
      } else {

        if (this.diagramOldVersion != undefined) {
          setTimeout(() => {
            let json = this.diagramNew.instance.export();
            let diagram = JSON.parse(json);

            // bucle con la version  anterior del diagrama
            this.diagramOldVersion.shapes.forEach(element => {
              // validar si hay algun sistema al que no se le haya dado nombre y crearlo en el treeview
              if (element.text == "Name...") {
                // Se busca en el diagrama actual si hay algun sistema con el mismo id
                diagram.shapes.forEach(x => {
                  if (x.key == element.key) {
                    // Se valida si el nombre del sistema es diferente al nombre anterior
                    if (x.text != element.text) {


                      // Se creael nuevo registro en el array groupItemsDiagram
                      this.groupItemsDiagram.forEach(y => {
                        y.items.forEach(z => {
                          if (z.id == element.key) {
                            z.text = x.text; // Usar el texto actual del diagrama, no el anterior
                          }
                        })
                      })
                      // Actualizar inmediatamente sin setTimeout
                      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
                      this.diagramTreeView.instance.option('items', sortedItems);
                      this.groupItemsDiagram = sortedItems;
                      console.log('groupItemsDiagram', this.groupItemsDiagram)


                      this.toast.success('System Name Updated Successfully');
                    }
                  }
                })
              } else {
                // si el sistema ya tiene nombre, actualizo el nombre en el treeview
                diagram.shapes.forEach(x => {
                  if (x.key == element.key) {
                    // Se valida si el nombre del sistema es diferente al nombre anterior
                    if (x.text != element.text) {

                      // Se creael nuevo registro en el array groupItemsDiagram
                      this.groupItemsDiagram.forEach(y => {
                        y.items.forEach(z => {
                          if (z.id == element.key) {
                            z.text = x.text; // Usar el texto actual del diagrama, no el anterior
                          }
                        })
                      })
                      // Actualizar inmediatamente sin setTimeout
                      console.log("dfngkjdfngkjndfjgk")
                      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
                      this.groupItemsDiagram = sortedItems;
                      console.log('groupItemsDiagram', this.groupItemsDiagram)
                      this.diagramTreeView.instance.option('items', sortedItems);
                      this.toast.success('System Updated Successfully');
                    }
                  }
                })

              }
            });

          }, 300);
        } else {
          this.selectItemInTreeView(e.items[0].id);

          setTimeout(() => {
            let json = this.diagramNew.instance.export();
            let diagram = JSON.parse(json);
            this.diagramOldVersion = diagram
          }, 300);
        }
      }
    }
  }




  selectItemInTreeView(id: string) {
    console.log("this.groupItemsDiagram", this.groupItemsDiagram)
    this.groupItemsDiagram.forEach(y => {
      y.items.forEach(z => {
        if (z.id == id) {
          z.selected = true;
        } else {
          z.selected = false;
        }
      });
    })
    const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
    this.groupItemsDiagram = sortedItems;
    console.log('groupItemsDiagram', this.groupItemsDiagram)
    this.diagramTreeView.instance.option('items', sortedItems);
    this.diagramTreeView.instance.selectItem(id);
  }

  onInserting(event: any) {
  }

  onDeleted(event: any) {
  }


  closeModalDiagramaNew() {
    // Mostrar modal de confirmación en lugar de cerrar directamente
    this.showCloseDiagramConfirmation = true;
  }

  confirmCloseDiagram() {
    // El usuario confirmó que quiere cerrar
    this.showCloseDiagramConfirmation = false;
    this.openModalDiagramNew = false;
    this.finishImport();
    this.dataTemporal = undefined;
  }

  cancelCloseDiagram() {
    // El usuario canceló el cierre
    this.showCloseDiagramConfirmation = false;
  }

  // En tu componente o controlador:
  handleEditOperation(e) {
    // 1. Verifica la operación 'addShape'
    if (e.operation === 'addShape') {

      const itemsAgregados = e.args.items;

      // 2. Comprueba si se están agregando múltiples elementos a la vez
      if (itemsAgregados && itemsAgregados.length > 1) {

        // Es muy probable que se trate de una operación de PEGAR 
        // (copiar y pegar selecciona varios elementos a la vez).
        console.log('Detectado posible Pegado (Paste): Se agregaron ' + itemsAgregados.length + ' elementos a la vez.');

        // Aquí puedes ejecutar tu lógica personalizada:

      } else if (itemsAgregados && itemsAgregados.length === 1) {
        // Podría ser un pegado de un solo elemento O la creación de una forma.
        // Si necesitas hacer una distinción estricta, pasa al punto 2 (la bandera).
        console.log('Detectado posible Pegado (Paste): Se agregó un solo elemento.');
      }
    }
  }

  getImageDimensions(base64String: string): Promise<{ width: number, height: number }> {
    return new Promise((resolve, reject) => {
      // Asegurar que el base64 tenga el prefijo correcto
      let imageUrl = base64String;
      if (!imageUrl.startsWith('data:image/')) {
        // Detectar el tipo de imagen por el inicio del base64
        if (imageUrl.startsWith('/9j/') || imageUrl.startsWith('iVBORw0KGgo')) {
          // JPG o PNG
          if (imageUrl.startsWith('/9j/')) {
            imageUrl = `data:image/jpeg;base64,${base64String}`;
          } else {
            imageUrl = `data:image/png;base64,${base64String}`;
          }
        } else {
          // Intentar con PNG por defecto
          imageUrl = `data:image/png;base64,${base64String}`;
        }
      }

      const img = new Image();

      img.onload = () => {
        resolve({
          width: img.width,
          height: img.height
        });
      };

      img.onerror = (error) => {
        reject(new Error('Error al cargar la imagen: ' + error));
      };

      img.src = imageUrl;
    });
  }

  SaveAndStay() {

    let json = this.diagramNew.instance.export();
    let diagram = JSON.parse(json);

    let SystemsFound = []

    this.groupItemsDiagram.forEach(x => {
      x.items.forEach(y => {
        SystemsFound.push(y)
      })
    })


    // validar con basic shapes
    const parentBasicShapes = this.groupItemsDiagram.find(x => x.id == 'Basic-shapes')
    if (!parentBasicShapes) {
      const data = {
        "id": 'Basic-shapes',
        "text": "Basic Shapes",
        "expanded": false,
        "parentId": 'Basic-shapes',
        "items": [],
        "dontShow": true,
      }
      this.groupItemsDiagram.push(data)
    }


    // validar con design tools

    const parentDesignTools = this.groupItemsDiagram.find(x => x.id == 'design-tools')
    if (!parentDesignTools) {
      const data = {
        "id": 'design-tools',
        "text": "Basic Shapes",
        "expanded": false,
        "parentId": 'design-tools',
        "items": [],
        "dontShow": true,
      }
      this.groupItemsDiagram.push(data)
    }

    let dataSysteNoAI = []

    if (diagram.shapes.length > 1) {


      console.log("diagram.shapes", diagram.shapes)
      console.log("SystemsFound", SystemsFound)
      diagram.shapes.forEach(x => {
        let contador = 0;
        SystemsFound.forEach(y => {
          if (y.id == x.key) {
            contador++;

            const canvas_x = x.x
            const canvas_y = x.y

            const scale_x = this.pageWidth / this.dimensionsImage.width
            const scale_y = this.pageHeight / this.dimensionsImage.height

            const image_x0 = canvas_x / (this.pageWidth / this.dimensionsImage.width)
            const image_y0 = canvas_y / (this.pageHeight / this.dimensionsImage.height)

            const image_x1 = image_x0 + (this.pageWidth / scale_x)
            const image_y1 = image_y0 + (this.pageHeight / scale_y)

            y.bbox = [Math.round(image_x0), Math.round(image_y0), Math.round(image_x1), Math.round(image_y1)]
            y.systemFound = true;

            console.log("sistemas encontrados", y)

            y.systemFound = false;
            y.type = x.type;
            y.style = x.style;
            y.styleText = x.styleText;
            y.width = x.width;
            y.height = x.height;
            y.color = x.color != undefined ? x.color : "white";
          }
        })


        if (contador == 0 && x.key != "background-image-999") {

          console.log("sistemas encontrados pero que no son del AI", x)
          const uniqueHexId = Date.now().toString(16) + Math.random().toString(16).substring(2);

          const canvas_x = x.x
          const canvas_y = x.y

          const scale_x = this.pageWidth / this.dimensionsImage.width
          const scale_y = this.pageHeight / this.dimensionsImage.height

          const image_x0 = canvas_x / (this.pageWidth / this.dimensionsImage.width)
          const image_y0 = canvas_y / (this.pageHeight / this.dimensionsImage.height)

          const image_x1 = image_x0 + (this.pageWidth / scale_x)
          const image_y1 = image_y0 + (this.pageHeight / scale_y)

          const bbox = [Math.round(image_x0), Math.round(image_y0), Math.round(image_x1), Math.round(image_y1)]

          let parentId = this.nameSVGs.includes(x.type) ? "design-tools" : "Basic-shapes";

          const data = {
            "id": uniqueHexId,
            "text": x.text,
            "expanded": false,
            "parentId": parentId,
            "items": [],
            "bbox": bbox,
            "source": "ocr/0",
            "highlighted": false,
            "selected": true,

            "systemFound": false,
            "type": x.type,
            "style": x.style,
            "styleText": x.styleText,
            "width": x.width,
            "height": x.height,
            "color": x.color != undefined ? x.color : "white",
          }

          dataSysteNoAI.push(data)
        }


      })

      dataSysteNoAI.forEach(x => {
        SystemsFound.push(x);
      })

      console.log("SystemsFound", SystemsFound)
    }

    // Crear nueva variable reemplazando los items hijos con los de SystemsFound
    const groupItemsDiagramUpdated = this.groupItemsDiagram.map(parentGroup => {
      // Buscar todos los items de SystemsFound que pertenecen a este grupo padre
      const updatedItems = SystemsFound.filter(item => item.parentId === parentGroup.id);

      // Retornar el grupo padre con los items actualizados
      return {
        ...parentGroup,
        items: updatedItems,
        image_name: this.image_name
      };
    });

    this.groupItemsDiagram = this.groupItemsDiagram.filter(x => x.dontShow == undefined);

    console.log("groupItemsDiagramUpdated", groupItemsDiagramUpdated)


    const data = {
      method: "SaveAreaAnalyzedImage",
      areaid: this.areaSelectedNew.areaID,
      overwrite: 1,
      jsondata: JSON.stringify(groupItemsDiagramUpdated)
    }

    this.MapInformationService.SaveInfoSites(data)
      .subscribe(resp => {
        this.toast.success("Progress Saved Successfully")
      })



  }





  importExistingWork() {
    this.showExistingWorkPopup = false;


    console.log("this.existingWorkData", this.existingWorkData)


    if (this.existingWorkData.length > 0) {

      this.openModalDiagramNew = true;

      console.log("this.existingWorkData", this.existingWorkData)

      try {
        let jsonData = typeof this.existingWorkData[0].DATA === 'string'
          ? JSON.parse(this.existingWorkData[0].DATA)
          : this.existingWorkData[0].DATA;


        // Eliminar duplicados en jsonData por id
        jsonData = jsonData.filter((item, index, self) =>
          index === self.findIndex(t => t.id === item.id)
        );

        // Eliminar duplicados en los arrays items internos por id
        jsonData.forEach(item => {
          if (item.items && Array.isArray(item.items)) {
            item.items = item.items.filter((subItem, subIndex, subSelf) =>
              subIndex === subSelf.findIndex(t => t.id === subItem.id)
            );
          }
        });

        console.log("jsonData", jsonData)

        console.log("jsonData", jsonData)

        this.processAndAddItemsToDiagram(jsonData);

        this.newDataGroupNames = jsonData.map((item: any) => item.text);

        if (!this.newDataGroupNames.includes("Design Tools")) {
          this.newDataGroupNames.push("Design Tools")
        }

        this.MapInformationService.cubePreviewImage({ image_name: jsonData[0].image_name }).subscribe(resultImage => {

          this.showProcessingPlanePopup = false;

          this.image_name = resultImage.image_name
          this.base64Returned = resultImage.base64

          this.getImageDimensions(this.base64Returned).then(dimensions => {
            this.dimensionsImage.width = dimensions.width;
            this.dimensionsImage.height = dimensions.height;
          }).catch(error => {
            console.error('Error al obtener dimensiones de la imagen:', error);
          });

          this.openModalDiagramNew = true

          setTimeout(() => {
            this.initDiagramNew();
            setTimeout(() => {
              this.addBackgroundImage(true);
            }, 300);
          }, 1000);


        }, error => {
          this.showProcessingPlanePopup = false;
          this.toast.warning('An error occurred while processing the plane with Cube AI');
        })

      } catch (e) {
        console.error('Error importing existing work:', e);
        this.toast.error("Error importing existing work");
      }
    }

    // Limpiar los datos temporales
    this.existingWorkData = null;
  }


  openContextImportLibraryIntoSystemFromTree(item: any): void {
    if (!this.isTreeviewSystemItem(item)) {
      return;
    }
    if (item == null || item.id == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    if (this.ModuleFrom !== 'Edit Estimate') {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgImportLibraryEstimateOnly'));
      return;
    }
    const areaItem = this.findAreaTreeItemContainingSystem(item);
    if (areaItem == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAnArea'));
      return;
    }
    const targetSysId = Number(item.id);
    if (isNaN(targetSysId) || targetSysId <= 0) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.systemLibraryGalleryImportIntoSystemId = targetSysId;
    this.openSystemLibraryGalleryCore(areaItem, item.id);
  }


  hiddenImportLibrary(data) {
    this.modal = false;
    console.log('data', data);

    const selectedSystem = this.dataSystemSelected;
    if (!selectedSystem || selectedSystem.systemTypeID == null) {
      return;
    }
    console.log('selectedSystem', selectedSystem);
    console.log('this.dataSystemSelected', this.dataSystemSelected);
    const selectedSystemTypeID = selectedSystem.systemTypeID;

    this.filteredSystemsForSelection = this.dataTest.filter(
      item => item.systemTypeID === selectedSystemTypeID && item.id !== selectedSystem.id
    );

    console.log('this.filteredSystemsForSelection', this.filteredSystemsForSelection);

    if (this.filteredSystemsForSelection.length > 0) {
      this.suggestedSystemData = selectedSystem;
      this.dataSystemInfo = { ID: selectedSystem.sytemOrigin };
      this.selectedSystemsForChange = [];
      this.showSelectSystemsPopup = true;
    }
  }


  showLibreryorRecommended(item) {
    console.log("item", item)

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
    }
    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {

      const itemMatch = resultMatch[0]

      const key = itemMatch.TYPEPROMPT.split(':')[2];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };

      this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {

        const resultString = JSON.stringify(resultSp);
        let prompt = {
          systemPrompt: `${itemMatch.SYSTEMPROMPT}`, // 
          userprompt: `${itemMatch.USERPROMPT} ${item.text} ${resultString}`, // 
        };

        this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
          const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID

          console.log("resultMatchType", resultMatchType)
          console.log("systemTypeIDFromAI", systemTypeIDFromAI)

          this.dataSystemSelected = {
            "id": item.id,
            "areaID": this.areaSelectedNew.areaID,
            "systemTypeID": systemTypeIDFromAI,
            "name": item.text,
            "sort": 1,
            "qty": 1,
            "sytemOrigin": null,
            "matchedArea": true,
            "matched": true,
            "fromDiagram": true
          }

          this.modal = true
          this.title = "Librery or Recommended"
        })
      })
    })
  }

  private resetAssociateSystemOriginModalState(): void {
    this.showAssociateSystemOriginPopup = false;
    this.selectedChildrenForSystemOrigin = [];
    this.filteredChildrenForSystemOrigin = [];
    this.currentSystemOriginData = null;
  }

  onAssociateSystemOriginPopupHidden(): void {
    this.resetAssociateSystemOriginModalState();
  }

  returnToDiagram(data) {

    this.groupItemsDiagram.forEach(item => {
      let contador = 0;
      item.items.forEach(itemChild => {
        if (itemChild.id == data.id) {
          itemChild.systemOrigin = data.systemOrigin
          itemChild.systemtypeid = data.systemTypeID
          contador++
        }
      });

      if (contador > 0 && item.items.length > 1) {
        // Filtrar los demás children del mismo parent, excluyendo el que se modificó
        this.filteredChildrenForSystemOrigin = item.items.filter(child => child.id !== data.id);

        // Guardar los datos necesarios para aplicar el cambio después
        this.currentSystemOriginData = {
          systemOrigin: data.systemOrigin,
          systemTypeID: data.systemTypeID,
          parentItem: item
        };

        // Inicializar vacío
        this.selectedChildrenForSystemOrigin = [];

        // Mostrar popup
        this.showAssociateSystemOriginPopup = true;
      }
    });

    if (this.diagramTreeView && this.diagramTreeView.instance) {
      this.diagramTreeView.instance.option('items', this.groupItemsDiagram);
    }
    console.log("this.groupItemsDiagram", this.groupItemsDiagram)
    this.modal = false
  }

  confirmAssociateSystemOrigin() {
    const effectiveSelected = (this.selectedChildrenForSystemOrigin || []).slice();

    const payload = this.currentSystemOriginData;
    if (!payload) {
      this.resetAssociateSystemOriginModalState();
      return;
    }

    if (effectiveSelected.length === 0) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgAssociateOriginPickOne'));
      return;
    }

    payload.parentItem.items.forEach(child => {
      if (effectiveSelected.some(sid => sid == child.id)) {
        child.systemOrigin = payload.systemOrigin;
        child.systemtypeid = payload.systemTypeID;
      }
    });

    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
      this.diagramTreeView.instance.option('items', sortedItems);
    }

    this.resetAssociateSystemOriginModalState();

    this.toast.success(this.translate.instant('ModuleSystemToArea.msgAssociateOriginSuccess'));

    console.log('this.groupItemsDiagram', this.groupItemsDiagram);
  }

  cancelAssociateSystemOrigin() {
    this.resetAssociateSystemOriginModalState();
  }

  changeChildParent(item: any) {
    if (!item || !item.parentId) {
      this.toast.warning('This item cannot be moved');
      return;
    }

    this.childToMove = item;

    // Obtener todos los parents disponibles (items que tienen items array o parentId null)
    this.availableParents = this.groupItemsDiagram.filter(parent =>
      parent.id !== item.parentId && (parent.items || parent.parentId === null)
    ).map(parent => ({
      id: parent.id,
      text: parent.text
    }));

    if (this.availableParents.length === 0) {
      this.toast.warning('No available parents to move this item to');
      return;
    }

    this.selectedNewParentId = null;
    this.showChangeParentPopup = true;
  }

  confirmChangeParent() {
    if (!this.childToMove || !this.selectedNewParentId) {
      this.toast.warning('Please select a new parent');
      return;
    }



    // Buscar el parent actual y remover el child
    const currentParent = this.groupItemsDiagram.find(p => p.id === this.childToMove.parentId);
    if (currentParent && currentParent.items) {
      const childIndex = currentParent.items.findIndex((child: any) => child.id === this.childToMove.id);
      if (childIndex !== -1) {
        currentParent.items.splice(childIndex, 1);
      }
    }

    // Buscar el nuevo parent y agregar el child


    const newParent = this.groupItemsDiagram.find(p => p.id === this.selectedNewParentId);
    console.log("newParent", newParent)

    if (newParent) {
      if (!newParent.items) {
        newParent.items = [];
      }

      // Actualizar el parentId del child
      this.childToMove.parentId = this.selectedNewParentId;


      // if (this.useStoredConfiguration) {
      this.childToMove.color = newParent.color || '#ffffff';
      // } else {
      //   this.childToMove.color = this.childToMove.color != undefined ? this.childToMove.color : '#ffffff';
      // }
      newParent.items.push(this.childToMove);
    }




    // Actualizar el diagrama con el nuevo color del shape
    if (this.diagramNew && this.diagramNew.instance) {
      const json = this.diagramNew.instance.export();
      const diagram = JSON.parse(json);

      if (diagram.shapes) {
        const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === this.childToMove.id);
        if (shapeIndex !== -1) {

          diagram.shapes[shapeIndex].style = {
            fill: newParent.color != undefined ? newParent.color : 'white',
            stroke: '#000000',
          };
          diagram.shapes[shapeIndex].width = newParent.width != undefined ? newParent.width : 800
          diagram.shapes[shapeIndex].height = newParent.height != undefined ? newParent.height : 300
          diagram.shapes[shapeIndex].styleText = newParent.styleText != undefined ? newParent.styleText : {
            "font-size": "8pt",
          }
          // if (!diagram.shapes[shapeIndex].style) {
          //   // if (this.useStoredConfiguration) {
          //   // this.groupItemsDiagram.forEach(y => {
          //   // if (y.id == this.childToMove.parentId) {

          //   console.log("newParent", newParent)
          //   console.log("this.childToMove", this.childToMove)


          //   // diagram.shapes[shapeIndex].style = y.color != undefined ? y.color : 'white', {
          //   //   fill: y.color != undefined ? y.color : 'white',
          //   //   stroke: '#000000',
          //   // }
          //   // diagram.shapes[shapeIndex].width = y.width != undefined ? y.width : 800
          //   // diagram.shapes[shapeIndex].height = y.height != undefined ? y.height : 300
          //   // diagram.shapes[shapeIndex].styleText = y.styleText != undefined ? y.styleText : {
          //   //   "font-size": "8pt",
          //   // }
          //   // }
          //   // });
          //   // } 
          //   // else {
          //   console.log("newParent", newParent)
          //   console.log("diagram.shapes[shapeIndex]", diagram.shapes[shapeIndex])


          //   diagram.shapes[shapeIndex].style = {
          //     fill: newParent.color != undefined ? newParent.color : 'white',
          //     stroke: '#000000',
          //   };
          //   diagram.shapes[shapeIndex].width = newParent.width != undefined ? newParent.width : 800
          //   diagram.shapes[shapeIndex].height = newParent.height != undefined ? newParent.height : 300
          //   diagram.shapes[shapeIndex].styleText = newParent.styleText != undefined ? newParent.styleText : {
          //     "font-size": "8pt",
          //   }
          //   // }
          // } else {

          // }
        }

        // Convertir todos los types a string
        diagram.shapes.forEach((shape: any) => {
          if (shape.type !== undefined) {
            shape.type = `${shape.type}`;
          }
        });

        const viewData = this.getCurrentDiagramView();
        this.diagramNew.instance.import(JSON.stringify(diagram));
        this.restoreDiagramView(viewData);
      }
    }

    // Actualizar el treeview
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
      this.groupItemsDiagram = sortedItems;

      console.log('groupItemsDiagram', this.groupItemsDiagram)
      this.diagramTreeView.instance.option('items', sortedItems);
    }

    this.toast.success('Child moved to new parent successfully');
    this.cancelChangeParent();
  }

  cancelChangeParent() {
    this.showChangeParentPopup = false;
    this.childToMove = null;
    this.availableParents = [];
    this.selectedNewParentId = null;
  }

  openColorPicker(item: any) {
    this.parentForColor = item;
    this.selectedColor = item.color || '#007bff';
    this.showColorPickerPopup = true;
  }



  cancelColorPicker() {
    this.showColorPickerPopup = false;
    this.parentForColor = null;
    this.selectedColor = '#007bff';
  }

  duplicateTreeItem(item: any) {
    console.log("item", item)




    let json = this.diagramNew.instance.export();
    let diagram = JSON.parse(json);

    console.log('diagram.shapes', diagram.shapes)

    console.log('this.diagragramOldVersion', this.diagramOldVersion)


    if (!diagram.shapes) {
      diagram.shapes = [];
    }

    // const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === event.itemData.id);

    // Solo agregar si no existe ya en el diagrama
    let bboxArray = item.bbox;
    if (typeof item.bbox === 'string') {
      try {
        bboxArray = JSON.parse(item.bbox);
      } catch (e) {
        bboxArray = [0, 0, 0, 0];
      }
    }

    let centerX = 0;
    let centerY = 0;
    if (bboxArray && Array.isArray(bboxArray) && bboxArray.length >= 4) {
      centerX = bboxArray[0]
      centerY = bboxArray[1]
    }

    const x0 = bboxArray[0];
    const y0 = bboxArray[1];
    const x1 = bboxArray[2];
    const y1 = bboxArray[3];

    const scale_x = this.pageWidth / this.dimensionsImage.width;
    const scale_y = this.pageHeight / this.dimensionsImage.height;

    let canvas_x0 = x0 * scale_x
    let canvas_y0 = y0 * scale_y
    const canvas_width = (x1 - x0) * scale_x
    const canvas_height = (y1 - y0) * scale_y


    console.log('this.dataTemporal', this.dataTemporal)

    const uniqueHexId = Date.now().toString(16) + Math.random().toString(16).substring(2);


    const newShape = {
      "key": uniqueHexId,
      "locked": false,
      "zIndex": 0,
      "type": 'rectangle',
      "text": item.text,
      "x": canvas_x0,
      "y": canvas_y0 + 250,
      "width": 800,
      "height": 300,
      "styleText": {
        "font-size": "8pt",
      },
    };


    diagram.shapes.push(newShape);

    diagram.shapes.forEach((item: any) => {
      if (item.type !== undefined) {
        item.type = `${item.type}`;
      }
    });

    const newItem = {
      id: uniqueHexId,
      text: item.text,
      expanded: false,
      parentId: item.parentId,
      items: [],
      bbox: item.bbox,
      source: item.source
    };


    console.log("this.groupItemsDiagram", this.groupItemsDiagram)
    console.log("item", item)
    this.groupItemsDiagram.forEach(itemGroup => {
      if (itemGroup.id == item.parentId) {
        itemGroup.items.push(newItem);
      }
    });
    const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
    this.diagramTreeView.instance.option('items', sortedItems);
    this.diagramTreeView.instance.selectItem(uniqueHexId);


    // Importar el diagrama
    this.diagramNew.instance.import(JSON.stringify(diagram));

    // Capturar el zoom y scroll actuales antes del import
    const viewData = this.getCurrentDiagramView();

    this.toast.success("Item duplicated successfully");

    // Restaurar el zoom y scroll después del import
    if (viewData) {
      setTimeout(() => {
        if (this.diagramNew && this.diagramNew.instance) {
          // Restaurar zoom
          if (viewData.zoom > 0) {
            try {
              this.diagramNew.instance.option('zoomLevel', viewData.zoom);
              this.zoomDiagramNew = viewData.zoom;
            } catch (e) {
              console.warn('Error al restaurar zoom:', e);
            }
          }

          // Restaurar scroll
          const diagramElement = document.getElementById('diagramNew');
          if (diagramElement && (viewData.scrollLeft > 0 || viewData.scrollTop > 0)) {
            try {
              const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
              if (scrollableContainer) {
                scrollableContainer.scrollLeft = viewData.scrollLeft;
                scrollableContainer.scrollTop = viewData.scrollTop;
                // scrollableContainer.scrollLeft = newShape.x;
                // scrollableContainer.scrollTop = newShape.y;
              } else {
                const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
                if (scrollableWrapper) {
                  scrollableWrapper.scrollLeft = viewData.scrollLeft;
                  scrollableWrapper.scrollTop = viewData.scrollTop;
                  // scrollableWrapper.scrollLeft = newShape.x;
                  // scrollableWrapper.scrollTop = newShape.y;
                }
              }
            } catch (e) {
              console.warn('Error al restaurar scroll:', e);
            }
          }
        }
      }, 100);
    }

  }

  fromTreeview = false;

  takeoffImage(item: any) {
    console.log("item", item)

    this.areaSelectedNew.AreaName = item.areaname
    this.areaSelectedNew.areaID = item.originalid

    this.dataDrawingTempo.forEach(item => {
      item.matchedArea = true
      item.areaname = item.areaname
      item.areaID = item.originalid
    })


    this.MapInformationService.SaveInfoSites({
      method: "GetAreaAnalyzedImage",
      areaid: item.originalid
    }).subscribe(resp => {
      console.log("resp", resp)
      if (resp && resp.length > 0) {
        this.existingWorkData = resp;
        console.log('this.existingWorkData', this.existingWorkData)

        this.importExistingWork();

        this.fromTreeview = true;


      }
    })
  }


  selectComponent(event: any) {

    this.groupItemsDiagram.forEach(item => {
      let contador = 0;
      item.items.forEach(itemChild => {
        if (itemChild.id == event.item.id) {
          itemChild.highlighted = true
          contador++
        } else {
          itemChild.highlighted = false
        }
      });
    });

    this.diagramTreeView.instance.option('items', this.groupItemsDiagram);
  }


  findParentInItems(items: any[], parentId: any): any {
    for (const item of items) {
      if (item.id === parentId) {
        return item;
      }
      if (item.items && item.items.length > 0) {
        const found = this.findParentInItems(item.items, parentId);
        if (found) return found;
      }
    }
    return null;
  }

  updateChildrenColorInItems(items: any[], parentId: any, colorCode: string): void {
    for (const item of items) {
      if (item.id === parentId && item.items) {
        item.items.forEach((child: any) => {
          child.color = colorCode;
        });
      }
      if (item.items && item.items.length > 0) {
        this.updateChildrenColorInItems(item.items, parentId, colorCode);
      }
    }
  }

  restoreDiagramView(viewData: any): void {
    if (!viewData || !this.diagramNew || !this.diagramNew.instance) {
      return;
    }

    setTimeout(() => {
      if (!this.diagramNew || !this.diagramNew.instance) {
        return;
      }

      if (viewData.zoom > 0) {
        try {
          this.zoomDiagramNew = viewData.zoom;
        } catch (e) {
          console.warn('Error al restaurar zoom:', e);
        }
      }

      const diagramElement = document.getElementById('diagramNew');
      if (diagramElement && (viewData.scrollLeft > 0 || viewData.scrollTop > 0)) {
        try {
          const scrollableContainer = diagramElement.querySelector('.dx-scrollable-container') as HTMLElement;
          if (scrollableContainer) {
            scrollableContainer.scrollLeft = viewData.scrollLeft;
            scrollableContainer.scrollTop = viewData.scrollTop;
          } else {
            const scrollableWrapper = diagramElement.querySelector('.dx-scrollable-wrapper') as HTMLElement;
            if (scrollableWrapper) {
              scrollableWrapper.scrollLeft = viewData.scrollLeft;
              scrollableWrapper.scrollTop = viewData.scrollTop;
            }
          }
        } catch (e) {
          console.warn('Error al restaurar scroll:', e);
        }
      }
    }, 100);
  }

  onColorSelected(parentId: any, colorCode: string) {
    console.log('Color selected for parent:', parentId, 'Color code:', colorCode);

    // Aplicar color a todos los children con este parentId
    this.updateChildrenColorInItems(this.groupItemsDiagram, parentId, colorCode);

    // Actualizar el diagrama con el nuevo color
    if (!this.diagramNew || !this.diagramNew.instance) {
      return;
    }

    const json = this.diagramNew.instance.export();
    const diagram = JSON.parse(json);

    if (!diagram.shapes) {
      return;
    }

    // Buscar el parent y actualizar los shapes de sus children
    const parent = this.findParentInItems(this.groupItemsDiagram, parentId);

    if (parent && parent.items) {
      parent.items.forEach((child: any) => {
        const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === child.id);
        if (shapeIndex !== -1) {
          if (!diagram.shapes[shapeIndex].style) {
            diagram.shapes[shapeIndex].style = {};
          }
          diagram.shapes[shapeIndex].style.fill = colorCode;
        }
      });
    }

    // Convertir todos los types a string
    diagram.shapes.forEach((shape: any) => {
      if (shape.type !== undefined) {
        shape.type = `${shape.type}`;
      }
    });

    const viewData = this.getCurrentDiagramView();
    this.diagramNew.instance.import(JSON.stringify(diagram));
    this.restoreDiagramView(viewData);

    // Actualizar el treeview
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
      this.diagramTreeView.instance.option('items', sortedItems);
      console.log("this.groupItemsDiagram", this.groupItemsDiagram)
      this.SaveAndStay();
    }
  }


  confirmColorSelection() {
    if (!this.parentForColor || !this.selectedColor) {
      this.toast.warning('Please select a color');
      return;
    }

    // Guardar el color en el item
    this.parentForColor.color = this.selectedColor;

    // Ejecutar evento con el código del color
    this.onColorSelected(this.parentForColor.id, this.selectedColor);

    // Actualizar el treeview
    if (this.diagramTreeView && this.diagramTreeView.instance) {
      const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
      this.diagramTreeView.instance.option('items', sortedItems);
    }

    this.cancelColorPicker();
  }


  onCustomCommand(event: any) {
    // To be implemented
    console.log("event", event)
  }


  closeSelectSystemWarning() {
    this.showSelectSystemWarningPopup = false;
  }



  copySelectedItems() {
    console.log("copySelectedItems")

    let itemsSelected = this.diagramNew.instance.getSelectedItems();

    console.log("itemsSelected", itemsSelected)

    if (!itemsSelected || itemsSelected.length === 0) {
      this.showSelectSystemWarningPopup = true;
      return;
    }

    if (itemsSelected[0].id == "background-image-999") {
      this.showSelectSystemWarningPopup = true;
      return;
    }



    let systemSelected: any = null;
    let systemChildren: any[] = [];

    // Buscar el sistema seleccionado
    this.groupItemsDiagram.forEach(x => {
      x.items.forEach(y => {
        if (y.id == itemsSelected[0].id) {
          systemSelected = y;
        }
      })
    })

    this.groupItemsDiagram.forEach(x => {
      x.items.forEach(y => {
        if (y.parentId == systemSelected.parentId) {
          systemChildren.push(y);
        }
      })
    })

    let json = this.diagramNew.instance.export();
    let diagram = JSON.parse(json);

    if (!diagram.shapes) {
      return;
    }

    // Buscar el shape del sistema seleccionado
    const selectedShapeIndex = diagram.shapes.findIndex((s: any) => s.key === systemSelected.id);

    if (selectedShapeIndex === -1) {
      this.toast.warning('Selected system shape not found in diagram');
      return;
    }

    const selectedShape = diagram.shapes[selectedShapeIndex];

    console.log("selectedShape", selectedShape)
    console.log("systemSelected", systemSelected)


    // Obtener los campos a copiar
    const styleToCopy = selectedShape.style ? JSON.parse(JSON.stringify(selectedShape.style)) : null;
    const styleTextToCopy = selectedShape.styleText ? JSON.parse(JSON.stringify(selectedShape.styleText)) : null;
    const widthToCopy = selectedShape.width;
    const heightToCopy = selectedShape.height;


    console.log("this.groupItemsDiagram", this.groupItemsDiagram)
    console.log("systemSelected", systemSelected)
    this.groupItemsDiagram.forEach(x => {
      x.items.forEach(y => {
        if (y.id == systemSelected.id) {
          x.style = styleToCopy == undefined ? undefined : { fill: systemSelected.color };
          x.styleText = styleTextToCopy;
          x.width = widthToCopy;
          x.height = heightToCopy;
        }
      })
    })



    // Aplicar los campos a todos los shapes de systemChildren
    systemChildren.forEach(child => {
      const childShapeIndex = diagram.shapes.findIndex((s: any) => s.key === child.id);

      if (childShapeIndex !== -1) {
        // Aplicar style
        if (styleToCopy) {
          diagram.shapes[childShapeIndex].style = styleToCopy;
        }

        // Aplicar styleText
        if (styleTextToCopy) {
          diagram.shapes[childShapeIndex].styleText = styleTextToCopy;
        }

        // Aplicar width y height
        if (widthToCopy !== undefined) {
          diagram.shapes[childShapeIndex].width = widthToCopy;
        }
        if (heightToCopy !== undefined) {
          diagram.shapes[childShapeIndex].height = heightToCopy;
        }
      }
    });

    // Convertir todos los types a string
    diagram.shapes.forEach((shape: any) => {
      if (shape.type !== undefined) {
        shape.type = `${shape.type}`;
      }
    });

    const viewData = this.getCurrentDiagramView();

    // Importar el diagrama actualizado
    this.diagramNew.instance.import(JSON.stringify(diagram));

    // Restaurar zoom y scroll
    this.restoreDiagramView(viewData);

    this.toast.success(`Configuration applied to ${systemChildren.length} system(s)`);
  }


  saveConfiguration() {
    console.log("saveConfiguration", this.groupItemsDiagram)

    // let parentWithData: any[] = [];
    // this.groupItemsDiagram.forEach(x => {
    //   if (x.color !== undefined && x.color !== null && x.color !== ''
    //     && x.style !== undefined && x.style !== null && x.style !== ''
    //     && x.styleText !== undefined && x.styleText !== null && x.styleText !== ''
    //     && x.width !== undefined && x.width !== null && x.width !== ''
    //     && x.height !== undefined && x.height !== null && x.height !== ''
    //   ) {
    //     const data = {
    //       id: x.id,
    //       color: x.color,
    //       style: x.style,
    //       styleText: x.styleText,
    //       width: x.width,
    //       height: x.height,
    //       name: x.text,
    //     }

    //     parentWithData.push(data);
    //   }
    // })



    // Obtener el sistema seleccionado y es el que se va a guardar en la base de datos
    let itemsSelected = this.diagramNew.instance.getSelectedItems();
    let parentWithData: any = null;

    if (!itemsSelected || itemsSelected.length === 0) {
      this.toast.warning('Please select a system first');
      return;
    }

    let systemSelected: any = null;
    let systemChildren: any[] = [];

    // Buscar el sistema seleccionado
    this.groupItemsDiagram.forEach(x => {
      x.items.forEach(y => {
        if (y.id == itemsSelected[0].id) {
          systemSelected = y;
        }
      })
    })


    let json = this.diagramNew.instance.export();
    let diagram = JSON.parse(json);

    if (!diagram.shapes) {
      return;
    }

    // Buscar el shape del sistema seleccionado
    const selectedShapeIndex = diagram.shapes.findIndex((s: any) => s.key === systemSelected.id);

    if (selectedShapeIndex === -1) {
      this.toast.warning('Selected system shape not found in diagram');
      return;
    }


    const selectedShape = diagram.shapes[selectedShapeIndex];

    // Obtener los campos a copiar
    const styleToCopy = selectedShape.style ? JSON.parse(JSON.stringify(selectedShape.style)) : null;
    const styleTextToCopy = selectedShape.styleText ? JSON.parse(JSON.stringify(selectedShape.styleText)) : null;
    const widthToCopy = selectedShape.width;
    const heightToCopy = selectedShape.height;



    this.groupItemsDiagram.forEach(x => {
      x.items.forEach(y => {
        if (y.id == selectedShape.key) {
          parentWithData = x
        }
      })
    })

    console.log("selectedShape", selectedShape)
    console.log("styleToCopy", styleToCopy)
    console.log("styleTextToCopy", styleTextToCopy)
    console.log("widthToCopy", widthToCopy)
    console.log("heightToCopy", heightToCopy)
    console.log("parentWithData", parentWithData)
    console.log("systemSelected", systemSelected)


    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
    }

    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {

      const itemMatch = resultMatch[0]

      const key = itemMatch.TYPEPROMPT.split(':')[2];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };



      this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {

        const resultString = JSON.stringify(resultSp);
        let prompt = {
          systemPrompt: `${itemMatch.SYSTEMPROMPT}`, // 
          userprompt: `${itemMatch.USERPROMPT} ${parentWithData.text} ${resultString}`, // 
        };

        this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
          const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID
          const systemTypeFromAI = JSON.parse(resultMatchType.content).system_type
          parentWithData.systemTypeID = systemTypeIDFromAI
          parentWithData.systemType = systemTypeFromAI

          // save data in database
          const data = {
            method: "Save_TakeOff_Img_Configuration",
            id: systemTypeIDFromAI,
            config: JSON.stringify({
              color: styleToCopy == undefined ? undefined : styleToCopy.fill,
              style: styleToCopy,
              styleText: styleTextToCopy,
              width: widthToCopy,
              height: heightToCopy,
            }),
          }
          console.log("data", data)
          this.MapInformationService.SaveInfoSites(data).subscribe(result => {
            console.log("result", result)
            this.toast.success("Configuration saved successfully");
          })

        })
      })
    })
  }


  validateSelection() {
    if (this.diagramNew) {
      let itemsSelected = this.diagramNew.instance.getSelectedItems();
      if (itemsSelected && itemsSelected.length > 0) {
        let itemSelected = itemsSelected[0];
        if (itemSelected.id == "background-image-999") {
          return false;
        }
      }
      return this.diagramNew.instance.getSelectedItems().length > 0;
    }
    return false;
  }


  toggleStoredConfiguration() {

    // En este caso va de true a false
    if (this.useStoredConfiguration) {
      // mostrar un modal de confirmación para desactivar la configuración almacenada
      this.showDisableStoredConfigConfirmation = true;
    } else {
      // En este caso va de false a true
      this.useStoredConfiguration = !this.useStoredConfiguration;


      this.MapInformationService.SaveInfoSites({
        method: "Get_TakeOff_Img_Configuration",
      }).subscribe(result => {
        this.setDataStoredConfiguration(result);
      })
    }

  }

  dataTempoPrevConfiguration: any[] = [];


  setDataStoredConfiguration(result: any) {
    console.log("result", result)
    console.log("this.groupItemsDiagram", this.groupItemsDiagram)

    const dataSPAI = {
      method: "GetCubeOpenAIQuestionByType",
      topic: "MATCH_SYSTEM_TYPE_AI_WITH_NAME"
    }

    const dataTreeTempo = []

    // guardar el estado actual de la treeview para poder restaurar el estado anterior (copia profunda)
    this.dataTempoPrevConfiguration = JSON.parse(JSON.stringify(this.groupItemsDiagram));


    this.groupItemsDiagram.forEach(x => {

      this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {

        const itemMatch = resultMatch[0]

        const key = itemMatch.TYPEPROMPT.split(':')[2];
        const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
        const newVariable = {
          method: spDinamic,
        };



        this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {

          const resultString = JSON.stringify(resultSp);
          let prompt = {
            systemPrompt: `${itemMatch.SYSTEMPROMPT}`, // 
            userprompt: `${itemMatch.USERPROMPT} ${x.text} ${resultString}`, // 
          };

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
            const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID
            const systemTypeFromAI = JSON.parse(resultMatchType.content).system_type
            x.systemTypeID = systemTypeIDFromAI
            x.systemType = systemTypeFromAI

            result.forEach(y => {
              if (y.ID == systemTypeIDFromAI) {
                if (y.TAKEOFF_IMG_CONFIG != undefined && y.TAKEOFF_IMG_CONFIG != null && y.TAKEOFF_IMG_CONFIG != '') {
                  const config = JSON.parse(y.TAKEOFF_IMG_CONFIG);
                  x.color = config.color;
                  x.style = config.style;
                  x.styleText = config.styleText;
                  x.width = config.width;
                  x.height = config.height;
                }
              }
            })

            dataTreeTempo.push(x);

            if (dataTreeTempo.length == this.groupItemsDiagram.length) {

              const sortedItems = this.sortItemsAlphabetically(dataTreeTempo);
              this.groupItemsDiagram = sortedItems;
              console.log('groupItemsDiagram', this.groupItemsDiagram)
              this.diagramTreeView.instance.option('items', sortedItems);

              console.log("dataTreeTempo", sortedItems)
            }
          })
        })
      })
    })

  }

  confirmDisableStoredConfig() {
    this.useStoredConfiguration = false;
    this.showDisableStoredConfigConfirmation = false;
    // Aquí puedes agregar lógica adicional cuando se desactiva la configuración almacenada
    console.log("this.dataTempoPrevConfiguration", this.dataTempoPrevConfiguration)
    console.log("this.groupItemsDiagram", this.groupItemsDiagram)

    const dataTempoPrevConfiguration = JSON.parse(JSON.stringify(this.dataTempoPrevConfiguration));

    this.groupItemsDiagram.forEach(x => {
      dataTempoPrevConfiguration.forEach(y => {
        if (y.id == x.id) {
          x.color = y.color;
          x.style = y.style;
          x.styleText = y.styleText;
          x.width = y.width;
          x.height = y.height;
        }
      });
    });
    const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
    this.groupItemsDiagram = sortedItems;

    console.log('groupItemsDiagram', this.groupItemsDiagram)
    this.diagramTreeView.instance.option('items', sortedItems);
  }

  cancelDisableStoredConfig() {
    this.showDisableStoredConfigConfirmation = false;
  }


  // <i class="fas fa-cog"></i>

  // <i class="fas fa-brush"></i>

  ApplyAllButtonOptions = {
    icon: 'fas fa-brush',
    hint: 'Apply to Same Type',
    stylingMode: 'outlined',
    elementAttr: {
      style: 'color: #007bff;'
    },
    onClick: () => {
      this.copySelectedItems();
    }
  };

  savePropertiesButtonOptions = {
    icon: 'fas fa-save',
    hint: 'Save Properties',
    stylingMode: 'outlined',
    elementAttr: {
      style: 'color: #007bff;'
    },
    onClick: () => {
      this.saveConfiguration();
    }
  };

  EditButtonOptions = {
    icon: 'fas fa-cog',
    hint: 'Show Library or Recommended',
    stylingMode: 'outlined',
    elementAttr: {
      style: 'color: #007bff;'
    },
    onClick: () => {
      // this.saveConfiguration();

      let itemsSelected = this.diagramNew.instance.getSelectedItems();
      if (itemsSelected && itemsSelected.length > 0) {
        let itemSelected = itemsSelected[0];
        if (itemSelected.id != "background-image-999") {
          console.log("itemSelected", itemSelected)

          this.showLibreryorRecommended(itemSelected)
        }
      }
    }
  };



  format(command: string) {
    console.log('Formato:', command);
  }


  saveTimeAutoSave() {
    // Detener el intervalo anterior si existe

    if (this.autosaveInterval) {
      clearInterval(this.autosaveInterval);
      this.autosaveInterval = null;
    }

    // Verificar que haya un tiempo seleccionado
    if (!this.selectedSaveConfiguration) {
      console.warn("No se ha seleccionado un tiempo para el autosave");
      return;
    }

    // Crear nuevo intervalo y guardar la referencia
    this.autosaveInterval = setInterval(() => {
      this.SaveAndStay()
    }, this.selectedSaveConfiguration);
  }

  autosaveData(event: any) {
    if (event.value) {
      console.log("testingdnskfnsl")
      console.log(this.selectedSaveConfiguration)

      this.saveTimeAutoSave()

    } else {
      this.stopAutosaveData()
    }
  }

  stopAutosaveData() {
    // Detener el intervalo de autosave
    if (this.autosaveInterval) {
      clearInterval(this.autosaveInterval);
      this.autosaveInterval = null;
    }

    // Detener el intervalo de detección de cambios de propiedades
    if (this.propertyChangeCheckInterval) {
      clearInterval(this.propertyChangeCheckInterval);
      this.propertyChangeCheckInterval = null;
    }
  }



  SetDataInDiagram() {
    console.log('this.groupItemsDiagram', this.groupItemsDiagram)

    // Eliminar duplicados basándose en el campo id
    this.groupItemsDiagram = this.groupItemsDiagram.filter((item, index, self) =>
      index === self.findIndex(t => t.id === item.id)
    );


    const dataSelected = this.diagramTreeView.instance.getSelectedNodes().filter(x => x.parent != undefined).map(x => x.itemData);

    let json = this.diagramNew.instance.export();
    let diagram = JSON.parse(json);

    if (!diagram.shapes) {
      diagram.shapes = [];
    }

    dataSelected.forEach((childItem: any) => {

      const shapeIndex = diagram.shapes.findIndex((s: any) => s.key === childItem.id);

      // Si el childItem.selected es true, debe colocarse en el diagrama
      if (childItem.selected === true) {
        // Solo agregar si no existe ya en el diagrama
        if (shapeIndex === -1) {
          let bboxArray = childItem.bbox;
          if (typeof childItem.bbox === 'string') {
            try {
              bboxArray = JSON.parse(childItem.bbox);
            } catch (e) {
              bboxArray = [0, 0, 0, 0];
            }
          }

          let centerX = 0;
          let centerY = 0;
          if (bboxArray && Array.isArray(bboxArray) && bboxArray.length >= 4) {
            centerX = bboxArray[0]
            centerY = bboxArray[1]
          }

          // Calcular escalado basado en las dimensiones de la imagen
          const x0 = bboxArray[0];
          const y0 = bboxArray[1];
          const x1 = bboxArray[2];
          const y1 = bboxArray[3];

          const scale_x = this.pageWidth / this.dimensionsImage.width;
          const scale_y = this.pageHeight / this.dimensionsImage.height;

          let canvas_x0 = x0 * scale_x
          let canvas_y0 = y0 * scale_y
          const canvas_width = (x1 - x0) * scale_x
          const canvas_height = (y1 - y0) * scale_y

          if (this.dataTemporal != undefined) {
            if (this.dataTemporal.shapes.length > 0) {
              this.dataTemporal.shapes.forEach((item: any) => {
                if (item.key == childItem.id) {
                  canvas_x0 = item.x
                  canvas_y0 = item.y
                }
              });
            }
          }




          let newShape

          this.groupItemsDiagram.forEach(x => {


            if (x.id == childItem.parentId) {

              if (!childItem.systemFound) {

                if (this.nameSVGs.includes(childItem.type)) {
                  console.log("Aqui estoy sdm,fnms,nf m,sd", childItem)

                  // Crear el shape de fondo
                  const uniqueId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
                  const newShape = {
                    key: uniqueId,
                    type: childItem.type, // Debe coincidir con el ID del componente
                    text: '',
                    x: canvas_x0,
                    y: canvas_y0,
                    width: 150,
                    height: 150,
                    locked: false,
                    zIndex: -1, // En el fondo
                  };
                  console.log("newShape", newShape)

                  diagram.shapes.push(newShape);

                } else {
                  newShape = {
                    "key": childItem.id,
                    "locked": false,
                    "zIndex": 0,
                    "type": childItem.type != undefined ? childItem.type : 'rectangle',
                    "text": childItem.text || '',
                    "x": canvas_x0,
                    "y": canvas_y0,
                    "width": childItem.width != undefined ? childItem.width : 800,
                    "height": childItem.height != undefined ? childItem.height : 300,
                    "styleText": childItem.styleText != undefined ? childItem.styleText : {
                      "font-size": "8pt",
                    },
                    "style": childItem.style != undefined ? childItem.style : {
                      fill: childItem.color != undefined ? childItem.color : 'white',
                      stroke: '#000000',
                    },
                    "color": childItem.color != undefined ? childItem.color : 'white',
                  };

                  diagram.shapes.push(newShape);
                }
              } else {
                newShape = {
                  "key": childItem.id,
                  "locked": false,
                  "zIndex": 0,
                  "type": childItem.type != undefined ? childItem.type : 'rectangle',
                  "text": childItem.text || '',
                  "x": canvas_x0,
                  "y": canvas_y0,
                  "width": x.width != undefined ? x.width : 800,
                  "height": x.height != undefined ? x.height : 300,
                  "styleText": x.styleText != undefined ? x.styleText : {
                    "font-size": "8pt",
                  },
                  style: x.style != undefined ? x.style : {
                    fill: x.color != undefined ? x.color : 'white',
                    stroke: '#000000',
                  },
                  "color": x.color != undefined ? x.color : 'white',
                };

                diagram.shapes.push(newShape);
              }
            }
          });



          diagram.shapes.forEach((item: any) => {
            if (item.type !== undefined) {
              item.type = `${item.type}`;
            }
          });

          // this.diagramNew.instance.import(JSON.stringify(diagram));
        }
      }
    });


    this.componentsNew = this.componentsNew.length > 0 ? [this.componentsNew[0]] : [];

    // Agregar los design tools ANTES de importar el diagrama para que los custom shapes estén registrados
    this.componentsDesignTools.forEach(item => {
      const data = {
        "ID": item.ID,
        "SystemType": item.SystemType,
        "TypeId": item.ID,
        "NAME": '',
        "Name": '',
        "COMPSCOPE": '',
        "Imagepath": item.filesvg,
        "filesvg": item.filesvg,
        "filename": item.filename,
        "ACHR": item.ACHR,
        "TAGID": item.TAGID,
        "TAGNAME": item.TAGNAME,
        "componentwidth": item.componentwidth,
        "componentHeight": item.componentHeight,
        "locked": item.locked
      }
      if (!this.componentsNew.find(x => x.ID === item.ID)) {
        this.componentsNew.push(data)
      }
    });

    console.log("this.componentsNew", this.componentsNew)


    let dataTempo



    this.groupItemsDiagram.forEach(item => {


      dataTempo = {
        "ID": item.id,
        "SystemType": item.text,
        "TypeId": item.id,
        "NAME": '',
        "COMPSCOPE": '',
        "Imagepath": "assets/imgcomponent/rectangulo.svg",
        "filesvg": "assets/imgcomponent/rectangulo.svg",
        "filename": "imageTest.jpg",
        "ACHR": "",
        "TAGID": 0,
        "TAGNAME": "NULL",
        "componentwidth": 0.5,
        "componentHeight": 0.5,
        "Name": '',
        "locked": false
      }
      this.componentsNew.push(dataTempo)
    });




    this.groupItemsDiagram.forEach(x => {
      if (x.dontShow) {
        this.groupItemsDiagram = this.groupItemsDiagram.filter(item => item.id !== x.id);
      }
    });

    const sortedItems = this.sortItemsAlphabetically(this.groupItemsDiagram);
    this.diagramTreeView.instance.option('items', sortedItems);

    // this.newDataGroupNames =this.newDataGroupNames.filter(x => x != "Design Tools");
    this.newDataGroupNames = this.newDataGroupNames.filter(x => x != "Basic Shapes");

    console.log("this.newDataGroupNames", this.newDataGroupNames)
    console.log("diagram.shapes", diagram)
    console.log("this.componentsNew", this.componentsNew)
    console.log("this.groupItemsDiagram", this.groupItemsDiagram)

    diagram.shapes.forEach((item: any) => {
      if (item.type) {
        item.type = `${item.type}`;
      }
    });

    setTimeout(() => {
      this.diagramNew.instance.import(JSON.stringify(diagram));
      this.diagramNew.instance.repaint();
    }, 500);



    console.log("this.componentsNew", this.componentsNew)
  }



  pageWidth = 24491;
  pageHeight = 15817;

  addBackgroundImage(showsystemsAfter: boolean = false) {
    if (!this.diagramNew || !this.diagramNew.instance || !this.base64Returned) {
      return;
    }


    // Dimensiones de la página
    const pageWidth = 24491;
    const pageHeight = 15817;

    // Crear la URL de la imagen con el formato correcto
    // Verificar si el base64 ya tiene el prefijo data:image
    let imageUrl = this.base64Returned;
    if (!imageUrl.startsWith('data:image/')) {
      // Si no tiene el prefijo, agregarlo (intentar con jpg primero, luego png)
      if (imageUrl.startsWith('/9j/') || imageUrl.length > 1000) {
        // Parece ser JPG
        imageUrl = `data:image/jpg;base64,${this.base64Returned}`;
      } else {
        // Asumir PNG
        imageUrl = `data:image/png;base64,${this.base64Returned}`;
      }
    }


    // Crear el objeto del componente para el custom shape
    const backgroundComponent = {
      ID: 999,
      SystemType: "Template",
      TypeId: 999,
      NAME: "Template System",
      COMPSCOPE: "Template",
      Imagepath: imageUrl,
      filesvg: imageUrl, // Esta es la propiedad que usa el HTML
      filename: "999.jpg",
      ACHR: "",
      TAGID: 0,
      TAGNAME: "NULL",
      componentwidth: pageWidth,
      componentHeight: pageHeight,
      Name: "Area I",
      locked: true,
    };

    // Agregar el componente a componentsNew para que se registre como custom shape
    const existingIndex = this.componentsNew.findIndex(c => c.ID === 999);
    if (existingIndex !== -1) {
      this.componentsNew[existingIndex] = backgroundComponent;
    } else {
      this.componentsNew.unshift(backgroundComponent); // Agregar al inicio
    }


    // Esperar un poco para que Angular detecte el cambio del componente
    setTimeout(() => {
      // Obtener el JSON actual del diagrama
      const currentJson = this.diagramNew.instance.export();
      const diagramData = JSON.parse(currentJson);

      // Verificar si ya existe un shape de fondo y eliminarlo
      if (diagramData.shapes) {
        const existingBackgroundIndex = diagramData.shapes.findIndex((shape: any) => shape.type === '999');
        if (existingBackgroundIndex !== -1) {
          diagramData.shapes.splice(existingBackgroundIndex, 1);
        }
      } else {
        diagramData.shapes = [];
      }

      // Crear el shape de fondo
      const backgroundShape = {
        key: 'background-image-999',
        type: '999', // Debe coincidir con el ID del componente
        text: 'Background Image II',
        x: 0,
        y: 0,
        width: pageWidth,
        height: pageHeight,
        locked: true,
        zIndex: -1, // En el fondo
      };

      // Agregar el shape de fondo al inicio del array de shapes
      diagramData.shapes.unshift(backgroundShape);

      // Asegurar que las unidades estén correctas
      if (diagramData.page) {
        diagramData.page.viewUnits = 'in';
        diagramData.page.units = 'in';
      }

      // Convertir todos los types a string
      diagramData.shapes.forEach((item: any) => {
        if (item.type) {
          item.type = `${item.type}`;
        }
      });


      // Reimportar el diagrama con la imagen de fondo
      this.diagramNew.instance.import(JSON.stringify(diagramData));


      if (showsystemsAfter) {

        console.log("SetDataInDiagrammnsdmf")
        this.SetDataInDiagram();

      }

    }, 200); // Esperar 200ms para que Angular detecte el cambio del componente
  }


  systemsSelectToMacth = []
  popupSystemsToMacth = false
  systemMatchTo
  systemMatchFrom

  MergeSystems() {
    let systems = this.getCheckedNew()

    if (systems.length != 2) {
      this.toast.warning('you must select 2 systems')
    }

    this.systemsSelectToMacth = systems
    this.popupSystemsToMacth = true
    console.log("🚀 ~ TreeviewProgrammerComponent ~ MergeSystems ~ systems:", systems)
  }

  getCheckedNew() {
    let nodes = this.treeViewSystemArea.instance.getSelectedNodes();
    let data = nodes.map(x => x.itemData).filter(f => f.issystem)
    return data;
  }

  refreshTreeNew() {
    this.refreshTree()
  }

  SaveMatchSystems() {
    let info = {
      method: 'Update_EstimateMergeSystems',
      systemtomergeto: this.systemMatchTo,
      systemtomergefrom: this.systemMatchFrom,
    }

    this.MapInformationService.MethodCallApiFlex(info).subscribe(resp => {
      this.toast.success('Successful update')
      this.closePopupSystemsMatch()
    })
  }

  closePopupSystemsMatch() {
    this.systemsSelectToMacth = []
    this.popupSystemsToMacth = false
    this.refreshTree()
  }


  showFullProjectExcelImport = false;
  showCubePartsMatchPrompt = false;
  allProjectImportFormatted: { headers: any[]; data: any[] } = { headers: [], data: [] };
  allProjectImportFileData: AOA = [];
  allProjectImportAreaNames: string[] = [];
  readonly allProjectImportDefaultAreaLabel = 'Default area';

  private _dragExpandSnapshot: any[] | null = null;

  // ── Add Individual Parts modal ──────────────────────────────────────────
  // ── AI Recommendations ──────────────────────────────────────────────────
  popupRecommendations = false;
  recommendationFile: File = null;
  recommendationFileName = '';
  recommendationFileSize = '';
  recommendationFileExt = '';
  isAnalyzing = false;
  recommendations: any[] = [];
  dragOver = false;
  recommendationTab: 'library' | 'shop' = 'library';

  /** 'area' → multi-select; 'system' → single-select */
  recommendationSource: 'area' | 'system' = 'area';
  recommendationSelectedItems: any[] = [];
  popupRecommendationConfirm = false;

  openRecommendations(source: 'area' | 'system' = 'area') {
    this.resetRecommendations();
    this.recommendationSource = source;
    this.popupRecommendations = true;
  }

  closeRecommendations() {
    this.popupRecommendations = false;
    this.popupRecommendationConfirm = false;
    this.resetRecommendations();
  }

  resetRecommendationsPublic() { this.resetRecommendations(); }

  private resetRecommendations() {
    this.recommendationFile = null;
    this.recommendationFileName = '';
    this.recommendationFileSize = '';
    this.recommendationFileExt = '';
    this.isAnalyzing = false;
    this.recommendations = [];
    this.dragOver = false;
    this.recommendationTab = 'library';
    this.recommendationSelectedItems = [];
    this.popupRecommendationConfirm = false;
  }

  toggleRecommendationSelection(rec: any): void {
    if (this.recommendationSource === 'system') {
      // single-select: replace selection
      this.recommendationSelectedItems = [rec];
    } else {
      // multi-select: toggle
      const idx = this.recommendationSelectedItems.indexOf(rec);
      if (idx >= 0) {
        this.recommendationSelectedItems = this.recommendationSelectedItems.filter((_, i) => i !== idx);
      } else {
        this.recommendationSelectedItems = [...this.recommendationSelectedItems, rec];
      }
    }
  }

  isRecommendationSelected(rec: any): boolean {
    return this.recommendationSelectedItems.indexOf(rec) >= 0;
  }

  openRecommendationConfirm(): void {
    if (this.recommendationSelectedItems.length === 0) return;
    this.popupRecommendationConfirm = true;
  }

  closeRecommendationConfirm(): void {
    this.popupRecommendationConfirm = false;
  }

  confirmAddRecommendations(): void {
    // TODO: wire actual import logic here
    console.log('Confirmed recommendation selection:', this.recommendationSelectedItems);
    this.popupRecommendationConfirm = false;
    this.closeRecommendations();
  }

  onDragOver(e: DragEvent) { e.preventDefault(); this.dragOver = true; }
  onDragLeave(e: DragEvent) { this.dragOver = false; }
  onDrop(e: DragEvent) {
    e.preventDefault();
    this.dragOver = false;
    const file = e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0];
    if (file) { this.setRecommendationFile(file); }
  }

  onNativeFileSelected(e: any) {
    const file = e.target && e.target.files && e.target.files[0];
    if (!file) return;
    this.setRecommendationFile(file);
    e.target.value = '';
  }

  private setRecommendationFile(file: File) {
    this.recommendationFile = file;
    this.recommendationFileName = file.name;
    const ext = file.name.split('.').pop() || '';
    this.recommendationFileExt = ext.toUpperCase();
    const kb = file.size / 1024;
    this.recommendationFileSize = kb >= 1024 ? (kb / 1024).toFixed(1) + ' MB' : kb.toFixed(1) + ' KB';
    this.recommendations = [];
  }

  analyzeDocument() {
    if (!this.recommendationFile) return;
    this.isAnalyzing = true;
    this.recommendations = [];

    const ext = this.recommendationFileExt.toUpperCase();
    const imageExts = ['PNG', 'JPG', 'JPEG', 'GIF', 'BMP', 'WEBP', 'TIFF', 'TIF'];

    if (imageExts.includes(ext)) {
      // ── Image pipeline: comp_tags_base64_alt → GetComponentsByTag ──
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const dataUrl = event.target.result as string;
        this.MapInformationService.compTagsBase64Alt({ Base64: dataUrl, dpi: 350 }).subscribe(
          (response: any) => {
            const tags =
              response && response.tags != null ? String(response.tags) :
              response && response.Tags != null ? String(response.Tags) : '';
            if (!tags || tags.trim() === '') {
              this.isAnalyzing = false;
              this.toast.warning('No tags found in the image');
              return;
            }
            this.runRecommendationGetComponentsByTag(tags, 'AI Image');
          },
          () => { this.isAnalyzing = false; this.toast.error('Error analyzing image'); }
        );
      };
      reader.readAsDataURL(this.recommendationFile);

    } else {
      // ── Document pipeline: extract text → analyze_sequence_tags_only → GetComponentsByTag ──
      this.extractRecommendationDocumentText(this.recommendationFile, ext)
        .then(text => {
          if (!text || text.trim().length < 10) {
            this.isAnalyzing = false;
            this.toast.warning('Could not extract text from file');
            return;
          }
          this.MapInformationService.SuggetsComponents({ sequence_text: text }).subscribe(
            (response: any) => {
              const tags =
                response && response.tags != null ? String(response.tags) :
                response && response.Tags != null ? String(response.Tags) : '';
              if (!tags || tags.trim() === '') {
                this.isAnalyzing = false;
                this.toast.warning('No tags found in the document');
                return;
              }
              this.runRecommendationGetComponentsByTag(tags, 'AI Document');
            },
            () => { this.isAnalyzing = false; this.toast.error('Error analyzing document'); }
          );
        })
        .catch(() => { this.isAnalyzing = false; this.toast.error('Error reading file'); });
    }
  }

  private runRecommendationGetComponentsByTag(tags: string, logLabel: string): void {
    this.MapInformationService.SaveInfoSites({
      method: 'GetComponentsByTag',
      tagids: tags,
      systemtypeID: 1,
    }).subscribe(
      (components: any[]) => {
        const filtered = (components || []).filter(c => c.ID != null);
        console.log(logLabel + ' Components (ID != null):', filtered);
        this.recommendations = filtered;
        this.isAnalyzing = false;
      },
      () => { this.isAnalyzing = false; this.toast.error('Error fetching components by tag'); }
    );
  }

  private extractRecommendationDocumentText(file: File, ext: string): Promise<string> {
    return new Promise((resolve, reject) => {

      if (ext === 'TXT' || ext === 'CSV') {
        const reader = new FileReader();
        reader.onload = (e: any) => resolve(e.target.result || '');
        reader.onerror = () => reject();
        reader.readAsText(file);

      } else if (ext === 'XLSX' || ext === 'XLS') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          try {
            const workbook = XLSX.read(new Uint8Array(e.target.result), { type: 'array' });
            let text = '';
            workbook.SheetNames.forEach(name => {
              text += XLSX.utils.sheet_to_txt(workbook.Sheets[name]) + '\n';
            });
            resolve(text);
          } catch { reject(); }
        };
        reader.onerror = () => reject();
        reader.readAsArrayBuffer(file);

      } else {
        // PDF / DOCX / others: read as binary and extract printable sequences
        const reader = new FileReader();
        reader.onload = (e: any) => {
          const raw: string = e.target.result || '';
          // Keep printable ASCII characters and whitespace
          const text = raw.replace(/[^\x20-\x7E\n\r\t]/g, ' ').replace(/\s+/g, ' ').trim();
          resolve(text);
        };
        reader.onerror = () => reject();
        reader.readAsBinaryString(file);
      }
    });
  }
  // ── end AI Recommendations ───────────────────────────────────────────────

  popupAddIndividualParts = false;
  addIndividualPartsSaving = false;
  addIndividualPartsSystemId: any = null;
  addIndividualPartsSystemLabel = '';
  addIndividualPartsPartImageUrl: string = null;
  addIndividualPartsImgLoading = false;
  addIndividualPartsModel = {
    Id: 0, PartId: null, PartNumber: '',
    AppNoteId: null, AppNote: '', PointType: null, Qty: 1, StdCost: 0,
  };
  addIndividualPartsDataSource: CustomStore;
  addIndividualAppNotesDataSource: CustomStore;
  addIndividualPointTypes: any[] = [];

  openFullProjectExcelImport() {
    this.showFullProjectExcelImport = true;
  }

  closeFullProjectExcelImport() {
    this.showFullProjectExcelImport = false;
    this.resetFullProjectExcelImportState();
  }

  onFullProjectExcelImportHidden() {
    this.showFullProjectExcelImport = false;
    this.resetFullProjectExcelImportState();
  }

  resetFullProjectExcelImportState() {
    this.allProjectImportFormatted = { headers: [], data: [] };
    this.allProjectImportFileData = [];
    this.allProjectImportAreaNames = [];
  }

  collectUniqueImportAreaNames(rows: any[]): string[] {
    const seen: { [key: string]: boolean } = {};
    const result: string[] = [];
    for (let i = 0; i < rows.length; i++) {
      const raw = rows[i].AREA;
      if (raw === undefined || raw === null) {
        continue;
      }
      const name = typeof raw === 'string' ? raw.trim() : String(raw).trim();
      if (name === '') {
        continue;
      }
      if (!seen[name]) {
        seen[name] = true;
        result.push(name);
      }
    }
    return result;
  }

  groupImportRowsBySystemNameWithSummedQty(
    rows: any[]
  ): Array<{
    SYSTEMNAME: string;
    SYSTEM_QTY: number;
    SYSTEMTYPE: any;
    AREA: string;
    NewSystemid: number;
  }> {
    const rowsBySystemNameKey: {
      [key: string]: {
        SYSTEMNAME: string;
        SYSTEM_QTY: number;
        SYSTEMTYPE: any;
        AREA: string;
        NewSystemid: number;
      };
    } = {};
    for (let i = 0; i < rows.length; i++) {
      const row = rows[i];
      const rawName = row.SYSTEMNAME;
      const nameStr = rawName == null ? '' : String(rawName).trim();
      const mapKey = nameStr === '' ? '__empty_systemname__' : nameStr;
      const q = Number(row.SYSTEM_QTY);
      const addQty = isNaN(q) ? 0 : q;
      if (!rowsBySystemNameKey[mapKey]) {
        rowsBySystemNameKey[mapKey] = {
          SYSTEMNAME: nameStr,
          SYSTEM_QTY: addQty,
          SYSTEMTYPE: row.SYSTEMTYPE,
          AREA: row.AREA,
          NewSystemid: 0
        };
      }
    }
    return Object.keys(rowsBySystemNameKey).map((key) => rowsBySystemNameKey[key]);
  }

  private allProjectImportArrayToObjects(arr: AOA): any[] {
    const keys = arr[0];
    const newArr = arr.slice(1, arr.length);
    const formatted: any[] = [];
    const cols = keys;
    const l = cols.length;
    for (let i = 0; i < newArr.length; i++) {
      const d = newArr[i];
      const o: any = {};
      for (let j = 0; j < l; j++) {
        o[cols[j]] = d[j];
      }
      formatted.push(o);
    }
    return formatted;
  }

  applyCatalogFlagsToFullProjectImportRows() {
    this.allProjectImportFormatted.data.forEach((row) => {
      this.estimateService
        .Get_EstimateAreaSystemDetailsImportCE(row.PARTNUMBER, row.APPNOTES, row.POINTTYPE)
        .subscribe((result) => {
          const catalogRow = result[0];
          if (catalogRow) {
            row.FlagApp_Note = catalogRow.App_Note;
            row.FlagPart_Number = catalogRow.Part_Number;
            row.FlagPoint_Type = catalogRow.Point_Type;
          }
        });
    });
  }

  private applyDefaultAreaLabelToImportRows(rows: any[]) {
    rows.forEach((row) => {
      const rawArea = row.AREA;
      const isMissingArea =
        rawArea === undefined ||
        rawArea === null ||
        (typeof rawArea === 'string' && rawArea.trim() === '') ||
        String(rawArea).trim() === '';
      if (isMissingArea) {
        row.AREA = this.allProjectImportDefaultAreaLabel;
      }
    });
  }

  onFullProjectExcelImportFileAdded(obj: File) {
    const validExcelTypes = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel.sheet.macroEnabled.12',
      'application/vnd.ms-excel.template.macroEnabled.12'
    ];
    const validExtensions = ['.xls', '.xlsx', '.xlsm', '.xltx'];
    const fileExtension = obj.name.toLowerCase().substring(obj.name.lastIndexOf('.'));

    if (!validExcelTypes.includes(obj.type) && !validExtensions.includes(fileExtension)) {
      this.toast.error('Please upload a valid Excel file (.xls, .xlsx, .xlsm, .xltx)');
      return;
    }

    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      try {
        const bstr: string = e.target.result;
        const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
        const wsname: string = wb.SheetNames[0];
        const ws: XLSX.WorkSheet = wb.Sheets[wsname];
        let data = XLSX.utils.sheet_to_json(ws, { header: 1 }) as AOA;
        data = data.filter((x) => x.length > 0);
        this.allProjectImportFileData = data;
        this.allProjectImportFormatted.headers = data[0];
        this.allProjectImportFormatted.data = this.allProjectImportArrayToObjects(data);
        if (this.allProjectImportFormatted.data.length > 0) {
          this.allProjectImportFormatted.data.forEach((element: any, index: number) => {
            element.id = index + 1;
          });
        }
        this.applyCatalogFlagsToFullProjectImportRows();
      } catch (error) {
        this.toast.error('Error reading Excel file. Please make sure it is a valid Excel file.');
        console.error('Error reading Excel file:', error);
      }
    };
    reader.readAsBinaryString(obj);
  }

  submitFullProjectExcelImport() {
    if (!this.gridfileAllProject || !this.gridfileAllProject.instance) {
      this.toast.warning(this.translate.instant('ModuleEditEstimate.msgValues'));
      return;
    }
    if (this.allProjectImportFormatted.data.length === 0) {
      this.toast.warning('Please upload a valid Excel file (.xls, .xlsx, .xlsm, .xltx)');
      return;
    }

    const importRows = this.allProjectImportFormatted.data;
    this.applyDefaultAreaLabelToImportRows(importRows);
    this.allProjectImportAreaNames = this.collectUniqueImportAreaNames(importRows);

    const createdEstimateAreas: { id: number; name: string }[] = [];

    if (this.allProjectImportAreaNames.length > 0) {
      let completedAreaSaveCount = 0;
      this.allProjectImportAreaNames.forEach((areaName, sortIndex) => {
        const insertAreaPayload = {
          method: 'Insert_EstimateAreaCE',
          estimateid: this.estimateid,
          name: areaName,
          id: 0,
          sort: sortIndex + 1,
          inactive: 0,
          alternate: 0
        };
        this.MapInformationService.SaveInfoSites(insertAreaPayload).subscribe((createAreaResponse) => {
          completedAreaSaveCount += 1;
          createdEstimateAreas.push({ id: createAreaResponse[0].ID, name: areaName });
          if (completedAreaSaveCount === this.allProjectImportAreaNames.length) {
            this.createSystemsForFullProjectImport(createdEstimateAreas, importRows);
          }
        });
      });
    }
  }


  createSystemsForFullProjectImport(
    estimateAreas: { id: number; name: string }[],
    importRows: any[]
  ) {
    this.dataSystemsToShowAndUpdate = [];
    let completedSystemSaveCount = 0;

    const groupedSystemRows = this.groupImportRowsBySystemNameWithSummedQty(importRows);
    const groupedSystemsWithNewIds: any[] = [];

    groupedSystemRows.forEach((groupedRow, groupedIndex) => {
      const areaMatch = estimateAreas.find((a) => a.name === groupedRow.AREA);
      const insertSystemPayload = {
        method: 'Insert_EstimateCreateNewSystemCE',
        id: 0,
        systemid: 0,
        sort: 0,
        areaname: areaMatch ? areaMatch.id : 0,
        systemname: groupedRow.SYSTEMNAME,
        qty: groupedRow.SYSTEM_QTY,
        // SYSTEMTYPE del import puede venir como nombre o como id → se resuelve contra la lista de system types.
        systemtype: this.resolveSystemTypeIdFromValue(groupedRow.SYSTEMTYPE),
        _rawSystemType: groupedRow.SYSTEMTYPE,
        inactive: 0,
        deleted: 0,
        scopeofwork: 0,
        sop: '',
        excludefromsearch: '',
        controldwgname: '',
        controldwgimg: '',
        tagtext: '',
        tagnum: '',
        description: '',
        idNewSystem: 0,
        _uiRowId: groupedIndex + 1
      };

      this.dataSystemsToShowAndUpdate.push(insertSystemPayload);

      // this.MapInformationService.SaveInfoSites(insertSystemPayload).subscribe((createSystemResponse) => {
      //   groupedRow.NewSystemid = createSystemResponse[0].resultID;
      //   groupedSystemsWithNewIds.push(groupedRow);
      //   completedSystemSaveCount += 1;
      //   if (completedSystemSaveCount === groupedSystemRows.length) {
      //     this.createLineDetailsForFullProjectImport(groupedSystemsWithNewIds, importRows);
      //   }
      // });
    });

    console.log("🚀 ~ TreeviewProgrammerComponent ~ createSystemsForFullProjectImport ~ this.dataSystemsToShowAndUpdate:", this.dataSystemsToShowAndUpdate)

    this.prepareDataSystemsToShowAndUpdateForModal();
    this.showModalToupdateSystems = true;
  }

  syncUpdateModalPayloadFields(row: any) {
    if (!row) {
      return;
    }
    row.systemname = row.name;
    row.systemtype = row.systemTypeID;
    if (row.matchedArea) {
      row.areaname = row.areaID;
    }
  }

  /**
   * Resuelve un SYSTEMTYPE del import (que puede venir como ID o como nombre) al ID real
   * buscando en `systemTypeMultipleData`. Devuelve 0 si no hay coincidencia o no hay valor.
   */
  private resolveSystemTypeIdFromValue(value: any): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }
    const list = this.systemTypeMultipleData || [];
    const valueStr = String(value).trim().toLowerCase();
    // 1) Coincidencia por ID.
    let match = list.find((t: any) => String(t.ID).trim().toLowerCase() === valueStr);
    // 2) Si no, coincidencia por nombre (SystemType). El nombre en la lista trae un "-" al final
    //    (ej. "HVAC - 1"), así que se hace split por "-" y se compara solo la posición [0].
    if (!match) {
      match = list.find((t: any) => {
        if (t.SystemType == null) {
          return false;
        }
        const namePart = String(t.SystemType).split('-')[0].trim().toLowerCase();
        return namePart === valueStr;
      });
    }
    return match ? match.ID : 0;
  }

  /**
   * Re-resuelve el system type de las filas importadas una vez que `systemTypeMultipleData`
   * ya está cargada (se llama al abrir el modal "Review and update systems").
   */
  private resolveImportedSystemTypesForModal() {
    this.dataSystemsToShowAndUpdate.forEach((row: any) => {
      if (row._rawSystemType !== undefined && row._rawSystemType !== null) {
        const resolvedId = this.resolveSystemTypeIdFromValue(row._rawSystemType);
        row.systemtype = resolvedId;
        row.systemTypeID = resolvedId;
      }
    });
  }

  prepareDataSystemsToShowAndUpdateForModal() {
    let maxUi = 0;
    this.dataSystemsToShowAndUpdate.forEach((r: any) => {
      if (r._uiRowId != null && r._uiRowId > maxUi) {
        maxUi = r._uiRowId;
      }
    });
    this.dataSystemsToShowAndUpdate.forEach((row: any) => {
      if (row._uiRowId == null) {
        maxUi += 1;
        row._uiRowId = maxUi;
      }
      row.id = row._uiRowId;
      if (row.matchedArea === undefined) {
        row.matchedArea = true;
      }
      if (row.matched === undefined) {
        row.matched = true;
      }
      if (row.areaID === undefined) {
        row.areaID = row.areaname;
      }
      if (row.name === undefined) {
        row.name = row.systemname;
      }
      if (row.systemTypeID === undefined) {
        row.systemTypeID = row.systemtype;
      }
      if (row.systemTypeName === undefined) {
        row.systemTypeName = '';
      }
      if (row.sytemOrigin === undefined) {
        row.sytemOrigin = null;
      }
      this.syncUpdateModalPayloadFields(row);
    });
  }

  onShownModalUpdateSystems() {
    if (this.estimateid) {
      this.getAreas();
    }
    // Cuando la lista de system types ya cargó, resolvemos el SYSTEMTYPE importado
    // (id o nombre) al ID real para que el dropdown del modal lo muestre seleccionado.
    this.getSystemTypeMultiple(() => {
      this.resolveImportedSystemTypesForModal();
      this.prepareDataSystemsToShowAndUpdateForModal();
    });
    this.prepareDataSystemsToShowAndUpdateForModal();
  }

  cancelModalUpdateSystems() {
    this.showModalToupdateSystems = false;
  }

  /** Una fila es válida cuando tiene área, nombre y system type asignados (✅); si no, advertencia (⚠). */
  isReviewRowValid(item: any): boolean {
    if (!item) {
      return false;
    }
    const hasArea = item.areaID !== '' && item.areaID !== undefined && item.areaID !== null;
    const hasName = item.name !== '' && item.name !== undefined && item.name !== null;
    const hasType =
      item.systemTypeID !== '' && item.systemTypeID !== undefined && item.systemTypeID !== null && item.systemTypeID !== 0;
    return hasArea && hasName && hasType;
  }

  /** Cantidad de filas con advertencias de configuración (no válidas) en el modal de revisión. */
  reviewWarningCount(): number {
    return (this.dataSystemsToShowAndUpdate || []).filter((r: any) => !this.isReviewRowValid(r)).length;
  }



  changeToSelectAreaModalUpdate(item: any) {
    this.dataSystemsToShowAndUpdate.forEach(element => {
      if (element._uiRowId === item._uiRowId) {
        element.matchedArea = !element.matchedArea;
      }
    });
  }

  changeAreaNameModalUpdate(newValue: string, item: any) {
    const model = {
      method: 'Insert_EstimateAreaCE',
      estimateid: this.estimateid,
      name: newValue,
      id: 0,
      sort: null,
      inactive: 0,
      alternate: 0,
    };

    this.MapInformationService.SaveInfoSites(model).subscribe(result => {
      for (let index = 0; index < this.dataSystemsToShowAndUpdate.length; index++) {
        if (this.dataSystemsToShowAndUpdate[index].areaname === item.areaname) {
          this.dataSystemsToShowAndUpdate[index].areaID = result[0].ID;
          this.dataSystemsToShowAndUpdate[index].matchedArea = true;
        }
      }
      this.getAreas();
    });
  }

  changeSystemTypeModalUpdate(newValue: string, item: any) {
    const model = {
      method: 'InsertUpdate_SystemTypesEngUtility',
      typrname: newValue,
      available: true,
      vav: false,
      shop: false,
      parentid: 0,
      image: '',
      id: 0
    };

    this.MapInformationService.SaveInfoSites(model).subscribe(result => {
      for (let index = 0; index < this.dataSystemsToShowAndUpdate.length; index++) {
        if (this.dataSystemsToShowAndUpdate[index].systemTypeName === item.systemTypeName) {
          this.dataSystemsToShowAndUpdate[index].systemTypeID = result[0].returnID;
          this.dataSystemsToShowAndUpdate[index].matched = true;
        }
      }
      this.getSystemTypeMultiple();
    });
  }

  changeToSelectModalUpdate(item: any) {
    this.dataSystemsToShowAndUpdate.forEach(element => {
      if (element._uiRowId === item._uiRowId) {
        element.matched = !element.matched;

        const dataSPAI = {
          method: 'GetCubeOpenAIQuestionByType',
          topic: 'MATCH_SYSTEM_TYPE_AI_WITH_NAME'
        };

        this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultPReguntasAI => {
          const itemEachPregunta = resultPReguntasAI[0];
          const spDinamic = itemEachPregunta.TYPEPROMPT.split(':')[1];
          const newVariable = {
            method: spDinamic,
          };

          this.MapInformationService.SaveInfoSites(newVariable).subscribe(result1 => {
            const resultString = JSON.stringify(result1);
            const prompt = {
              systemPrompt: `${itemEachPregunta.SYSTEMPROMPT} `,
              userprompt: `${itemEachPregunta.USERPROMPT} ${element.name} ${resultString}`,
            };

            this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultDatafromAI => {
              if (resultDatafromAI.content != undefined) {
                const resultData = JSON.parse(resultDatafromAI.content);
                element.systemTypeID = resultData.id;
                this.syncUpdateModalPayloadFields(element);
              }
            });
          });
        });
      }
    });
  }

  matchSystemTypeOriginModalUpdate(item: any) {
    const dataSPAI = {
      method: 'GetCubeOpenAIQuestionByType',
      topic: 'MATCH_SYSTEM_TYPE_AI_WITH_NAME'
    };

    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {
      const itemMatch = resultMatch[0];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };

      this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {
        const resultString = JSON.stringify(resultSp);
        const prompt = {
          systemPrompt: `${itemMatch.SYSTEMPROMPT}`,
          userprompt: `${itemMatch.USERPROMPT} ${item.name} ${resultString}`,
        };

        this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
          const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID;

          this.dataSystemsToShowAndUpdate.forEach(itemOrigin => {
            if (itemOrigin._uiRowId === item._uiRowId) {
              itemOrigin.systemTypeID = systemTypeIDFromAI;
              this.syncUpdateModalPayloadFields(itemOrigin);
            }
          });
        });
      });
    });
  }

  matchAllSystemTypeOriginModalUpdate() {
    const dataSPAI = {
      method: 'GetCubeOpenAIQuestionByType',
      topic: 'MATCH_SYSTEM_TYPE_AI_WITH_NAME'
    };

    this.MapInformationService.SaveInfoSites(dataSPAI).subscribe(resultMatch => {
      const itemMatch = resultMatch[0];
      const spDinamic = itemMatch.TYPEPROMPT.split(':')[1];
      const newVariable = {
        method: spDinamic,
      };

      this.dataSystemsToShowAndUpdate.forEach(itemEachAI => {
        this.MapInformationService.SaveInfoSites(newVariable).subscribe(resultSp => {
          const resultString = JSON.stringify(resultSp);
          const prompt = {
            systemPrompt: `${itemMatch.SYSTEMPROMPT}`,
            userprompt: `${itemMatch.USERPROMPT} ${itemEachAI.name} ${resultString}`,
          };

          this.MapInformationService.GetCodeFromAI(prompt).subscribe(resultMatchType => {
            const systemTypeIDFromAI = JSON.parse(resultMatchType.content).ID;
            itemEachAI.systemTypeID = systemTypeIDFromAI;
            this.syncUpdateModalPayloadFields(itemEachAI);
          });
        });
      });
    });
  }

  newSystemMultipleModalUpdate() {
    const dataTempo = [...this.dataSystemsToShowAndUpdate];
    const last = dataTempo[dataTempo.length - 1];
    const newSort = last ? last.sort + 1 : 1;
    const maxUi = dataTempo.reduce((m, r: any) => Math.max(m, r._uiRowId || 0), 0);
    const newRow: any = {
      method: 'Insert_EstimateCreateNewSystemCE',
      id: 0,
      systemid: 0,
      sort: newSort,
      areaname: this.idAreaxDefault,
      systemname: '',
      name: '',
      qty: 1,
      systemtype: 0,
      systemTypeID: 0,
      areaID: this.idAreaxDefault,
      inactive: 0,
      deleted: 0,
      scopeofwork: 0,
      sop: '',
      excludefromsearch: '',
      controldwgname: '',
      controldwgimg: '',
      tagtext: '',
      tagnum: '',
      description: '',
      idNewSystem: 0,
      matchedArea: true,
      matched: true,
      systemTypeName: '',
      sytemOrigin: null,
      _uiRowId: maxUi + 1,
    };
    newRow.id = newRow._uiRowId;
    dataTempo.push(newRow);
    this.dataSystemsToShowAndUpdate = dataTempo;
    this.syncUpdateModalPayloadFields(newRow);
  }

  deletesystemMultipleModalUpdate(data: any) {
    this.dataSystemsToShowAndUpdate = this.dataSystemsToShowAndUpdate.filter(x => x._uiRowId !== data._uiRowId);
  }

  showSuggestedSystemModalUpdate(item: any) {
    this.suggestedSystemTargetArray = 'updateModal';
    this.MapInformationService.SaveInfoSites({ method: 'GetMostUsedSystemBySystemType', systemtypeid: item.systemTypeID }).subscribe(respSystem => {
      if (respSystem.length > 0) {
        this.MapInformationService.SaveInfoSites({ method: 'GetEstimateAreaSystemInfoCE', systemid: respSystem[0].systemid }).subscribe(respSystemInfo => {
          this.usedTimes = respSystem[0].cnt;
          this.dataSystemInfo = respSystemInfo[0];

          this.MapInformationService.SaveInfoSites({ method: 'Get_SystemImagePath', systemid: respSystem[0].systemid }).subscribe(respPath => {
            this.MapInformationService.GetDocument(respPath[0].ImagePath).subscribe(result => {
              if (result.filestring && result.filestring !== 'Not_Image') {
                let imageType = 'jpeg';
                const base64Start = result.filestring.substring(0, 5).toUpperCase();
                if (base64Start === 'IVBOR') {
                  imageType = 'png';
                } else if (base64Start === '/9J/4') {
                  imageType = 'jpeg';
                }
                if (!result.filestring.startsWith('data:image')) {
                  this.imgSystemSelected = `data:image/${imageType};base64,${result.filestring}`;
                } else {
                  this.imgSystemSelected = result.filestring;
                }
              } else {
                this.imgSystemSelected = 'Not_Image';
              }
              this.suggestedSystemData = item;
              this.showSuggestedSystemPopup = true;
            });
          });
        });
      } else {
        this.toast.warning('No suggested system found for the selected system type');
      }
    });
  }

  importComponentFromLibraryModalUpdate(dataSystem: any) {
    this.modal = true;
    this.dataSystemSelected = dataSystem;
    this.closeStepper.emit('ENG-ENGPROJ-MODIMPORTLIBRARY');
  }

  onCleanClickModalUpdate(item: any) {
    this.dataSystemsToShowAndUpdate.forEach(x => {
      if (x._uiRowId === item._uiRowId) {
        x.sytemOrigin = null;
      }
    });
  }








  onCubePartsMatchPromptHidden() {
    this.showCubePartsMatchPrompt = false;
  }

  onCubePartsMatchPromptChoice(choice: 'cancel' | 'associateAll' | 'associatePartial') {
    this.showCubePartsMatchPrompt = false;
    this.fullProjectImportCubeMatchChoice.emit(choice);
  }

  resetUiAfterFullProjectExcelImport() {
    this.popupNewSystem = false;
    this.dataTest = [
      {
        id: 0,
        areaID: this.idAreaxDefault,
        systemTypeID: 1,
        name: '',
        sort: 1,
        qty: 1
      }
    ];
    this.returnWithInfo.emit(this.systemid);
    this.closeStepper.emit();
    this.reload.emit();
    this.showExcelInputElement = false;
    this.hasUploadedFile = false;
  }


  createLineDetailsForFullProjectImport(groupedSystemsWithNewIds: any[], importRows: any[]) {
    console.log("🚀 ~ createLineDetailsForFullProjectImport ~ groupedSystemsWithNewIds:", groupedSystemsWithNewIds)
    console.log("🚀 ~ createLineDetailsForFullProjectImport ~ importRows:", importRows)

    // Cierra el flujo (toast + cierra ambos modales + refresca). Se llama una sola vez al terminar.
    const finish = () => {
      this.toast.success('Details created successfully');
      this.closeFullProjectExcelImport();
      this.refreshTree();
      this.resetUiAfterFullProjectExcelImport();
      this.showCubePartsMatchPrompt = true;
      this.showModalToupdateSystems = false;
      console.log('Full project Excel import completed successfully');
    };

    // Solo armamos detalles para las filas del import cuyo sistema sí se creó (match por nombre).
    // Si el sistema no existe (nombre editado, fila agregada, etc.) se omite esa línea en vez de romper.
    const linePayloads: any[] = [];
    (importRows || []).forEach((lineRow) => {
      const systemGroup = groupedSystemsWithNewIds.find((g) => g.systemname === lineRow.SYSTEMNAME);
      if (!systemGroup || systemGroup.NewSystemid == null) {
        return;
      }
      linePayloads.push({
        method: 'Insert_EstimateAreaSystemDetailsImportCE',
        qty: lineRow.QTY,
        partnumber: lineRow.PARTNUMBER,
        applicationnotes1: lineRow.APPNOTES,
        tag: lineRow.TAG,
        pointype: lineRow.POINTTYPE,
        pointnumber: lineRow.POINTNUMBER,
        systemid: systemGroup.NewSystemid,
        id: 0,
        damper: 0,
        VALVE: 0,
        partcost: 0,
        prefix: lineRow.PREFIX
      });
    });

    // Sin líneas que guardar (p. ej. sistemas sin componentes): igual cerramos el flujo.
    if (linePayloads.length === 0) {
      finish();
      return;
    }

    let completedDetailSaveCount = 0;
    const onOneDone = () => {
      completedDetailSaveCount += 1;
      if (completedDetailSaveCount === linePayloads.length) {
        finish();
      }
    };

    linePayloads.forEach((payload) => {
      this.MapInformationService.SaveInfoSites(payload).subscribe(
        () => onOneDone(),
        () => onOneDone() // un error en una línea no debe dejar el modal colgado
      );
    });
  }



  saveModalUpdateSystems() {

    const groupedSystemsWithNewIds: any[] = [];
    let completedSystemSaveCount = 0;
    this.dataSystemsToShowAndUpdate.forEach((row: any) => {
      this.MapInformationService.SaveInfoSites(row).subscribe((createSystemResponse) => {
        row.NewSystemid = createSystemResponse[0].resultID;
        groupedSystemsWithNewIds.push(row);
        completedSystemSaveCount += 1;
        if (completedSystemSaveCount === this.dataSystemsToShowAndUpdate.length) {
          this.createLineDetailsForFullProjectImport(groupedSystemsWithNewIds, this.allProjectImportFormatted.data);
        }
      });
    });
  }

  // ── Add Individual Parts ─────────────────────────────────────────────────

  openAddIndividualPartsFromTree(item: any): void {
    if (!item || item.id == null) {
      this.toast.warning(this.translate.instant('ModuleSystemToArea.msgSelSys'));
      return;
    }
    this.addIndividualPartsSystemId = item.id;
    this.addIndividualPartsSystemLabel = item.text || '';
    this.resetAddIndividualPartsModel();
    this.initAddIndividualPartsSources();
    this.popupAddIndividualParts = true;
  }

  resetAddIndividualPartsModel(): void {
    this.addIndividualPartsModel = {
      Id: 0, PartId: null, PartNumber: '',
      AppNoteId: null, AppNote: '', PointType: null, Qty: 1, StdCost: 0,
    };
    this.addIndividualPartsPartImageUrl = null;
    this.addIndividualPartsImgLoading = false;
    this.addIndividualPartsSaving = false;
    this.addIndividualPartsPartPlaceholder = 'Search part...';
  }

  /**
   * Replica de PartCreated (de edit-estimate) pero para el modal "Add Individual Parts" del treeview:
   * tras crear un part lo deja como placeholder del select y seleccionado en el modelo, y recarga la lista.
   */
  onTreeNewPartCreated(newPart: any): void {
    if (!newPart) {
      return;
    }
    this.addIndividualPartsPartPlaceholder =
      (newPart.partnumber || '') + ' | ' + (newPart.partdescription || '') +
      ' [' + (newPart.price != null ? newPart.price : '') + ' ]';
    this.addIndividualPartsModel.PartId = newPart.idNewPart;
    this.addIndividualPartsModel.PartNumber = newPart.partnumber;
    if (newPart.price != null) {
      this.addIndividualPartsModel.StdCost = newPart.price;
    }
    // Recarga el datasource para que el nuevo part aparezca en la búsqueda.
    this.initAddIndividualPartsSources();
  }

  private initAddIndividualPartsSources(): void {
    const mythis = this;
    this.addIndividualPartsDataSource = new CustomStore({
      key: 'ID',
      load: (loadOptions: any) => {
        const search = loadOptions.searchValue || 'par';
        return mythis.estimateService.Get_AccParts(search).toPromise();
      },
    });
    this.addIndividualAppNotesDataSource = new CustomStore({
      key: 'ID',
      useDefaultSearch: false,
      load: (loadOptions: any) =>
        mythis.systemComponentService.Get_ApplicationNotesActive(loadOptions.searchValue).toPromise(),
    });
    this.utilityService.GetPointType().subscribe((res: any[]) => {
      this.addIndividualPointTypes = res || [];
    });
  }

  onIndividualPartChange(e: any): void {
    if (e && e.selectedItem) {
      this.addIndividualPartsModel.PartId = e.selectedItem.ID;
      this.addIndividualPartsModel.PartNumber = e.selectedItem.DESCRIPTION
        ? e.selectedItem.DESCRIPTION.split('|')[0] : '';

      // Load part image via Get_AcctPartsDetailByIDCE
      this.addIndividualPartsPartImageUrl = null;
      this.addIndividualPartsImgLoading = true;
      this.MapInformationService.SaveInfoSites({
        method: 'Get_AcctPartsDetailByIDCE',
        PARTid: e.selectedItem.ID
      }).subscribe(
        (result: any) => {
          const detail = Array.isArray(result) && result.length > 0 ? result[0] : null;
          this.addIndividualPartsModel.StdCost = detail && detail.STDCOST != null ? Number(detail.STDCOST) : 0;
          const imageFile = detail ? detail.IMAGEFILE : null;
          if (imageFile && String(imageFile).trim() !== '') {
            this.MapInformationService.GetDocumentThumImg(String(imageFile).trim()).subscribe(
              (imgResult: any) => {
                this.addIndividualPartsImgLoading = false;
                if (imgResult && imgResult.filestring) {
                  const d = imgResult.filestring.substring(0, 5);
                  const tipo = d.toUpperCase() === '/9J/4' ? 'jpeg' : 'png';
                  this.addIndividualPartsPartImageUrl = 'data:image/' + tipo + ';base64,' + imgResult.filestring;
                }
              },
              () => { this.addIndividualPartsImgLoading = false; }
            );
          } else {
            this.addIndividualPartsImgLoading = false;
          }
        },
        () => { this.addIndividualPartsImgLoading = false; }
      );
    }
  }

  onIndividualAppNoteChange(e: any): void {
    if (e && e.selectedItem) {
      this.addIndividualPartsModel.AppNoteId = e.selectedItem.ID;
      this.addIndividualPartsModel.AppNote = e.selectedItem.Application_Notes;
    }
  }

  saveAddIndividualParts(): void {
    const m = this.addIndividualPartsModel;
    if (!m.PartId) {
      this.toast.warning('Please select a Part.');
      return;
    }
    this.addIndividualPartsSaving = true;
    this.estimateService.Insert_EstimateAreaSystemDetailsSingleCE(
      m.Qty, m.PartNumber, m.AppNote, '', m.PointType, 0,
      this.addIndividualPartsSystemId, m.StdCost, m.AppNoteId, m.PartId, m.Id, '', false,
    ).subscribe({
      next: () => {
        this.toast.success(this.translate.instant('ModuleEditEstimate.msgAddSucc'));
        this.reload.emit(this.estimateid);
        this.popupAddIndividualParts = false;
        this.resetAddIndividualPartsModel();
      },
      error: () => { this.addIndividualPartsSaving = false; },
    });
  }

  closeAddIndividualParts(): void {
    this.popupAddIndividualParts = false;
    this.resetAddIndividualPartsModel();
  }
}
